/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class ProductionOrderExcelServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 导出计划下的工单数据
     * @param bizCode (optional) 业务数据
     * @param bizDataId (optional) 业务数据ID
     * @param planId (optional) 计划Id
     * @param tenantId (optional) 租户Id
     * @return OK
     */
    orderLis(bizCode: string | null | undefined, bizDataId: string | null | undefined, planId: string | null | undefined, tenantId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/export-production-order/{planId}/export-list?";
        if (planId !== null && planId !== undefined)
        url_ = url_.replace("{planId}", encodeURIComponent("" + planId)); 
        else
            url_ = url_.replace("/{planId}", "");
        if (bizCode !== undefined)
            url_ += "bizCode=" + encodeURIComponent("" + bizCode) + "&"; 
        if (bizDataId !== undefined)
            url_ += "bizDataId=" + encodeURIComponent("" + bizDataId) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processOrderLis(_response);
        });
    }

    protected processOrderLis(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class MaterialAssignRecordServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 派料
     * @param assignMaterialDTO assignMaterialDTO
     * @return OK
     */
    assignMaterial(assignMaterialDTO: AssignMaterialDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/material-assign-record";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignMaterialDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAssignMaterial(_response);
        });
    }

    protected processAssignMaterial(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 退料
     * @param assignMaterialDTO assignMaterialDTO
     * @return OK
     */
    returnMaterial(assignMaterialDTO: AssignMaterialDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/material-assign-record/return-material";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignMaterialDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processReturnMaterial(_response);
        });
    }

    protected processReturnMaterial(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class MaterialCallServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 缺料呼叫确认
     * @param materialCallConfirmDTO materialCallConfirmDTO
     * @return OK
     */
    confirm(materialCallConfirmDTO: MaterialCallConfirmDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/material-call";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(materialCallConfirmDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processConfirm(_response);
        });
    }

    protected processConfirm(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询缺料呼叫列表
     * @param materialCode (optional) 物料code
     * @param planId (optional) 计划Id
     * @return OK
     */
    materialCallRecordList(materialCode: string | null | undefined, planId: string | null | undefined): Promise<MaterialCallRecordVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/material-call/list?";
        if (materialCode !== undefined)
            url_ += "materialCode=" + encodeURIComponent("" + materialCode) + "&"; 
        if (planId !== undefined)
            url_ += "planId=" + encodeURIComponent("" + planId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMaterialCallRecordList(_response);
        });
    }

    protected processMaterialCallRecordList(response: AxiosResponse): Promise<MaterialCallRecordVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialCallRecordVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<MaterialCallRecordVO[]>(<any>null);
    }
}

export class MaterialCollectionRecordServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 收领确认
     * @param collectPlanDTO collectPlanDTO
     * @return OK
     */
    collectMaterial(collectPlanDTO: CollectPlanDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/material-collection-record/collect";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(collectPlanDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCollectMaterial(_response);
        });
    }

    protected processCollectMaterial(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 收领记录
     * @param planId planId
     * @return OK
     */
    collectList(planId: string): Promise<CollectMaterialVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/material-collection-record/collect/list?";
        if (planId === undefined || planId === null)
            throw new Error("The parameter 'planId' must be defined and cannot be null.");
        else
            url_ += "planId=" + encodeURIComponent("" + planId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCollectList(_response);
        });
    }

    protected processCollectList(response: AxiosResponse): Promise<CollectMaterialVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CollectMaterialVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<CollectMaterialVO[]>(<any>null);
    }

    /**
     * 退领确认
     * @param collectPlanDTO collectPlanDTO
     * @return OK
     */
    returnMaterial(collectPlanDTO: CollectPlanDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/material-collection-record/return";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(collectPlanDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processReturnMaterial(_response);
        });
    }

    protected processReturnMaterial(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 退领记录
     * @param planId planId
     * @return OK
     */
    returnList(planId: string): Promise<CollectMaterialVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/material-collection-record/return/list?";
        if (planId === undefined || planId === null)
            throw new Error("The parameter 'planId' must be defined and cannot be null.");
        else
            url_ += "planId=" + encodeURIComponent("" + planId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processReturnList(_response);
        });
    }

    protected processReturnList(response: AxiosResponse): Promise<CollectMaterialVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CollectMaterialVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<CollectMaterialVO[]>(<any>null);
    }
}

export class OrderProcessMaterialServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 工单物料消耗
     * @param planId planId
     * @return OK
     */
    orderProcessMaterialDetail(planId: string): Promise<OrderProcessMaterialVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/order-process-material/getDatail?";
        if (planId === undefined || planId === null)
            throw new Error("The parameter 'planId' must be defined and cannot be null.");
        else
            url_ += "planId=" + encodeURIComponent("" + planId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processOrderProcessMaterialDetail(_response);
        });
    }

    protected processOrderProcessMaterialDetail(response: AxiosResponse): Promise<OrderProcessMaterialVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderProcessMaterialVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<OrderProcessMaterialVO[]>(<any>null);
    }
}

export class OrderProcessItemQcServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 添加质检工序以及质检项
     * @param orderProcessQcAddDTO orderProcessQcAddDTO
     * @return OK
     */
    saveQcItem(orderProcessQcAddDTO: OrderProcessQcAddDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/order-process-qc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderProcessQcAddDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveQcItem(_response);
        });
    }

    protected processSaveQcItem(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 修改工单工序质检项
     * @param qcItemUpdateDTO qcItemUpdateDTO
     * @return OK
     */
    updateQcItem(qcItemUpdateDTO: QcItemUpdateDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/order-process-qc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(qcItemUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateQcItem(_response);
        });
    }

    protected processUpdateQcItem(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 判断质检情形
     * @param poProcessId poProcessId
     * @return OK
     */
    judge(poProcessId: string): Promise<number> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/order-process-qc/judge?";
        if (poProcessId === undefined || poProcessId === null)
            throw new Error("The parameter 'poProcessId' must be defined and cannot be null.");
        else
            url_ += "poProcessId=" + encodeURIComponent("" + poProcessId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processJudge(_response);
        });
    }

    protected processJudge(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * 分页查询质检记录
     * @param query query
     * @return OK
     */
    page(query: Query): Promise<IPageOfPageOrderProcessQcItemVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/order-process-qc/page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<IPageOfPageOrderProcessQcItemVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfPageOrderProcessQcItemVO.fromJS(resultData200) : new IPageOfPageOrderProcessQcItemVO();
            return result200;
        }
        return Promise.resolve<IPageOfPageOrderProcessQcItemVO>(<any>null);
    }
}

export class ProductionOrderProcessWorkStationRecordServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 添加报工记录的备注
     * @param recordRemarkDTO recordRemarkDTO
     * @return OK
     */
    addRecordRemark(recordRemarkDTO: RecordRemarkDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/order-record/add-remark";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recordRemarkDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddRecordRemark(_response);
        });
    }

    protected processAddRecordRemark(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 批量修改工单工序工位的工位产能
     * @param productionCapacities productionCapacities
     * @return OK
     */
    batchUpdate(productionCapacities: UpdateWorkStationProductionCapacityDTO[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/order-record/batch-update-workstation-capacity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionCapacities);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processBatchUpdate(_response);
        });
    }

    protected processBatchUpdate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 删除报工记录
     * @param recordId recordId
     * @return OK
     */
    deleteRecordReportWork(recordId: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/order-record/deleteRecord/{recordId}";
        if (recordId === undefined || recordId === null)
            throw new Error("The parameter 'recordId' must be defined.");
        url_ = url_.replace("{recordId}", encodeURIComponent("" + recordId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteRecordReportWork(_response);
        });
    }

    protected processDeleteRecordReportWork(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 报工历史导出Excel
     * @param bizType (optional) 业务类型-bizType
     * @param orderId (optional) 工单ID
     * @return OK
     */
    orderProcessRecordExcel(bizType: string | null | undefined, orderId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/order-record/export-record-list/{orderId}?";
        if (orderId !== null && orderId !== undefined)
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId)); 
        else
            url_ = url_.replace("/{orderId}", "");
        if (bizType !== undefined)
            url_ += "bizType=" + encodeURIComponent("" + bizType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processOrderProcessRecordExcel(_response);
        });
    }

    protected processOrderProcessRecordExcel(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取工单工序工位产能信息
     * @param orderId orderId
     * @return OK
     */
    getProcessWorkStationProductionCapacity(orderId: string): Promise<ProductionOrderProcessWorkStationVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/order-record/get-production-capacity/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProcessWorkStationProductionCapacity(_response);
        });
    }

    protected processGetProcessWorkStationProductionCapacity(response: AxiosResponse): Promise<ProductionOrderProcessWorkStationVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionOrderProcessWorkStationVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductionOrderProcessWorkStationVO[]>(<any>null);
    }

    /**
     * 手机端报工历史
     * @param dto dto
     * @return OK
     */
    listOrderProcessRecord(dto: ReportWorkHistoryDTO): Promise<ReportWorkHistoryVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/order-record/mobile/history/start-report-work";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListOrderProcessRecord(_response);
        });
    }

    protected processListOrderProcessRecord(response: AxiosResponse): Promise<ReportWorkHistoryVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportWorkHistoryVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ReportWorkHistoryVO[]>(<any>null);
    }

    /**
     * 手机端报工工位历史详情
     * @param dto dto
     * @return OK
     */
    getProcessWorkStationDetail(dto: ReportWorkHistoryDetailDTO): Promise<ReportWorkHistoryDetailVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/order-record/mobile/history/start-report-work/detail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProcessWorkStationDetail(_response);
        });
    }

    protected processGetProcessWorkStationDetail(response: AxiosResponse): Promise<ReportWorkHistoryDetailVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ReportWorkHistoryDetailVO.fromJS(resultData200) : new ReportWorkHistoryDetailVO();
            return result200;
        }
        return Promise.resolve<ReportWorkHistoryDetailVO>(<any>null);
    }

    /**
     * 根据工单工序id获取加工人员列表
     * @param orderProcessId orderProcessId
     * @return OK
     */
    getProcessMember(orderProcessId: string): Promise<string[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/order-record/producer/{orderProcessId}";
        if (orderProcessId === undefined || orderProcessId === null)
            throw new Error("The parameter 'orderProcessId' must be defined.");
        url_ = url_.replace("{orderProcessId}", encodeURIComponent("" + orderProcessId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProcessMember(_response);
        });
    }

    protected processGetProcessMember(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * 修改报工记录
     * @param orderProcessReportWorkDTO orderProcessReportWorkDTO
     * @return OK
     */
    updateRecordReportWork(orderProcessReportWorkDTO: OrderProcessReportWorkDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/order-record/updateRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderProcessReportWorkDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateRecordReportWork(_response);
        });
    }

    protected processUpdateRecordReportWork(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 根据工位报工记录id获取工位报废原因
     * @param recordId recordId
     * @return OK
     */
    workStationScrappedRecord(recordId: string): Promise<WorkStationScrappedRecordDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/order-record/workStation/scrapped/record?";
        if (recordId === undefined || recordId === null)
            throw new Error("The parameter 'recordId' must be defined and cannot be null.");
        else
            url_ += "recordId=" + encodeURIComponent("" + recordId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationScrappedRecord(_response);
        });
    }

    protected processWorkStationScrappedRecord(response: AxiosResponse): Promise<WorkStationScrappedRecordDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkStationScrappedRecordDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkStationScrappedRecordDTO[]>(<any>null);
    }

    /**
     * 报工历史
     * @param current (optional) 当前页
     * @param orderId orderId
     * @param size (optional) 每页的数量
     * @return OK
     */
    orderProcessRecord(current: number | null | undefined, orderId: string, size: number | null | undefined): Promise<IPageOfProductionOrderProcessWorkStationRecordVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/order-record/{orderId}?";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId)); 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processOrderProcessRecord(_response);
        });
    }

    protected processOrderProcessRecord(response: AxiosResponse): Promise<IPageOfProductionOrderProcessWorkStationRecordVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfProductionOrderProcessWorkStationRecordVO.fromJS(resultData200) : new IPageOfProductionOrderProcessWorkStationRecordVO();
            return result200;
        }
        return Promise.resolve<IPageOfProductionOrderProcessWorkStationRecordVO>(<any>null);
    }
}

export class PlanMaterialHmiServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 在制品入库
     * @param workInProcessInStockDTO workInProcessInStockDTO
     * @return OK
     */
    workInProgressInStock(workInProcessInStockDTO: WorkInProcessInStockDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/plan-material-hmi/in-stock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workInProcessInStockDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkInProgressInStock(_response);
        });
    }

    protected processWorkInProgressInStock(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 在制品入库的可入库数量
     * @param orderId orderId
     * @param orderProcessId orderProcessId
     * @return OK
     */
    workInProgressInStockNum(orderId: string, orderProcessId: string): Promise<number> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/plan-material-hmi/in-stock-num?";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined and cannot be null.");
        else
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        if (orderProcessId === undefined || orderProcessId === null)
            throw new Error("The parameter 'orderProcessId' must be defined and cannot be null.");
        else
            url_ += "orderProcessId=" + encodeURIComponent("" + orderProcessId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkInProgressInStockNum(_response);
        });
    }

    protected processWorkInProgressInStockNum(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * 物料需求hmi的列表
     * @param planOrderId (optional) 工单id
     * @param processCode (optional) 工序code
     * @return OK
     */
    planMaterialHmiList(planOrderId: string | null | undefined, processCode: string | null | undefined): Promise<PlanMaterialHmiVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/plan-material-hmi/list?";
        if (planOrderId !== undefined)
            url_ += "planOrderId=" + encodeURIComponent("" + planOrderId) + "&"; 
        if (processCode !== undefined)
            url_ += "processCode=" + encodeURIComponent("" + processCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPlanMaterialHmiList(_response);
        });
    }

    protected processPlanMaterialHmiList(response: AxiosResponse): Promise<PlanMaterialHmiVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanMaterialHmiVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<PlanMaterialHmiVO[]>(<any>null);
    }

    /**
     * 查询物料接收记录
     * @param orderId orderId
     * @return OK
     */
    materialReceiveRecordList(orderId: string): Promise<MaterialReceiveRecordVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/plan-material-hmi/list/material-receive-record?";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined and cannot be null.");
        else
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMaterialReceiveRecordList(_response);
        });
    }

    protected processMaterialReceiveRecordList(response: AxiosResponse): Promise<MaterialReceiveRecordVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialReceiveRecordVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<MaterialReceiveRecordVO[]>(<any>null);
    }

    /**
     * 新增缺料呼叫
     * @param materialCallRecordDTO materialCallRecordDTO
     * @return OK
     */
    saveMaterialCallRecord(materialCallRecordDTO: MaterialCallRecordDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/plan-material-hmi/save/material-call-record";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(materialCallRecordDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveMaterialCallRecord(_response);
        });
    }

    protected processSaveMaterialCallRecord(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 新增物料接收记录
     * @param materialReceiveRecordDTO materialReceiveRecordDTO
     * @return OK
     */
    saveMaterialReceiveRecord(materialReceiveRecordDTO: MaterialReceiveRecordDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/plan-material-hmi/save/material-receive-record";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(materialReceiveRecordDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveMaterialReceiveRecord(_response);
        });
    }

    protected processSaveMaterialReceiveRecord(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class PlanMaterialServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 修改物料需求数量
     * @param planMaterialsDTO (optional) 物料列表
     * @return OK
     */
    updateMaterialRequireNum(planMaterialsDTO: PlanMaterialDTO[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/plan-material/require-num";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(planMaterialsDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateMaterialRequireNum(_response);
        });
    }

    protected processUpdateMaterialRequireNum(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 物料需求的关闭/重启按钮
     * @param planMaterialStatusDTO planMaterialStatusDTO
     * @return OK
     */
    shutdownAndRestartMaterial(planMaterialStatusDTO: PlanMaterialStatusDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/plan-material/update-status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(planMaterialStatusDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processShutdownAndRestartMaterial(_response);
        });
    }

    protected processShutdownAndRestartMaterial(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 物料需求清单列表
     * @param filter (optional) 
     * @param planId (optional) 计划ID
     * @return OK
     */
    materialList(filter: string | null | undefined, planId: string | null | undefined): Promise<PlanMaterialVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/plan-material/{planId}/list?";
        if (planId !== null && planId !== undefined)
        url_ = url_.replace("{planId}", encodeURIComponent("" + planId)); 
        else
            url_ = url_.replace("/{planId}", "");
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMaterialList(_response);
        });
    }

    protected processMaterialList(response: AxiosResponse): Promise<PlanMaterialVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanMaterialVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<PlanMaterialVO[]>(<any>null);
    }
}

export class PlanProcessMaterialServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 物料需求清单下表
     * @param id id
     * @return OK
     */
    materialList(id: string): Promise<PlanProcessMaterialVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/plan-process-material/plan-material-list?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMaterialList(_response);
        });
    }

    protected processMaterialList(response: AxiosResponse): Promise<PlanProcessMaterialVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanProcessMaterialVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<PlanProcessMaterialVO[]>(<any>null);
    }
}

export class ProductionCardServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 获取计划加工中和完工数量
     * @return OK
     */
    getCardInfo(): Promise<WorkingBO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-card";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCardInfo(_response);
        });
    }

    protected processGetCardInfo(response: AxiosResponse): Promise<WorkingBO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkingBO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkingBO[]>(<any>null);
    }

    /**
     * 人员绩效卡片
     * @return OK
     */
    employeePerformanceCardList(): Promise<EmployeePerformanceCardVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-card/employee-performance-card";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEmployeePerformanceCardList(_response);
        });
    }

    protected processEmployeePerformanceCardList(response: AxiosResponse): Promise<EmployeePerformanceCardVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeePerformanceCardVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<EmployeePerformanceCardVO[]>(<any>null);
    }

    /**
     * 获取当前未完工计划
     * @return OK
     */
    getUnfinishedPlan(): Promise<ProductionPlanCardVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-card/unfinished-plan";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetUnfinishedPlan(_response);
        });
    }

    protected processGetUnfinishedPlan(response: AxiosResponse): Promise<ProductionPlanCardVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionPlanCardVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductionPlanCardVO[]>(<any>null);
    }
}

export class ProductionOrderServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 工单删除
     * @param orderIds 工单Id字符串集合
     * @return OK
     */
    deleteOrder(orderIds: string[]): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order?";
        if (orderIds === undefined || orderIds === null)
            throw new Error("The parameter 'orderIds' must be defined and cannot be null.");
        else
            orderIds && orderIds.forEach(item => { url_ += "orderIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteOrder(_response);
        });
    }

    protected processDeleteOrder(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 批量工单派发
     * @param planIds (optional) 计划Ids
     * @return OK
     */
    assignPlanBatch(planIds: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order/assign-batch/{planIds}";
        if (planIds !== null && planIds !== undefined)
        url_ = url_.replace("{planIds}", encodeURIComponent("" + planIds)); 
        else
            url_ = url_.replace("/{planIds}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAssignPlanBatch(_response);
        });
    }

    protected processAssignPlanBatch(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 获取工艺流转卡
     * @param orderId orderId
     * @return OK
     */
    getCraftCard(orderId: string): Promise<CraftCardBO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order/getCraftCard/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCraftCard(_response);
        });
    }

    protected processGetCraftCard(response: AxiosResponse): Promise<CraftCardBO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? CraftCardBO.fromJS(resultData200) : new CraftCardBO();
            return result200;
        }
        return Promise.resolve<CraftCardBO>(<any>null);
    }

    /**
     * 工序列表
     * @param dto dto
     * @return OK
     */
    getOrderProcessByPlanType(dto: ProductionOrderProcessMobileDTO): Promise<OrderProcessOutVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order/mobile/processList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetOrderProcessByPlanType(_response);
        });
    }

    protected processGetOrderProcessByPlanType(response: AxiosResponse): Promise<OrderProcessOutVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderProcessOutVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<OrderProcessOutVO[]>(<any>null);
    }

    /**
     * 工单详情
     * @param poId (optional) 工单Id
     * @return OK
     */
    orderDetailByProcessId(poId: string | null | undefined): Promise<ProductionOrderOutVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order/mobile/{poId}/list";
        if (poId !== null && poId !== undefined)
        url_ = url_.replace("{poId}", encodeURIComponent("" + poId)); 
        else
            url_ = url_.replace("/{poId}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processOrderDetailByProcessId(_response);
        });
    }

    protected processOrderDetailByProcessId(response: AxiosResponse): Promise<ProductionOrderOutVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ProductionOrderOutVO.fromJS(resultData200) : new ProductionOrderOutVO();
            return result200;
        }
        return Promise.resolve<ProductionOrderOutVO>(<any>null);
    }

    /**
     * 获取工单工序信息列表
     * @param orderId 工单Id
     * @return OK
     */
    getOrderProcessInfoList(orderId: string): Promise<ProductionOrderProcessWorkStationDTO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order/order-process-info/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetOrderProcessInfoList(_response);
        });
    }

    protected processGetOrderProcessInfoList(response: AxiosResponse): Promise<ProductionOrderProcessWorkStationDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ProductionOrderProcessWorkStationDTO.fromJS(resultData200) : new ProductionOrderProcessWorkStationDTO();
            return result200;
        }
        return Promise.resolve<ProductionOrderProcessWorkStationDTO>(<any>null);
    }

    /**
     * 编辑工单工位
     * @param productionOrderWorkStationDTO productionOrderWorkStationDTO
     * @return OK
     */
    updateOrderWorkStation(productionOrderWorkStationDTO: ProductionOrderWorkStationDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order/update-order-work-station";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionOrderWorkStationDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateOrderWorkStation(_response);
        });
    }

    protected processUpdateOrderWorkStation(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 微信小程序开报工的工序列表
     * @param dto dto
     * @return OK
     */
    getOrderProcessByPlanTypeWeiXin(dto: ProductionOrderProcessWeiXinDTO): Promise<OrderProcessOutVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order/weChart/processList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetOrderProcessByPlanTypeWeiXin(_response);
        });
    }

    protected processGetOrderProcessByPlanTypeWeiXin(response: AxiosResponse): Promise<OrderProcessOutVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderProcessOutVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<OrderProcessOutVO[]>(<any>null);
    }

    /**
     * 完成工单
     * @param id (optional) 工单Id
     * @return OK
     */
    completeMultiModeOrder(id: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order/{id}/complete-multi-mode-order";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCompleteMultiModeOrder(_response);
        });
    }

    protected processCompleteMultiModeOrder(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 工单工序列表
     * @param orderId 工单Id
     * @return OK
     */
    processList(orderId: string): Promise<OrderProcessOutDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order/{orderId}/processList";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processProcessList(_response);
        });
    }

    protected processProcessList(response: AxiosResponse): Promise<OrderProcessOutDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderProcessOutDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<OrderProcessOutDTO[]>(<any>null);
    }

    /**
     * 工单派发
     * @param planId 计划Id
     * @param productionOrderDTO productionOrderDTO
     * @return OK
     */
    assignPlan(planId: string, productionOrderDTO: ProductionOrderDTO): Promise<ProductionOrder> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order/{planId}/assign";
        if (planId === undefined || planId === null)
            throw new Error("The parameter 'planId' must be defined.");
        url_ = url_.replace("{planId}", encodeURIComponent("" + planId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionOrderDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAssignPlan(_response);
        });
    }

    protected processAssignPlan(response: AxiosResponse): Promise<ProductionOrder> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ProductionOrder.fromJS(resultData200) : new ProductionOrder();
            return result200;
        }
        return Promise.resolve<ProductionOrder>(<any>null);
    }

    /**
     * 工单列表
     * @param planId 计划Id
     * @return OK
     */
    orderLis(planId: string): Promise<ProductionOrderOutDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order/{planId}/list";
        if (planId === undefined || planId === null)
            throw new Error("The parameter 'planId' must be defined.");
        url_ = url_.replace("{planId}", encodeURIComponent("" + planId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processOrderLis(_response);
        });
    }

    protected processOrderLis(response: AxiosResponse): Promise<ProductionOrderOutDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionOrderOutDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductionOrderOutDTO[]>(<any>null);
    }
}

export class ProductionOrderProcessAssignRecordServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 保存工单工序派发记录
     * @param processAssignDTO processAssignDTO
     * @return OK
     */
    saveProcessAssignRecord(processAssignDTO: ProcessAssignDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order-process-assign-record";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(processAssignDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveProcessAssignRecord(_response);
        });
    }

    protected processSaveProcessAssignRecord(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 派工调整
     * @param assignRecordUpdateDTO assignRecordUpdateDTO
     * @return OK
     */
    updateAssignRecord(assignRecordUpdateDTO: AssignRecordUpdateDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order-process-assign-record";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignRecordUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateAssignRecord(_response);
        });
    }

    protected processUpdateAssignRecord(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 根据工序，工位查询员工
     * @param poProcessId poProcessId
     * @param workStationId workStationId
     * @return OK
     */
    getOpenEmployee(poProcessId: string, workStationId: string): Promise<EmployeeInfoBO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order-process-assign-record/employee?";
        if (poProcessId === undefined || poProcessId === null)
            throw new Error("The parameter 'poProcessId' must be defined and cannot be null.");
        else
            url_ += "poProcessId=" + encodeURIComponent("" + poProcessId) + "&"; 
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined and cannot be null.");
        else
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetOpenEmployee(_response);
        });
    }

    protected processGetOpenEmployee(response: AxiosResponse): Promise<EmployeeInfoBO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeInfoBO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<EmployeeInfoBO[]>(<any>null);
    }

    /**
     * 根据工序、工位、人员查询待报工数量
     * @param employeeId (optional) 员工id
     * @param poProcessId (optional) 工单工序id
     * @param workStationId (optional) 工位id
     * @return OK
     */
    employeeUnReportNum(employeeId: string | null | undefined, poProcessId: string | null | undefined, workStationId: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order-process-assign-record/employee/unreport-num?";
        if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&"; 
        if (poProcessId !== undefined)
            url_ += "poProcessId=" + encodeURIComponent("" + poProcessId) + "&"; 
        if (workStationId !== undefined)
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEmployeeUnReportNum(_response);
        });
    }

    protected processEmployeeUnReportNum(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * 根据条件查询派发记录
     * @param assignRecordSearchDTO assignRecordSearchDTO
     * @return OK
     */
    getAssignRecordList(assignRecordSearchDTO: AssignRecordSearchDTO): Promise<AssignRecordOutDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order-process-assign-record/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignRecordSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAssignRecordList(_response);
        });
    }

    protected processGetAssignRecordList(response: AxiosResponse): Promise<AssignRecordOutDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssignRecordOutDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<AssignRecordOutDTO[]>(<any>null);
    }

    /**
     * 查询派发记录详情
     * @param id id
     * @return OK
     */
    getAssignRecord(id: string): Promise<ProcessDetailDTO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order-process-assign-record/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAssignRecord(_response);
        });
    }

    protected processGetAssignRecord(response: AxiosResponse): Promise<ProcessDetailDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ProcessDetailDTO.fromJS(resultData200) : new ProcessDetailDTO();
            return result200;
        }
        return Promise.resolve<ProcessDetailDTO>(<any>null);
    }

    /**
     * 删除派工记录
     * @param id id
     * @return OK
     */
    deleteAssignRecord(id: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order-process-assign-record/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteAssignRecord(_response);
        });
    }

    protected processDeleteAssignRecord(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class ProductionOrderProcessAssignServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 根据条件查询工序派工概况
     * @param assignSearchDTO assignSearchDTO
     * @return OK
     */
    getAssignList(assignSearchDTO: AssignSearchDTO): Promise<AssignOutDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order-process-assign/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAssignList(_response);
        });
    }

    protected processGetAssignList(response: AxiosResponse): Promise<AssignOutDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssignOutDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<AssignOutDTO[]>(<any>null);
    }

    /**
     * 根据工位查询工序派工概况
     * @param workStationId workStationId
     * @return OK
     */
    getAssignListByWorkStation(workStationId: string): Promise<WorkStationAssignOutDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order-process-assign/work-station?";
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined and cannot be null.");
        else
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAssignListByWorkStation(_response);
        });
    }

    protected processGetAssignListByWorkStation(response: AxiosResponse): Promise<WorkStationAssignOutDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkStationAssignOutDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkStationAssignOutDTO[]>(<any>null);
    }
}

export class ProductionOrderProcessServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 工序工位详情
     * @param processId processId
     * @return OK
     */
    getProcessDetail(processId: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order-process/getProcessDetail/{processId}";
        if (processId === undefined || processId === null)
            throw new Error("The parameter 'processId' must be defined.");
        url_ = url_.replace("{processId}", encodeURIComponent("" + processId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProcessDetail(_response);
        });
    }

    protected processGetProcessDetail(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 工位生产日历
     * @param stationCalendarDTO stationCalendarDTO
     * @return OK
     */
    getWorkstationDetailByWorkStationId(stationCalendarDTO: StationCalendarDTO): Promise<StationProductionCalendarVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order-process/getWorkstationCalendar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stationCalendarDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkstationDetailByWorkStationId(_response);
        });
    }

    protected processGetWorkstationDetailByWorkStationId(response: AxiosResponse): Promise<StationProductionCalendarVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StationProductionCalendarVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<StationProductionCalendarVO[]>(<any>null);
    }

    /**
     * 手机端工序工位详情
     * @param processId processId
     * @param type (optional) type
     * @return OK
     * @deprecated
     */
    getProcessDetailById(processId: string, type: number | null | undefined): Promise<OrderProcessWorkDetailVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order-process/mobile/getProcessDetail/{processId}?";
        if (processId === undefined || processId === null)
            throw new Error("The parameter 'processId' must be defined.");
        url_ = url_.replace("{processId}", encodeURIComponent("" + processId)); 
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProcessDetailById(_response);
        });
    }

    protected processGetProcessDetailById(response: AxiosResponse): Promise<OrderProcessWorkDetailVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? OrderProcessWorkDetailVO.fromJS(resultData200) : new OrderProcessWorkDetailVO();
            return result200;
        }
        return Promise.resolve<OrderProcessWorkDetailVO>(<any>null);
    }

    /**
     * 工序派工需要的信息
     * @param id (optional) 工单工序id
     * @return OK
     */
    processAssignInfo(id: string | null | undefined): Promise<ProcessAssignInfoVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order-process/process-assign/info/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processProcessAssignInfo(_response);
        });
    }

    protected processProcessAssignInfo(response: AxiosResponse): Promise<ProcessAssignInfoVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ProcessAssignInfoVO.fromJS(resultData200) : new ProcessAssignInfoVO();
            return result200;
        }
        return Promise.resolve<ProcessAssignInfoVO>(<any>null);
    }

    /**
     * 工序派工工单工序列表
     * @param processAssignSearchDTO processAssignSearchDTO
     * @return OK
     */
    processAssignList(processAssignSearchDTO: ProcessAssignSearchDTO): Promise<ProcessAssignListVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order-process/process-assign/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(processAssignSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processProcessAssignList(_response);
        });
    }

    protected processProcessAssignList(response: AxiosResponse): Promise<ProcessAssignListVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcessAssignListVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProcessAssignListVO[]>(<any>null);
    }

    /**
     * 工序工位报工
     * @param reportWorkDTOList reportWorkDTOList
     * @return OK
     */
    reportWork(reportWorkDTOList: OrderProcessReportWorkDTO[]): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order-process/reportWork";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportWorkDTOList);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processReportWork(_response);
        });
    }

    protected processReportWork(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 工序工位开工
     * @param startWorkDTOList startWorkDTOList
     * @return OK
     */
    startWork(startWorkDTOList: OrderProcessStartWorkDTO[]): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order-process/startWork";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(startWorkDTOList);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processStartWork(_response);
        });
    }

    protected processStartWork(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 微信小程序工序工位详情
     * @param processId processId
     * @return OK
     */
    getProcessDetailByIdWeChart(processId: string): Promise<OrderProcessWorkDetailVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order-process/weChart/getProcessDetail/{processId}";
        if (processId === undefined || processId === null)
            throw new Error("The parameter 'processId' must be defined.");
        url_ = url_.replace("{processId}", encodeURIComponent("" + processId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProcessDetailByIdWeChart(_response);
        });
    }

    protected processGetProcessDetailByIdWeChart(response: AxiosResponse): Promise<OrderProcessWorkDetailVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? OrderProcessWorkDetailVO.fromJS(resultData200) : new OrderProcessWorkDetailVO();
            return result200;
        }
        return Promise.resolve<OrderProcessWorkDetailVO>(<any>null);
    }

    /**
     * 工单工序详情
     * @param processId (optional) 工单工序Id
     * @return OK
     */
    processDetail(processId: string | null | undefined): Promise<OrderProcessDetailDTO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-order-process/{processId}";
        if (processId !== null && processId !== undefined)
        url_ = url_.replace("{processId}", encodeURIComponent("" + processId)); 
        else
            url_ = url_.replace("/{processId}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processProcessDetail(_response);
        });
    }

    protected processProcessDetail(response: AxiosResponse): Promise<OrderProcessDetailDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? OrderProcessDetailDTO.fromJS(resultData200) : new OrderProcessDetailDTO();
            return result200;
        }
        return Promise.resolve<OrderProcessDetailDTO>(<any>null);
    }
}

export class ProductionPlanServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 创建生产计划
     * @param productionPlanSaveDTO productionPlanSaveDTO
     * @return OK
     */
    save(productionPlanSaveDTO: ProductionPlanSaveDTO): Promise<ProductionPlan> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionPlanSaveDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<ProductionPlan> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ProductionPlan.fromJS(resultData200) : new ProductionPlan();
            return result200;
        }
        return Promise.resolve<ProductionPlan>(<any>null);
    }

    /**
     * 更新生产计划
     * @param productionPlanSaveDTO productionPlanSaveDTO
     * @return OK
     */
    update(productionPlanSaveDTO: ProductionPlanSaveDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionPlanSaveDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 删除生产或者来料计划
     * @param productionPlanIds productionPlanIds
     * @return OK
     */
    delete(productionPlanIds: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionPlanIds);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 追加生产计划
     * @param additionPlanDTO additionPlanDTO
     * @param planId planId
     * @return OK
     */
    additionalPlan(additionPlanDTO: AdditionPlanDTO, planId: string): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan/additionalPlan?";
        if (planId === undefined || planId === null)
            throw new Error("The parameter 'planId' must be defined and cannot be null.");
        else
            url_ += "planId=" + encodeURIComponent("" + planId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(additionPlanDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAdditionalPlan(_response);
        });
    }

    protected processAdditionalPlan(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 查询所有计划编号
     * @return OK
     */
    productCodeList(): Promise<string[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan/all-product-code-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processProductCodeList(_response);
        });
    }

    protected processProductCodeList(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * 根据计划类型查询生产计划
     * @param typeId typeId
     * @return OK
     */
    getByCategory(typeId: string): Promise<ProductionPlanBO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan/getByTypeId?";
        if (typeId === undefined || typeId === null)
            throw new Error("The parameter 'typeId' must be defined and cannot be null.");
        else
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetByCategory(_response);
        });
    }

    protected processGetByCategory(response: AxiosResponse): Promise<ProductionPlanBO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionPlanBO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductionPlanBO[]>(<any>null);
    }

    /**
     * 查询来料计划信息
     * @param planId planId
     * @return OK
     */
    getIncomingPlan(planId: string): Promise<IncomingPlanBO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan/getIncomingPlan?";
        if (planId === undefined || planId === null)
            throw new Error("The parameter 'planId' must be defined and cannot be null.");
        else
            url_ += "planId=" + encodeURIComponent("" + planId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIncomingPlan(_response);
        });
    }

    protected processGetIncomingPlan(response: AxiosResponse): Promise<IncomingPlanBO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IncomingPlanBO.fromJS(resultData200) : new IncomingPlanBO();
            return result200;
        }
        return Promise.resolve<IncomingPlanBO>(<any>null);
    }

    /**
     * 计划类型获取产品列表
     * @param planTypeId planTypeId
     * @return OK
     */
    getProduct(planTypeId: string): Promise<ProductDictDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan/getProduct?";
        if (planTypeId === undefined || planTypeId === null)
            throw new Error("The parameter 'planTypeId' must be defined and cannot be null.");
        else
            url_ += "planTypeId=" + encodeURIComponent("" + planTypeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProduct(_response);
        });
    }

    protected processGetProduct(response: AxiosResponse): Promise<ProductDictDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductDictDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductDictDTO[]>(<any>null);
    }

    /**
     * 查询资源文件信息
     * @param resourceId resourceId
     * @return OK
     */
    getResourceFile(resourceId: string): Promise<FileDetailInfoVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan/getResourceFile?";
        if (resourceId === undefined || resourceId === null)
            throw new Error("The parameter 'resourceId' must be defined and cannot be null.");
        else
            url_ += "resourceId=" + encodeURIComponent("" + resourceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetResourceFile(_response);
        });
    }

    protected processGetResourceFile(response: AxiosResponse): Promise<FileDetailInfoVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDetailInfoVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<FileDetailInfoVO[]>(<any>null);
    }

    /**
     * 查询生产计划工序未完成数量
     * @param id (optional) 生产计划Id
     * @return OK
     */
    incompleteList(id: string | null | undefined): Promise<IncompletePlanDTO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan/incomplete-list/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processIncompleteList(_response);
        });
    }

    protected processIncompleteList(response: AxiosResponse): Promise<IncompletePlanDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IncompletePlanDTO.fromJS(resultData200) : new IncompletePlanDTO();
            return result200;
        }
        return Promise.resolve<IncompletePlanDTO>(<any>null);
    }

    /**
     * 分页查询生产或者来料计划
     * @param current (optional) 当前页
     * @param productionPlanSearchDTO productionPlanSearchDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    page(current: number | null | undefined, productionPlanSearchDTO: ProductionPlanSearchDTO, size: number | null | undefined): Promise<IPageOfPageProductionPlanBO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionPlanSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<IPageOfPageProductionPlanBO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfPageProductionPlanBO.fromJS(resultData200) : new IPageOfPageProductionPlanBO();
            return result200;
        }
        return Promise.resolve<IPageOfPageProductionPlanBO>(<any>null);
    }

    /**
     * 查询计划以及成品物料
     * @return OK
     */
    productMaterials(): Promise<ProductMaterialVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan/product-material";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processProductMaterials(_response);
        });
    }

    protected processProductMaterials(response: AxiosResponse): Promise<ProductMaterialVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductMaterialVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductMaterialVO[]>(<any>null);
    }

    /**
     * 保存来料计划
     * @param productionPlanDTO productionPlanDTO
     * @return OK
     */
    saveInComingPlan(productionPlanDTO: ProductionPlanDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan/saveInComingPlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionPlanDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveInComingPlan(_response);
        });
    }

    protected processSaveInComingPlan(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 上传文件
     * @param fileUploadDTO fileUploadDTO
     * @return OK
     */
    upLoadFile(fileUploadDTO: FileUploadDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan/uploadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileUploadDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpLoadFile(_response);
        });
    }

    protected processUpLoadFile(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 获取单条生产或者来料计划
     * @param id id
     * @return OK
     */
    detail(id: string): Promise<ProductionPlan> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: AxiosResponse): Promise<ProductionPlan> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ProductionPlan.fromJS(resultData200) : new ProductionPlan();
            return result200;
        }
        return Promise.resolve<ProductionPlan>(<any>null);
    }

    /**
     * 关闭生产计划
     * @param id (optional) 生产计划Id
     * @return OK
     */
    closePlan(id: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan/{id}/close";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processClosePlan(_response);
        });
    }

    protected processClosePlan(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 完成生产计划
     * @param id (optional) 生产计划Id
     * @return OK
     */
    completePlan(id: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan/{id}/complete";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCompletePlan(_response);
        });
    }

    protected processCompletePlan(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 暂停生产计划
     * @param id (optional) 生产计划Id
     * @return OK
     */
    pausePlan(id: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan/{id}/pause";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPausePlan(_response);
        });
    }

    protected processPausePlan(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 重启生产计划
     * @param id (optional) 生产计划Id
     * @return OK
     */
    restartPlan(id: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan/{id}/restart";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRestartPlan(_response);
        });
    }

    protected processRestartPlan(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ProductionPlanExcelServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 导出生产计划
     * @param productionPlanExcelExportDTO productionPlanExcelExportDTO
     * @return OK
     */
    exportProductionPlan(productionPlanExcelExportDTO: ProductionPlanExcelExportDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan-excel/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionPlanExcelExportDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportProductionPlan(_response);
        });
    }

    protected processExportProductionPlan(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出来料计划模板
     * @param bizDataId bizDataId
     * @return OK
     */
    exportIncomingPlanTemplate(bizDataId: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan-excel/export/incoming-plan/template?";
        if (bizDataId === undefined || bizDataId === null)
            throw new Error("The parameter 'bizDataId' must be defined and cannot be null.");
        else
            url_ += "bizDataId=" + encodeURIComponent("" + bizDataId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportIncomingPlanTemplate(_response);
        });
    }

    protected processExportIncomingPlanTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出生产计划模板
     * @param bizDataId bizDataId
     * @return OK
     */
    exportProductionPlanTemplate(bizDataId: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan-excel/export/production-plan/template?";
        if (bizDataId === undefined || bizDataId === null)
            throw new Error("The parameter 'bizDataId' must be defined and cannot be null.");
        else
            url_ += "bizDataId=" + encodeURIComponent("" + bizDataId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportProductionPlanTemplate(_response);
        });
    }

    protected processExportProductionPlanTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导入来料计划
     * @param file (optional) file
     * @param typeId (optional) typeId
     * @return OK
     */
    importIncomingPlan(file: FileParameter | null | undefined, typeId: string | null | undefined): Promise<ProductionPlanExportResult> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan-excel/import/incoming-plan?";
        if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportIncomingPlan(_response);
        });
    }

    protected processImportIncomingPlan(response: AxiosResponse): Promise<ProductionPlanExportResult> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ProductionPlanExportResult.fromJS(resultData200) : new ProductionPlanExportResult();
            return result200;
        }
        return Promise.resolve<ProductionPlanExportResult>(<any>null);
    }

    /**
     * 导入生产计划
     * @param file (optional) file
     * @param typeId (optional) typeId
     * @return OK
     */
    importProductionPlan(file: FileParameter | null | undefined, typeId: string | null | undefined): Promise<ProductionPlanExportResult> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan-excel/import/production-plan?";
        if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportProductionPlan(_response);
        });
    }

    protected processImportProductionPlan(response: AxiosResponse): Promise<ProductionPlanExportResult> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ProductionPlanExportResult.fromJS(resultData200) : new ProductionPlanExportResult();
            return result200;
        }
        return Promise.resolve<ProductionPlanExportResult>(<any>null);
    }
}

export class ProductionPlanProcessServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 批量保存自定义工序
     * @param list list
     * @return OK
     */
    submit(list: ProductionPlanProcessDTO[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan-process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(list);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 编辑自定义工序
     * @param productionPlanProcessDTO productionPlanProcessDTO
     * @return OK
     */
    update(productionPlanProcessDTO: ProductionPlanProcessDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan-process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionPlanProcessDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 删除自定义工序
     * @param id id
     * @return OK
     */
    delete(id: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan-process/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 获取自定义工序列表
     * @param planId planId
     * @return OK
     */
    getProductionProcessList(planId: string): Promise<ProductionPlanProcessBO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan-process/getProductionProcessList/{planId}";
        if (planId === undefined || planId === null)
            throw new Error("The parameter 'planId' must be defined.");
        url_ = url_.replace("{planId}", encodeURIComponent("" + planId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProductionProcessList(_response);
        });
    }

    protected processGetProductionProcessList(response: AxiosResponse): Promise<ProductionPlanProcessBO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionPlanProcessBO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductionPlanProcessBO[]>(<any>null);
    }
}

export class ProductionPlanTypeServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 获取计划类型关联的产品类型
     * @return OK
     */
    getProductionPlanTypeInfo(): Promise<ProductionPlanTypeInfoVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan-type";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProductionPlanTypeInfo(_response);
        });
    }

    protected processGetProductionPlanTypeInfo(response: AxiosResponse): Promise<ProductionPlanTypeInfoVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionPlanTypeInfoVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductionPlanTypeInfoVO[]>(<any>null);
    }

    /**
     * 获取计划的语言信息
     * @param id id
     * @return OK
     */
    getCurrentTypeInfo(id: string): Promise<CurrentTypeInfoVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan-type/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCurrentTypeInfo(_response);
        });
    }

    protected processGetCurrentTypeInfo(response: AxiosResponse): Promise<CurrentTypeInfoVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? CurrentTypeInfoVO.fromJS(resultData200) : new CurrentTypeInfoVO();
            return result200;
        }
        return Promise.resolve<CurrentTypeInfoVO>(<any>null);
    }
}

export class ProductionPlanTypeProductTypeServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 保存计划类型和产品类型关联关系
     * @param productionPlanTypeProductTypeDTO productionPlanTypeProductTypeDTO
     * @return OK
     */
    saveProductionTypeProductType(productionPlanTypeProductTypeDTO: ProductionPlanTypeProductTypeDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan-type-product-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionPlanTypeProductTypeDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveProductionTypeProductType(_response);
        });
    }

    protected processSaveProductionTypeProductType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 保存计划类型和产品类型多语言
     * @param productionPlanSettingDTO productionPlanSettingDTO
     * @return OK
     */
    insertProductionTypeProductTypeLanguage(productionPlanSettingDTO: ProductionPlanSettingDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan-type-product-type/insert-production-type-language";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionPlanSettingDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processInsertProductionTypeProductTypeLanguage(_response);
        });
    }

    protected processInsertProductionTypeProductTypeLanguage(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 根据计划类型ID获取产品类型ID
     * @param planTypeId planTypeId
     * @return OK
     */
    getProductTypeIds(planTypeId: string): Promise<string[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan-type-product-type/{planTypeId}";
        if (planTypeId === undefined || planTypeId === null)
            throw new Error("The parameter 'planTypeId' must be defined.");
        url_ = url_.replace("{planTypeId}", encodeURIComponent("" + planTypeId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProductTypeIds(_response);
        });
    }

    protected processGetProductTypeIds(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * 根据计划类型ID获取产品类型集合
     * @param planTypeId planTypeId
     * @return OK
     */
    getProductTypeList(planTypeId: string): Promise<ProductTypeVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan-type-product-type/{planTypeId}/list";
        if (planTypeId === undefined || planTypeId === null)
            throw new Error("The parameter 'planTypeId' must be defined.");
        url_ = url_.replace("{planTypeId}", encodeURIComponent("" + planTypeId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProductTypeList(_response);
        });
    }

    protected processGetProductTypeList(response: AxiosResponse): Promise<ProductTypeVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductTypeVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductTypeVO[]>(<any>null);
    }

    /**
     * 获取已定版工艺的产品
     * @param planTypeId planTypeId
     * @return OK
     */
    getProductFixCraftVersion(planTypeId: string): Promise<ProductFixCraftVersionDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-plan-type-product-type/{planTypeId}/products";
        if (planTypeId === undefined || planTypeId === null)
            throw new Error("The parameter 'planTypeId' must be defined.");
        url_ = url_.replace("{planTypeId}", encodeURIComponent("" + planTypeId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProductFixCraftVersion(_response);
        });
    }

    protected processGetProductFixCraftVersion(response: AxiosResponse): Promise<ProductFixCraftVersionDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductFixCraftVersionDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductFixCraftVersionDTO[]>(<any>null);
    }
}

export class ProductionStatisticsExcelServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 导出生产计划员工绩效
     * @param bizCode (optional) 业务数据
     * @param bizDataId (optional) 业务数据ID
     * @param current (optional) 当前页
     * @param productionPlanSearchDTO productionPlanSearchDTO
     * @param size (optional) 每页的数量
     * @param tenantId (optional) 租户Id
     * @return OK
     */
    getPageEmployeePerformance(bizCode: string | null | undefined, bizDataId: string | null | undefined, current: number | null | undefined, productionPlanSearchDTO: ProductionPlanSearchDTO, size: number | null | undefined, tenantId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-statistics-excel/export-plan-employee-performance?";
        if (bizCode !== undefined)
            url_ += "bizCode=" + encodeURIComponent("" + bizCode) + "&"; 
        if (bizDataId !== undefined)
            url_ += "bizDataId=" + encodeURIComponent("" + bizDataId) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionPlanSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageEmployeePerformance(_response);
        });
    }

    protected processGetPageEmployeePerformance(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出生产计划超期分析
     * @param bizCode (optional) 业务数据
     * @param bizDataId (optional) 业务数据ID
     * @param current (optional) 当前页
     * @param productionPlanSearchDTO productionPlanSearchDTO
     * @param size (optional) 每页的数量
     * @param tenantId (optional) 租户Id
     * @return OK
     */
    getProductionPlanOverdueAnalysis(bizCode: string | null | undefined, bizDataId: string | null | undefined, current: number | null | undefined, productionPlanSearchDTO: ProductionPlanSearchDTO, size: number | null | undefined, tenantId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-statistics-excel/export-plan-overdue?";
        if (bizCode !== undefined)
            url_ += "bizCode=" + encodeURIComponent("" + bizCode) + "&"; 
        if (bizDataId !== undefined)
            url_ += "bizDataId=" + encodeURIComponent("" + bizDataId) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionPlanSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProductionPlanOverdueAnalysis(_response);
        });
    }

    protected processGetProductionPlanOverdueAnalysis(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出计划工序分析
     * @param bizCode (optional) 业务数据
     * @param bizDataId (optional) 业务数据ID
     * @param current (optional) 当前页
     * @param productionPlanSearchDTO productionPlanSearchDTO
     * @param size (optional) 每页的数量
     * @param tenantId (optional) 租户Id
     * @return OK
     */
    getProductionProcessScheduleAnalysis(bizCode: string | null | undefined, bizDataId: string | null | undefined, current: number | null | undefined, productionPlanSearchDTO: ProductionPlanSearchDTO, size: number | null | undefined, tenantId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-statistics-excel/export-plan-process-schedule?";
        if (bizCode !== undefined)
            url_ += "bizCode=" + encodeURIComponent("" + bizCode) + "&"; 
        if (bizDataId !== undefined)
            url_ += "bizDataId=" + encodeURIComponent("" + bizDataId) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionPlanSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProductionProcessScheduleAnalysis(_response);
        });
    }

    protected processGetProductionProcessScheduleAnalysis(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出生产计划进度
     * @param bizCode (optional) 业务数据
     * @param bizDataId (optional) 业务数据ID
     * @param current (optional) 当前页
     * @param productionPlanSearchDTO productionPlanSearchDTO
     * @param size (optional) 每页的数量
     * @param tenantId (optional) 租户Id
     * @return OK
     */
    getProductionPlanScheduleAnalysis(bizCode: string | null | undefined, bizDataId: string | null | undefined, current: number | null | undefined, productionPlanSearchDTO: ProductionPlanSearchDTO, size: number | null | undefined, tenantId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-statistics-excel/export-plan-schedule?";
        if (bizCode !== undefined)
            url_ += "bizCode=" + encodeURIComponent("" + bizCode) + "&"; 
        if (bizDataId !== undefined)
            url_ += "bizDataId=" + encodeURIComponent("" + bizDataId) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionPlanSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProductionPlanScheduleAnalysis(_response);
        });
    }

    protected processGetProductionPlanScheduleAnalysis(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出生产综合统计-工位查询
     * @param productionStatisticsByWorkStationReportExcelDTO productionStatisticsByWorkStationReportExcelDTO
     * @return OK
     */
    getProductionStatisticByWorkStationsReport(productionStatisticsByWorkStationReportExcelDTO: ProductionStatisticsByWorkStationReportExcelDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-statistics-excel/export-production-statistic-by-work-station-report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionStatisticsByWorkStationReportExcelDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProductionStatisticByWorkStationsReport(_response);
        });
    }

    protected processGetProductionStatisticByWorkStationsReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出报废原因分析报表
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @param srappedReasonSearchDTO srappedReasonSearchDTO
     * @return OK
     */
    exportScrappedReasonSchedule(current: number | null | undefined, size: number | null | undefined, srappedReasonSearchDTO: SrappedReasonSearchDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-statistics-excel/export-scrapped-reason-report?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(srappedReasonSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportScrappedReasonSchedule(_response);
        });
    }

    protected processExportScrappedReasonSchedule(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出生产综合统计
     * @param bizCode (optional) 业务数据
     * @param bizDataId (optional) 业务数据ID
     * @param productionStatisticsReportExcelDTO productionStatisticsReportExcelDTO
     * @param tenantId (optional) 租户Id
     * @return OK
     */
    getPageProductionStatisticsReport(bizCode: string | null | undefined, bizDataId: string | null | undefined, productionStatisticsReportExcelDTO: ProductionStatisticsReportExcelDTO, tenantId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-statistics-excel/export_production-statistic-report?";
        if (bizCode !== undefined)
            url_ += "bizCode=" + encodeURIComponent("" + bizCode) + "&"; 
        if (bizDataId !== undefined)
            url_ += "bizDataId=" + encodeURIComponent("" + bizDataId) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionStatisticsReportExcelDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageProductionStatisticsReport(_response);
        });
    }

    protected processGetPageProductionStatisticsReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出工位生产日历报表
     * @param bizCode (optional) 业务数据
     * @param bizDataId (optional) 业务数据ID
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @param tenantId (optional) 租户Id
     * @param workStationCalendarReportDTO workStationCalendarReportDTO
     * @return OK
     */
    getPageWorkStationCalendarReport(bizCode: string | null | undefined, bizDataId: string | null | undefined, current: number | null | undefined, size: number | null | undefined, tenantId: string | null | undefined, workStationCalendarReportDTO: WorkStationCalendarReportDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-statistics-excel/export_workStation-calendar-report?";
        if (bizCode !== undefined)
            url_ += "bizCode=" + encodeURIComponent("" + bizCode) + "&"; 
        if (bizDataId !== undefined)
            url_ += "bizDataId=" + encodeURIComponent("" + bizDataId) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationCalendarReportDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageWorkStationCalendarReport(_response);
        });
    }

    protected processGetPageWorkStationCalendarReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 生产计划在制品统计
     * @param bizCode (optional) 业务数据
     * @param bizDataId (optional) 业务数据ID
     * @param current (optional) 当前页
     * @param productionPlanSearchDTO productionPlanSearchDTO
     * @param size (optional) 每页的数量
     * @param tenantId (optional) 租户Id
     * @return OK
     */
    getPagePlanWip(bizCode: string | null | undefined, bizDataId: string | null | undefined, current: number | null | undefined, productionPlanSearchDTO: ProductionPlanSearchDTO, size: number | null | undefined, tenantId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-statistics-excel/plan-wip/page?";
        if (bizCode !== undefined)
            url_ += "bizCode=" + encodeURIComponent("" + bizCode) + "&"; 
        if (bizDataId !== undefined)
            url_ += "bizDataId=" + encodeURIComponent("" + bizDataId) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionPlanSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPagePlanWip(_response);
        });
    }

    protected processGetPagePlanWip(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ProductionStatisticsServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 工序质检参数报表-下表
     * @param current (optional) 当前页
     * @param planId planId
     * @param size (optional) 每页的数量
     * @return OK
     */
    orderProcessQcReport(current: number | null | undefined, planId: string, size: number | null | undefined): Promise<IPageOfProcessReportVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-statistics/order-process-qc-report?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (planId === undefined || planId === null)
            throw new Error("The parameter 'planId' must be defined and cannot be null.");
        else
            url_ += "planId=" + encodeURIComponent("" + planId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processOrderProcessQcReport(_response);
        });
    }

    protected processOrderProcessQcReport(response: AxiosResponse): Promise<IPageOfProcessReportVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfProcessReportVO.fromJS(resultData200) : new IPageOfProcessReportVO();
            return result200;
        }
        return Promise.resolve<IPageOfProcessReportVO>(<any>null);
    }

    /**
     * 工单工序分析
     * @param current (optional) 当前页
     * @param productionOrderProcessSearchDTO productionOrderProcessSearchDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    getProductionOrderProcessScheduleAnalysis(current: number | null | undefined, productionOrderProcessSearchDTO: ProductionOrderProcessSearchDTO, size: number | null | undefined): Promise<ProductionOrderProcessScheduleVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-statistics/order-process-schedule?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionOrderProcessSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProductionOrderProcessScheduleAnalysis(_response);
        });
    }

    protected processGetProductionOrderProcessScheduleAnalysis(response: AxiosResponse): Promise<ProductionOrderProcessScheduleVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionOrderProcessScheduleVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductionOrderProcessScheduleVO[]>(<any>null);
    }

    /**
     * 工单工序在制品统计
     * @param planId (optional) 计划Id
     * @return OK
     */
    orderProcessWip(planId: string | null | undefined): Promise<OrderProcessWipDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-statistics/order-process-wip/{planId}";
        if (planId !== null && planId !== undefined)
        url_ = url_.replace("{planId}", encodeURIComponent("" + planId)); 
        else
            url_ = url_.replace("/{planId}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processOrderProcessWip(_response);
        });
    }

    protected processOrderProcessWip(response: AxiosResponse): Promise<OrderProcessWipDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderProcessWipDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<OrderProcessWipDTO[]>(<any>null);
    }

    /**
     * 生产计划员工绩效
     * @param current (optional) 当前页
     * @param productionPlanSearchDTO productionPlanSearchDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageEmployeePerformance(current: number | null | undefined, productionPlanSearchDTO: ProductionPlanSearchDTO, size: number | null | undefined): Promise<IPageOfEmployeePerformanceDTO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-statistics/plan-employee-performance/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionPlanSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageEmployeePerformance(_response);
        });
    }

    protected processGetPageEmployeePerformance(response: AxiosResponse): Promise<IPageOfEmployeePerformanceDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfEmployeePerformanceDTO.fromJS(resultData200) : new IPageOfEmployeePerformanceDTO();
            return result200;
        }
        return Promise.resolve<IPageOfEmployeePerformanceDTO>(<any>null);
    }

    /**
     * 生产计划工单进度
     * @param current (optional) 当前页
     * @param productionPlanOrderSearchDTO productionPlanOrderSearchDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    getProductionPlanOrderScheduleAnalysis(current: number | null | undefined, productionPlanOrderSearchDTO: ProductionPlanOrderSearchDTO, size: number | null | undefined): Promise<ProductionPlanOrderScheduleVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-statistics/plan-order-schedule?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionPlanOrderSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProductionPlanOrderScheduleAnalysis(_response);
        });
    }

    protected processGetProductionPlanOrderScheduleAnalysis(response: AxiosResponse): Promise<ProductionPlanOrderScheduleVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionPlanOrderScheduleVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductionPlanOrderScheduleVO[]>(<any>null);
    }

    /**
     * 生产计划超期分析
     * @param current (optional) 当前页
     * @param productionPlanSearchDTO productionPlanSearchDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    getProductionPlanOverdueAnalysis(current: number | null | undefined, productionPlanSearchDTO: ProductionPlanSearchDTO, size: number | null | undefined): Promise<IPageOfProductionPlanOverdueVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-statistics/plan-overdue?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionPlanSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProductionPlanOverdueAnalysis(_response);
        });
    }

    protected processGetProductionPlanOverdueAnalysis(response: AxiosResponse): Promise<IPageOfProductionPlanOverdueVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfProductionPlanOverdueVO.fromJS(resultData200) : new IPageOfProductionPlanOverdueVO();
            return result200;
        }
        return Promise.resolve<IPageOfProductionPlanOverdueVO>(<any>null);
    }

    /**
     * 计划工序分析
     * @param current (optional) 当前页
     * @param productionPlanSearchDTO productionPlanSearchDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    getProductionProcessScheduleAnalysis(current: number | null | undefined, productionPlanSearchDTO: ProductionPlanSearchDTO, size: number | null | undefined): Promise<IPageOfProductionPlanProcessScheduleVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-statistics/plan-process-schedule?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionPlanSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProductionProcessScheduleAnalysis(_response);
        });
    }

    protected processGetProductionProcessScheduleAnalysis(response: AxiosResponse): Promise<IPageOfProductionPlanProcessScheduleVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfProductionPlanProcessScheduleVO.fromJS(resultData200) : new IPageOfProductionPlanProcessScheduleVO();
            return result200;
        }
        return Promise.resolve<IPageOfProductionPlanProcessScheduleVO>(<any>null);
    }

    /**
     * 生产计划进度
     * @param current (optional) 当前页
     * @param productionPlanSearchDTO productionPlanSearchDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    getProductionPlanScheduleAnalysis(current: number | null | undefined, productionPlanSearchDTO: ProductionPlanSearchDTO, size: number | null | undefined): Promise<IPageOfProductionPlanScheduleVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-statistics/plan-schedule?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionPlanSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProductionPlanScheduleAnalysis(_response);
        });
    }

    protected processGetProductionPlanScheduleAnalysis(response: AxiosResponse): Promise<IPageOfProductionPlanScheduleVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfProductionPlanScheduleVO.fromJS(resultData200) : new IPageOfProductionPlanScheduleVO();
            return result200;
        }
        return Promise.resolve<IPageOfProductionPlanScheduleVO>(<any>null);
    }

    /**
     * 生产计划在制品统计
     * @param current (optional) 当前页
     * @param productionPlanSearchDTO productionPlanSearchDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPagePlanWip(current: number | null | undefined, productionPlanSearchDTO: ProductionPlanSearchDTO, size: number | null | undefined): Promise<IPageOfPlanWipDTO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-statistics/plan-wip/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionPlanSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPagePlanWip(_response);
        });
    }

    protected processGetPagePlanWip(response: AxiosResponse): Promise<IPageOfPlanWipDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfPlanWipDTO.fromJS(resultData200) : new IPageOfPlanWipDTO();
            return result200;
        }
        return Promise.resolve<IPageOfPlanWipDTO>(<any>null);
    }

    /**
     * 生产综合统计
     * @param productionStatisticReportDTO productionStatisticReportDTO
     * @return OK
     */
    getProductionStatisticReport(productionStatisticReportDTO: ProductionStatisticsReportDTO): Promise<ProductionStatisticsVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-statistics/production-statistic-report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionStatisticReportDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProductionStatisticReport(_response);
        });
    }

    protected processGetProductionStatisticReport(response: AxiosResponse): Promise<ProductionStatisticsVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionStatisticsVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductionStatisticsVO[]>(<any>null);
    }

    /**
     * 生产综合统计-工位查询
     * @param productionStatisticsWorkStationReportDTO productionStatisticsWorkStationReportDTO
     * @return OK
     */
    getProductionStatisticWorkStationReport(productionStatisticsWorkStationReportDTO: ProductionStatisticsWorkStationReportDTO): Promise<ProductionStatisticsByWorkStationVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-statistics/production-statistic-work-station-report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionStatisticsWorkStationReportDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProductionStatisticWorkStationReport(_response);
        });
    }

    protected processGetProductionStatisticWorkStationReport(response: AxiosResponse): Promise<ProductionStatisticsByWorkStationVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionStatisticsByWorkStationVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductionStatisticsByWorkStationVO[]>(<any>null);
    }

    /**
     * 工序质检参数报表-上表
     * @param current (optional) 当前页
     * @param qcPlanSearchDTO qcPlanSearchDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    qcPlan(current: number | null | undefined, qcPlanSearchDTO: QcPlanSearchDTO, size: number | null | undefined): Promise<IPageOfQcPlanReportVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-statistics/qc-plan?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(qcPlanSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQcPlan(_response);
        });
    }

    protected processQcPlan(response: AxiosResponse): Promise<IPageOfQcPlanReportVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfQcPlanReportVO.fromJS(resultData200) : new IPageOfQcPlanReportVO();
            return result200;
        }
        return Promise.resolve<IPageOfQcPlanReportVO>(<any>null);
    }

    /**
     * 报废原因分析报表
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @param srappedReasonSearchDTO srappedReasonSearchDTO
     * @return OK
     */
    scrappedReasonSchedule(current: number | null | undefined, size: number | null | undefined, srappedReasonSearchDTO: SrappedReasonSearchDTO): Promise<IPageOfScrappedReasonReportVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-statistics/scrapped-reason-report?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(srappedReasonSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processScrappedReasonSchedule(_response);
        });
    }

    protected processScrappedReasonSchedule(response: AxiosResponse): Promise<IPageOfScrappedReasonReportVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfScrappedReasonReportVO.fromJS(resultData200) : new IPageOfScrappedReasonReportVO();
            return result200;
        }
        return Promise.resolve<IPageOfScrappedReasonReportVO>(<any>null);
    }

    /**
     * 工位生产日历报表
     * @param workStationCalendarReportDTO workStationCalendarReportDTO
     * @return OK
     */
    getWorkStationCalendarReport(workStationCalendarReportDTO: WorkStationCalendarReportDTO): Promise<WorkStationCalendarReportVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/production-statistics/workStation-calendar-report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationCalendarReportDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkStationCalendarReport(_response);
        });
    }

    protected processGetWorkStationCalendarReport(response: AxiosResponse): Promise<WorkStationCalendarReportVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkStationCalendarReportVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkStationCalendarReportVO[]>(<any>null);
    }
}

export class ServiceRouteServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * listRoutes
     * @return OK
     */
    listRoutes(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListRoutes(_response);
        });
    }

    protected processListRoutes(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }
}

export class ListRoutesServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * listRoutes
     * @return OK
     */
    1(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process1(_response);
        });
    }

    protected process1(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    2(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process2(_response);
        });
    }

    protected process2(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    3(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process3(_response);
        });
    }

    protected process3(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    5(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process5(_response);
        });
    }

    protected process5(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    6(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process6(_response);
        });
    }

    protected process6(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    4(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process4(_response);
        });
    }

    protected process4(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }
}

export class CoproductionVisualServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 当天工单进度
     * @param orderStatus (optional) orderStatus
     * @return OK
     * @deprecated
     */
    currentDayOrderProgress(orderStatus: number[] | null | undefined): Promise<ROfListOfProductionOrderVisualVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/visual/current-day-order-progress?";
        if (orderStatus !== undefined)
            orderStatus && orderStatus.forEach(item => { url_ += "orderStatus=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCurrentDayOrderProgress(_response);
        });
    }

    protected processCurrentDayOrderProgress(response: AxiosResponse): Promise<ROfListOfProductionOrderVisualVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfProductionOrderVisualVO.fromJS(resultData200) : new ROfListOfProductionOrderVisualVO();
            return result200;
        }
        return Promise.resolve<ROfListOfProductionOrderVisualVO>(<any>null);
    }

    /**
     * 工单实际进度和预计进度
     * @return OK
     */
    orderActualAndEstimateProcess(): Promise<ROfVisualOrderProcess> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/visual/order-actual-and-estimate-process";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processOrderActualAndEstimateProcess(_response);
        });
    }

    protected processOrderActualAndEstimateProcess(response: AxiosResponse): Promise<ROfVisualOrderProcess> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfVisualOrderProcess.fromJS(resultData200) : new ROfVisualOrderProcess();
            return result200;
        }
        return Promise.resolve<ROfVisualOrderProcess>(<any>null);
    }

    /**
     * 工单进度
     * @param productionOrderMergeDTO productionOrderMergeDTO
     * @return OK
     */
    orderProgressMerge(productionOrderMergeDTO: ProductionOrderMergeDTO): Promise<ProductionOrderVisualVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/visual/order-progress-speed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionOrderMergeDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processOrderProgressMerge(_response);
        });
    }

    protected processOrderProgressMerge(response: AxiosResponse): Promise<ProductionOrderVisualVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionOrderVisualVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductionOrderVisualVO[]>(<any>null);
    }

    /**
     * 人员绩效可视化
     * @return OK
     */
    employeePerformanceVisual(): Promise<ROfListOfEmployeePerformanceDTO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/visual/plan-employee-performance";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEmployeePerformanceVisual(_response);
        });
    }

    protected processEmployeePerformanceVisual(response: AxiosResponse): Promise<ROfListOfEmployeePerformanceDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfEmployeePerformanceDTO.fromJS(resultData200) : new ROfListOfEmployeePerformanceDTO();
            return result200;
        }
        return Promise.resolve<ROfListOfEmployeePerformanceDTO>(<any>null);
    }

    /**
     * 生产计划工单进度
     * @param orderStatus (optional) orderStatus
     * @return OK
     * @deprecated
     */
    getPlanOrderProgress(orderStatus: number[] | null | undefined): Promise<ROfListOfProductionOrderVisualVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/visual/plan-order-progress?";
        if (orderStatus !== undefined)
            orderStatus && orderStatus.forEach(item => { url_ += "orderStatus=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPlanOrderProgress(_response);
        });
    }

    protected processGetPlanOrderProgress(response: AxiosResponse): Promise<ROfListOfProductionOrderVisualVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfProductionOrderVisualVO.fromJS(resultData200) : new ROfListOfProductionOrderVisualVO();
            return result200;
        }
        return Promise.resolve<ROfListOfProductionOrderVisualVO>(<any>null);
    }

    /**
     * 总体生产计划完成进度
     * @param groupIdsDTO groupIdsDTO
     * @return OK
     */
    productionPlanOverAllProgress(groupIdsDTO: GroupIdsDTO): Promise<ROfProductionPlanOverAllProgress> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/visual/plan-over-all-progress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupIdsDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processProductionPlanOverAllProgress(_response);
        });
    }

    protected processProductionPlanOverAllProgress(response: AxiosResponse): Promise<ROfProductionPlanOverAllProgress> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfProductionPlanOverAllProgress.fromJS(resultData200) : new ROfProductionPlanOverAllProgress();
            return result200;
        }
        return Promise.resolve<ROfProductionPlanOverAllProgress>(<any>null);
    }

    /**
     * 在制品分析
     * @param extend1 (optional) extend1
     * @param extend2 (optional) extend2
     * @param extend3 (optional) extend3
     * @param extend4 (optional) extend4
     * @param extend5 (optional) extend5
     * @param isDisplay (optional) isDisplay
     * @param planStatusList (optional) planStatusList
     * @return OK
     */
    planWipAnalysis(extend1: string | null | undefined, extend2: string | null | undefined, extend3: string | null | undefined, extend4: string | null | undefined, extend5: string | null | undefined, isDisplay: number | null | undefined, planStatusList: number[] | null | undefined): Promise<ROfListOfVisualPlanWipVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/visual/plan-wip-analysis?";
        if (extend1 !== undefined)
            url_ += "extend1=" + encodeURIComponent("" + extend1) + "&"; 
        if (extend2 !== undefined)
            url_ += "extend2=" + encodeURIComponent("" + extend2) + "&"; 
        if (extend3 !== undefined)
            url_ += "extend3=" + encodeURIComponent("" + extend3) + "&"; 
        if (extend4 !== undefined)
            url_ += "extend4=" + encodeURIComponent("" + extend4) + "&"; 
        if (extend5 !== undefined)
            url_ += "extend5=" + encodeURIComponent("" + extend5) + "&"; 
        if (isDisplay !== undefined)
            url_ += "isDisplay=" + encodeURIComponent("" + isDisplay) + "&"; 
        if (planStatusList !== undefined)
            planStatusList && planStatusList.forEach(item => { url_ += "planStatusList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPlanWipAnalysis(_response);
        });
    }

    protected processPlanWipAnalysis(response: AxiosResponse): Promise<ROfListOfVisualPlanWipVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfVisualPlanWipVO.fromJS(resultData200) : new ROfListOfVisualPlanWipVO();
            return result200;
        }
        return Promise.resolve<ROfListOfVisualPlanWipVO>(<any>null);
    }

    /**
     * 生产计划进度
     * @param extend1 (optional) extend1
     * @param extend2 (optional) extend2
     * @param extend3 (optional) extend3
     * @param extend4 (optional) extend4
     * @param extend5 (optional) extend5
     * @param isDisplay (optional) isDisplay
     * @param planStatusList (optional) planStatusList
     * @return OK
     */
    productionPlanProgress(extend1: string | null | undefined, extend2: string | null | undefined, extend3: string | null | undefined, extend4: string | null | undefined, extend5: string | null | undefined, isDisplay: number | null | undefined, planStatusList: number[] | null | undefined): Promise<ROfListOfVisualProductionPlanScheduleVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/visual/product-plan-progress?";
        if (extend1 !== undefined)
            url_ += "extend1=" + encodeURIComponent("" + extend1) + "&"; 
        if (extend2 !== undefined)
            url_ += "extend2=" + encodeURIComponent("" + extend2) + "&"; 
        if (extend3 !== undefined)
            url_ += "extend3=" + encodeURIComponent("" + extend3) + "&"; 
        if (extend4 !== undefined)
            url_ += "extend4=" + encodeURIComponent("" + extend4) + "&"; 
        if (extend5 !== undefined)
            url_ += "extend5=" + encodeURIComponent("" + extend5) + "&"; 
        if (isDisplay !== undefined)
            url_ += "isDisplay=" + encodeURIComponent("" + isDisplay) + "&"; 
        if (planStatusList !== undefined)
            planStatusList && planStatusList.forEach(item => { url_ += "planStatusList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processProductionPlanProgress(_response);
        });
    }

    protected processProductionPlanProgress(response: AxiosResponse): Promise<ROfListOfVisualProductionPlanScheduleVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfVisualProductionPlanScheduleVO.fromJS(resultData200) : new ROfListOfVisualProductionPlanScheduleVO();
            return result200;
        }
        return Promise.resolve<ROfListOfVisualProductionPlanScheduleVO>(<any>null);
    }

    /**
     * 设备当前详细信息
     * @param workStationId workStationId
     * @return OK
     */
    workStationCurDetails(workStationId: string): Promise<ROfMdcVisualVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/visual/work-station-cur-details?";
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined and cannot be null.");
        else
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationCurDetails(_response);
        });
    }

    protected processWorkStationCurDetails(response: AxiosResponse): Promise<ROfMdcVisualVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfMdcVisualVO.fromJS(resultData200) : new ROfMdcVisualVO();
            return result200;
        }
        return Promise.resolve<ROfMdcVisualVO>(<any>null);
    }

    /**
     * 设备当前班次的加工人员和生产计划工单
     * @param workStationId workStationId
     * @return OK
     */
    workStationCurEmployee(workStationId: string): Promise<ROfListOfEmployeeDetails> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/visual/work-station-cur-employee?";
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined and cannot be null.");
        else
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationCurEmployee(_response);
        });
    }

    protected processWorkStationCurEmployee(response: AxiosResponse): Promise<ROfListOfEmployeeDetails> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfEmployeeDetails.fromJS(resultData200) : new ROfListOfEmployeeDetails();
            return result200;
        }
        return Promise.resolve<ROfListOfEmployeeDetails>(<any>null);
    }

    /**
     * 设备当前工单的详细信息和合格率及加工人员
     * @param workStationId workStationId
     * @return OK
     */
    workStationCurOrdersPassRate(workStationId: string): Promise<ROfListOfProductionOrderDetailsVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/visual/work-station-cur-order-pass-rate?";
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined and cannot be null.");
        else
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationCurOrdersPassRate(_response);
        });
    }

    protected processWorkStationCurOrdersPassRate(response: AxiosResponse): Promise<ROfListOfProductionOrderDetailsVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfProductionOrderDetailsVO.fromJS(resultData200) : new ROfListOfProductionOrderDetailsVO();
            return result200;
        }
        return Promise.resolve<ROfListOfProductionOrderDetailsVO>(<any>null);
    }

    /**
     * 设备当前班次的传输日志
     * @param workStationId workStationId
     * @return OK
     */
    workStationCurTransferLog(workStationId: string): Promise<ROfListOfVisualTransferLog> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/visual/work-station-cur-transfer-log?";
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined and cannot be null.");
        else
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationCurTransferLog(_response);
        });
    }

    protected processWorkStationCurTransferLog(response: AxiosResponse): Promise<ROfListOfVisualTransferLog> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfVisualTransferLog.fromJS(resultData200) : new ROfListOfVisualTransferLog();
            return result200;
        }
        return Promise.resolve<ROfListOfVisualTransferLog>(<any>null);
    }

    /**
     * 工位工单工艺版本
     * @return OK
     */
    workStationOrderCraft(): Promise<ROfListOfWorkStationOrderCraftVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/visual/work-station-order-craft";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationOrderCraft(_response);
        });
    }

    protected processWorkStationOrderCraft(response: AxiosResponse): Promise<ROfListOfWorkStationOrderCraftVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfWorkStationOrderCraftVO.fromJS(resultData200) : new ROfListOfWorkStationOrderCraftVO();
            return result200;
        }
        return Promise.resolve<ROfListOfWorkStationOrderCraftVO>(<any>null);
    }

    /**
     * 工位工单工艺版本工位组工位
     * @param groupId groupId
     * @return OK
     */
    workStationOrderCraftByGroupId(groupId: string): Promise<ROfListOfWorkStationOrderCraftVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/visual/work-station-order-craft-group-id?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationOrderCraftByGroupId(_response);
        });
    }

    protected processWorkStationOrderCraftByGroupId(response: AxiosResponse): Promise<ROfListOfWorkStationOrderCraftVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfWorkStationOrderCraftVO.fromJS(resultData200) : new ROfListOfWorkStationOrderCraftVO();
            return result200;
        }
        return Promise.resolve<ROfListOfWorkStationOrderCraftVO>(<any>null);
    }

    /**
     * 工位实时加工人员与及生产工单
     * @return OK
     */
    workStationProducerOrder(): Promise<ROfListOfVisualWorkStationStatusVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/visual/work-station-producer-order";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationProducerOrder(_response);
        });
    }

    protected processWorkStationProducerOrder(response: AxiosResponse): Promise<ROfListOfVisualWorkStationStatusVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfVisualWorkStationStatusVO.fromJS(resultData200) : new ROfListOfVisualWorkStationStatusVO();
            return result200;
        }
        return Promise.resolve<ROfListOfVisualWorkStationStatusVO>(<any>null);
    }

    /**
     * 工位实时加工人员与及生产工单工位组分组
     * @param groupId groupId
     * @return OK
     */
    workStationProducerOrderByGroupId(groupId: string): Promise<ROfListOfVisualWorkStationStatusVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/visual/work-station-producer-order-group-id?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationProducerOrderByGroupId(_response);
        });
    }

    protected processWorkStationProducerOrderByGroupId(response: AxiosResponse): Promise<ROfListOfVisualWorkStationStatusVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfVisualWorkStationStatusVO.fromJS(resultData200) : new ROfListOfVisualWorkStationStatusVO();
            return result200;
        }
        return Promise.resolve<ROfListOfVisualWorkStationStatusVO>(<any>null);
    }

    /**
     * 工位实时加工人员与及生产工单  合并
     * @param workStationQueryDataSourceDTO workStationQueryDataSourceDTO
     * @return OK
     */
    workStationProducerOrderMerge(workStationQueryDataSourceDTO: WorkStationQueryDataSourceDTO): Promise<ROfListOfVisualWorkStationStatusVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/visual/work-station-producer-order-merge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationQueryDataSourceDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationProducerOrderMerge(_response);
        });
    }

    protected processWorkStationProducerOrderMerge(response: AxiosResponse): Promise<ROfListOfVisualWorkStationStatusVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfVisualWorkStationStatusVO.fromJS(resultData200) : new ROfListOfVisualWorkStationStatusVO();
            return result200;
        }
        return Promise.resolve<ROfListOfVisualWorkStationStatusVO>(<any>null);
    }

    /**
     * 工位生产日历报表
     * @param workStationCalendarReportDTO workStationCalendarReportDTO
     * @return OK
     */
    getWorkStationCalendarReport(workStationCalendarReportDTO: WorkStationCalendarReportDTO): Promise<ROfListOfWorkStationCalendarReportVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/visual/workStation-calendar-report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationCalendarReportDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkStationCalendarReport(_response);
        });
    }

    protected processGetWorkStationCalendarReport(response: AxiosResponse): Promise<ROfListOfWorkStationCalendarReportVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfWorkStationCalendarReportVO.fromJS(resultData200) : new ROfListOfWorkStationCalendarReportVO();
            return result200;
        }
        return Promise.resolve<ROfListOfWorkStationCalendarReportVO>(<any>null);
    }
}

export class WorkInProgressServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 在制品入库
     * @param workInProcessInStockDTO workInProcessInStockDTO
     * @return OK
     */
    workInProgressInStock(workInProcessInStockDTO: WorkInProcessInStockDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/work-in-progress/in-stock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workInProcessInStockDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkInProgressInStock(_response);
        });
    }

    protected processWorkInProgressInStock(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 在制品出库统计
     * @param planId planId
     * @return OK
     */
    wipStockInRecordList(planId: string): Promise<WipStockInRecordVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/work-in-progress/in-stock-statistics?";
        if (planId === undefined || planId === null)
            throw new Error("The parameter 'planId' must be defined and cannot be null.");
        else
            url_ += "planId=" + encodeURIComponent("" + planId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWipStockInRecordList(_response);
        });
    }

    protected processWipStockInRecordList(response: AxiosResponse): Promise<WipStockInRecordVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WipStockInRecordVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WipStockInRecordVO[]>(<any>null);
    }

    /**
     * 在制品出库
     * @param workInProcessOutStockDTO workInProcessOutStockDTO
     * @return OK
     */
    workInProgressOutStock(workInProcessOutStockDTO: WorkInProcessOutStockDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/work-in-progress/out-stock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workInProcessOutStockDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkInProgressOutStock(_response);
        });
    }

    protected processWorkInProgressOutStock(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 在制品出库统计
     * @param planId planId
     * @return OK
     */
    wipStockOutRecordList(planId: string): Promise<WipStockOutRecordVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/work-in-progress/out-stock-statistics?";
        if (planId === undefined || planId === null)
            throw new Error("The parameter 'planId' must be defined and cannot be null.");
        else
            url_ += "planId=" + encodeURIComponent("" + planId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWipStockOutRecordList(_response);
        });
    }

    protected processWipStockOutRecordList(response: AxiosResponse): Promise<WipStockOutRecordVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WipStockOutRecordVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WipStockOutRecordVO[]>(<any>null);
    }
}

export class WorkStationOrderProcessServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 获取工位下的工单列表
     * @param code (optional) code
     * @param planTypeId (optional) 计划id
     * @param workStationId (optional) 工位id
     * @return OK
     */
    getWorkStationOrderProcessInfo(code: string | null | undefined, planTypeId: string | null | undefined, workStationId: string | null | undefined): Promise<WorkStationOrderProcessInfo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/workStation-order-process?";
        if (planTypeId !== undefined)
            url_ += "planTypeId=" + encodeURIComponent("" + planTypeId) + "&"; 
        if (workStationId !== undefined)
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkStationOrderProcessInfo(_response);
        });
    }

    protected processGetWorkStationOrderProcessInfo(response: AxiosResponse): Promise<WorkStationOrderProcessInfo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkStationOrderProcessInfo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkStationOrderProcessInfo[]>(<any>null);
    }

    /**
     * 按资源ID查询文件列表
     * @param resourceId (optional) 资源id
     * @return OK
     */
    getResourceFileList(resourceId: string | null | undefined): Promise<ResourceFileVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/workStation-order-process/file-list?";
        if (resourceId !== undefined)
            url_ += "resourceId=" + encodeURIComponent("" + resourceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetResourceFileList(_response);
        });
    }

    protected processGetResourceFileList(response: AxiosResponse): Promise<ResourceFileVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceFileVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ResourceFileVO[]>(<any>null);
    }

    /**
     * 发送单个文件到传输目录
     * @param fileToTransfer (optional) 发送单个文件到传输目录参数
     * @return OK
     */
    sendOneFileToTransfer(fileToTransfer: FileToTransfer | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/workStation-order-process/file/send-to-transform";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileToTransfer);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSendOneFileToTransfer(_response);
        });
    }

    protected processSendOneFileToTransfer(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 根据员工获取工位下的工单列表
     * @param code (optional) code
     * @param planTypeId (optional) 计划id
     * @param producerId (optional) 工位id
     * @param workStationId (optional) 工位id
     * @return OK
     */
    listByWorkStationAndProducer(code: string | null | undefined, planTypeId: string | null | undefined, producerId: string | null | undefined, workStationId: string | null | undefined): Promise<WorkStationOrderProcessInfo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/workStation-order-process/list?";
        if (planTypeId !== undefined)
            url_ += "planTypeId=" + encodeURIComponent("" + planTypeId) + "&"; 
        if (producerId !== undefined)
            url_ += "producerId=" + encodeURIComponent("" + producerId) + "&"; 
        if (workStationId !== undefined)
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListByWorkStationAndProducer(_response);
        });
    }

    protected processListByWorkStationAndProducer(response: AxiosResponse): Promise<WorkStationOrderProcessInfo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkStationOrderProcessInfo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkStationOrderProcessInfo[]>(<any>null);
    }

    /**
     * 获取当前工位是否开工
     * @param workStationId (optional) 工位id
     * @return OK
     */
    getWorkStationStatus(workStationId: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/workStation-order-process/start-or-not?";
        if (workStationId !== undefined)
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkStationStatus(_response);
        });
    }

    protected processGetWorkStationStatus(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 获取当前工单下的详细信息
     * @param orderId (optional) 工单id
     * @param poProcessId (optional) 工序id
     * @param workStationId (optional) 工位id
     * @return OK
     */
    getWorkStationOrderDetail(orderId: string | null | undefined, poProcessId: string | null | undefined, workStationId: string | null | undefined): Promise<WorkStationOrderProcessInfoBO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/workStation-order-process/{orderId}/{poProcessId}?";
        if (orderId !== null && orderId !== undefined)
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId)); 
        else
            url_ = url_.replace("/{orderId}", "");
        if (poProcessId !== null && poProcessId !== undefined)
        url_ = url_.replace("{poProcessId}", encodeURIComponent("" + poProcessId)); 
        else
            url_ = url_.replace("/{poProcessId}", "");
        if (workStationId !== undefined)
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkStationOrderDetail(_response);
        });
    }

    protected processGetWorkStationOrderDetail(response: AxiosResponse): Promise<WorkStationOrderProcessInfoBO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkStationOrderProcessInfoBO.fromJS(resultData200) : new WorkStationOrderProcessInfoBO();
            return result200;
        }
        return Promise.resolve<WorkStationOrderProcessInfoBO>(<any>null);
    }

    /**
     * 发送文件到传输目录
     * @param resourceId (optional) 资源id
     * @param workStationId (optional) 工位id
     * @return OK
     */
    sendFileToTransfer(resourceId: string | null | undefined, workStationId: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/workStation-order-process/{resourceId}/send-to-transform?";
        if (resourceId !== null && resourceId !== undefined)
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId)); 
        else
            url_ = url_.replace("/{resourceId}", "");
        if (workStationId !== undefined)
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSendFileToTransfer(_response);
        });
    }

    protected processSendFileToTransfer(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 获取当前工位已开工的详情
     * @param planTypeId (optional) 计划类型id
     * @param workStationId (optional) 工位id
     * @return OK
     */
    getCurrentWorkStationProcess(planTypeId: string | null | undefined, workStationId: string | null | undefined): Promise<OrderProcessDetailInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/workStation-order-process/{workStationId}?";
        if (workStationId !== null && workStationId !== undefined)
        url_ = url_.replace("{workStationId}", encodeURIComponent("" + workStationId)); 
        else
            url_ = url_.replace("/{workStationId}", "");
        if (planTypeId !== undefined)
            url_ += "planTypeId=" + encodeURIComponent("" + planTypeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCurrentWorkStationProcess(_response);
        });
    }

    protected processGetCurrentWorkStationProcess(response: AxiosResponse): Promise<OrderProcessDetailInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? OrderProcessDetailInfo.fromJS(resultData200) : new OrderProcessDetailInfo();
            return result200;
        }
        return Promise.resolve<OrderProcessDetailInfo>(<any>null);
    }

    /**
     * 获取当前工位开工员工信息
     * @param workStationId (optional) 工位id
     * @return OK
     */
    getWorkStationProducerInfo(workStationId: string | null | undefined): Promise<WorkStationProducerDTO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-coproduction')+ "/workStation-order-process/{workStationId}/producerInfo";
        if (workStationId !== null && workStationId !== undefined)
        url_ = url_.replace("{workStationId}", encodeURIComponent("" + workStationId)); 
        else
            url_ = url_.replace("/{workStationId}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkStationProducerInfo(_response);
        });
    }

    protected processGetWorkStationProducerInfo(response: AxiosResponse): Promise<WorkStationProducerDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkStationProducerDTO.fromJS(resultData200) : new WorkStationProducerDTO();
            return result200;
        }
        return Promise.resolve<WorkStationProducerDTO>(<any>null);
    }
}

/** 追加生产计划信息 */
export class AdditionPlanDTO implements IAdditionPlanDTO {
    /** 生产计划编号 */
    code!: string | undefined;
    extend1!: string | undefined;
    extend2!: string | undefined;
    extend3!: string | undefined;
    extend4!: string | undefined;
    extend5!: string | undefined;
    /** 文件信息列表 */
    fileList!: FileInfoDetailDTO[] | undefined;
    /** 计划结束时间 */
    planEndTime!: Date | undefined;
    /** 计划数量 */
    planNum!: number | undefined;
    /** 计划开始时间 */
    planStartTime!: Date | undefined;
    /** 资源ID */
    resourceId!: string | undefined;
    /** 开始工序号 */
    selectStartProcessIndex!: number | undefined;

    constructor(data?: IAdditionPlanDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            if (data["fileList"] && data["fileList"].constructor === Array) {
                this.fileList = [] as any;
                for (let item of data["fileList"])
                    this.fileList!.push(FileInfoDetailDTO.fromJS(item));
            }
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.planNum = data["planNum"];
            this.planStartTime = data["planStartTime"] ? new Date(data["planStartTime"].toString()) : <any>undefined;
            this.resourceId = data["resourceId"];
            this.selectStartProcessIndex = data["selectStartProcessIndex"];
        }
    }

    static fromJS(data: any): AdditionPlanDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionPlanDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        if (this.fileList && this.fileList.constructor === Array) {
            data["fileList"] = [];
            for (let item of this.fileList)
                data["fileList"].push(item.toJSON());
        }
        data["planEndTime"] = this.planEndTime ? this.planEndTime.toISOString() : <any>undefined;
        data["planNum"] = this.planNum;
        data["planStartTime"] = this.planStartTime ? this.planStartTime.toISOString() : <any>undefined;
        data["resourceId"] = this.resourceId;
        data["selectStartProcessIndex"] = this.selectStartProcessIndex;
        return data; 
    }
}

/** 追加生产计划信息 */
export interface IAdditionPlanDTO {
    /** 生产计划编号 */
    code: string | undefined;
    extend1: string | undefined;
    extend2: string | undefined;
    extend3: string | undefined;
    extend4: string | undefined;
    extend5: string | undefined;
    /** 文件信息列表 */
    fileList: FileInfoDetailDTO[] | undefined;
    /** 计划结束时间 */
    planEndTime: Date | undefined;
    /** 计划数量 */
    planNum: number | undefined;
    /** 计划开始时间 */
    planStartTime: Date | undefined;
    /** 资源ID */
    resourceId: string | undefined;
    /** 开始工序号 */
    selectStartProcessIndex: number | undefined;
}

/** 追加生产计划信息 */
export class AssignMaterialDTO implements IAssignMaterialDTO {
    /** 物料编号 */
    materialCode!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 本次派退料数量 */
    number!: number | undefined;
    /** 工单Id */
    orderId!: string | undefined;
    /** 工单物料Id */
    orderMaterialId!: string | undefined;
    /** 工单物料工序Id */
    orderProcessId!: string | undefined;
    /** 工序编码 */
    processCode!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;

    constructor(data?: IAssignMaterialDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.materialCode = data["materialCode"];
            this.materialName = data["materialName"];
            this.number = data["number"];
            this.orderId = data["orderId"];
            this.orderMaterialId = data["orderMaterialId"];
            this.orderProcessId = data["orderProcessId"];
            this.processCode = data["processCode"];
            this.processName = data["processName"];
        }
    }

    static fromJS(data: any): AssignMaterialDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssignMaterialDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialCode"] = this.materialCode;
        data["materialName"] = this.materialName;
        data["number"] = this.number;
        data["orderId"] = this.orderId;
        data["orderMaterialId"] = this.orderMaterialId;
        data["orderProcessId"] = this.orderProcessId;
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        return data; 
    }
}

/** 追加生产计划信息 */
export interface IAssignMaterialDTO {
    /** 物料编号 */
    materialCode: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 本次派退料数量 */
    number: number | undefined;
    /** 工单Id */
    orderId: string | undefined;
    /** 工单物料Id */
    orderMaterialId: string | undefined;
    /** 工单物料工序Id */
    orderProcessId: string | undefined;
    /** 工序编码 */
    processCode: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
}

export class AssignOutDTO implements IAssignOutDTO {
    /** 生产班组id */
    assignDeptId!: string | undefined;
    /** 生产班组名称 */
    assignDeptName!: string | undefined;
    /** 采集数量 */
    collectionNum!: number | undefined;
    /** 指派ID */
    id!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 生产人员id */
    producerId!: string | undefined;
    /** 生产人员名称 */
    producerName!: string | undefined;
    /** 报工数量 */
    reportNum!: number | undefined;
    /** 指派总数 */
    totalNum!: number | undefined;
    /** 待报工数量 */
    unreportNum!: number | undefined;
    /** 工位id */
    workStationId!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;
    /** 工位产能 */
    workstationCapacity!: number | undefined;

    constructor(data?: IAssignOutDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignDeptId = data["assignDeptId"];
            this.assignDeptName = data["assignDeptName"];
            this.collectionNum = data["collectionNum"];
            this.id = data["id"];
            this.processName = data["processName"];
            this.producerId = data["producerId"];
            this.producerName = data["producerName"];
            this.reportNum = data["reportNum"];
            this.totalNum = data["totalNum"];
            this.unreportNum = data["unreportNum"];
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
            this.workstationCapacity = data["workstationCapacity"];
        }
    }

    static fromJS(data: any): AssignOutDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssignOutDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignDeptId"] = this.assignDeptId;
        data["assignDeptName"] = this.assignDeptName;
        data["collectionNum"] = this.collectionNum;
        data["id"] = this.id;
        data["processName"] = this.processName;
        data["producerId"] = this.producerId;
        data["producerName"] = this.producerName;
        data["reportNum"] = this.reportNum;
        data["totalNum"] = this.totalNum;
        data["unreportNum"] = this.unreportNum;
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        data["workstationCapacity"] = this.workstationCapacity;
        return data; 
    }
}

export interface IAssignOutDTO {
    /** 生产班组id */
    assignDeptId: string | undefined;
    /** 生产班组名称 */
    assignDeptName: string | undefined;
    /** 采集数量 */
    collectionNum: number | undefined;
    /** 指派ID */
    id: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 生产人员id */
    producerId: string | undefined;
    /** 生产人员名称 */
    producerName: string | undefined;
    /** 报工数量 */
    reportNum: number | undefined;
    /** 指派总数 */
    totalNum: number | undefined;
    /** 待报工数量 */
    unreportNum: number | undefined;
    /** 工位id */
    workStationId: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
    /** 工位产能 */
    workstationCapacity: number | undefined;
}

export class AssignRecordDetailDTO implements IAssignRecordDetailDTO {
    /** 生产班组id */
    assignDeptId!: string | undefined;
    /** 生产班组名称 */
    assignDeptName!: string | undefined;
    /** 指派数量 */
    assignNum!: number | undefined;
    /** 采集数量 */
    collectionNum!: number | undefined;
    /** 已派数量 */
    hasAssignNum!: number | undefined;
    /** 主键ID */
    id!: string | undefined;
    /** 预计结束时间 */
    planEndTime!: Date | undefined;
    /** 预计开始时间 */
    planStartTime!: Date | undefined;
    /** 生产人员编码 */
    producerCode!: string | undefined;
    /** 生产人员id */
    producerId!: string | undefined;
    /** 生产人员名称 */
    producerName!: string | undefined;
    /** 报工数量 */
    reportNum!: number | undefined;
    /** 工位产能 */
    stationProductionCapacity!: number | undefined;
    /** 待报数量 */
    unreportNum!: number | undefined;
    /** 工位id */
    workStationId!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;

    constructor(data?: IAssignRecordDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignDeptId = data["assignDeptId"];
            this.assignDeptName = data["assignDeptName"];
            this.assignNum = data["assignNum"];
            this.collectionNum = data["collectionNum"];
            this.hasAssignNum = data["hasAssignNum"];
            this.id = data["id"];
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.planStartTime = data["planStartTime"] ? new Date(data["planStartTime"].toString()) : <any>undefined;
            this.producerCode = data["producerCode"];
            this.producerId = data["producerId"];
            this.producerName = data["producerName"];
            this.reportNum = data["reportNum"];
            this.stationProductionCapacity = data["stationProductionCapacity"];
            this.unreportNum = data["unreportNum"];
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): AssignRecordDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssignRecordDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignDeptId"] = this.assignDeptId;
        data["assignDeptName"] = this.assignDeptName;
        data["assignNum"] = this.assignNum;
        data["collectionNum"] = this.collectionNum;
        data["hasAssignNum"] = this.hasAssignNum;
        data["id"] = this.id;
        data["planEndTime"] = this.planEndTime ? formatDate(this.planEndTime) : <any>undefined;
        data["planStartTime"] = this.planStartTime ? formatDate(this.planStartTime) : <any>undefined;
        data["producerCode"] = this.producerCode;
        data["producerId"] = this.producerId;
        data["producerName"] = this.producerName;
        data["reportNum"] = this.reportNum;
        data["stationProductionCapacity"] = this.stationProductionCapacity;
        data["unreportNum"] = this.unreportNum;
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IAssignRecordDetailDTO {
    /** 生产班组id */
    assignDeptId: string | undefined;
    /** 生产班组名称 */
    assignDeptName: string | undefined;
    /** 指派数量 */
    assignNum: number | undefined;
    /** 采集数量 */
    collectionNum: number | undefined;
    /** 已派数量 */
    hasAssignNum: number | undefined;
    /** 主键ID */
    id: string | undefined;
    /** 预计结束时间 */
    planEndTime: Date | undefined;
    /** 预计开始时间 */
    planStartTime: Date | undefined;
    /** 生产人员编码 */
    producerCode: string | undefined;
    /** 生产人员id */
    producerId: string | undefined;
    /** 生产人员名称 */
    producerName: string | undefined;
    /** 报工数量 */
    reportNum: number | undefined;
    /** 工位产能 */
    stationProductionCapacity: number | undefined;
    /** 待报数量 */
    unreportNum: number | undefined;
    /** 工位id */
    workStationId: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
}

export class AssignRecordOutDTO implements IAssignRecordOutDTO {
    /** 生产班组id */
    assignDeptId!: string | undefined;
    /** 生产班组名称 */
    assignDeptName!: string | undefined;
    /** 指派数量 */
    assignNum!: number | undefined;
    /** 指派状态 */
    assignStatus!: number | undefined;
    /** 指派时间 */
    assignTime!: Date | undefined;
    /** 采集数量 */
    collectionNum!: number | undefined;
    /** 主键ID */
    id!: string | undefined;
    /** 预计结束时间 */
    planEndTime!: Date | undefined;
    /** 预计开始时间 */
    planStartTime!: Date | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 生产人员编码 */
    producerCode!: string | undefined;
    /** 生产人员id */
    producerId!: string | undefined;
    /** 生产人员名称 */
    producerName!: string | undefined;
    /** 报工数量 */
    reportNum!: number | undefined;
    /** 工位id */
    workStationId!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;
    /** 工位产能 */
    workstationCapacity!: number | undefined;

    constructor(data?: IAssignRecordOutDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignDeptId = data["assignDeptId"];
            this.assignDeptName = data["assignDeptName"];
            this.assignNum = data["assignNum"];
            this.assignStatus = data["assignStatus"];
            this.assignTime = data["assignTime"] ? new Date(data["assignTime"].toString()) : <any>undefined;
            this.collectionNum = data["collectionNum"];
            this.id = data["id"];
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.planStartTime = data["planStartTime"] ? new Date(data["planStartTime"].toString()) : <any>undefined;
            this.processName = data["processName"];
            this.producerCode = data["producerCode"];
            this.producerId = data["producerId"];
            this.producerName = data["producerName"];
            this.reportNum = data["reportNum"];
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
            this.workstationCapacity = data["workstationCapacity"];
        }
    }

    static fromJS(data: any): AssignRecordOutDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssignRecordOutDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignDeptId"] = this.assignDeptId;
        data["assignDeptName"] = this.assignDeptName;
        data["assignNum"] = this.assignNum;
        data["assignStatus"] = this.assignStatus;
        data["assignTime"] = this.assignTime ? this.assignTime.toISOString() : <any>undefined;
        data["collectionNum"] = this.collectionNum;
        data["id"] = this.id;
        data["planEndTime"] = this.planEndTime ? formatDate(this.planEndTime) : <any>undefined;
        data["planStartTime"] = this.planStartTime ? formatDate(this.planStartTime) : <any>undefined;
        data["processName"] = this.processName;
        data["producerCode"] = this.producerCode;
        data["producerId"] = this.producerId;
        data["producerName"] = this.producerName;
        data["reportNum"] = this.reportNum;
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        data["workstationCapacity"] = this.workstationCapacity;
        return data; 
    }
}

export interface IAssignRecordOutDTO {
    /** 生产班组id */
    assignDeptId: string | undefined;
    /** 生产班组名称 */
    assignDeptName: string | undefined;
    /** 指派数量 */
    assignNum: number | undefined;
    /** 指派状态 */
    assignStatus: number | undefined;
    /** 指派时间 */
    assignTime: Date | undefined;
    /** 采集数量 */
    collectionNum: number | undefined;
    /** 主键ID */
    id: string | undefined;
    /** 预计结束时间 */
    planEndTime: Date | undefined;
    /** 预计开始时间 */
    planStartTime: Date | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 生产人员编码 */
    producerCode: string | undefined;
    /** 生产人员id */
    producerId: string | undefined;
    /** 生产人员名称 */
    producerName: string | undefined;
    /** 报工数量 */
    reportNum: number | undefined;
    /** 工位id */
    workStationId: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
    /** 工位产能 */
    workstationCapacity: number | undefined;
}

export class AssignRecordSearchDTO implements IAssignRecordSearchDTO {
    /** 生产班组ID */
    assignDeptId!: string | undefined;
    /** 指派ID */
    assignId!: string | undefined;
    /** 状态 */
    assignStatus!: number | undefined;
    /** 排序字段 */
    orderBy!: number | undefined;
    /** 工单工序ID */
    poProcessId!: string | undefined;
    /** 生产人员职权域Id */
    producerDeptId!: string | undefined;
    /** 生产人员ID */
    producerId!: string | undefined;
    /** 工位ID */
    workStationId!: string | undefined;

    constructor(data?: IAssignRecordSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignDeptId = data["assignDeptId"];
            this.assignId = data["assignId"];
            this.assignStatus = data["assignStatus"];
            this.orderBy = data["orderBy"];
            this.poProcessId = data["poProcessId"];
            this.producerDeptId = data["producerDeptId"];
            this.producerId = data["producerId"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): AssignRecordSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssignRecordSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignDeptId"] = this.assignDeptId;
        data["assignId"] = this.assignId;
        data["assignStatus"] = this.assignStatus;
        data["orderBy"] = this.orderBy;
        data["poProcessId"] = this.poProcessId;
        data["producerDeptId"] = this.producerDeptId;
        data["producerId"] = this.producerId;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IAssignRecordSearchDTO {
    /** 生产班组ID */
    assignDeptId: string | undefined;
    /** 指派ID */
    assignId: string | undefined;
    /** 状态 */
    assignStatus: number | undefined;
    /** 排序字段 */
    orderBy: number | undefined;
    /** 工单工序ID */
    poProcessId: string | undefined;
    /** 生产人员职权域Id */
    producerDeptId: string | undefined;
    /** 生产人员ID */
    producerId: string | undefined;
    /** 工位ID */
    workStationId: string | undefined;
}

export class AssignRecordUpdateDTO implements IAssignRecordUpdateDTO {
    /** 指派数量 */
    assignNum!: number;
    /** 主键ID */
    id!: string;
    /** 预计结束时间 */
    planEndTime!: Date;
    /** 预计开始时间 */
    planStartTime!: Date;

    constructor(data?: IAssignRecordUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignNum = data["assignNum"];
            this.id = data["id"];
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.planStartTime = data["planStartTime"] ? new Date(data["planStartTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AssignRecordUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssignRecordUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignNum"] = this.assignNum;
        data["id"] = this.id;
        data["planEndTime"] = this.planEndTime ? formatDate(this.planEndTime) : <any>undefined;
        data["planStartTime"] = this.planStartTime ? formatDate(this.planStartTime) : <any>undefined;
        return data; 
    }
}

export interface IAssignRecordUpdateDTO {
    /** 指派数量 */
    assignNum: number;
    /** 主键ID */
    id: string;
    /** 预计结束时间 */
    planEndTime: Date;
    /** 预计开始时间 */
    planStartTime: Date;
}

export class AssignSearchDTO implements IAssignSearchDTO {
    /** 工单工序ID */
    poProcessId!: string | undefined;

    constructor(data?: IAssignSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.poProcessId = data["poProcessId"];
        }
    }

    static fromJS(data: any): AssignSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssignSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poProcessId"] = this.poProcessId;
        return data; 
    }
}

export interface IAssignSearchDTO {
    /** 工单工序ID */
    poProcessId: string | undefined;
}

export class BomProcessVO implements IBomProcessVO {
    /** 用量分母 */
    denominator!: number | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 固定损耗 */
    loss!: number | undefined;
    /** 用量分子 */
    molecule!: number | undefined;
    /** 工序Code */
    processCode!: string | undefined;
    /** processId */
    processId!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;

    constructor(data?: IBomProcessVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.denominator = data["denominator"];
            this.id = data["id"];
            this.loss = data["loss"];
            this.molecule = data["molecule"];
            this.processCode = data["processCode"];
            this.processId = data["processId"];
            this.processName = data["processName"];
        }
    }

    static fromJS(data: any): BomProcessVO {
        data = typeof data === 'object' ? data : {};
        let result = new BomProcessVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["denominator"] = this.denominator;
        data["id"] = this.id;
        data["loss"] = this.loss;
        data["molecule"] = this.molecule;
        data["processCode"] = this.processCode;
        data["processId"] = this.processId;
        data["processName"] = this.processName;
        return data; 
    }
}

export interface IBomProcessVO {
    /** 用量分母 */
    denominator: number | undefined;
    /** 主键id */
    id: string | undefined;
    /** 固定损耗 */
    loss: number | undefined;
    /** 用量分子 */
    molecule: number | undefined;
    /** 工序Code */
    processCode: string | undefined;
    /** processId */
    processId: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
}

/** 收领物料 */
export class CollectMaterialDTO implements ICollectMaterialDTO {
    /** 库区 */
    area!: string | undefined;
    /** 收退领人员 */
    collectionPerson!: string | undefined;
    /** 库位 */
    location!: string | undefined;
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 收退领数量 */
    number!: number | undefined;
    /** 计划物料Id */
    planMaterialId!: string | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 单位 */
    unit!: string | undefined;

    constructor(data?: ICollectMaterialDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.area = data["area"];
            this.collectionPerson = data["collectionPerson"];
            this.location = data["location"];
            this.materialCode = data["materialCode"];
            this.materialName = data["materialName"];
            this.number = data["number"];
            this.planMaterialId = data["planMaterialId"];
            this.standardModel = data["standardModel"];
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): CollectMaterialDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CollectMaterialDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["area"] = this.area;
        data["collectionPerson"] = this.collectionPerson;
        data["location"] = this.location;
        data["materialCode"] = this.materialCode;
        data["materialName"] = this.materialName;
        data["number"] = this.number;
        data["planMaterialId"] = this.planMaterialId;
        data["standardModel"] = this.standardModel;
        data["unit"] = this.unit;
        return data; 
    }
}

/** 收领物料 */
export interface ICollectMaterialDTO {
    /** 库区 */
    area: string | undefined;
    /** 收退领人员 */
    collectionPerson: string | undefined;
    /** 库位 */
    location: string | undefined;
    /** 物料编码 */
    materialCode: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 收退领数量 */
    number: number | undefined;
    /** 计划物料Id */
    planMaterialId: string | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 单位 */
    unit: string | undefined;
}

/** 收领物料 */
export class CollectMaterialVO implements ICollectMaterialVO {
    /** 库区 */
    area!: string | undefined;
    /** 收退领人员 */
    collectionPerson!: string | undefined;
    /** 库位 */
    location!: string | undefined;
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 收退领数量 */
    number!: number | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 单位 */
    unit!: string | undefined;

    constructor(data?: ICollectMaterialVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.area = data["area"];
            this.collectionPerson = data["collectionPerson"];
            this.location = data["location"];
            this.materialCode = data["materialCode"];
            this.materialName = data["materialName"];
            this.number = data["number"];
            this.standardModel = data["standardModel"];
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): CollectMaterialVO {
        data = typeof data === 'object' ? data : {};
        let result = new CollectMaterialVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["area"] = this.area;
        data["collectionPerson"] = this.collectionPerson;
        data["location"] = this.location;
        data["materialCode"] = this.materialCode;
        data["materialName"] = this.materialName;
        data["number"] = this.number;
        data["standardModel"] = this.standardModel;
        data["unit"] = this.unit;
        return data; 
    }
}

/** 收领物料 */
export interface ICollectMaterialVO {
    /** 库区 */
    area: string | undefined;
    /** 收退领人员 */
    collectionPerson: string | undefined;
    /** 库位 */
    location: string | undefined;
    /** 物料编码 */
    materialCode: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 收退领数量 */
    number: number | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 单位 */
    unit: string | undefined;
}

/** 计划收领 */
export class CollectPlanDTO implements ICollectPlanDTO {
    /** 物料 */
    collectMaterialDTOList!: CollectMaterialDTO[] | undefined;
    /** 计划Code */
    planCode!: string | undefined;
    /** 计划Id */
    planId!: string | undefined;
    /** 计划数量 */
    planNum!: number | undefined;
    /** 版本 */
    version!: string | undefined;

    constructor(data?: ICollectPlanDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["collectMaterialDTOList"] && data["collectMaterialDTOList"].constructor === Array) {
                this.collectMaterialDTOList = [] as any;
                for (let item of data["collectMaterialDTOList"])
                    this.collectMaterialDTOList!.push(CollectMaterialDTO.fromJS(item));
            }
            this.planCode = data["planCode"];
            this.planId = data["planId"];
            this.planNum = data["planNum"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): CollectPlanDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CollectPlanDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.collectMaterialDTOList && this.collectMaterialDTOList.constructor === Array) {
            data["collectMaterialDTOList"] = [];
            for (let item of this.collectMaterialDTOList)
                data["collectMaterialDTOList"].push(item.toJSON());
        }
        data["planCode"] = this.planCode;
        data["planId"] = this.planId;
        data["planNum"] = this.planNum;
        data["version"] = this.version;
        return data; 
    }
}

/** 计划收领 */
export interface ICollectPlanDTO {
    /** 物料 */
    collectMaterialDTOList: CollectMaterialDTO[] | undefined;
    /** 计划Code */
    planCode: string | undefined;
    /** 计划Id */
    planId: string | undefined;
    /** 计划数量 */
    planNum: number | undefined;
    /** 版本 */
    version: string | undefined;
}

export class ColumnInfo implements IColumnInfo {
    /** 图表数据列表 */
    data!: any[] | undefined;
    /** 图表对应图例名 */
    name!: string | undefined;

    constructor(data?: IColumnInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(item);
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): ColumnInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ColumnInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IColumnInfo {
    /** 图表数据列表 */
    data: any[] | undefined;
    /** 图表对应图例名 */
    name: string | undefined;
}

/** 工艺流转卡 */
export class CraftCardBO implements ICraftCardBO {
    /** 生产计划编号 */
    code!: string | undefined;
    /** 工单号 */
    orderCode!: string | undefined;
    /** 产品编码 */
    productionCode!: string | undefined;
    /** 产品名称 */
    productionName!: string | undefined;
    /** 订单工序列表 */
    productionOrderProcessBO!: ProductionOrderProcessBO[] | undefined;
    /** 产品规格 */
    standardModel!: string | undefined;
    /** 工艺版本 */
    version!: string | undefined;

    constructor(data?: ICraftCardBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.orderCode = data["orderCode"];
            this.productionCode = data["productionCode"];
            this.productionName = data["productionName"];
            if (data["productionOrderProcessBO"] && data["productionOrderProcessBO"].constructor === Array) {
                this.productionOrderProcessBO = [] as any;
                for (let item of data["productionOrderProcessBO"])
                    this.productionOrderProcessBO!.push(ProductionOrderProcessBO.fromJS(item));
            }
            this.standardModel = data["standardModel"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): CraftCardBO {
        data = typeof data === 'object' ? data : {};
        let result = new CraftCardBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["orderCode"] = this.orderCode;
        data["productionCode"] = this.productionCode;
        data["productionName"] = this.productionName;
        if (this.productionOrderProcessBO && this.productionOrderProcessBO.constructor === Array) {
            data["productionOrderProcessBO"] = [];
            for (let item of this.productionOrderProcessBO)
                data["productionOrderProcessBO"].push(item.toJSON());
        }
        data["standardModel"] = this.standardModel;
        data["version"] = this.version;
        return data; 
    }
}

/** 工艺流转卡 */
export interface ICraftCardBO {
    /** 生产计划编号 */
    code: string | undefined;
    /** 工单号 */
    orderCode: string | undefined;
    /** 产品编码 */
    productionCode: string | undefined;
    /** 产品名称 */
    productionName: string | undefined;
    /** 订单工序列表 */
    productionOrderProcessBO: ProductionOrderProcessBO[] | undefined;
    /** 产品规格 */
    standardModel: string | undefined;
    /** 工艺版本 */
    version: string | undefined;
}

export class CurrentTypeInfoVO implements ICurrentTypeInfoVO {
    /** id */
    id!: string | undefined;
    /** 语言信息 */
    languageInfo!: LanguageInfoVO[] | undefined;
    /** 工序派工（0-未启用、1-启用） */
    processAssignMode!: number | undefined;
    /** 开工模式1-依序进行、2-多序进行 */
    startWorkModel!: number | undefined;
    /** 产品类型id */
    typeIds!: string[] | undefined;

    constructor(data?: ICurrentTypeInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["languageInfo"] && data["languageInfo"].constructor === Array) {
                this.languageInfo = [] as any;
                for (let item of data["languageInfo"])
                    this.languageInfo!.push(LanguageInfoVO.fromJS(item));
            }
            this.processAssignMode = data["processAssignMode"];
            this.startWorkModel = data["startWorkModel"];
            if (data["typeIds"] && data["typeIds"].constructor === Array) {
                this.typeIds = [] as any;
                for (let item of data["typeIds"])
                    this.typeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CurrentTypeInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentTypeInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.languageInfo && this.languageInfo.constructor === Array) {
            data["languageInfo"] = [];
            for (let item of this.languageInfo)
                data["languageInfo"].push(item.toJSON());
        }
        data["processAssignMode"] = this.processAssignMode;
        data["startWorkModel"] = this.startWorkModel;
        if (this.typeIds && this.typeIds.constructor === Array) {
            data["typeIds"] = [];
            for (let item of this.typeIds)
                data["typeIds"].push(item);
        }
        return data; 
    }
}

export interface ICurrentTypeInfoVO {
    /** id */
    id: string | undefined;
    /** 语言信息 */
    languageInfo: LanguageInfoVO[] | undefined;
    /** 工序派工（0-未启用、1-启用） */
    processAssignMode: number | undefined;
    /** 开工模式1-依序进行、2-多序进行 */
    startWorkModel: number | undefined;
    /** 产品类型id */
    typeIds: string[] | undefined;
}

export class EmployeeDetails implements IEmployeeDetails {
    /** 加工人员姓名 */
    name!: string | undefined;
    /** 加工工单编号 */
    orderCode!: string | undefined;
    /** 加工工单数量 */
    orderNum!: number | undefined;
    /** 加工人员照片 */
    photoUrl!: string | undefined;

    constructor(data?: IEmployeeDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.orderCode = data["orderCode"];
            this.orderNum = data["orderNum"];
            this.photoUrl = data["photoUrl"];
        }
    }

    static fromJS(data: any): EmployeeDetails {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["orderCode"] = this.orderCode;
        data["orderNum"] = this.orderNum;
        data["photoUrl"] = this.photoUrl;
        return data; 
    }
}

export interface IEmployeeDetails {
    /** 加工人员姓名 */
    name: string | undefined;
    /** 加工工单编号 */
    orderCode: string | undefined;
    /** 加工工单数量 */
    orderNum: number | undefined;
    /** 加工人员照片 */
    photoUrl: string | undefined;
}

/** 员工管理 */
export class EmployeeInfoBO implements IEmployeeInfoBO {
    /** 员工编号 */
    code!: string | undefined;
    /** 权限id */
    deptId!: string | undefined;
    /** 职权域名 */
    deptName!: string | undefined;
    /** 员工邮箱 */
    email!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 员工姓名 */
    name!: string | undefined;
    /** 启用禁用按钮1-启动0-禁用 */
    status!: number | undefined;
    /** 员工电话 */
    tel!: string | undefined;

    constructor(data?: IEmployeeInfoBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.deptId = data["deptId"];
            this.deptName = data["deptName"];
            this.email = data["email"];
            this.id = data["id"];
            this.name = data["name"];
            this.status = data["status"];
            this.tel = data["tel"];
        }
    }

    static fromJS(data: any): EmployeeInfoBO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeInfoBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["deptId"] = this.deptId;
        data["deptName"] = this.deptName;
        data["email"] = this.email;
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["tel"] = this.tel;
        return data; 
    }
}

/** 员工管理 */
export interface IEmployeeInfoBO {
    /** 员工编号 */
    code: string | undefined;
    /** 权限id */
    deptId: string | undefined;
    /** 职权域名 */
    deptName: string | undefined;
    /** 员工邮箱 */
    email: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 员工姓名 */
    name: string | undefined;
    /** 启用禁用按钮1-启动0-禁用 */
    status: number | undefined;
    /** 员工电话 */
    tel: string | undefined;
}

export class EmployeePerformanceCardVO implements IEmployeePerformanceCardVO {
    /** 工序编号 */
    processCode!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 员工编号 */
    producerCode!: string | undefined;
    /** 员工姓名 */
    producerName!: string | undefined;
    /** 产品编号 */
    productCode!: string | undefined;
    /** 合格率 */
    qualifyRate!: string | undefined;

    constructor(data?: IEmployeePerformanceCardVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.processCode = data["processCode"];
            this.processName = data["processName"];
            this.producerCode = data["producerCode"];
            this.producerName = data["producerName"];
            this.productCode = data["productCode"];
            this.qualifyRate = data["qualifyRate"];
        }
    }

    static fromJS(data: any): EmployeePerformanceCardVO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePerformanceCardVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        data["producerCode"] = this.producerCode;
        data["producerName"] = this.producerName;
        data["productCode"] = this.productCode;
        data["qualifyRate"] = this.qualifyRate;
        return data; 
    }
}

export interface IEmployeePerformanceCardVO {
    /** 工序编号 */
    processCode: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 员工编号 */
    producerCode: string | undefined;
    /** 员工姓名 */
    producerName: string | undefined;
    /** 产品编号 */
    productCode: string | undefined;
    /** 合格率 */
    qualifyRate: string | undefined;
}

export class EmployeePerformanceDTO implements IEmployeePerformanceDTO {
    /** 工时差 */
    differenceTime!: number | undefined;
    /** 派发数量 */
    inputNum!: number | undefined;
    /** 计划编号 */
    planCode!: string | undefined;
    /** 工序编号 */
    processCode!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 工序序号 */
    processSequence!: string | undefined;
    /** 员工编号 */
    producerCode!: string | undefined;
    /** 员工姓名 */
    producerName!: string | undefined;
    /** 产品编号 */
    productCode!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 产品类型名称 */
    productTypeName!: string | undefined;
    /** 合格数量 */
    qualifyNum!: number | undefined;
    /** 合格率 */
    qualifyRate!: string | undefined;
    /** 报工数量 */
    reportNum!: number | undefined;
    /** 报废数量 */
    scrappedNum!: number | undefined;
    /** 报废率 */
    scrappedRate!: string | undefined;
    /** 工序顺序 */
    sort!: number | undefined;
    /** 标准工时 */
    standardTime!: string | undefined;
    /** 标准总工时 */
    standardTotalTime!: number | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;
    /** 实际总工时 */
    workTime!: number | undefined;

    constructor(data?: IEmployeePerformanceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.differenceTime = data["differenceTime"];
            this.inputNum = data["inputNum"];
            this.planCode = data["planCode"];
            this.processCode = data["processCode"];
            this.processName = data["processName"];
            this.processSequence = data["processSequence"];
            this.producerCode = data["producerCode"];
            this.producerName = data["producerName"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.productTypeName = data["productTypeName"];
            this.qualifyNum = data["qualifyNum"];
            this.qualifyRate = data["qualifyRate"];
            this.reportNum = data["reportNum"];
            this.scrappedNum = data["scrappedNum"];
            this.scrappedRate = data["scrappedRate"];
            this.sort = data["sort"];
            this.standardTime = data["standardTime"];
            this.standardTotalTime = data["standardTotalTime"];
            this.workStationName = data["workStationName"];
            this.workTime = data["workTime"];
        }
    }

    static fromJS(data: any): EmployeePerformanceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePerformanceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["differenceTime"] = this.differenceTime;
        data["inputNum"] = this.inputNum;
        data["planCode"] = this.planCode;
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        data["processSequence"] = this.processSequence;
        data["producerCode"] = this.producerCode;
        data["producerName"] = this.producerName;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productTypeName"] = this.productTypeName;
        data["qualifyNum"] = this.qualifyNum;
        data["qualifyRate"] = this.qualifyRate;
        data["reportNum"] = this.reportNum;
        data["scrappedNum"] = this.scrappedNum;
        data["scrappedRate"] = this.scrappedRate;
        data["sort"] = this.sort;
        data["standardTime"] = this.standardTime;
        data["standardTotalTime"] = this.standardTotalTime;
        data["workStationName"] = this.workStationName;
        data["workTime"] = this.workTime;
        return data; 
    }
}

export interface IEmployeePerformanceDTO {
    /** 工时差 */
    differenceTime: number | undefined;
    /** 派发数量 */
    inputNum: number | undefined;
    /** 计划编号 */
    planCode: string | undefined;
    /** 工序编号 */
    processCode: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 工序序号 */
    processSequence: string | undefined;
    /** 员工编号 */
    producerCode: string | undefined;
    /** 员工姓名 */
    producerName: string | undefined;
    /** 产品编号 */
    productCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 产品类型名称 */
    productTypeName: string | undefined;
    /** 合格数量 */
    qualifyNum: number | undefined;
    /** 合格率 */
    qualifyRate: string | undefined;
    /** 报工数量 */
    reportNum: number | undefined;
    /** 报废数量 */
    scrappedNum: number | undefined;
    /** 报废率 */
    scrappedRate: string | undefined;
    /** 工序顺序 */
    sort: number | undefined;
    /** 标准工时 */
    standardTime: string | undefined;
    /** 标准总工时 */
    standardTotalTime: number | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
    /** 实际总工时 */
    workTime: number | undefined;
}

export class FileDetailInfoVO implements IFileDetailInfoVO {
    /** 文件大小,必须大于等于0 */
    contentLength!: string | undefined;
    /** 文件H5 */
    contentMd5!: string | undefined;
    /** 内容类型，文件夹为null */
    contentType!: string | undefined;
    createDatetime!: Date | undefined;
    /** createUserId */
    createUserId!: string | undefined;
    createUserName!: string | undefined;
    /** 名称 */
    displayName!: string | undefined;
    /** 文件类别：1、加工文件，2、工艺文件 */
    fileType!: number | undefined;
    /** 主键Id */
    id!: string | undefined;
    /** 文件唯一标识 */
    objectKey!: string | undefined;
    /** 后缀名，文件夹为null */
    suffix!: string | undefined;

    constructor(data?: IFileDetailInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentLength = data["contentLength"];
            this.contentMd5 = data["contentMd5"];
            this.contentType = data["contentType"];
            this.createDatetime = data["createDatetime"] ? new Date(data["createDatetime"].toString()) : <any>undefined;
            this.createUserId = data["createUserId"];
            this.createUserName = data["createUserName"];
            this.displayName = data["displayName"];
            this.fileType = data["fileType"];
            this.id = data["id"];
            this.objectKey = data["objectKey"];
            this.suffix = data["suffix"];
        }
    }

    static fromJS(data: any): FileDetailInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new FileDetailInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentLength"] = this.contentLength;
        data["contentMd5"] = this.contentMd5;
        data["contentType"] = this.contentType;
        data["createDatetime"] = this.createDatetime ? this.createDatetime.toISOString() : <any>undefined;
        data["createUserId"] = this.createUserId;
        data["createUserName"] = this.createUserName;
        data["displayName"] = this.displayName;
        data["fileType"] = this.fileType;
        data["id"] = this.id;
        data["objectKey"] = this.objectKey;
        data["suffix"] = this.suffix;
        return data; 
    }
}

export interface IFileDetailInfoVO {
    /** 文件大小,必须大于等于0 */
    contentLength: string | undefined;
    /** 文件H5 */
    contentMd5: string | undefined;
    /** 内容类型，文件夹为null */
    contentType: string | undefined;
    createDatetime: Date | undefined;
    /** createUserId */
    createUserId: string | undefined;
    createUserName: string | undefined;
    /** 名称 */
    displayName: string | undefined;
    /** 文件类别：1、加工文件，2、工艺文件 */
    fileType: number | undefined;
    /** 主键Id */
    id: string | undefined;
    /** 文件唯一标识 */
    objectKey: string | undefined;
    /** 后缀名，文件夹为null */
    suffix: string | undefined;
}

export class FileInfoDetailDTO implements IFileInfoDetailDTO {
    /** 文件大小,必须大于等于0 */
    contentLength!: string | undefined;
    /** 文件H5 */
    contentMd5!: string | undefined;
    /** 内容类型，文件夹为null */
    contentType!: string | undefined;
    /** 名称 */
    displayName!: string | undefined;
    /** 文件类别：1、加工文件，2、工艺文件 */
    fileType!: number | undefined;
    /** 文件唯一标识 */
    objectKey!: string | undefined;
    /** 后缀名，文件夹为null */
    suffix!: string | undefined;

    constructor(data?: IFileInfoDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentLength = data["contentLength"];
            this.contentMd5 = data["contentMd5"];
            this.contentType = data["contentType"];
            this.displayName = data["displayName"];
            this.fileType = data["fileType"];
            this.objectKey = data["objectKey"];
            this.suffix = data["suffix"];
        }
    }

    static fromJS(data: any): FileInfoDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FileInfoDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentLength"] = this.contentLength;
        data["contentMd5"] = this.contentMd5;
        data["contentType"] = this.contentType;
        data["displayName"] = this.displayName;
        data["fileType"] = this.fileType;
        data["objectKey"] = this.objectKey;
        data["suffix"] = this.suffix;
        return data; 
    }
}

export interface IFileInfoDetailDTO {
    /** 文件大小,必须大于等于0 */
    contentLength: string | undefined;
    /** 文件H5 */
    contentMd5: string | undefined;
    /** 内容类型，文件夹为null */
    contentType: string | undefined;
    /** 名称 */
    displayName: string | undefined;
    /** 文件类别：1、加工文件，2、工艺文件 */
    fileType: number | undefined;
    /** 文件唯一标识 */
    objectKey: string | undefined;
    /** 后缀名，文件夹为null */
    suffix: string | undefined;
}

export class FileInfoVO implements IFileInfoVO {
    /** 文件大小,必须大于等于0 */
    contentLength!: string | undefined;
    /** 文件H5 */
    contentMd5!: string | undefined;
    /** 内容类型，文件夹为null */
    contentType!: string | undefined;
    /** 名称 */
    displayName!: string | undefined;
    /** 文件类别：1、加工文件，2、工艺文件 */
    fileType!: number | undefined;
    /** 主键Id */
    id!: string | undefined;
    /** 文件唯一标识 */
    objectKey!: string | undefined;
    /** 后缀名，文件夹为null */
    suffix!: string | undefined;

    constructor(data?: IFileInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentLength = data["contentLength"];
            this.contentMd5 = data["contentMd5"];
            this.contentType = data["contentType"];
            this.displayName = data["displayName"];
            this.fileType = data["fileType"];
            this.id = data["id"];
            this.objectKey = data["objectKey"];
            this.suffix = data["suffix"];
        }
    }

    static fromJS(data: any): FileInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new FileInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentLength"] = this.contentLength;
        data["contentMd5"] = this.contentMd5;
        data["contentType"] = this.contentType;
        data["displayName"] = this.displayName;
        data["fileType"] = this.fileType;
        data["id"] = this.id;
        data["objectKey"] = this.objectKey;
        data["suffix"] = this.suffix;
        return data; 
    }
}

export interface IFileInfoVO {
    /** 文件大小,必须大于等于0 */
    contentLength: string | undefined;
    /** 文件H5 */
    contentMd5: string | undefined;
    /** 内容类型，文件夹为null */
    contentType: string | undefined;
    /** 名称 */
    displayName: string | undefined;
    /** 文件类别：1、加工文件，2、工艺文件 */
    fileType: number | undefined;
    /** 主键Id */
    id: string | undefined;
    /** 文件唯一标识 */
    objectKey: string | undefined;
    /** 后缀名，文件夹为null */
    suffix: string | undefined;
}

export class FileToTransfer implements IFileToTransfer {
    /** 文件信息 */
    file!: FileInfoVO | undefined;
    /** 资源id */
    resourceId!: string | undefined;
    /** 工位id */
    workStationId!: string | undefined;

    constructor(data?: IFileToTransfer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.file = data["file"] ? FileInfoVO.fromJS(data["file"]) : <any>undefined;
            this.resourceId = data["resourceId"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): FileToTransfer {
        data = typeof data === 'object' ? data : {};
        let result = new FileToTransfer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        data["resourceId"] = this.resourceId;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IFileToTransfer {
    /** 文件信息 */
    file: FileInfoVO | undefined;
    /** 资源id */
    resourceId: string | undefined;
    /** 工位id */
    workStationId: string | undefined;
}

export class FileUploadDTO implements IFileUploadDTO {
    /** 文件列表 */
    fileList!: FileInfoDetailDTO[] | undefined;
    /** 资源ID */
    resourceId!: string | undefined;

    constructor(data?: IFileUploadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["fileList"] && data["fileList"].constructor === Array) {
                this.fileList = [] as any;
                for (let item of data["fileList"])
                    this.fileList!.push(FileInfoDetailDTO.fromJS(item));
            }
            this.resourceId = data["resourceId"];
        }
    }

    static fromJS(data: any): FileUploadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.fileList && this.fileList.constructor === Array) {
            data["fileList"] = [];
            for (let item of this.fileList)
                data["fileList"].push(item.toJSON());
        }
        data["resourceId"] = this.resourceId;
        return data; 
    }
}

export interface IFileUploadDTO {
    /** 文件列表 */
    fileList: FileInfoDetailDTO[] | undefined;
    /** 资源ID */
    resourceId: string | undefined;
}

export class GatewayFilterDefinition implements IGatewayFilterDefinition {
    args!: { [key: string] : string; } | undefined;
    name!: string | undefined;

    constructor(data?: IGatewayFilterDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["args"]) {
                this.args = {} as any;
                for (let key in data["args"]) {
                    if (data["args"].hasOwnProperty(key))
                        this.args![key] = data["args"][key];
                }
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayFilterDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayFilterDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    data["args"][key] = this.args[key];
            }
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayFilterDefinition {
    args: { [key: string] : string; } | undefined;
    name: string | undefined;
}

export class GatewayPredicateDefinition implements IGatewayPredicateDefinition {
    args!: { [key: string] : string; } | undefined;
    name!: string | undefined;

    constructor(data?: IGatewayPredicateDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["args"]) {
                this.args = {} as any;
                for (let key in data["args"]) {
                    if (data["args"].hasOwnProperty(key))
                        this.args![key] = data["args"][key];
                }
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayPredicateDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayPredicateDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    data["args"][key] = this.args[key];
            }
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayPredicateDefinition {
    args: { [key: string] : string; } | undefined;
    name: string | undefined;
}

export class GroupIdsDTO implements IGroupIdsDTO {
    groupIdList!: string[] | undefined;

    constructor(data?: IGroupIdsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["groupIdList"] && data["groupIdList"].constructor === Array) {
                this.groupIdList = [] as any;
                for (let item of data["groupIdList"])
                    this.groupIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): GroupIdsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GroupIdsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.groupIdList && this.groupIdList.constructor === Array) {
            data["groupIdList"] = [];
            for (let item of this.groupIdList)
                data["groupIdList"].push(item);
        }
        return data; 
    }
}

export interface IGroupIdsDTO {
    groupIdList: string[] | undefined;
}

export class IPageOfEmployeePerformanceDTO implements IIPageOfEmployeePerformanceDTO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: EmployeePerformanceDTO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfEmployeePerformanceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(EmployeePerformanceDTO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfEmployeePerformanceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfEmployeePerformanceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfEmployeePerformanceDTO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: EmployeePerformanceDTO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfPageOrderProcessQcItemVO implements IIPageOfPageOrderProcessQcItemVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: PageOrderProcessQcItemVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfPageOrderProcessQcItemVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(PageOrderProcessQcItemVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfPageOrderProcessQcItemVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfPageOrderProcessQcItemVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfPageOrderProcessQcItemVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: PageOrderProcessQcItemVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfPageProductionPlanBO implements IIPageOfPageProductionPlanBO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: PageProductionPlanBO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfPageProductionPlanBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(PageProductionPlanBO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfPageProductionPlanBO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfPageProductionPlanBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfPageProductionPlanBO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: PageProductionPlanBO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfPlanWipDTO implements IIPageOfPlanWipDTO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: PlanWipDTO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfPlanWipDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(PlanWipDTO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfPlanWipDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfPlanWipDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfPlanWipDTO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: PlanWipDTO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfProcessReportVO implements IIPageOfProcessReportVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: ProcessReportVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfProcessReportVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(ProcessReportVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfProcessReportVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfProcessReportVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfProcessReportVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: ProcessReportVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfProductionOrderProcessWorkStationRecordVO implements IIPageOfProductionOrderProcessWorkStationRecordVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: ProductionOrderProcessWorkStationRecordVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfProductionOrderProcessWorkStationRecordVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(ProductionOrderProcessWorkStationRecordVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfProductionOrderProcessWorkStationRecordVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfProductionOrderProcessWorkStationRecordVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfProductionOrderProcessWorkStationRecordVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: ProductionOrderProcessWorkStationRecordVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfProductionPlanOverdueVO implements IIPageOfProductionPlanOverdueVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: ProductionPlanOverdueVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfProductionPlanOverdueVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(ProductionPlanOverdueVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfProductionPlanOverdueVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfProductionPlanOverdueVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfProductionPlanOverdueVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: ProductionPlanOverdueVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfProductionPlanProcessScheduleVO implements IIPageOfProductionPlanProcessScheduleVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: ProductionPlanProcessScheduleVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfProductionPlanProcessScheduleVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(ProductionPlanProcessScheduleVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfProductionPlanProcessScheduleVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfProductionPlanProcessScheduleVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfProductionPlanProcessScheduleVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: ProductionPlanProcessScheduleVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfProductionPlanScheduleVO implements IIPageOfProductionPlanScheduleVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: ProductionPlanScheduleVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfProductionPlanScheduleVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(ProductionPlanScheduleVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfProductionPlanScheduleVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfProductionPlanScheduleVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfProductionPlanScheduleVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: ProductionPlanScheduleVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfQcPlanReportVO implements IIPageOfQcPlanReportVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: QcPlanReportVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfQcPlanReportVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(QcPlanReportVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfQcPlanReportVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfQcPlanReportVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfQcPlanReportVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: QcPlanReportVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfScrappedReasonReportVO implements IIPageOfScrappedReasonReportVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: ScrappedReasonReportVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfScrappedReasonReportVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(ScrappedReasonReportVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfScrappedReasonReportVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfScrappedReasonReportVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfScrappedReasonReportVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: ScrappedReasonReportVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class InStockDTO implements IInStockDTO {
    /** 库区名称 */
    area!: string | undefined;
    /** 库区id */
    areaId!: string | undefined;
    /** 库位 */
    location!: string | undefined;
    /** 库位id */
    locationId!: string | undefined;
    /** 物料编号 */
    materialCode!: string | undefined;
    /** 物料Id */
    materialId!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 物料类型 */
    materialType!: string | undefined;
    /** 入库数量 */
    number!: number | undefined;
    /** 入库工序编号 */
    processCode!: string | undefined;
    /** 工序Id */
    processId!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 备注 */
    remarks!: string | undefined;
    /** 规格 */
    specification!: string | undefined;
    /** 库存 */
    stockNumber!: number | undefined;
    /** 材质 */
    stuff!: string | undefined;
    /** 单位 */
    unit!: string | undefined;

    constructor(data?: IInStockDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.area = data["area"];
            this.areaId = data["areaId"];
            this.location = data["location"];
            this.locationId = data["locationId"];
            this.materialCode = data["materialCode"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.materialType = data["materialType"];
            this.number = data["number"];
            this.processCode = data["processCode"];
            this.processId = data["processId"];
            this.processName = data["processName"];
            this.remarks = data["remarks"];
            this.specification = data["specification"];
            this.stockNumber = data["stockNumber"];
            this.stuff = data["stuff"];
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): InStockDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InStockDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["area"] = this.area;
        data["areaId"] = this.areaId;
        data["location"] = this.location;
        data["locationId"] = this.locationId;
        data["materialCode"] = this.materialCode;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["materialType"] = this.materialType;
        data["number"] = this.number;
        data["processCode"] = this.processCode;
        data["processId"] = this.processId;
        data["processName"] = this.processName;
        data["remarks"] = this.remarks;
        data["specification"] = this.specification;
        data["stockNumber"] = this.stockNumber;
        data["stuff"] = this.stuff;
        data["unit"] = this.unit;
        return data; 
    }
}

export interface IInStockDTO {
    /** 库区名称 */
    area: string | undefined;
    /** 库区id */
    areaId: string | undefined;
    /** 库位 */
    location: string | undefined;
    /** 库位id */
    locationId: string | undefined;
    /** 物料编号 */
    materialCode: string | undefined;
    /** 物料Id */
    materialId: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 物料类型 */
    materialType: string | undefined;
    /** 入库数量 */
    number: number | undefined;
    /** 入库工序编号 */
    processCode: string | undefined;
    /** 工序Id */
    processId: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 备注 */
    remarks: string | undefined;
    /** 规格 */
    specification: string | undefined;
    /** 库存 */
    stockNumber: number | undefined;
    /** 材质 */
    stuff: string | undefined;
    /** 单位 */
    unit: string | undefined;
}

/** 来料计划信息 */
export class IncomingPlanBO implements IIncomingPlanBO {
    /** 生产计划编号 */
    code!: string | undefined;
    /** 扩展字段1 */
    extend1!: string | undefined;
    /** 扩展字段2 */
    extend2!: string | undefined;
    /** 扩展字段3 */
    extend3!: string | undefined;
    /** 扩展字段4 */
    extend4!: string | undefined;
    /** 扩展字段5 */
    extend5!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 自定义工序列表 */
    list!: ProductionPlanProcessDTO[] | undefined;
    /** 物料编号 */
    materialCode!: string | undefined;
    /** 订单编码 */
    orderCode!: string | undefined;
    /** 计划结束时间 */
    planEndTime!: Date | undefined;
    /** 计划模式，1-依序进行、2-多序并行 */
    planMode!: number | undefined;
    /** 计划开始时间 */
    planStartTime!: Date | undefined;
    /** 产品编号 */
    productCode!: string | undefined;
    /** 所属产品 */
    productId!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 产品类型Id */
    productTypeId!: string | undefined;
    /** 产品类型名称 */
    productTypeName!: string | undefined;
    /** 资源ID */
    resourceId!: string | undefined;

    constructor(data?: IIncomingPlanBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.id = data["id"];
            if (data["list"] && data["list"].constructor === Array) {
                this.list = [] as any;
                for (let item of data["list"])
                    this.list!.push(ProductionPlanProcessDTO.fromJS(item));
            }
            this.materialCode = data["materialCode"];
            this.orderCode = data["orderCode"];
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.planMode = data["planMode"];
            this.planStartTime = data["planStartTime"] ? new Date(data["planStartTime"].toString()) : <any>undefined;
            this.productCode = data["productCode"];
            this.productId = data["productId"];
            this.productName = data["productName"];
            this.productTypeId = data["productTypeId"];
            this.productTypeName = data["productTypeName"];
            this.resourceId = data["resourceId"];
        }
    }

    static fromJS(data: any): IncomingPlanBO {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingPlanBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["id"] = this.id;
        if (this.list && this.list.constructor === Array) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        data["materialCode"] = this.materialCode;
        data["orderCode"] = this.orderCode;
        data["planEndTime"] = this.planEndTime ? this.planEndTime.toISOString() : <any>undefined;
        data["planMode"] = this.planMode;
        data["planStartTime"] = this.planStartTime ? this.planStartTime.toISOString() : <any>undefined;
        data["productCode"] = this.productCode;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productTypeId"] = this.productTypeId;
        data["productTypeName"] = this.productTypeName;
        data["resourceId"] = this.resourceId;
        return data; 
    }
}

/** 来料计划信息 */
export interface IIncomingPlanBO {
    /** 生产计划编号 */
    code: string | undefined;
    /** 扩展字段1 */
    extend1: string | undefined;
    /** 扩展字段2 */
    extend2: string | undefined;
    /** 扩展字段3 */
    extend3: string | undefined;
    /** 扩展字段4 */
    extend4: string | undefined;
    /** 扩展字段5 */
    extend5: string | undefined;
    /** id */
    id: string | undefined;
    /** 自定义工序列表 */
    list: ProductionPlanProcessDTO[] | undefined;
    /** 物料编号 */
    materialCode: string | undefined;
    /** 订单编码 */
    orderCode: string | undefined;
    /** 计划结束时间 */
    planEndTime: Date | undefined;
    /** 计划模式，1-依序进行、2-多序并行 */
    planMode: number | undefined;
    /** 计划开始时间 */
    planStartTime: Date | undefined;
    /** 产品编号 */
    productCode: string | undefined;
    /** 所属产品 */
    productId: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 产品类型Id */
    productTypeId: string | undefined;
    /** 产品类型名称 */
    productTypeName: string | undefined;
    /** 资源ID */
    resourceId: string | undefined;
}

export class IncompletePlanDTO implements IIncompletePlanDTO {
    /** 待加工工序 */
    incompleteProcessDTOS!: IncompleteProcessDTO[] | undefined;
    /** 待加工数量 */
    surplusNum!: number | undefined;

    constructor(data?: IIncompletePlanDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["incompleteProcessDTOS"] && data["incompleteProcessDTOS"].constructor === Array) {
                this.incompleteProcessDTOS = [] as any;
                for (let item of data["incompleteProcessDTOS"])
                    this.incompleteProcessDTOS!.push(IncompleteProcessDTO.fromJS(item));
            }
            this.surplusNum = data["surplusNum"];
        }
    }

    static fromJS(data: any): IncompletePlanDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IncompletePlanDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.incompleteProcessDTOS && this.incompleteProcessDTOS.constructor === Array) {
            data["incompleteProcessDTOS"] = [];
            for (let item of this.incompleteProcessDTOS)
                data["incompleteProcessDTOS"].push(item.toJSON());
        }
        data["surplusNum"] = this.surplusNum;
        return data; 
    }
}

export interface IIncompletePlanDTO {
    /** 待加工工序 */
    incompleteProcessDTOS: IncompleteProcessDTO[] | undefined;
    /** 待加工数量 */
    surplusNum: number | undefined;
}

export class IncompleteProcessDTO implements IIncompleteProcessDTO {
    /** 投产数量 */
    inputNum!: number | undefined;
    /** 工序编码 */
    processCode!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 工序序号 */
    processSequence!: string | undefined;
    /** 程序名称 */
    programName!: string | undefined;
    /** 合格数量 */
    qualifyNum!: number | undefined;
    /** 报废数量 */
    scrappedNum!: number | undefined;
    /** 工序顺序 */
    sort!: number | undefined;
    /** 待加工数量 */
    surplusNum!: number | undefined;

    constructor(data?: IIncompleteProcessDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.inputNum = data["inputNum"];
            this.processCode = data["processCode"];
            this.processName = data["processName"];
            this.processSequence = data["processSequence"];
            this.programName = data["programName"];
            this.qualifyNum = data["qualifyNum"];
            this.scrappedNum = data["scrappedNum"];
            this.sort = data["sort"];
            this.surplusNum = data["surplusNum"];
        }
    }

    static fromJS(data: any): IncompleteProcessDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IncompleteProcessDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputNum"] = this.inputNum;
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        data["processSequence"] = this.processSequence;
        data["programName"] = this.programName;
        data["qualifyNum"] = this.qualifyNum;
        data["scrappedNum"] = this.scrappedNum;
        data["sort"] = this.sort;
        data["surplusNum"] = this.surplusNum;
        return data; 
    }
}

export interface IIncompleteProcessDTO {
    /** 投产数量 */
    inputNum: number | undefined;
    /** 工序编码 */
    processCode: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 工序序号 */
    processSequence: string | undefined;
    /** 程序名称 */
    programName: string | undefined;
    /** 合格数量 */
    qualifyNum: number | undefined;
    /** 报废数量 */
    scrappedNum: number | undefined;
    /** 工序顺序 */
    sort: number | undefined;
    /** 待加工数量 */
    surplusNum: number | undefined;
}

export class KeyNameDTO implements IKeyNameDTO {
    /** key */
    key!: string | undefined;
    /** 名称 */
    name!: string | undefined;

    constructor(data?: IKeyNameDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): KeyNameDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KeyNameDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["name"] = this.name;
        return data; 
    }
}

export interface IKeyNameDTO {
    /** key */
    key: string | undefined;
    /** 名称 */
    name: string | undefined;
}

export class LanguageDTO implements ILanguageDTO {
    /** 语种名 */
    languageName!: string | undefined;
    /** 语言值 */
    textValue!: string | undefined;

    constructor(data?: ILanguageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.languageName = data["languageName"];
            this.textValue = data["textValue"];
        }
    }

    static fromJS(data: any): LanguageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        data["textValue"] = this.textValue;
        return data; 
    }
}

export interface ILanguageDTO {
    /** 语种名 */
    languageName: string | undefined;
    /** 语言值 */
    textValue: string | undefined;
}

export class LanguageInfoVO implements ILanguageInfoVO {
    /** 多语言的key */
    key!: string | undefined;
    /** 语种 */
    languageType!: string | undefined;
    /** 多语言的值 */
    value!: string | undefined;

    constructor(data?: ILanguageInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"];
            this.languageType = data["languageType"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): LanguageInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["languageType"] = this.languageType;
        data["value"] = this.value;
        return data; 
    }
}

export interface ILanguageInfoVO {
    /** 多语言的key */
    key: string | undefined;
    /** 语种 */
    languageType: string | undefined;
    /** 多语言的值 */
    value: string | undefined;
}

export class MaterialCallConfirmDTO implements IMaterialCallConfirmDTO {
    /** 主键Id */
    id!: string | undefined;
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 计划id */
    planId!: string | undefined;

    constructor(data?: IMaterialCallConfirmDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.materialCode = data["materialCode"];
            this.planId = data["planId"];
        }
    }

    static fromJS(data: any): MaterialCallConfirmDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialCallConfirmDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialCode"] = this.materialCode;
        data["planId"] = this.planId;
        return data; 
    }
}

export interface IMaterialCallConfirmDTO {
    /** 主键Id */
    id: string | undefined;
    /** 物料编码 */
    materialCode: string | undefined;
    /** 计划id */
    planId: string | undefined;
}

export class MaterialCallRecordDTO implements IMaterialCallRecordDTO {
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 缺料数量 */
    number!: number | undefined;
    /** 工单id */
    orderId!: string | undefined;
    /** 计划物料id */
    planMaterialId!: string | undefined;
    /** 工位编码 */
    workStationCode!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;

    constructor(data?: IMaterialCallRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.materialCode = data["materialCode"];
            this.materialName = data["materialName"];
            this.number = data["number"];
            this.orderId = data["orderId"];
            this.planMaterialId = data["planMaterialId"];
            this.workStationCode = data["workStationCode"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): MaterialCallRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialCallRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialCode"] = this.materialCode;
        data["materialName"] = this.materialName;
        data["number"] = this.number;
        data["orderId"] = this.orderId;
        data["planMaterialId"] = this.planMaterialId;
        data["workStationCode"] = this.workStationCode;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IMaterialCallRecordDTO {
    /** 物料编码 */
    materialCode: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 缺料数量 */
    number: number | undefined;
    /** 工单id */
    orderId: string | undefined;
    /** 计划物料id */
    planMaterialId: string | undefined;
    /** 工位编码 */
    workStationCode: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
}

export class MaterialCallRecordVO implements IMaterialCallRecordVO {
    id!: string | undefined;
    /** 是否确认 */
    isConfirm!: boolean | undefined;
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 缺料数量 */
    number!: number | undefined;
    /** 计划id */
    planId!: string | undefined;
    /** 工位编码 */
    workStationCode!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;

    constructor(data?: IMaterialCallRecordVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.isConfirm = data["isConfirm"];
            this.materialCode = data["materialCode"];
            this.materialName = data["materialName"];
            this.number = data["number"];
            this.planId = data["planId"];
            this.workStationCode = data["workStationCode"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): MaterialCallRecordVO {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialCallRecordVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isConfirm"] = this.isConfirm;
        data["materialCode"] = this.materialCode;
        data["materialName"] = this.materialName;
        data["number"] = this.number;
        data["planId"] = this.planId;
        data["workStationCode"] = this.workStationCode;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IMaterialCallRecordVO {
    id: string | undefined;
    /** 是否确认 */
    isConfirm: boolean | undefined;
    /** 物料编码 */
    materialCode: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 缺料数量 */
    number: number | undefined;
    /** 计划id */
    planId: string | undefined;
    /** 工位编码 */
    workStationCode: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
}

export class MaterialReceiveRecordDTO implements IMaterialReceiveRecordDTO {
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 接收数量 */
    number!: number | undefined;
    /** 工单id */
    orderId!: string | undefined;
    /** 工序编码 */
    processCode!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;

    constructor(data?: IMaterialReceiveRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.materialCode = data["materialCode"];
            this.materialName = data["materialName"];
            this.number = data["number"];
            this.orderId = data["orderId"];
            this.processCode = data["processCode"];
            this.processName = data["processName"];
        }
    }

    static fromJS(data: any): MaterialReceiveRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialReceiveRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialCode"] = this.materialCode;
        data["materialName"] = this.materialName;
        data["number"] = this.number;
        data["orderId"] = this.orderId;
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        return data; 
    }
}

export interface IMaterialReceiveRecordDTO {
    /** 物料编码 */
    materialCode: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 接收数量 */
    number: number | undefined;
    /** 工单id */
    orderId: string | undefined;
    /** 工序编码 */
    processCode: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
}

export class MaterialReceiveRecordVO implements IMaterialReceiveRecordVO {
    id!: string | undefined;
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 接收数量 */
    number!: number | undefined;
    /** 工单id */
    orderId!: string | undefined;
    /** 工序编码 */
    processCode!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;

    constructor(data?: IMaterialReceiveRecordVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.materialCode = data["materialCode"];
            this.materialName = data["materialName"];
            this.number = data["number"];
            this.orderId = data["orderId"];
            this.processCode = data["processCode"];
            this.processName = data["processName"];
        }
    }

    static fromJS(data: any): MaterialReceiveRecordVO {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialReceiveRecordVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialCode"] = this.materialCode;
        data["materialName"] = this.materialName;
        data["number"] = this.number;
        data["orderId"] = this.orderId;
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        return data; 
    }
}

export interface IMaterialReceiveRecordVO {
    id: string | undefined;
    /** 物料编码 */
    materialCode: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 接收数量 */
    number: number | undefined;
    /** 工单id */
    orderId: string | undefined;
    /** 工序编码 */
    processCode: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
}

export class MdcVisualData implements IMdcVisualData {
    data!: number[] | undefined;
    name!: string | undefined;

    constructor(data?: IMdcVisualData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(item);
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): MdcVisualData {
        data = typeof data === 'object' ? data : {};
        let result = new MdcVisualData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IMdcVisualData {
    data: number[] | undefined;
    name: string | undefined;
}

export class MdcVisualVO implements IMdcVisualVO {
    /** 工位名称集合 */
    categories!: string[] | undefined;
    /** 工位数据 */
    series!: MdcVisualData[] | undefined;

    constructor(data?: IMdcVisualVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["categories"] && data["categories"].constructor === Array) {
                this.categories = [] as any;
                for (let item of data["categories"])
                    this.categories!.push(item);
            }
            if (data["series"] && data["series"].constructor === Array) {
                this.series = [] as any;
                for (let item of data["series"])
                    this.series!.push(MdcVisualData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MdcVisualVO {
        data = typeof data === 'object' ? data : {};
        let result = new MdcVisualVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.categories && this.categories.constructor === Array) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        if (this.series && this.series.constructor === Array) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMdcVisualVO {
    /** 工位名称集合 */
    categories: string[] | undefined;
    /** 工位数据 */
    series: MdcVisualData[] | undefined;
}

export class OrderProcessDTO implements IOrderProcessDTO {
    /** 工序编码 */
    code!: string;
    /** 拆卸工时 */
    disassemblyTime!: number | undefined;
    /** 工艺参数1 */
    extend1!: string | undefined;
    /** 工艺参数2 */
    extend2!: string | undefined;
    /** 工艺参数3 */
    extend3!: string | undefined;
    /** 工艺参数4 */
    extend4!: string | undefined;
    /** 工艺参数5 */
    extend5!: string | undefined;
    /**  工序名称 */
    name!: string | undefined;
    /** 准备工时 */
    prepareTime!: number | undefined;
    /** 工序序号 */
    processSequence!: string | undefined;
    /** 程序名称 */
    programName!: string | undefined;
    /** 指派工位集合 */
    simpleWorkstationDTOList!: SimpleWorkstationDTO[] | undefined;
    /** 工序顺序 */
    sort!: number;
    /** 标准工时 */
    standardTime!: number;
    /** 运输工时 */
    transportTime!: number | undefined;

    constructor(data?: IOrderProcessDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.disassemblyTime = data["disassemblyTime"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.name = data["name"];
            this.prepareTime = data["prepareTime"];
            this.processSequence = data["processSequence"];
            this.programName = data["programName"];
            if (data["simpleWorkstationDTOList"] && data["simpleWorkstationDTOList"].constructor === Array) {
                this.simpleWorkstationDTOList = [] as any;
                for (let item of data["simpleWorkstationDTOList"])
                    this.simpleWorkstationDTOList!.push(SimpleWorkstationDTO.fromJS(item));
            }
            this.sort = data["sort"];
            this.standardTime = data["standardTime"];
            this.transportTime = data["transportTime"];
        }
    }

    static fromJS(data: any): OrderProcessDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProcessDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["disassemblyTime"] = this.disassemblyTime;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["name"] = this.name;
        data["prepareTime"] = this.prepareTime;
        data["processSequence"] = this.processSequence;
        data["programName"] = this.programName;
        if (this.simpleWorkstationDTOList && this.simpleWorkstationDTOList.constructor === Array) {
            data["simpleWorkstationDTOList"] = [];
            for (let item of this.simpleWorkstationDTOList)
                data["simpleWorkstationDTOList"].push(item.toJSON());
        }
        data["sort"] = this.sort;
        data["standardTime"] = this.standardTime;
        data["transportTime"] = this.transportTime;
        return data; 
    }
}

export interface IOrderProcessDTO {
    /** 工序编码 */
    code: string;
    /** 拆卸工时 */
    disassemblyTime: number | undefined;
    /** 工艺参数1 */
    extend1: string | undefined;
    /** 工艺参数2 */
    extend2: string | undefined;
    /** 工艺参数3 */
    extend3: string | undefined;
    /** 工艺参数4 */
    extend4: string | undefined;
    /** 工艺参数5 */
    extend5: string | undefined;
    /**  工序名称 */
    name: string | undefined;
    /** 准备工时 */
    prepareTime: number | undefined;
    /** 工序序号 */
    processSequence: string | undefined;
    /** 程序名称 */
    programName: string | undefined;
    /** 指派工位集合 */
    simpleWorkstationDTOList: SimpleWorkstationDTO[] | undefined;
    /** 工序顺序 */
    sort: number;
    /** 标准工时 */
    standardTime: number;
    /** 运输工时 */
    transportTime: number | undefined;
}

export class OrderProcessDetailDTO implements IOrderProcessDetailDTO {
    /** 工艺id */
    craftId!: string | undefined;
    /** 主键Id */
    id!: string | undefined;
    /** 投产数量 */
    inputNum!: number | undefined;
    /** 工单号 */
    orderCode!: string | undefined;
    /** 工单数量 */
    orderNum!: number | undefined;
    /** 计划编号 */
    planCode!: string | undefined;
    /** 计划数量 */
    planNum!: number | undefined;
    /** 工序编码 */
    processCode!: string | undefined;
    /**  工序名称 */
    processName!: string | undefined;
    /** 工序序号 */
    processSequence!: string | undefined;
    /** 产品编号 */
    productCode!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 合格数量 */
    qualifyNum!: number | undefined;
    /** 报工数量 */
    reportNum!: number | undefined;
    /** 报废数量 */
    scrappedNum!: number | undefined;
    /** 工序序号 */
    sort!: number | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;

    constructor(data?: IOrderProcessDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.craftId = data["craftId"];
            this.id = data["id"];
            this.inputNum = data["inputNum"];
            this.orderCode = data["orderCode"];
            this.orderNum = data["orderNum"];
            this.planCode = data["planCode"];
            this.planNum = data["planNum"];
            this.processCode = data["processCode"];
            this.processName = data["processName"];
            this.processSequence = data["processSequence"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.qualifyNum = data["qualifyNum"];
            this.reportNum = data["reportNum"];
            this.scrappedNum = data["scrappedNum"];
            this.sort = data["sort"];
            this.standardModel = data["standardModel"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): OrderProcessDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProcessDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["craftId"] = this.craftId;
        data["id"] = this.id;
        data["inputNum"] = this.inputNum;
        data["orderCode"] = this.orderCode;
        data["orderNum"] = this.orderNum;
        data["planCode"] = this.planCode;
        data["planNum"] = this.planNum;
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        data["processSequence"] = this.processSequence;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["qualifyNum"] = this.qualifyNum;
        data["reportNum"] = this.reportNum;
        data["scrappedNum"] = this.scrappedNum;
        data["sort"] = this.sort;
        data["standardModel"] = this.standardModel;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IOrderProcessDetailDTO {
    /** 工艺id */
    craftId: string | undefined;
    /** 主键Id */
    id: string | undefined;
    /** 投产数量 */
    inputNum: number | undefined;
    /** 工单号 */
    orderCode: string | undefined;
    /** 工单数量 */
    orderNum: number | undefined;
    /** 计划编号 */
    planCode: string | undefined;
    /** 计划数量 */
    planNum: number | undefined;
    /** 工序编码 */
    processCode: string | undefined;
    /**  工序名称 */
    processName: string | undefined;
    /** 工序序号 */
    processSequence: string | undefined;
    /** 产品编号 */
    productCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 合格数量 */
    qualifyNum: number | undefined;
    /** 报工数量 */
    reportNum: number | undefined;
    /** 报废数量 */
    scrappedNum: number | undefined;
    /** 工序序号 */
    sort: number | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
}

/** 工单工序详细信息 */
export class OrderProcessDetailInfo implements IOrderProcessDetailInfo {
    /** 开工记录ID */
    currentRecordId!: string | undefined;
    /** 上序合格数 */
    lastQualifyNum!: string | undefined;
    /** 物料编号 */
    materialCode!: string | undefined;
    /** 工单编号 */
    orderCode!: string | undefined;
    /** 工单数量 */
    orderNum!: number | undefined;
    /** 计划编号 */
    planCode!: string | undefined;
    /** 计划结束时间 */
    planEndTime!: Date | undefined;
    /** 计划数量 */
    planNum!: number | undefined;
    /** 计划开始时间 */
    planStartTime!: Date | undefined;
    /** 工单工序Id */
    poProcessId!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 员工姓名 */
    producerName!: string | undefined;
    /** 产品编号 */
    productCode!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 本序合格数 */
    qualifyNum!: number | undefined;
    /** 本次可报工 */
    reportableNum!: number | undefined;
    /** 本序报废数 */
    scrappedNum!: number | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 采集数量 */
    startCollectionNum!: number | undefined;
    /** 工位产能 */
    stationProductionCapacity!: number | undefined;
    /** 提交工时 */
    time!: number | undefined;
    /** 产量倍率 */
    yieldRatio!: number | undefined;

    constructor(data?: IOrderProcessDetailInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentRecordId = data["currentRecordId"];
            this.lastQualifyNum = data["lastQualifyNum"];
            this.materialCode = data["materialCode"];
            this.orderCode = data["orderCode"];
            this.orderNum = data["orderNum"];
            this.planCode = data["planCode"];
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.planNum = data["planNum"];
            this.planStartTime = data["planStartTime"] ? new Date(data["planStartTime"].toString()) : <any>undefined;
            this.poProcessId = data["poProcessId"];
            this.processName = data["processName"];
            this.producerName = data["producerName"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.qualifyNum = data["qualifyNum"];
            this.reportableNum = data["reportableNum"];
            this.scrappedNum = data["scrappedNum"];
            this.standardModel = data["standardModel"];
            this.startCollectionNum = data["startCollectionNum"];
            this.stationProductionCapacity = data["stationProductionCapacity"];
            this.time = data["time"];
            this.yieldRatio = data["yieldRatio"];
        }
    }

    static fromJS(data: any): OrderProcessDetailInfo {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProcessDetailInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentRecordId"] = this.currentRecordId;
        data["lastQualifyNum"] = this.lastQualifyNum;
        data["materialCode"] = this.materialCode;
        data["orderCode"] = this.orderCode;
        data["orderNum"] = this.orderNum;
        data["planCode"] = this.planCode;
        data["planEndTime"] = this.planEndTime ? this.planEndTime.toISOString() : <any>undefined;
        data["planNum"] = this.planNum;
        data["planStartTime"] = this.planStartTime ? this.planStartTime.toISOString() : <any>undefined;
        data["poProcessId"] = this.poProcessId;
        data["processName"] = this.processName;
        data["producerName"] = this.producerName;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["qualifyNum"] = this.qualifyNum;
        data["reportableNum"] = this.reportableNum;
        data["scrappedNum"] = this.scrappedNum;
        data["standardModel"] = this.standardModel;
        data["startCollectionNum"] = this.startCollectionNum;
        data["stationProductionCapacity"] = this.stationProductionCapacity;
        data["time"] = this.time;
        data["yieldRatio"] = this.yieldRatio;
        return data; 
    }
}

/** 工单工序详细信息 */
export interface IOrderProcessDetailInfo {
    /** 开工记录ID */
    currentRecordId: string | undefined;
    /** 上序合格数 */
    lastQualifyNum: string | undefined;
    /** 物料编号 */
    materialCode: string | undefined;
    /** 工单编号 */
    orderCode: string | undefined;
    /** 工单数量 */
    orderNum: number | undefined;
    /** 计划编号 */
    planCode: string | undefined;
    /** 计划结束时间 */
    planEndTime: Date | undefined;
    /** 计划数量 */
    planNum: number | undefined;
    /** 计划开始时间 */
    planStartTime: Date | undefined;
    /** 工单工序Id */
    poProcessId: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 员工姓名 */
    producerName: string | undefined;
    /** 产品编号 */
    productCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 本序合格数 */
    qualifyNum: number | undefined;
    /** 本次可报工 */
    reportableNum: number | undefined;
    /** 本序报废数 */
    scrappedNum: number | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 采集数量 */
    startCollectionNum: number | undefined;
    /** 工位产能 */
    stationProductionCapacity: number | undefined;
    /** 提交工时 */
    time: number | undefined;
    /** 产量倍率 */
    yieldRatio: number | undefined;
}

export class OrderProcessMaterialVO implements IOrderProcessMaterialVO {
    /** 已派数量 */
    assignedNum!: number | undefined;
    /** id */
    id!: string | undefined;
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 未派数量 */
    numNotAssigned!: number | undefined;
    /** 工单号 */
    orderCode!: string | undefined;
    /** 工单Id */
    orderId!: string | undefined;
    /** 工单物料Id */
    orderMaterialId!: string | undefined;
    /** 工序编码 */
    processCode!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 接收数量 */
    receiveNum!: number | undefined;
    /** 需求数量 */
    requireNum!: number | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 单位 */
    unit!: string | undefined;

    constructor(data?: IOrderProcessMaterialVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignedNum = data["assignedNum"];
            this.id = data["id"];
            this.materialCode = data["materialCode"];
            this.materialName = data["materialName"];
            this.numNotAssigned = data["numNotAssigned"];
            this.orderCode = data["orderCode"];
            this.orderId = data["orderId"];
            this.orderMaterialId = data["orderMaterialId"];
            this.processCode = data["processCode"];
            this.processName = data["processName"];
            this.receiveNum = data["receiveNum"];
            this.requireNum = data["requireNum"];
            this.standardModel = data["standardModel"];
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): OrderProcessMaterialVO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProcessMaterialVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedNum"] = this.assignedNum;
        data["id"] = this.id;
        data["materialCode"] = this.materialCode;
        data["materialName"] = this.materialName;
        data["numNotAssigned"] = this.numNotAssigned;
        data["orderCode"] = this.orderCode;
        data["orderId"] = this.orderId;
        data["orderMaterialId"] = this.orderMaterialId;
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        data["receiveNum"] = this.receiveNum;
        data["requireNum"] = this.requireNum;
        data["standardModel"] = this.standardModel;
        data["unit"] = this.unit;
        return data; 
    }
}

export interface IOrderProcessMaterialVO {
    /** 已派数量 */
    assignedNum: number | undefined;
    /** id */
    id: string | undefined;
    /** 物料编码 */
    materialCode: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 未派数量 */
    numNotAssigned: number | undefined;
    /** 工单号 */
    orderCode: string | undefined;
    /** 工单Id */
    orderId: string | undefined;
    /** 工单物料Id */
    orderMaterialId: string | undefined;
    /** 工序编码 */
    processCode: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 接收数量 */
    receiveNum: number | undefined;
    /** 需求数量 */
    requireNum: number | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 单位 */
    unit: string | undefined;
}

export class OrderProcessOutDTO implements IOrderProcessOutDTO {
    /** 采集数量 */
    collectionNum!: number | undefined;
    /** 拆卸工时 */
    disassemblyTime!: number | undefined;
    /** 待派发数量=投产数量-报工数量 */
    distributedNum!: number | undefined;
    /** 结束时间 */
    endTime!: Date | undefined;
    /** 工艺参数1 */
    extend1!: string | undefined;
    /** 工艺参数2 */
    extend2!: string | undefined;
    /** 工艺参数3 */
    extend3!: string | undefined;
    /** 工艺参数4 */
    extend4!: string | undefined;
    /** 工艺参数5 */
    extend5!: string | undefined;
    /** 主键Id */
    id!: string | undefined;
    /** 投产数量 */
    inputNum!: number | undefined;
    /** 准备工时 */
    prepareTime!: number | undefined;
    /** 工序编码 */
    processCode!: string | undefined;
    /**  工序名称 */
    processName!: string | undefined;
    /** 工序序号 */
    processSequence!: string | undefined;
    /** 工序状态 */
    processStatus!: number | undefined;
    /** 程序名称 */
    programName!: string | undefined;
    /** 合格数量 */
    qualifyNum!: number | undefined;
    /** 报工数量 */
    reportNum!: number | undefined;
    /** 报废数量 */
    scrappedNum!: number | undefined;
    /** 工序序号 */
    sort!: number | undefined;
    /** 标准工时 */
    standardTime!: number | undefined;
    /** 开始时间 */
    startTime!: Date | undefined;
    /** 运输工时 */
    transportTime!: number | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;
    /** 计划报工工时 */
    workTime!: number | undefined;

    constructor(data?: IOrderProcessOutDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.collectionNum = data["collectionNum"];
            this.disassemblyTime = data["disassemblyTime"];
            this.distributedNum = data["distributedNum"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.id = data["id"];
            this.inputNum = data["inputNum"];
            this.prepareTime = data["prepareTime"];
            this.processCode = data["processCode"];
            this.processName = data["processName"];
            this.processSequence = data["processSequence"];
            this.processStatus = data["processStatus"];
            this.programName = data["programName"];
            this.qualifyNum = data["qualifyNum"];
            this.reportNum = data["reportNum"];
            this.scrappedNum = data["scrappedNum"];
            this.sort = data["sort"];
            this.standardTime = data["standardTime"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.transportTime = data["transportTime"];
            this.workStationName = data["workStationName"];
            this.workTime = data["workTime"];
        }
    }

    static fromJS(data: any): OrderProcessOutDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProcessOutDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collectionNum"] = this.collectionNum;
        data["disassemblyTime"] = this.disassemblyTime;
        data["distributedNum"] = this.distributedNum;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["id"] = this.id;
        data["inputNum"] = this.inputNum;
        data["prepareTime"] = this.prepareTime;
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        data["processSequence"] = this.processSequence;
        data["processStatus"] = this.processStatus;
        data["programName"] = this.programName;
        data["qualifyNum"] = this.qualifyNum;
        data["reportNum"] = this.reportNum;
        data["scrappedNum"] = this.scrappedNum;
        data["sort"] = this.sort;
        data["standardTime"] = this.standardTime;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["transportTime"] = this.transportTime;
        data["workStationName"] = this.workStationName;
        data["workTime"] = this.workTime;
        return data; 
    }
}

export interface IOrderProcessOutDTO {
    /** 采集数量 */
    collectionNum: number | undefined;
    /** 拆卸工时 */
    disassemblyTime: number | undefined;
    /** 待派发数量=投产数量-报工数量 */
    distributedNum: number | undefined;
    /** 结束时间 */
    endTime: Date | undefined;
    /** 工艺参数1 */
    extend1: string | undefined;
    /** 工艺参数2 */
    extend2: string | undefined;
    /** 工艺参数3 */
    extend3: string | undefined;
    /** 工艺参数4 */
    extend4: string | undefined;
    /** 工艺参数5 */
    extend5: string | undefined;
    /** 主键Id */
    id: string | undefined;
    /** 投产数量 */
    inputNum: number | undefined;
    /** 准备工时 */
    prepareTime: number | undefined;
    /** 工序编码 */
    processCode: string | undefined;
    /**  工序名称 */
    processName: string | undefined;
    /** 工序序号 */
    processSequence: string | undefined;
    /** 工序状态 */
    processStatus: number | undefined;
    /** 程序名称 */
    programName: string | undefined;
    /** 合格数量 */
    qualifyNum: number | undefined;
    /** 报工数量 */
    reportNum: number | undefined;
    /** 报废数量 */
    scrappedNum: number | undefined;
    /** 工序序号 */
    sort: number | undefined;
    /** 标准工时 */
    standardTime: number | undefined;
    /** 开始时间 */
    startTime: Date | undefined;
    /** 运输工时 */
    transportTime: number | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
    /** 计划报工工时 */
    workTime: number | undefined;
}

/** 工单工序 */
export class OrderProcessOutVO implements IOrderProcessOutVO {
    /** 派工数量（派发数量） */
    assignNum!: number | undefined;
    /** 采集数量 */
    collectionNum!: number | undefined;
    /** 拆卸工时 */
    disassemblyTime!: number | undefined;
    /** 待派发数量=投产数量-报工数量 */
    distributedNum!: number | undefined;
    /** 结束时间 */
    endTime!: Date | undefined;
    /** 工艺参数1 */
    extend1!: string | undefined;
    /** 工艺参数2 */
    extend2!: string | undefined;
    /** 工艺参数3 */
    extend3!: string | undefined;
    /** 工艺参数4 */
    extend4!: string | undefined;
    /** 工艺参数5 */
    extend5!: string | undefined;
    /** 主键Id */
    id!: string | undefined;
    /** 投产数量 */
    inputNum!: number | undefined;
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 工单id */
    poId!: string | undefined;
    /** 准备工时 */
    prepareTime!: number | undefined;
    /** 上序合格数量 */
    previousQualifyNum!: number | undefined;
    /** 工序编码 */
    processCode!: string | undefined;
    /**  工序名称 */
    processName!: string | undefined;
    /** 工序序号 */
    processSequence!: string | undefined;
    /** 工序状态 */
    processStatus!: number | undefined;
    /** 产品编号 */
    productCode!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 工单编码（工单号） */
    productionOrderCode!: string | undefined;
    /** 程序名称 */
    programName!: string | undefined;
    /** 合格数量 */
    qualifyNum!: number | undefined;
    /** 报工数量 */
    reportNum!: number | undefined;
    /** 报废数量 */
    scrappedNum!: number | undefined;
    /** 工序序号 */
    sort!: number | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 标准工时 */
    standardTime!: number | undefined;
    /** 开始时间 */
    startTime!: Date | undefined;
    /** 运输工时 */
    transportTime!: number | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;
    /** 状态：1 未开工  2 已开工 */
    workStatus!: number | undefined;
    /** 工序状态描述:1 未开工  2 已开工 */
    workStatusDesc!: string | undefined;
    /** 计划报工工时 */
    workTime!: number | undefined;

    constructor(data?: IOrderProcessOutVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignNum = data["assignNum"];
            this.collectionNum = data["collectionNum"];
            this.disassemblyTime = data["disassemblyTime"];
            this.distributedNum = data["distributedNum"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.id = data["id"];
            this.inputNum = data["inputNum"];
            this.materialCode = data["materialCode"];
            this.poId = data["poId"];
            this.prepareTime = data["prepareTime"];
            this.previousQualifyNum = data["previousQualifyNum"];
            this.processCode = data["processCode"];
            this.processName = data["processName"];
            this.processSequence = data["processSequence"];
            this.processStatus = data["processStatus"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.productionOrderCode = data["productionOrderCode"];
            this.programName = data["programName"];
            this.qualifyNum = data["qualifyNum"];
            this.reportNum = data["reportNum"];
            this.scrappedNum = data["scrappedNum"];
            this.sort = data["sort"];
            this.standardModel = data["standardModel"];
            this.standardTime = data["standardTime"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.transportTime = data["transportTime"];
            this.workStationName = data["workStationName"];
            this.workStatus = data["workStatus"];
            this.workStatusDesc = data["workStatusDesc"];
            this.workTime = data["workTime"];
        }
    }

    static fromJS(data: any): OrderProcessOutVO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProcessOutVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignNum"] = this.assignNum;
        data["collectionNum"] = this.collectionNum;
        data["disassemblyTime"] = this.disassemblyTime;
        data["distributedNum"] = this.distributedNum;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["id"] = this.id;
        data["inputNum"] = this.inputNum;
        data["materialCode"] = this.materialCode;
        data["poId"] = this.poId;
        data["prepareTime"] = this.prepareTime;
        data["previousQualifyNum"] = this.previousQualifyNum;
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        data["processSequence"] = this.processSequence;
        data["processStatus"] = this.processStatus;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productionOrderCode"] = this.productionOrderCode;
        data["programName"] = this.programName;
        data["qualifyNum"] = this.qualifyNum;
        data["reportNum"] = this.reportNum;
        data["scrappedNum"] = this.scrappedNum;
        data["sort"] = this.sort;
        data["standardModel"] = this.standardModel;
        data["standardTime"] = this.standardTime;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["transportTime"] = this.transportTime;
        data["workStationName"] = this.workStationName;
        data["workStatus"] = this.workStatus;
        data["workStatusDesc"] = this.workStatusDesc;
        data["workTime"] = this.workTime;
        return data; 
    }
}

/** 工单工序 */
export interface IOrderProcessOutVO {
    /** 派工数量（派发数量） */
    assignNum: number | undefined;
    /** 采集数量 */
    collectionNum: number | undefined;
    /** 拆卸工时 */
    disassemblyTime: number | undefined;
    /** 待派发数量=投产数量-报工数量 */
    distributedNum: number | undefined;
    /** 结束时间 */
    endTime: Date | undefined;
    /** 工艺参数1 */
    extend1: string | undefined;
    /** 工艺参数2 */
    extend2: string | undefined;
    /** 工艺参数3 */
    extend3: string | undefined;
    /** 工艺参数4 */
    extend4: string | undefined;
    /** 工艺参数5 */
    extend5: string | undefined;
    /** 主键Id */
    id: string | undefined;
    /** 投产数量 */
    inputNum: number | undefined;
    /** 物料编码 */
    materialCode: string | undefined;
    /** 工单id */
    poId: string | undefined;
    /** 准备工时 */
    prepareTime: number | undefined;
    /** 上序合格数量 */
    previousQualifyNum: number | undefined;
    /** 工序编码 */
    processCode: string | undefined;
    /**  工序名称 */
    processName: string | undefined;
    /** 工序序号 */
    processSequence: string | undefined;
    /** 工序状态 */
    processStatus: number | undefined;
    /** 产品编号 */
    productCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 工单编码（工单号） */
    productionOrderCode: string | undefined;
    /** 程序名称 */
    programName: string | undefined;
    /** 合格数量 */
    qualifyNum: number | undefined;
    /** 报工数量 */
    reportNum: number | undefined;
    /** 报废数量 */
    scrappedNum: number | undefined;
    /** 工序序号 */
    sort: number | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 标准工时 */
    standardTime: number | undefined;
    /** 开始时间 */
    startTime: Date | undefined;
    /** 运输工时 */
    transportTime: number | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
    /** 状态：1 未开工  2 已开工 */
    workStatus: number | undefined;
    /** 工序状态描述:1 未开工  2 已开工 */
    workStatusDesc: string | undefined;
    /** 计划报工工时 */
    workTime: number | undefined;
}

export class OrderProcessQcAddDTO implements IOrderProcessQcAddDTO {
    /** 工单工序id */
    poProcessId!: string | undefined;
    /** 加工人员 */
    producerName!: string | undefined;
    qcItemDTOList!: QcItemDTO[] | undefined;
    /** 质检人员 */
    qcName!: string | undefined;

    constructor(data?: IOrderProcessQcAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.poProcessId = data["poProcessId"];
            this.producerName = data["producerName"];
            if (data["qcItemDTOList"] && data["qcItemDTOList"].constructor === Array) {
                this.qcItemDTOList = [] as any;
                for (let item of data["qcItemDTOList"])
                    this.qcItemDTOList!.push(QcItemDTO.fromJS(item));
            }
            this.qcName = data["qcName"];
        }
    }

    static fromJS(data: any): OrderProcessQcAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProcessQcAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poProcessId"] = this.poProcessId;
        data["producerName"] = this.producerName;
        if (this.qcItemDTOList && this.qcItemDTOList.constructor === Array) {
            data["qcItemDTOList"] = [];
            for (let item of this.qcItemDTOList)
                data["qcItemDTOList"].push(item.toJSON());
        }
        data["qcName"] = this.qcName;
        return data; 
    }
}

export interface IOrderProcessQcAddDTO {
    /** 工单工序id */
    poProcessId: string | undefined;
    /** 加工人员 */
    producerName: string | undefined;
    qcItemDTOList: QcItemDTO[] | undefined;
    /** 质检人员 */
    qcName: string | undefined;
}

export class OrderProcessReportWorkDTO implements IOrderProcessReportWorkDTO {
    /** 自定义字段1 */
    extend1!: string | undefined;
    /** 自定义字段2 */
    extend2!: string | undefined;
    /** 自定义字段3 */
    extend3!: string | undefined;
    /** 报工合格数量 */
    qualifyNum!: number | undefined;
    /** 开工记录id */
    recordId!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 报工报废数量 */
    scrappedNum!: number | undefined;
    /** 报废原因集合 */
    workStationScrappedRecordDTOList!: WorkStationScrappedRecordDTO[] | undefined;

    constructor(data?: IOrderProcessReportWorkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.qualifyNum = data["qualifyNum"];
            this.recordId = data["recordId"];
            this.remark = data["remark"];
            this.scrappedNum = data["scrappedNum"];
            if (data["workStationScrappedRecordDTOList"] && data["workStationScrappedRecordDTOList"].constructor === Array) {
                this.workStationScrappedRecordDTOList = [] as any;
                for (let item of data["workStationScrappedRecordDTOList"])
                    this.workStationScrappedRecordDTOList!.push(WorkStationScrappedRecordDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderProcessReportWorkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProcessReportWorkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["qualifyNum"] = this.qualifyNum;
        data["recordId"] = this.recordId;
        data["remark"] = this.remark;
        data["scrappedNum"] = this.scrappedNum;
        if (this.workStationScrappedRecordDTOList && this.workStationScrappedRecordDTOList.constructor === Array) {
            data["workStationScrappedRecordDTOList"] = [];
            for (let item of this.workStationScrappedRecordDTOList)
                data["workStationScrappedRecordDTOList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IOrderProcessReportWorkDTO {
    /** 自定义字段1 */
    extend1: string | undefined;
    /** 自定义字段2 */
    extend2: string | undefined;
    /** 自定义字段3 */
    extend3: string | undefined;
    /** 报工合格数量 */
    qualifyNum: number | undefined;
    /** 开工记录id */
    recordId: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 报工报废数量 */
    scrappedNum: number | undefined;
    /** 报废原因集合 */
    workStationScrappedRecordDTOList: WorkStationScrappedRecordDTO[] | undefined;
}

export class OrderProcessStartWorkDTO implements IOrderProcessStartWorkDTO {
    /** 生产员工编号 */
    employeeCode!: string | undefined;
    /** 生产员工id */
    employeeId!: string | undefined;
    /** 生产员工姓名 */
    employeeName!: string | undefined;
    /** 工单工序id */
    orderProcessId!: string | undefined;
    /** 工位id */
    workStationId!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;
    /** 产量倍率 */
    yieldRatio!: number | undefined;

    constructor(data?: IOrderProcessStartWorkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.employeeCode = data["employeeCode"];
            this.employeeId = data["employeeId"];
            this.employeeName = data["employeeName"];
            this.orderProcessId = data["orderProcessId"];
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
            this.yieldRatio = data["yieldRatio"];
        }
    }

    static fromJS(data: any): OrderProcessStartWorkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProcessStartWorkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeCode"] = this.employeeCode;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["orderProcessId"] = this.orderProcessId;
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        data["yieldRatio"] = this.yieldRatio;
        return data; 
    }
}

export interface IOrderProcessStartWorkDTO {
    /** 生产员工编号 */
    employeeCode: string | undefined;
    /** 生产员工id */
    employeeId: string | undefined;
    /** 生产员工姓名 */
    employeeName: string | undefined;
    /** 工单工序id */
    orderProcessId: string | undefined;
    /** 工位id */
    workStationId: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
    /** 产量倍率 */
    yieldRatio: number | undefined;
}

export class OrderProcessWipDTO implements IOrderProcessWipDTO {
    /** 本序采集数/采集数量 */
    collectionNum!: number | undefined;
    /** 工序编码 */
    processCode!: string | undefined;
    /** 工序顺序 */
    processIndex!: number | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 工序序号 */
    processSequence!: string | undefined;
    /** 本序合格数 */
    qualifyNum!: number | undefined;
    /** 合格率 */
    qualifyRate!: string | undefined;
    /** 本序报废数 */
    scrappedNum!: number | undefined;
    /** 上序合格数 */
    superQualifyNum!: number | undefined;
    /** 剩余数量 */
    surplusNum!: number | undefined;

    constructor(data?: IOrderProcessWipDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.collectionNum = data["collectionNum"];
            this.processCode = data["processCode"];
            this.processIndex = data["processIndex"];
            this.processName = data["processName"];
            this.processSequence = data["processSequence"];
            this.qualifyNum = data["qualifyNum"];
            this.qualifyRate = data["qualifyRate"];
            this.scrappedNum = data["scrappedNum"];
            this.superQualifyNum = data["superQualifyNum"];
            this.surplusNum = data["surplusNum"];
        }
    }

    static fromJS(data: any): OrderProcessWipDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProcessWipDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collectionNum"] = this.collectionNum;
        data["processCode"] = this.processCode;
        data["processIndex"] = this.processIndex;
        data["processName"] = this.processName;
        data["processSequence"] = this.processSequence;
        data["qualifyNum"] = this.qualifyNum;
        data["qualifyRate"] = this.qualifyRate;
        data["scrappedNum"] = this.scrappedNum;
        data["superQualifyNum"] = this.superQualifyNum;
        data["surplusNum"] = this.surplusNum;
        return data; 
    }
}

export interface IOrderProcessWipDTO {
    /** 本序采集数/采集数量 */
    collectionNum: number | undefined;
    /** 工序编码 */
    processCode: string | undefined;
    /** 工序顺序 */
    processIndex: number | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 工序序号 */
    processSequence: string | undefined;
    /** 本序合格数 */
    qualifyNum: number | undefined;
    /** 合格率 */
    qualifyRate: string | undefined;
    /** 本序报废数 */
    scrappedNum: number | undefined;
    /** 上序合格数 */
    superQualifyNum: number | undefined;
    /** 剩余数量 */
    surplusNum: number | undefined;
}

/** 手机端工序详情 */
export class OrderProcessWorkDetailVO implements IOrderProcessWorkDetailVO {
    /** 派发数量 */
    assignNum!: number | undefined;
    /** 采集数量 */
    collectionNum!: number | undefined;
    /** 结束时间 */
    endTime!: Date | undefined;
    /** 工单编号 */
    orderCode!: string | undefined;
    /** 工单工序id */
    orderProcessId!: string | undefined;
    /** 投产数量 */
    orderProcessInputNum!: number | undefined;
    /** 工序名称 */
    orderProcessName!: string | undefined;
    /** 已报工数量 */
    orderProcessReportNum!: number | undefined;
    /** 待报工数量（本次可报） */
    orderProcessUnreportNum!: number | undefined;
    /** 工序工位详情 */
    orderProcessWorkStations!: OrderProcessWorkStationDTO[] | undefined;
    /** 上序合格数量[第一道序的上一道序合格为空] */
    previousQualifyNum!: number | undefined;
    /** 工序派工（0-未启用、1-启用） */
    processAssignMode!: number | undefined;
    /** 工序编号 */
    processCode!: string | undefined;
    /** 当前状态 */
    processStatus!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 本序合格数量 */
    qualifyNum!: number | undefined;
    /** 本序报废数量 */
    scrappedNum!: number | undefined;
    /** 工序顺序 */
    sort!: number | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 提交工时 */
    submitWorkHour!: number | undefined;

    constructor(data?: IOrderProcessWorkDetailVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignNum = data["assignNum"];
            this.collectionNum = data["collectionNum"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.orderCode = data["orderCode"];
            this.orderProcessId = data["orderProcessId"];
            this.orderProcessInputNum = data["orderProcessInputNum"];
            this.orderProcessName = data["orderProcessName"];
            this.orderProcessReportNum = data["orderProcessReportNum"];
            this.orderProcessUnreportNum = data["orderProcessUnreportNum"];
            if (data["orderProcessWorkStations"] && data["orderProcessWorkStations"].constructor === Array) {
                this.orderProcessWorkStations = [] as any;
                for (let item of data["orderProcessWorkStations"])
                    this.orderProcessWorkStations!.push(OrderProcessWorkStationDTO.fromJS(item));
            }
            this.previousQualifyNum = data["previousQualifyNum"];
            this.processAssignMode = data["processAssignMode"];
            this.processCode = data["processCode"];
            this.processStatus = data["processStatus"];
            this.productName = data["productName"];
            this.qualifyNum = data["qualifyNum"];
            this.scrappedNum = data["scrappedNum"];
            this.sort = data["sort"];
            this.standardModel = data["standardModel"];
            this.submitWorkHour = data["submitWorkHour"];
        }
    }

    static fromJS(data: any): OrderProcessWorkDetailVO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProcessWorkDetailVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignNum"] = this.assignNum;
        data["collectionNum"] = this.collectionNum;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["orderCode"] = this.orderCode;
        data["orderProcessId"] = this.orderProcessId;
        data["orderProcessInputNum"] = this.orderProcessInputNum;
        data["orderProcessName"] = this.orderProcessName;
        data["orderProcessReportNum"] = this.orderProcessReportNum;
        data["orderProcessUnreportNum"] = this.orderProcessUnreportNum;
        if (this.orderProcessWorkStations && this.orderProcessWorkStations.constructor === Array) {
            data["orderProcessWorkStations"] = [];
            for (let item of this.orderProcessWorkStations)
                data["orderProcessWorkStations"].push(item.toJSON());
        }
        data["previousQualifyNum"] = this.previousQualifyNum;
        data["processAssignMode"] = this.processAssignMode;
        data["processCode"] = this.processCode;
        data["processStatus"] = this.processStatus;
        data["productName"] = this.productName;
        data["qualifyNum"] = this.qualifyNum;
        data["scrappedNum"] = this.scrappedNum;
        data["sort"] = this.sort;
        data["standardModel"] = this.standardModel;
        data["submitWorkHour"] = this.submitWorkHour;
        return data; 
    }
}

/** 手机端工序详情 */
export interface IOrderProcessWorkDetailVO {
    /** 派发数量 */
    assignNum: number | undefined;
    /** 采集数量 */
    collectionNum: number | undefined;
    /** 结束时间 */
    endTime: Date | undefined;
    /** 工单编号 */
    orderCode: string | undefined;
    /** 工单工序id */
    orderProcessId: string | undefined;
    /** 投产数量 */
    orderProcessInputNum: number | undefined;
    /** 工序名称 */
    orderProcessName: string | undefined;
    /** 已报工数量 */
    orderProcessReportNum: number | undefined;
    /** 待报工数量（本次可报） */
    orderProcessUnreportNum: number | undefined;
    /** 工序工位详情 */
    orderProcessWorkStations: OrderProcessWorkStationDTO[] | undefined;
    /** 上序合格数量[第一道序的上一道序合格为空] */
    previousQualifyNum: number | undefined;
    /** 工序派工（0-未启用、1-启用） */
    processAssignMode: number | undefined;
    /** 工序编号 */
    processCode: string | undefined;
    /** 当前状态 */
    processStatus: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 本序合格数量 */
    qualifyNum: number | undefined;
    /** 本序报废数量 */
    scrappedNum: number | undefined;
    /** 工序顺序 */
    sort: number | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 提交工时 */
    submitWorkHour: number | undefined;
}

export class OrderProcessWorkStationBO implements IOrderProcessWorkStationBO {
    /** 工序编号 */
    processCode!: string | undefined;
    /** 工序id */
    processId!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 工序序号 */
    processSequence!: string | undefined;
    /** 工序顺序 */
    sort!: number | undefined;
    /** 工序工位信息 */
    workStationInfoDTO!: WorkStationInfoDTO[] | undefined;

    constructor(data?: IOrderProcessWorkStationBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.processCode = data["processCode"];
            this.processId = data["processId"];
            this.processName = data["processName"];
            this.processSequence = data["processSequence"];
            this.sort = data["sort"];
            if (data["workStationInfoDTO"] && data["workStationInfoDTO"].constructor === Array) {
                this.workStationInfoDTO = [] as any;
                for (let item of data["workStationInfoDTO"])
                    this.workStationInfoDTO!.push(WorkStationInfoDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderProcessWorkStationBO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProcessWorkStationBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processCode"] = this.processCode;
        data["processId"] = this.processId;
        data["processName"] = this.processName;
        data["processSequence"] = this.processSequence;
        data["sort"] = this.sort;
        if (this.workStationInfoDTO && this.workStationInfoDTO.constructor === Array) {
            data["workStationInfoDTO"] = [];
            for (let item of this.workStationInfoDTO)
                data["workStationInfoDTO"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IOrderProcessWorkStationBO {
    /** 工序编号 */
    processCode: string | undefined;
    /** 工序id */
    processId: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 工序序号 */
    processSequence: string | undefined;
    /** 工序顺序 */
    sort: number | undefined;
    /** 工序工位信息 */
    workStationInfoDTO: WorkStationInfoDTO[] | undefined;
}

export class OrderProcessWorkStationDTO implements IOrderProcessWorkStationDTO {
    /** 指派数量 */
    assignNum!: number | undefined;
    /** 采集数量 */
    collectionNum!: number | undefined;
    /** 人员待报工数量 */
    employeeUnreportNum!: number | undefined;
    /** 开工工位id */
    id!: string | undefined;
    /** 加工人员id */
    producerId!: string | undefined;
    /** 加工人员姓名 */
    producerName!: string | undefined;
    /** 待加工数量=指派数量-合格-报废 */
    unreportNum!: number | undefined;
    /** 设备采集产量 */
    workStationCollectNum!: number | undefined;
    /** 所属工位id */
    workStationId!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;
    /** 当前工作记录id */
    workStationRecordId!: string | undefined;
    /** 工位状态：null或1-未开工，2-已开工 */
    workStationStatus!: number | undefined;
    /** 产量倍率 */
    yieldRatio!: number | undefined;

    constructor(data?: IOrderProcessWorkStationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignNum = data["assignNum"];
            this.collectionNum = data["collectionNum"];
            this.employeeUnreportNum = data["employeeUnreportNum"];
            this.id = data["id"];
            this.producerId = data["producerId"];
            this.producerName = data["producerName"];
            this.unreportNum = data["unreportNum"];
            this.workStationCollectNum = data["workStationCollectNum"];
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
            this.workStationRecordId = data["workStationRecordId"];
            this.workStationStatus = data["workStationStatus"];
            this.yieldRatio = data["yieldRatio"];
        }
    }

    static fromJS(data: any): OrderProcessWorkStationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProcessWorkStationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignNum"] = this.assignNum;
        data["collectionNum"] = this.collectionNum;
        data["employeeUnreportNum"] = this.employeeUnreportNum;
        data["id"] = this.id;
        data["producerId"] = this.producerId;
        data["producerName"] = this.producerName;
        data["unreportNum"] = this.unreportNum;
        data["workStationCollectNum"] = this.workStationCollectNum;
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        data["workStationRecordId"] = this.workStationRecordId;
        data["workStationStatus"] = this.workStationStatus;
        data["yieldRatio"] = this.yieldRatio;
        return data; 
    }
}

export interface IOrderProcessWorkStationDTO {
    /** 指派数量 */
    assignNum: number | undefined;
    /** 采集数量 */
    collectionNum: number | undefined;
    /** 人员待报工数量 */
    employeeUnreportNum: number | undefined;
    /** 开工工位id */
    id: string | undefined;
    /** 加工人员id */
    producerId: string | undefined;
    /** 加工人员姓名 */
    producerName: string | undefined;
    /** 待加工数量=指派数量-合格-报废 */
    unreportNum: number | undefined;
    /** 设备采集产量 */
    workStationCollectNum: number | undefined;
    /** 所属工位id */
    workStationId: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
    /** 当前工作记录id */
    workStationRecordId: string | undefined;
    /** 工位状态：null或1-未开工，2-已开工 */
    workStationStatus: number | undefined;
    /** 产量倍率 */
    yieldRatio: number | undefined;
}

export class OutStockDTO implements IOutStockDTO {
    /** 库区名称 */
    area!: string | undefined;
    /** 库区Id */
    areaId!: string | undefined;
    /** 库位 */
    location!: string | undefined;
    /** 库位Id */
    locationId!: string | undefined;
    /** 物料编号 */
    materialCode!: string | undefined;
    /** 物料Id */
    materialId!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 物料类型 */
    materialType!: string | undefined;
    /** 出库数量 */
    number!: number | undefined;
    /** 出库工序编号 */
    processCode!: string | undefined;
    /** 工序Id */
    processId!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 备注 */
    remarks!: string | undefined;
    /** 规格 */
    specification!: string | undefined;
    /** 库存 */
    stockNumber!: number | undefined;
    /** 材质 */
    stuff!: string | undefined;
    /** 单位 */
    unit!: string | undefined;

    constructor(data?: IOutStockDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.area = data["area"];
            this.areaId = data["areaId"];
            this.location = data["location"];
            this.locationId = data["locationId"];
            this.materialCode = data["materialCode"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.materialType = data["materialType"];
            this.number = data["number"];
            this.processCode = data["processCode"];
            this.processId = data["processId"];
            this.processName = data["processName"];
            this.remarks = data["remarks"];
            this.specification = data["specification"];
            this.stockNumber = data["stockNumber"];
            this.stuff = data["stuff"];
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): OutStockDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OutStockDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["area"] = this.area;
        data["areaId"] = this.areaId;
        data["location"] = this.location;
        data["locationId"] = this.locationId;
        data["materialCode"] = this.materialCode;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["materialType"] = this.materialType;
        data["number"] = this.number;
        data["processCode"] = this.processCode;
        data["processId"] = this.processId;
        data["processName"] = this.processName;
        data["remarks"] = this.remarks;
        data["specification"] = this.specification;
        data["stockNumber"] = this.stockNumber;
        data["stuff"] = this.stuff;
        data["unit"] = this.unit;
        return data; 
    }
}

export interface IOutStockDTO {
    /** 库区名称 */
    area: string | undefined;
    /** 库区Id */
    areaId: string | undefined;
    /** 库位 */
    location: string | undefined;
    /** 库位Id */
    locationId: string | undefined;
    /** 物料编号 */
    materialCode: string | undefined;
    /** 物料Id */
    materialId: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 物料类型 */
    materialType: string | undefined;
    /** 出库数量 */
    number: number | undefined;
    /** 出库工序编号 */
    processCode: string | undefined;
    /** 工序Id */
    processId: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 备注 */
    remarks: string | undefined;
    /** 规格 */
    specification: string | undefined;
    /** 库存 */
    stockNumber: number | undefined;
    /** 材质 */
    stuff: string | undefined;
    /** 单位 */
    unit: string | undefined;
}

export class PageOrderProcessQcItemVO implements IPageOrderProcessQcItemVO {
    /** 主键id */
    id!: string | undefined;
    /** 质检项名称 */
    itemName!: string | undefined;
    /** 测量值 */
    measuredValue!: number | undefined;
    /** 工单号 */
    orderCode!: string | undefined;
    /** 工序编码 */
    processCode!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 加工人员 */
    producerName!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 质检人员 */
    qcName!: string | undefined;
    /** 质检时间 */
    qcTime!: Date | undefined;
    /** 标准值 */
    standardValue!: number | undefined;
    /** 加工工位 */
    workStationName!: string | undefined;

    constructor(data?: IPageOrderProcessQcItemVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.itemName = data["itemName"];
            this.measuredValue = data["measuredValue"];
            this.orderCode = data["orderCode"];
            this.processCode = data["processCode"];
            this.processName = data["processName"];
            this.producerName = data["producerName"];
            this.productName = data["productName"];
            this.qcName = data["qcName"];
            this.qcTime = data["qcTime"] ? new Date(data["qcTime"].toString()) : <any>undefined;
            this.standardValue = data["standardValue"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): PageOrderProcessQcItemVO {
        data = typeof data === 'object' ? data : {};
        let result = new PageOrderProcessQcItemVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemName"] = this.itemName;
        data["measuredValue"] = this.measuredValue;
        data["orderCode"] = this.orderCode;
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        data["producerName"] = this.producerName;
        data["productName"] = this.productName;
        data["qcName"] = this.qcName;
        data["qcTime"] = this.qcTime ? this.qcTime.toISOString() : <any>undefined;
        data["standardValue"] = this.standardValue;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IPageOrderProcessQcItemVO {
    /** 主键id */
    id: string | undefined;
    /** 质检项名称 */
    itemName: string | undefined;
    /** 测量值 */
    measuredValue: number | undefined;
    /** 工单号 */
    orderCode: string | undefined;
    /** 工序编码 */
    processCode: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 加工人员 */
    producerName: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 质检人员 */
    qcName: string | undefined;
    /** 质检时间 */
    qcTime: Date | undefined;
    /** 标准值 */
    standardValue: number | undefined;
    /** 加工工位 */
    workStationName: string | undefined;
}

export class PageProductionPlanBO implements IPageProductionPlanBO {
    /** bom版本 */
    bomVersion!: string | undefined;
    /** 计划类别 */
    category!: number | undefined;
    /** 生产计划编号 */
    code!: string | undefined;
    /** 所属产品工艺 */
    craftId!: string | undefined;
    /** 产品工艺版本 */
    craftVersion!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 客户名称 */
    customerName!: string | undefined;
    /** 实际结束时间 */
    endTime!: Date | undefined;
    /** 扩展字段1 */
    extend1!: string | undefined;
    /** 扩展字段2 */
    extend2!: string | undefined;
    /** 扩展字段3 */
    extend3!: string | undefined;
    /** 扩展字段4 */
    extend4!: string | undefined;
    /** 扩展字段5 */
    extend5!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 物料编号 */
    materialCode!: string | undefined;
    /** 订单编码 */
    orderCode!: string | undefined;
    /** 计划结束时间 */
    planEndTime!: Date | undefined;
    /** 计划模式，1-依序进行、2-多序并行 */
    planMode!: number | undefined;
    /** 计划数量 */
    planNum!: number | undefined;
    /** 计划开始时间 */
    planStartTime!: Date | undefined;
    /** 计划状态 */
    planStatus!: number | undefined;
    /** 暂停前状态 */
    planStatusBefore!: number | undefined;
    /** 产品编号 */
    productCode!: string | undefined;
    /** 所属产品 */
    productId!: string | undefined;
    /** 产品信息 */
    productInfo!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 产品类型Id */
    productTypeId!: string | undefined;
    /** 产品类型名称 */
    productTypeName!: string | undefined;
    /** 合格数量 */
    qualifyNum!: number | undefined;
    /** 报工数量 */
    reportNum!: number | undefined;
    /** 报废数量 */
    scrappedNum!: number | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 实际开始时间 */
    startTime!: Date | undefined;
    /** 待派发数量 */
    unassignedNum!: number | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IPageProductionPlanBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bomVersion = data["bomVersion"];
            this.category = data["category"];
            this.code = data["code"];
            this.craftId = data["craftId"];
            this.craftVersion = data["craftVersion"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.customerName = data["customerName"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.id = data["id"];
            this.materialCode = data["materialCode"];
            this.orderCode = data["orderCode"];
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.planMode = data["planMode"];
            this.planNum = data["planNum"];
            this.planStartTime = data["planStartTime"] ? new Date(data["planStartTime"].toString()) : <any>undefined;
            this.planStatus = data["planStatus"];
            this.planStatusBefore = data["planStatusBefore"];
            this.productCode = data["productCode"];
            this.productId = data["productId"];
            this.productInfo = data["productInfo"];
            this.productName = data["productName"];
            this.productTypeId = data["productTypeId"];
            this.productTypeName = data["productTypeName"];
            this.qualifyNum = data["qualifyNum"];
            this.reportNum = data["reportNum"];
            this.scrappedNum = data["scrappedNum"];
            this.standardModel = data["standardModel"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.unassignedNum = data["unassignedNum"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): PageProductionPlanBO {
        data = typeof data === 'object' ? data : {};
        let result = new PageProductionPlanBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bomVersion"] = this.bomVersion;
        data["category"] = this.category;
        data["code"] = this.code;
        data["craftId"] = this.craftId;
        data["craftVersion"] = this.craftVersion;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["customerName"] = this.customerName;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["id"] = this.id;
        data["materialCode"] = this.materialCode;
        data["orderCode"] = this.orderCode;
        data["planEndTime"] = this.planEndTime ? this.planEndTime.toISOString() : <any>undefined;
        data["planMode"] = this.planMode;
        data["planNum"] = this.planNum;
        data["planStartTime"] = this.planStartTime ? this.planStartTime.toISOString() : <any>undefined;
        data["planStatus"] = this.planStatus;
        data["planStatusBefore"] = this.planStatusBefore;
        data["productCode"] = this.productCode;
        data["productId"] = this.productId;
        data["productInfo"] = this.productInfo;
        data["productName"] = this.productName;
        data["productTypeId"] = this.productTypeId;
        data["productTypeName"] = this.productTypeName;
        data["qualifyNum"] = this.qualifyNum;
        data["reportNum"] = this.reportNum;
        data["scrappedNum"] = this.scrappedNum;
        data["standardModel"] = this.standardModel;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["unassignedNum"] = this.unassignedNum;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

export interface IPageProductionPlanBO {
    /** bom版本 */
    bomVersion: string | undefined;
    /** 计划类别 */
    category: number | undefined;
    /** 生产计划编号 */
    code: string | undefined;
    /** 所属产品工艺 */
    craftId: string | undefined;
    /** 产品工艺版本 */
    craftVersion: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 客户名称 */
    customerName: string | undefined;
    /** 实际结束时间 */
    endTime: Date | undefined;
    /** 扩展字段1 */
    extend1: string | undefined;
    /** 扩展字段2 */
    extend2: string | undefined;
    /** 扩展字段3 */
    extend3: string | undefined;
    /** 扩展字段4 */
    extend4: string | undefined;
    /** 扩展字段5 */
    extend5: string | undefined;
    /** id */
    id: string | undefined;
    /** 物料编号 */
    materialCode: string | undefined;
    /** 订单编码 */
    orderCode: string | undefined;
    /** 计划结束时间 */
    planEndTime: Date | undefined;
    /** 计划模式，1-依序进行、2-多序并行 */
    planMode: number | undefined;
    /** 计划数量 */
    planNum: number | undefined;
    /** 计划开始时间 */
    planStartTime: Date | undefined;
    /** 计划状态 */
    planStatus: number | undefined;
    /** 暂停前状态 */
    planStatusBefore: number | undefined;
    /** 产品编号 */
    productCode: string | undefined;
    /** 所属产品 */
    productId: string | undefined;
    /** 产品信息 */
    productInfo: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 产品类型Id */
    productTypeId: string | undefined;
    /** 产品类型名称 */
    productTypeName: string | undefined;
    /** 合格数量 */
    qualifyNum: number | undefined;
    /** 报工数量 */
    reportNum: number | undefined;
    /** 报废数量 */
    scrappedNum: number | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 实际开始时间 */
    startTime: Date | undefined;
    /** 待派发数量 */
    unassignedNum: number | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

export class PlanMaterialDTO implements IPlanMaterialDTO {
    /** 库区 */
    area!: string | undefined;
    /** 配领人员 */
    customer!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 库位 */
    location!: string | undefined;
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 实际需求 */
    realRequireNum!: number | undefined;
    /** 需求数量 */
    requireNum!: number | undefined;
    /** 需求状态 */
    requireStatus!: number | undefined;

    constructor(data?: IPlanMaterialDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.area = data["area"];
            this.customer = data["customer"];
            this.id = data["id"];
            this.location = data["location"];
            this.materialCode = data["materialCode"];
            this.materialName = data["materialName"];
            this.realRequireNum = data["realRequireNum"];
            this.requireNum = data["requireNum"];
            this.requireStatus = data["requireStatus"];
        }
    }

    static fromJS(data: any): PlanMaterialDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlanMaterialDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["area"] = this.area;
        data["customer"] = this.customer;
        data["id"] = this.id;
        data["location"] = this.location;
        data["materialCode"] = this.materialCode;
        data["materialName"] = this.materialName;
        data["realRequireNum"] = this.realRequireNum;
        data["requireNum"] = this.requireNum;
        data["requireStatus"] = this.requireStatus;
        return data; 
    }
}

export interface IPlanMaterialDTO {
    /** 库区 */
    area: string | undefined;
    /** 配领人员 */
    customer: string | undefined;
    /** id */
    id: string | undefined;
    /** 库位 */
    location: string | undefined;
    /** 物料编码 */
    materialCode: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 实际需求 */
    realRequireNum: number | undefined;
    /** 需求数量 */
    requireNum: number | undefined;
    /** 需求状态 */
    requireStatus: number | undefined;
}

export class PlanMaterialHmiVO implements IPlanMaterialHmiVO {
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 计划物料Id */
    planMaterialId!: string | undefined;
    /** 计划工序物料id */
    planProcessMaterialId!: string | undefined;

    constructor(data?: IPlanMaterialHmiVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.materialCode = data["materialCode"];
            this.materialName = data["materialName"];
            this.planMaterialId = data["planMaterialId"];
            this.planProcessMaterialId = data["planProcessMaterialId"];
        }
    }

    static fromJS(data: any): PlanMaterialHmiVO {
        data = typeof data === 'object' ? data : {};
        let result = new PlanMaterialHmiVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialCode"] = this.materialCode;
        data["materialName"] = this.materialName;
        data["planMaterialId"] = this.planMaterialId;
        data["planProcessMaterialId"] = this.planProcessMaterialId;
        return data; 
    }
}

export interface IPlanMaterialHmiVO {
    /** 物料编码 */
    materialCode: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 计划物料Id */
    planMaterialId: string | undefined;
    /** 计划工序物料id */
    planProcessMaterialId: string | undefined;
}

export class PlanMaterialStatusDTO implements IPlanMaterialStatusDTO {
    /** id */
    id!: string | undefined;
    /** SHUTDOWN--关闭、RESTART--重启、COMPLETE--完成 */
    planMaterialEnums!: PlanMaterialStatusDTOPlanMaterialEnums | undefined;

    constructor(data?: IPlanMaterialStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.planMaterialEnums = data["planMaterialEnums"];
        }
    }

    static fromJS(data: any): PlanMaterialStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlanMaterialStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["planMaterialEnums"] = this.planMaterialEnums;
        return data; 
    }
}

export interface IPlanMaterialStatusDTO {
    /** id */
    id: string | undefined;
    /** SHUTDOWN--关闭、RESTART--重启、COMPLETE--完成 */
    planMaterialEnums: PlanMaterialStatusDTOPlanMaterialEnums | undefined;
}

export class PlanMaterialVO implements IPlanMaterialVO {
    /** 领认数量 */
    acceptedNum!: number | undefined;
    /** 收领人员 */
    acceptedPerson!: string | undefined;
    /** 库区 */
    area!: string | undefined;
    /** 排料数量 */
    assignedNum!: number | undefined;
    /** bom物料Id */
    bomMaterialId!: string | undefined;
    /** 物料Id */
    id!: string | undefined;
    /** 是否缺料 */
    lackMaterial!: number | undefined;
    /** 缺料呼叫 */
    lackMaterialCall!: number | undefined;
    /** 库位 */
    location!: string | undefined;
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 物料ID */
    materialId!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 未领数量 */
    numNotAccepted!: number | undefined;
    /** 出库未派数量 */
    numNotAssigned!: number | undefined;
    /** 计划待出数量 */
    numNotOut!: number | undefined;
    /** 计划数量 */
    planNum!: number | undefined;
    /** 计划开始时间 */
    planStockOutTime!: Date | undefined;
    /** 关联的工序 */
    processVOList!: BomProcessVO[] | undefined;
    /** 物料属性 */
    property!: number | undefined;
    /** 需求总量 */
    requireNum!: number | undefined;
    /** 需求状态 0-待出库 1-配料中 2-完成 3-关闭 4-重启 */
    requireStatus!: number | undefined;
    /** 规格尺寸 */
    standardModel!: string | undefined;
    /** 库存总量 */
    stock!: number | undefined;
    /** 出库数量 */
    stockOutNum!: number | undefined;
    /** 出库人员 */
    stockOutPerson!: string | undefined;
    /** 单位 */
    unit!: string | undefined;

    constructor(data?: IPlanMaterialVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.acceptedNum = data["acceptedNum"];
            this.acceptedPerson = data["acceptedPerson"];
            this.area = data["area"];
            this.assignedNum = data["assignedNum"];
            this.bomMaterialId = data["bomMaterialId"];
            this.id = data["id"];
            this.lackMaterial = data["lackMaterial"];
            this.lackMaterialCall = data["lackMaterialCall"];
            this.location = data["location"];
            this.materialCode = data["materialCode"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.numNotAccepted = data["numNotAccepted"];
            this.numNotAssigned = data["numNotAssigned"];
            this.numNotOut = data["numNotOut"];
            this.planNum = data["planNum"];
            this.planStockOutTime = data["planStockOutTime"] ? new Date(data["planStockOutTime"].toString()) : <any>undefined;
            if (data["processVOList"] && data["processVOList"].constructor === Array) {
                this.processVOList = [] as any;
                for (let item of data["processVOList"])
                    this.processVOList!.push(BomProcessVO.fromJS(item));
            }
            this.property = data["property"];
            this.requireNum = data["requireNum"];
            this.requireStatus = data["requireStatus"];
            this.standardModel = data["standardModel"];
            this.stock = data["stock"];
            this.stockOutNum = data["stockOutNum"];
            this.stockOutPerson = data["stockOutPerson"];
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): PlanMaterialVO {
        data = typeof data === 'object' ? data : {};
        let result = new PlanMaterialVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acceptedNum"] = this.acceptedNum;
        data["acceptedPerson"] = this.acceptedPerson;
        data["area"] = this.area;
        data["assignedNum"] = this.assignedNum;
        data["bomMaterialId"] = this.bomMaterialId;
        data["id"] = this.id;
        data["lackMaterial"] = this.lackMaterial;
        data["lackMaterialCall"] = this.lackMaterialCall;
        data["location"] = this.location;
        data["materialCode"] = this.materialCode;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["numNotAccepted"] = this.numNotAccepted;
        data["numNotAssigned"] = this.numNotAssigned;
        data["numNotOut"] = this.numNotOut;
        data["planNum"] = this.planNum;
        data["planStockOutTime"] = this.planStockOutTime ? this.planStockOutTime.toISOString() : <any>undefined;
        if (this.processVOList && this.processVOList.constructor === Array) {
            data["processVOList"] = [];
            for (let item of this.processVOList)
                data["processVOList"].push(item.toJSON());
        }
        data["property"] = this.property;
        data["requireNum"] = this.requireNum;
        data["requireStatus"] = this.requireStatus;
        data["standardModel"] = this.standardModel;
        data["stock"] = this.stock;
        data["stockOutNum"] = this.stockOutNum;
        data["stockOutPerson"] = this.stockOutPerson;
        data["unit"] = this.unit;
        return data; 
    }
}

export interface IPlanMaterialVO {
    /** 领认数量 */
    acceptedNum: number | undefined;
    /** 收领人员 */
    acceptedPerson: string | undefined;
    /** 库区 */
    area: string | undefined;
    /** 排料数量 */
    assignedNum: number | undefined;
    /** bom物料Id */
    bomMaterialId: string | undefined;
    /** 物料Id */
    id: string | undefined;
    /** 是否缺料 */
    lackMaterial: number | undefined;
    /** 缺料呼叫 */
    lackMaterialCall: number | undefined;
    /** 库位 */
    location: string | undefined;
    /** 物料编码 */
    materialCode: string | undefined;
    /** 物料ID */
    materialId: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 未领数量 */
    numNotAccepted: number | undefined;
    /** 出库未派数量 */
    numNotAssigned: number | undefined;
    /** 计划待出数量 */
    numNotOut: number | undefined;
    /** 计划数量 */
    planNum: number | undefined;
    /** 计划开始时间 */
    planStockOutTime: Date | undefined;
    /** 关联的工序 */
    processVOList: BomProcessVO[] | undefined;
    /** 物料属性 */
    property: number | undefined;
    /** 需求总量 */
    requireNum: number | undefined;
    /** 需求状态 0-待出库 1-配料中 2-完成 3-关闭 4-重启 */
    requireStatus: number | undefined;
    /** 规格尺寸 */
    standardModel: string | undefined;
    /** 库存总量 */
    stock: number | undefined;
    /** 出库数量 */
    stockOutNum: number | undefined;
    /** 出库人员 */
    stockOutPerson: string | undefined;
    /** 单位 */
    unit: string | undefined;
}

export class PlanProcessMaterialVO implements IPlanProcessMaterialVO {
    assignedNum!: number | undefined;
    id!: string | undefined;
    numNotAssigned!: number | undefined;
    planProcessId!: string | undefined;
    processCode!: string | undefined;
    processName!: string | undefined;
    requireNum!: number | undefined;

    constructor(data?: IPlanProcessMaterialVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignedNum = data["assignedNum"];
            this.id = data["id"];
            this.numNotAssigned = data["numNotAssigned"];
            this.planProcessId = data["planProcessId"];
            this.processCode = data["processCode"];
            this.processName = data["processName"];
            this.requireNum = data["requireNum"];
        }
    }

    static fromJS(data: any): PlanProcessMaterialVO {
        data = typeof data === 'object' ? data : {};
        let result = new PlanProcessMaterialVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedNum"] = this.assignedNum;
        data["id"] = this.id;
        data["numNotAssigned"] = this.numNotAssigned;
        data["planProcessId"] = this.planProcessId;
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        data["requireNum"] = this.requireNum;
        return data; 
    }
}

export interface IPlanProcessMaterialVO {
    assignedNum: number | undefined;
    id: string | undefined;
    numNotAssigned: number | undefined;
    planProcessId: string | undefined;
    processCode: string | undefined;
    processName: string | undefined;
    requireNum: number | undefined;
}

export class PlanWipDTO implements IPlanWipDTO {
    /** 计划编号 */
    code!: string | undefined;
    /** 主键Id */
    id!: string | undefined;
    /** 计划结束时间 */
    planEndTime!: Date | undefined;
    /** 计划数量 */
    planNum!: number | undefined;
    /** 计划开始时间 */
    planStartTime!: Date | undefined;
    /** 产品编号 */
    productCode!: string | undefined;
    /** 产品类型名称 */
    productTypeName!: string | undefined;
    /** 计划合格数量 */
    qualifyNum!: number | undefined;
    /** 计划报工数量 */
    reportNum!: number | undefined;
    /** 工序在制品汇总 */
    summary!: string | undefined;

    constructor(data?: IPlanWipDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.planNum = data["planNum"];
            this.planStartTime = data["planStartTime"] ? new Date(data["planStartTime"].toString()) : <any>undefined;
            this.productCode = data["productCode"];
            this.productTypeName = data["productTypeName"];
            this.qualifyNum = data["qualifyNum"];
            this.reportNum = data["reportNum"];
            this.summary = data["summary"];
        }
    }

    static fromJS(data: any): PlanWipDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlanWipDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["planEndTime"] = this.planEndTime ? this.planEndTime.toISOString() : <any>undefined;
        data["planNum"] = this.planNum;
        data["planStartTime"] = this.planStartTime ? this.planStartTime.toISOString() : <any>undefined;
        data["productCode"] = this.productCode;
        data["productTypeName"] = this.productTypeName;
        data["qualifyNum"] = this.qualifyNum;
        data["reportNum"] = this.reportNum;
        data["summary"] = this.summary;
        return data; 
    }
}

export interface IPlanWipDTO {
    /** 计划编号 */
    code: string | undefined;
    /** 主键Id */
    id: string | undefined;
    /** 计划结束时间 */
    planEndTime: Date | undefined;
    /** 计划数量 */
    planNum: number | undefined;
    /** 计划开始时间 */
    planStartTime: Date | undefined;
    /** 产品编号 */
    productCode: string | undefined;
    /** 产品类型名称 */
    productTypeName: string | undefined;
    /** 计划合格数量 */
    qualifyNum: number | undefined;
    /** 计划报工数量 */
    reportNum: number | undefined;
    /** 工序在制品汇总 */
    summary: string | undefined;
}

export class ProcessAssignDTO implements IProcessAssignDTO {
    /** 待指派数量 */
    noAssignNum!: number | undefined;
    /** 工单工序ID */
    poProcessId!: string | undefined;
    workStationAssignDTOList!: WorkStationAssignDTO[] | undefined;

    constructor(data?: IProcessAssignDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.noAssignNum = data["noAssignNum"];
            this.poProcessId = data["poProcessId"];
            if (data["workStationAssignDTOList"] && data["workStationAssignDTOList"].constructor === Array) {
                this.workStationAssignDTOList = [] as any;
                for (let item of data["workStationAssignDTOList"])
                    this.workStationAssignDTOList!.push(WorkStationAssignDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcessAssignDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessAssignDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noAssignNum"] = this.noAssignNum;
        data["poProcessId"] = this.poProcessId;
        if (this.workStationAssignDTOList && this.workStationAssignDTOList.constructor === Array) {
            data["workStationAssignDTOList"] = [];
            for (let item of this.workStationAssignDTOList)
                data["workStationAssignDTOList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProcessAssignDTO {
    /** 待指派数量 */
    noAssignNum: number | undefined;
    /** 工单工序ID */
    poProcessId: string | undefined;
    workStationAssignDTOList: WorkStationAssignDTO[] | undefined;
}

export class ProcessAssignInfoVO implements IProcessAssignInfoVO {
    /** 指派数量 */
    assignNum!: number | undefined;
    /** 派工状态(0-待派工、1-已派工) */
    assignStatus!: number | undefined;
    /** 采集总数 */
    collectionNum!: number | undefined;
    /** 拆卸工时 */
    disassemblyTime!: number | undefined;
    /** 待派发数量=投产数量-报工数量 */
    distributedNum!: number | undefined;
    /** 结束时间 */
    endTime!: Date | undefined;
    /** 工艺参数1 */
    extend1!: string | undefined;
    /** 工艺参数2 */
    extend2!: string | undefined;
    /** 工艺参数3 */
    extend3!: string | undefined;
    /** 工艺参数4 */
    extend4!: string | undefined;
    /** 工艺参数5 */
    extend5!: string | undefined;
    /** 投产数量 */
    inputNum!: number | undefined;
    /** 计划编码 */
    planCode!: string | undefined;
    /** 所属生产计划 */
    planId!: string | undefined;
    /** 所属工单 */
    poId!: string | undefined;
    /** 准备工时 */
    prepareTime!: number | undefined;
    /** 工序编号 */
    processCode!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 工序序号 */
    processSequence!: string | undefined;
    /** 工序状态 */
    processStatus!: number | undefined;
    /** 暂停前状态 */
    processStatusBefore!: number | undefined;
    /** 程序名称 */
    programName!: string | undefined;
    /** 工序合格数量 */
    qualifyNum!: number | undefined;
    /** 报工数量 */
    reportNum!: number | undefined;
    /** 工序报废数量 */
    scrappedNum!: number | undefined;
    /** 工序顺序 */
    sort!: number | undefined;
    /** 标准工时 */
    standardTime!: number | undefined;
    /** 开始时间 */
    startTime!: Date | undefined;
    /** 运输工时 */
    transportTime!: number | undefined;
    /** 待指派数量=投产数量-指派数量 */
    unassignedNum!: number | undefined;
    /** 工位id */
    workStationId!: string | undefined;
    /** 工序工位信息 */
    workStationInfo!: ProcessAssignWorkStationVO[] | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;
    /** 计划报工工时 */
    workTime!: number | undefined;

    constructor(data?: IProcessAssignInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignNum = data["assignNum"];
            this.assignStatus = data["assignStatus"];
            this.collectionNum = data["collectionNum"];
            this.disassemblyTime = data["disassemblyTime"];
            this.distributedNum = data["distributedNum"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.inputNum = data["inputNum"];
            this.planCode = data["planCode"];
            this.planId = data["planId"];
            this.poId = data["poId"];
            this.prepareTime = data["prepareTime"];
            this.processCode = data["processCode"];
            this.processName = data["processName"];
            this.processSequence = data["processSequence"];
            this.processStatus = data["processStatus"];
            this.processStatusBefore = data["processStatusBefore"];
            this.programName = data["programName"];
            this.qualifyNum = data["qualifyNum"];
            this.reportNum = data["reportNum"];
            this.scrappedNum = data["scrappedNum"];
            this.sort = data["sort"];
            this.standardTime = data["standardTime"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.transportTime = data["transportTime"];
            this.unassignedNum = data["unassignedNum"];
            this.workStationId = data["workStationId"];
            if (data["workStationInfo"] && data["workStationInfo"].constructor === Array) {
                this.workStationInfo = [] as any;
                for (let item of data["workStationInfo"])
                    this.workStationInfo!.push(ProcessAssignWorkStationVO.fromJS(item));
            }
            this.workStationName = data["workStationName"];
            this.workTime = data["workTime"];
        }
    }

    static fromJS(data: any): ProcessAssignInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessAssignInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignNum"] = this.assignNum;
        data["assignStatus"] = this.assignStatus;
        data["collectionNum"] = this.collectionNum;
        data["disassemblyTime"] = this.disassemblyTime;
        data["distributedNum"] = this.distributedNum;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["inputNum"] = this.inputNum;
        data["planCode"] = this.planCode;
        data["planId"] = this.planId;
        data["poId"] = this.poId;
        data["prepareTime"] = this.prepareTime;
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        data["processSequence"] = this.processSequence;
        data["processStatus"] = this.processStatus;
        data["processStatusBefore"] = this.processStatusBefore;
        data["programName"] = this.programName;
        data["qualifyNum"] = this.qualifyNum;
        data["reportNum"] = this.reportNum;
        data["scrappedNum"] = this.scrappedNum;
        data["sort"] = this.sort;
        data["standardTime"] = this.standardTime;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["transportTime"] = this.transportTime;
        data["unassignedNum"] = this.unassignedNum;
        data["workStationId"] = this.workStationId;
        if (this.workStationInfo && this.workStationInfo.constructor === Array) {
            data["workStationInfo"] = [];
            for (let item of this.workStationInfo)
                data["workStationInfo"].push(item.toJSON());
        }
        data["workStationName"] = this.workStationName;
        data["workTime"] = this.workTime;
        return data; 
    }
}

export interface IProcessAssignInfoVO {
    /** 指派数量 */
    assignNum: number | undefined;
    /** 派工状态(0-待派工、1-已派工) */
    assignStatus: number | undefined;
    /** 采集总数 */
    collectionNum: number | undefined;
    /** 拆卸工时 */
    disassemblyTime: number | undefined;
    /** 待派发数量=投产数量-报工数量 */
    distributedNum: number | undefined;
    /** 结束时间 */
    endTime: Date | undefined;
    /** 工艺参数1 */
    extend1: string | undefined;
    /** 工艺参数2 */
    extend2: string | undefined;
    /** 工艺参数3 */
    extend3: string | undefined;
    /** 工艺参数4 */
    extend4: string | undefined;
    /** 工艺参数5 */
    extend5: string | undefined;
    /** 投产数量 */
    inputNum: number | undefined;
    /** 计划编码 */
    planCode: string | undefined;
    /** 所属生产计划 */
    planId: string | undefined;
    /** 所属工单 */
    poId: string | undefined;
    /** 准备工时 */
    prepareTime: number | undefined;
    /** 工序编号 */
    processCode: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 工序序号 */
    processSequence: string | undefined;
    /** 工序状态 */
    processStatus: number | undefined;
    /** 暂停前状态 */
    processStatusBefore: number | undefined;
    /** 程序名称 */
    programName: string | undefined;
    /** 工序合格数量 */
    qualifyNum: number | undefined;
    /** 报工数量 */
    reportNum: number | undefined;
    /** 工序报废数量 */
    scrappedNum: number | undefined;
    /** 工序顺序 */
    sort: number | undefined;
    /** 标准工时 */
    standardTime: number | undefined;
    /** 开始时间 */
    startTime: Date | undefined;
    /** 运输工时 */
    transportTime: number | undefined;
    /** 待指派数量=投产数量-指派数量 */
    unassignedNum: number | undefined;
    /** 工位id */
    workStationId: string | undefined;
    /** 工序工位信息 */
    workStationInfo: ProcessAssignWorkStationVO[] | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
    /** 计划报工工时 */
    workTime: number | undefined;
}

export class ProcessAssignListVO implements IProcessAssignListVO {
    /** 指派数量 */
    assignNum!: number | undefined;
    /** 派工状态(0-待派工、1-已派工) */
    assignStatus!: number | undefined;
    /** 采集数量 */
    collectionNum!: number | undefined;
    /** 工单工序id */
    id!: string | undefined;
    /** 投产数量 */
    inputNum!: number | undefined;
    /** 工单编码 */
    orderCode!: string | undefined;
    /** 计划编码 */
    planCode!: string | undefined;
    /** 计划结束时间 */
    planEndTime!: Date | undefined;
    /** 订单编码 */
    planOrderCode!: string | undefined;
    /** 计划开始时间 */
    planStartTime!: Date | undefined;
    /** 工序编码 */
    processCode!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 产品编码 */
    productCode!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 合格数量 */
    qualifyNum!: number | undefined;
    /** 报工数量 */
    reportNum!: number | undefined;
    /** 报废数量 */
    scrappedNum!: number | undefined;
    /** 待指派数量 */
    unassignedNum!: number | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;

    constructor(data?: IProcessAssignListVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignNum = data["assignNum"];
            this.assignStatus = data["assignStatus"];
            this.collectionNum = data["collectionNum"];
            this.id = data["id"];
            this.inputNum = data["inputNum"];
            this.orderCode = data["orderCode"];
            this.planCode = data["planCode"];
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.planOrderCode = data["planOrderCode"];
            this.planStartTime = data["planStartTime"] ? new Date(data["planStartTime"].toString()) : <any>undefined;
            this.processCode = data["processCode"];
            this.processName = data["processName"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.qualifyNum = data["qualifyNum"];
            this.reportNum = data["reportNum"];
            this.scrappedNum = data["scrappedNum"];
            this.unassignedNum = data["unassignedNum"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): ProcessAssignListVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessAssignListVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignNum"] = this.assignNum;
        data["assignStatus"] = this.assignStatus;
        data["collectionNum"] = this.collectionNum;
        data["id"] = this.id;
        data["inputNum"] = this.inputNum;
        data["orderCode"] = this.orderCode;
        data["planCode"] = this.planCode;
        data["planEndTime"] = this.planEndTime ? this.planEndTime.toISOString() : <any>undefined;
        data["planOrderCode"] = this.planOrderCode;
        data["planStartTime"] = this.planStartTime ? this.planStartTime.toISOString() : <any>undefined;
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["qualifyNum"] = this.qualifyNum;
        data["reportNum"] = this.reportNum;
        data["scrappedNum"] = this.scrappedNum;
        data["unassignedNum"] = this.unassignedNum;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IProcessAssignListVO {
    /** 指派数量 */
    assignNum: number | undefined;
    /** 派工状态(0-待派工、1-已派工) */
    assignStatus: number | undefined;
    /** 采集数量 */
    collectionNum: number | undefined;
    /** 工单工序id */
    id: string | undefined;
    /** 投产数量 */
    inputNum: number | undefined;
    /** 工单编码 */
    orderCode: string | undefined;
    /** 计划编码 */
    planCode: string | undefined;
    /** 计划结束时间 */
    planEndTime: Date | undefined;
    /** 订单编码 */
    planOrderCode: string | undefined;
    /** 计划开始时间 */
    planStartTime: Date | undefined;
    /** 工序编码 */
    processCode: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 产品编码 */
    productCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 合格数量 */
    qualifyNum: number | undefined;
    /** 报工数量 */
    reportNum: number | undefined;
    /** 报废数量 */
    scrappedNum: number | undefined;
    /** 待指派数量 */
    unassignedNum: number | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
}

export class ProcessAssignSearchDTO implements IProcessAssignSearchDTO {
    /** 派工状态(0-待派工、1-已派工) */
    assignStatusList!: number[] | undefined;
    /** 生产计划编码 */
    planCode!: string | undefined;
    /** 计划结束时间 */
    planEndTime!: Date | undefined;
    /** 计划开始时间 */
    planStartTime!: Date | undefined;
    /** 工序编码 */
    processCode!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 产品编码 */
    productCode!: string | undefined;
    /** 计划类型 */
    typeId!: string | undefined;

    constructor(data?: IProcessAssignSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["assignStatusList"] && data["assignStatusList"].constructor === Array) {
                this.assignStatusList = [] as any;
                for (let item of data["assignStatusList"])
                    this.assignStatusList!.push(item);
            }
            this.planCode = data["planCode"];
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.planStartTime = data["planStartTime"] ? new Date(data["planStartTime"].toString()) : <any>undefined;
            this.processCode = data["processCode"];
            this.processName = data["processName"];
            this.productCode = data["productCode"];
            this.typeId = data["typeId"];
        }
    }

    static fromJS(data: any): ProcessAssignSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessAssignSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.assignStatusList && this.assignStatusList.constructor === Array) {
            data["assignStatusList"] = [];
            for (let item of this.assignStatusList)
                data["assignStatusList"].push(item);
        }
        data["planCode"] = this.planCode;
        data["planEndTime"] = this.planEndTime ? this.planEndTime.toISOString() : <any>undefined;
        data["planStartTime"] = this.planStartTime ? this.planStartTime.toISOString() : <any>undefined;
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        data["productCode"] = this.productCode;
        data["typeId"] = this.typeId;
        return data; 
    }
}

export interface IProcessAssignSearchDTO {
    /** 派工状态(0-待派工、1-已派工) */
    assignStatusList: number[] | undefined;
    /** 生产计划编码 */
    planCode: string | undefined;
    /** 计划结束时间 */
    planEndTime: Date | undefined;
    /** 计划开始时间 */
    planStartTime: Date | undefined;
    /** 工序编码 */
    processCode: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 产品编码 */
    productCode: string | undefined;
    /** 计划类型 */
    typeId: string | undefined;
}

export class ProcessAssignWorkStationVO implements IProcessAssignWorkStationVO {
    /** 采集数量 */
    collectionNum!: number | undefined;
    /** 指派数量  即 已派数量 */
    hasAssignNum!: number | undefined;
    /** 工单工序的开工工位id */
    processAssignWorkStationId!: string | undefined;
    /** 报工数量 */
    reportNum!: number | undefined;
    /** 工位产能 */
    stationProductionCapacity!: number | undefined;
    /** 待报工数量 */
    unreportNum!: number | undefined;
    /** 工位id */
    workStationId!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;

    constructor(data?: IProcessAssignWorkStationVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.collectionNum = data["collectionNum"];
            this.hasAssignNum = data["hasAssignNum"];
            this.processAssignWorkStationId = data["processAssignWorkStationId"];
            this.reportNum = data["reportNum"];
            this.stationProductionCapacity = data["stationProductionCapacity"];
            this.unreportNum = data["unreportNum"];
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): ProcessAssignWorkStationVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessAssignWorkStationVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collectionNum"] = this.collectionNum;
        data["hasAssignNum"] = this.hasAssignNum;
        data["processAssignWorkStationId"] = this.processAssignWorkStationId;
        data["reportNum"] = this.reportNum;
        data["stationProductionCapacity"] = this.stationProductionCapacity;
        data["unreportNum"] = this.unreportNum;
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IProcessAssignWorkStationVO {
    /** 采集数量 */
    collectionNum: number | undefined;
    /** 指派数量  即 已派数量 */
    hasAssignNum: number | undefined;
    /** 工单工序的开工工位id */
    processAssignWorkStationId: string | undefined;
    /** 报工数量 */
    reportNum: number | undefined;
    /** 工位产能 */
    stationProductionCapacity: number | undefined;
    /** 待报工数量 */
    unreportNum: number | undefined;
    /** 工位id */
    workStationId: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
}

export class ProcessDetailDTO implements IProcessDetailDTO {
    /** 指派数量 */
    assignNum!: number | undefined;
    assignRecordDetailDTO!: AssignRecordDetailDTO | undefined;
    /** 采集数量 */
    collectionNum!: number | undefined;
    /** 计划编码 */
    planCode!: string | undefined;
    /** 工序编号 */
    processCode!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 工序序号 */
    processSequence!: string | undefined;
    /** 工序顺序 */
    sort!: number | undefined;
    /** 待指派数量=投产数量-指派数量 */
    unassignedNum!: number | undefined;

    constructor(data?: IProcessDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignNum = data["assignNum"];
            this.assignRecordDetailDTO = data["assignRecordDetailDTO"] ? AssignRecordDetailDTO.fromJS(data["assignRecordDetailDTO"]) : <any>undefined;
            this.collectionNum = data["collectionNum"];
            this.planCode = data["planCode"];
            this.processCode = data["processCode"];
            this.processName = data["processName"];
            this.processSequence = data["processSequence"];
            this.sort = data["sort"];
            this.unassignedNum = data["unassignedNum"];
        }
    }

    static fromJS(data: any): ProcessDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignNum"] = this.assignNum;
        data["assignRecordDetailDTO"] = this.assignRecordDetailDTO ? this.assignRecordDetailDTO.toJSON() : <any>undefined;
        data["collectionNum"] = this.collectionNum;
        data["planCode"] = this.planCode;
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        data["processSequence"] = this.processSequence;
        data["sort"] = this.sort;
        data["unassignedNum"] = this.unassignedNum;
        return data; 
    }
}

export interface IProcessDetailDTO {
    /** 指派数量 */
    assignNum: number | undefined;
    assignRecordDetailDTO: AssignRecordDetailDTO | undefined;
    /** 采集数量 */
    collectionNum: number | undefined;
    /** 计划编码 */
    planCode: string | undefined;
    /** 工序编号 */
    processCode: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 工序序号 */
    processSequence: string | undefined;
    /** 工序顺序 */
    sort: number | undefined;
    /** 待指派数量=投产数量-指派数量 */
    unassignedNum: number | undefined;
}

export class ProcessReportVO implements IProcessReportVO {
    /** 主键id */
    id!: string | undefined;
    /** 工单号 */
    orderCode!: string | undefined;
    /** 工序编码 */
    processCode!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 生产人员 */
    producerName!: string | undefined;
    qcItemReportVOList!: QcItemReportVO[] | undefined;
    /** 质检人员 */
    qcName!: string | undefined;
    /** 质检时间 */
    qcTime!: Date | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;

    constructor(data?: IProcessReportVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.orderCode = data["orderCode"];
            this.processCode = data["processCode"];
            this.processName = data["processName"];
            this.producerName = data["producerName"];
            if (data["qcItemReportVOList"] && data["qcItemReportVOList"].constructor === Array) {
                this.qcItemReportVOList = [] as any;
                for (let item of data["qcItemReportVOList"])
                    this.qcItemReportVOList!.push(QcItemReportVO.fromJS(item));
            }
            this.qcName = data["qcName"];
            this.qcTime = data["qcTime"] ? new Date(data["qcTime"].toString()) : <any>undefined;
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): ProcessReportVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessReportVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderCode"] = this.orderCode;
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        data["producerName"] = this.producerName;
        if (this.qcItemReportVOList && this.qcItemReportVOList.constructor === Array) {
            data["qcItemReportVOList"] = [];
            for (let item of this.qcItemReportVOList)
                data["qcItemReportVOList"].push(item.toJSON());
        }
        data["qcName"] = this.qcName;
        data["qcTime"] = this.qcTime ? this.qcTime.toISOString() : <any>undefined;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IProcessReportVO {
    /** 主键id */
    id: string | undefined;
    /** 工单号 */
    orderCode: string | undefined;
    /** 工序编码 */
    processCode: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 生产人员 */
    producerName: string | undefined;
    qcItemReportVOList: QcItemReportVO[] | undefined;
    /** 质检人员 */
    qcName: string | undefined;
    /** 质检时间 */
    qcTime: Date | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
}

export class ProcessWorkStationBO implements IProcessWorkStationBO {
    /** 工位code */
    workStationCode!: string | undefined;
    /** 工位id */
    workStationId!: string | undefined;
    /** 工位name */
    workStationName!: string | undefined;

    constructor(data?: IProcessWorkStationBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.workStationCode = data["workStationCode"];
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): ProcessWorkStationBO {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessWorkStationBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workStationCode"] = this.workStationCode;
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IProcessWorkStationBO {
    /** 工位code */
    workStationCode: string | undefined;
    /** 工位id */
    workStationId: string | undefined;
    /** 工位name */
    workStationName: string | undefined;
}

export class ProcessWorkStationDTO implements IProcessWorkStationDTO {
    /** 新工序工位列表 */
    newWorkStationInfo!: WorkStationInfoDTO[] | undefined;
    /** 原工序工位列表 */
    oldWorkStationInfo!: WorkStationInfoDTO[] | undefined;
    /** 工序ID */
    prcessId!: string;

    constructor(data?: IProcessWorkStationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["newWorkStationInfo"] && data["newWorkStationInfo"].constructor === Array) {
                this.newWorkStationInfo = [] as any;
                for (let item of data["newWorkStationInfo"])
                    this.newWorkStationInfo!.push(WorkStationInfoDTO.fromJS(item));
            }
            if (data["oldWorkStationInfo"] && data["oldWorkStationInfo"].constructor === Array) {
                this.oldWorkStationInfo = [] as any;
                for (let item of data["oldWorkStationInfo"])
                    this.oldWorkStationInfo!.push(WorkStationInfoDTO.fromJS(item));
            }
            this.prcessId = data["prcessId"];
        }
    }

    static fromJS(data: any): ProcessWorkStationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessWorkStationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.newWorkStationInfo && this.newWorkStationInfo.constructor === Array) {
            data["newWorkStationInfo"] = [];
            for (let item of this.newWorkStationInfo)
                data["newWorkStationInfo"].push(item.toJSON());
        }
        if (this.oldWorkStationInfo && this.oldWorkStationInfo.constructor === Array) {
            data["oldWorkStationInfo"] = [];
            for (let item of this.oldWorkStationInfo)
                data["oldWorkStationInfo"].push(item.toJSON());
        }
        data["prcessId"] = this.prcessId;
        return data; 
    }
}

export interface IProcessWorkStationDTO {
    /** 新工序工位列表 */
    newWorkStationInfo: WorkStationInfoDTO[] | undefined;
    /** 原工序工位列表 */
    oldWorkStationInfo: WorkStationInfoDTO[] | undefined;
    /** 工序ID */
    prcessId: string;
}

export class ProductDictDTO implements IProductDictDTO {
    /** 产品编码 */
    code!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 产品名称 */
    name!: string | undefined;

    constructor(data?: IProductDictDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): ProductDictDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDictDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IProductDictDTO {
    /** 产品编码 */
    code: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 产品名称 */
    name: string | undefined;
}

export class ProductFixCraftVersionDTO implements IProductFixCraftVersionDTO {
    /** 产品编码 */
    code!: string | undefined;
    /** 产品ID */
    id!: string | undefined;
    /** 物料编号 */
    materialCode!: string | undefined;
    /** 产品名称 */
    name!: string | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;

    constructor(data?: IProductFixCraftVersionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.materialCode = data["materialCode"];
            this.name = data["name"];
            this.standardModel = data["standardModel"];
        }
    }

    static fromJS(data: any): ProductFixCraftVersionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductFixCraftVersionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["materialCode"] = this.materialCode;
        data["name"] = this.name;
        data["standardModel"] = this.standardModel;
        return data; 
    }
}

export interface IProductFixCraftVersionDTO {
    /** 产品编码 */
    code: string | undefined;
    /** 产品ID */
    id: string | undefined;
    /** 物料编号 */
    materialCode: string | undefined;
    /** 产品名称 */
    name: string | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
}

export class ProductMaterialVO implements IProductMaterialVO {
    /** 客户id */
    customerId!: string | undefined;
    /** 客户名称 */
    customerName!: string | undefined;
    /** 物料Code */
    materialCode!: string | undefined;
    /** 订单编号 */
    orderCode!: string | undefined;
    /** 计划Code */
    planCode!: string | undefined;
    /** 计划Id */
    planId!: string | undefined;

    constructor(data?: IProductMaterialVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerId = data["customerId"];
            this.customerName = data["customerName"];
            this.materialCode = data["materialCode"];
            this.orderCode = data["orderCode"];
            this.planCode = data["planCode"];
            this.planId = data["planId"];
        }
    }

    static fromJS(data: any): ProductMaterialVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMaterialVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["materialCode"] = this.materialCode;
        data["orderCode"] = this.orderCode;
        data["planCode"] = this.planCode;
        data["planId"] = this.planId;
        return data; 
    }
}

export interface IProductMaterialVO {
    /** 客户id */
    customerId: string | undefined;
    /** 客户名称 */
    customerName: string | undefined;
    /** 物料Code */
    materialCode: string | undefined;
    /** 订单编号 */
    orderCode: string | undefined;
    /** 计划Code */
    planCode: string | undefined;
    /** 计划Id */
    planId: string | undefined;
}

/** 产品类型信息 */
export class ProductTypeVO implements IProductTypeVO {
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    description!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    name!: string | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IProductTypeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.description = data["description"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.name = data["name"];
            this.status = data["status"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): ProductTypeVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductTypeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["description"] = this.description;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["status"] = this.status;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

/** 产品类型信息 */
export interface IProductTypeVO {
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    description: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    name: string | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

export class ProductionOrder implements IProductionOrder {
    /** 派发数量 */
    assignNum!: number | undefined;
    /** 工单编号 */
    code!: string | undefined;
    /** 采集数量 */
    collectionNum!: number | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 结束时间 */
    endTime!: Date | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 工单状态 */
    orderStatus!: number | undefined;
    /** 所属生产计划 */
    planId!: string | undefined;
    /** 工单合格数量 */
    qualifyNum!: number | undefined;
    /** 工单报废数量 */
    scrappedNum!: number | undefined;
    /** 开始时间 */
    startTime!: Date | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 计划暂停之前状态 */
    statusBefore!: number | undefined;
    /** 租户ID */
    tenantId!: string | undefined;
    /** 标准总工时 */
    totalStandardTime!: number | undefined;
    /** 待加工数量 */
    unassignedNum!: number | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;
    /** 计划报工工时 */
    workTime!: number | undefined;

    constructor(data?: IProductionOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignNum = data["assignNum"];
            this.code = data["code"];
            this.collectionNum = data["collectionNum"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.orderStatus = data["orderStatus"];
            this.planId = data["planId"];
            this.qualifyNum = data["qualifyNum"];
            this.scrappedNum = data["scrappedNum"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.status = data["status"];
            this.statusBefore = data["statusBefore"];
            this.tenantId = data["tenantId"];
            this.totalStandardTime = data["totalStandardTime"];
            this.unassignedNum = data["unassignedNum"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
            this.workTime = data["workTime"];
        }
    }

    static fromJS(data: any): ProductionOrder {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignNum"] = this.assignNum;
        data["code"] = this.code;
        data["collectionNum"] = this.collectionNum;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["orderStatus"] = this.orderStatus;
        data["planId"] = this.planId;
        data["qualifyNum"] = this.qualifyNum;
        data["scrappedNum"] = this.scrappedNum;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["statusBefore"] = this.statusBefore;
        data["tenantId"] = this.tenantId;
        data["totalStandardTime"] = this.totalStandardTime;
        data["unassignedNum"] = this.unassignedNum;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        data["workTime"] = this.workTime;
        return data; 
    }
}

export interface IProductionOrder {
    /** 派发数量 */
    assignNum: number | undefined;
    /** 工单编号 */
    code: string | undefined;
    /** 采集数量 */
    collectionNum: number | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 结束时间 */
    endTime: Date | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 工单状态 */
    orderStatus: number | undefined;
    /** 所属生产计划 */
    planId: string | undefined;
    /** 工单合格数量 */
    qualifyNum: number | undefined;
    /** 工单报废数量 */
    scrappedNum: number | undefined;
    /** 开始时间 */
    startTime: Date | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 计划暂停之前状态 */
    statusBefore: number | undefined;
    /** 租户ID */
    tenantId: string | undefined;
    /** 标准总工时 */
    totalStandardTime: number | undefined;
    /** 待加工数量 */
    unassignedNum: number | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
    /** 计划报工工时 */
    workTime: number | undefined;
}

export class ProductionOrderDTO implements IProductionOrderDTO {
    /** 派发数量 */
    assignNum!: number;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 工单号 */
    orderCode!: string | undefined;
    /** 工序信息集合 */
    orderProcessDTOList!: OrderProcessDTO[] | undefined;
    /** 生产计划单号 */
    planCode!: string;

    constructor(data?: IProductionOrderDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignNum = data["assignNum"];
            this.codeRuleId = data["codeRuleId"];
            this.orderCode = data["orderCode"];
            if (data["orderProcessDTOList"] && data["orderProcessDTOList"].constructor === Array) {
                this.orderProcessDTOList = [] as any;
                for (let item of data["orderProcessDTOList"])
                    this.orderProcessDTOList!.push(OrderProcessDTO.fromJS(item));
            }
            this.planCode = data["planCode"];
        }
    }

    static fromJS(data: any): ProductionOrderDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionOrderDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignNum"] = this.assignNum;
        data["codeRuleId"] = this.codeRuleId;
        data["orderCode"] = this.orderCode;
        if (this.orderProcessDTOList && this.orderProcessDTOList.constructor === Array) {
            data["orderProcessDTOList"] = [];
            for (let item of this.orderProcessDTOList)
                data["orderProcessDTOList"].push(item.toJSON());
        }
        data["planCode"] = this.planCode;
        return data; 
    }
}

export interface IProductionOrderDTO {
    /** 派发数量 */
    assignNum: number;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 工单号 */
    orderCode: string | undefined;
    /** 工序信息集合 */
    orderProcessDTOList: OrderProcessDTO[] | undefined;
    /** 生产计划单号 */
    planCode: string;
}

export class ProductionOrderDetailsVO implements IProductionOrderDetailsVO {
    /** 加工人员姓名 */
    name!: string | undefined;
    /** 当前加工工单编号 */
    orderCode!: string | undefined;
    /** 当前加工工单数量 */
    orderNum!: number | undefined;
    /** 所有加工工单合格率 */
    passRate!: number | undefined;

    constructor(data?: IProductionOrderDetailsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.orderCode = data["orderCode"];
            this.orderNum = data["orderNum"];
            this.passRate = data["passRate"];
        }
    }

    static fromJS(data: any): ProductionOrderDetailsVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionOrderDetailsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["orderCode"] = this.orderCode;
        data["orderNum"] = this.orderNum;
        data["passRate"] = this.passRate;
        return data; 
    }
}

export interface IProductionOrderDetailsVO {
    /** 加工人员姓名 */
    name: string | undefined;
    /** 当前加工工单编号 */
    orderCode: string | undefined;
    /** 当前加工工单数量 */
    orderNum: number | undefined;
    /** 所有加工工单合格率 */
    passRate: number | undefined;
}

export class ProductionOrderMergeDTO implements IProductionOrderMergeDTO {
    /** 工单状态(1：待加工，2：加工中，3：暂停，4：关闭,5:完工) */
    planStatus!: number[] | undefined;
    /** 计划时间维度（1 当天  2：总体） */
    planTimeType!: number | undefined;

    constructor(data?: IProductionOrderMergeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["planStatus"] && data["planStatus"].constructor === Array) {
                this.planStatus = [] as any;
                for (let item of data["planStatus"])
                    this.planStatus!.push(item);
            }
            this.planTimeType = data["planTimeType"];
        }
    }

    static fromJS(data: any): ProductionOrderMergeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionOrderMergeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.planStatus && this.planStatus.constructor === Array) {
            data["planStatus"] = [];
            for (let item of this.planStatus)
                data["planStatus"].push(item);
        }
        data["planTimeType"] = this.planTimeType;
        return data; 
    }
}

export interface IProductionOrderMergeDTO {
    /** 工单状态(1：待加工，2：加工中，3：暂停，4：关闭,5:完工) */
    planStatus: number[] | undefined;
    /** 计划时间维度（1 当天  2：总体） */
    planTimeType: number | undefined;
}

export class ProductionOrderOutDTO implements IProductionOrderOutDTO {
    /** 派发数量 */
    assignNum!: number | undefined;
    /** 工单号 */
    code!: string | undefined;
    /** 工艺版本 */
    craftVersion!: string | undefined;
    /** 工单结束时间 */
    endTime!: Date | undefined;
    /** 主键Id */
    id!: string | undefined;
    /** 工单状态(1：待加工，2：加工中，3：暂停，4：关闭,5:完工) */
    orderStatus!: number | undefined;
    /** 合格数 */
    qualifyNum!: number | undefined;
    /** 报废数 */
    scrappedNum!: number | undefined;
    /** 工单开始时间 */
    startTime!: Date | undefined;
    /** 待加工数 */
    unassignedNum!: number | undefined;

    constructor(data?: IProductionOrderOutDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignNum = data["assignNum"];
            this.code = data["code"];
            this.craftVersion = data["craftVersion"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.id = data["id"];
            this.orderStatus = data["orderStatus"];
            this.qualifyNum = data["qualifyNum"];
            this.scrappedNum = data["scrappedNum"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.unassignedNum = data["unassignedNum"];
        }
    }

    static fromJS(data: any): ProductionOrderOutDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionOrderOutDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignNum"] = this.assignNum;
        data["code"] = this.code;
        data["craftVersion"] = this.craftVersion;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["orderStatus"] = this.orderStatus;
        data["qualifyNum"] = this.qualifyNum;
        data["scrappedNum"] = this.scrappedNum;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["unassignedNum"] = this.unassignedNum;
        return data; 
    }
}

export interface IProductionOrderOutDTO {
    /** 派发数量 */
    assignNum: number | undefined;
    /** 工单号 */
    code: string | undefined;
    /** 工艺版本 */
    craftVersion: string | undefined;
    /** 工单结束时间 */
    endTime: Date | undefined;
    /** 主键Id */
    id: string | undefined;
    /** 工单状态(1：待加工，2：加工中，3：暂停，4：关闭,5:完工) */
    orderStatus: number | undefined;
    /** 合格数 */
    qualifyNum: number | undefined;
    /** 报废数 */
    scrappedNum: number | undefined;
    /** 工单开始时间 */
    startTime: Date | undefined;
    /** 待加工数 */
    unassignedNum: number | undefined;
}

/** 手机端工单详情 */
export class ProductionOrderOutVO implements IProductionOrderOutVO {
    /** 派发数量 */
    assignNum!: number | undefined;
    /** 工单号 */
    code!: string | undefined;
    /** 工艺版本 */
    craftVersion!: string | undefined;
    /** 工单结束时间 */
    endTime!: Date | undefined;
    /** 主键Id */
    id!: string | undefined;
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 工单状态(1：待加工，2：加工中，3：暂停，4：关闭,5:完工) */
    orderStatus!: number | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 合格数 */
    qualifyNum!: number | undefined;
    /** 报废数 */
    scrappedNum!: number | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 工单开始时间 */
    startTime!: Date | undefined;
    /** 待加工数 */
    unassignedNum!: number | undefined;

    constructor(data?: IProductionOrderOutVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignNum = data["assignNum"];
            this.code = data["code"];
            this.craftVersion = data["craftVersion"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.id = data["id"];
            this.materialCode = data["materialCode"];
            this.orderStatus = data["orderStatus"];
            this.productName = data["productName"];
            this.qualifyNum = data["qualifyNum"];
            this.scrappedNum = data["scrappedNum"];
            this.standardModel = data["standardModel"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.unassignedNum = data["unassignedNum"];
        }
    }

    static fromJS(data: any): ProductionOrderOutVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionOrderOutVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignNum"] = this.assignNum;
        data["code"] = this.code;
        data["craftVersion"] = this.craftVersion;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["materialCode"] = this.materialCode;
        data["orderStatus"] = this.orderStatus;
        data["productName"] = this.productName;
        data["qualifyNum"] = this.qualifyNum;
        data["scrappedNum"] = this.scrappedNum;
        data["standardModel"] = this.standardModel;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["unassignedNum"] = this.unassignedNum;
        return data; 
    }
}

/** 手机端工单详情 */
export interface IProductionOrderOutVO {
    /** 派发数量 */
    assignNum: number | undefined;
    /** 工单号 */
    code: string | undefined;
    /** 工艺版本 */
    craftVersion: string | undefined;
    /** 工单结束时间 */
    endTime: Date | undefined;
    /** 主键Id */
    id: string | undefined;
    /** 物料编码 */
    materialCode: string | undefined;
    /** 工单状态(1：待加工，2：加工中，3：暂停，4：关闭,5:完工) */
    orderStatus: number | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 合格数 */
    qualifyNum: number | undefined;
    /** 报废数 */
    scrappedNum: number | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 工单开始时间 */
    startTime: Date | undefined;
    /** 待加工数 */
    unassignedNum: number | undefined;
}

/** 订单工序 */
export class ProductionOrderProcessBO implements IProductionOrderProcessBO {
    /** 工单工序id */
    id!: string | undefined;
    /** 工序编号 */
    processCode!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 工序序号 */
    processSequence!: string | undefined;
    /** 程序名称 */
    programName!: string | undefined;
    /** 工序顺序 */
    sort!: number | undefined;

    constructor(data?: IProductionOrderProcessBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.processCode = data["processCode"];
            this.processName = data["processName"];
            this.processSequence = data["processSequence"];
            this.programName = data["programName"];
            this.sort = data["sort"];
        }
    }

    static fromJS(data: any): ProductionOrderProcessBO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionOrderProcessBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        data["processSequence"] = this.processSequence;
        data["programName"] = this.programName;
        data["sort"] = this.sort;
        return data; 
    }
}

/** 订单工序 */
export interface IProductionOrderProcessBO {
    /** 工单工序id */
    id: string | undefined;
    /** 工序编号 */
    processCode: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 工序序号 */
    processSequence: string | undefined;
    /** 程序名称 */
    programName: string | undefined;
    /** 工序顺序 */
    sort: number | undefined;
}

/** 手机端查询工序列表 */
export class ProductionOrderProcessMobileDTO implements IProductionOrderProcessMobileDTO {
    /** 计划类型id */
    planTypeId!: string | undefined;
    /** 工单编号 */
    poCode!: string | undefined;
    /** 工序id */
    processId!: string | undefined;
    /** 类型：【1：开工 2：报工】 */
    type!: number | undefined;
    /** 设备id */
    workStationId!: string | undefined;

    constructor(data?: IProductionOrderProcessMobileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planTypeId = data["planTypeId"];
            this.poCode = data["poCode"];
            this.processId = data["processId"];
            this.type = data["type"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): ProductionOrderProcessMobileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionOrderProcessMobileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planTypeId"] = this.planTypeId;
        data["poCode"] = this.poCode;
        data["processId"] = this.processId;
        data["type"] = this.type;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

/** 手机端查询工序列表 */
export interface IProductionOrderProcessMobileDTO {
    /** 计划类型id */
    planTypeId: string | undefined;
    /** 工单编号 */
    poCode: string | undefined;
    /** 工序id */
    processId: string | undefined;
    /** 类型：【1：开工 2：报工】 */
    type: number | undefined;
    /** 设备id */
    workStationId: string | undefined;
}

export class ProductionOrderProcessScheduleVO implements IProductionOrderProcessScheduleVO {
    /** 采集数量 */
    collectionNum!: number | undefined;
    /** 工序派工数量 */
    inputNum!: number | undefined;
    /** 工单编号 */
    orderCode!: string | undefined;
    /** 工序编号 */
    processCode!: string | undefined;
    /** 工序采集工时 */
    processCollectionTime!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 工序报工工时 */
    processReportTime!: number | undefined;
    /** 工序序号 */
    processSequence!: string | undefined;
    /** 工序报工数量 */
    reportNum!: number | undefined;
    /** 工序顺序 */
    sort!: number | undefined;
    /** 工序额定工时 */
    standardTime!: number | undefined;
    /** 工序工时差1 */
    workTimeDiference1!: number | undefined;
    /** 工序工时差2 */
    workTimeDifference2!: number | undefined;

    constructor(data?: IProductionOrderProcessScheduleVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.collectionNum = data["collectionNum"];
            this.inputNum = data["inputNum"];
            this.orderCode = data["orderCode"];
            this.processCode = data["processCode"];
            this.processCollectionTime = data["processCollectionTime"];
            this.processName = data["processName"];
            this.processReportTime = data["processReportTime"];
            this.processSequence = data["processSequence"];
            this.reportNum = data["reportNum"];
            this.sort = data["sort"];
            this.standardTime = data["standardTime"];
            this.workTimeDiference1 = data["workTimeDiference1"];
            this.workTimeDifference2 = data["workTimeDifference2"];
        }
    }

    static fromJS(data: any): ProductionOrderProcessScheduleVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionOrderProcessScheduleVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collectionNum"] = this.collectionNum;
        data["inputNum"] = this.inputNum;
        data["orderCode"] = this.orderCode;
        data["processCode"] = this.processCode;
        data["processCollectionTime"] = this.processCollectionTime;
        data["processName"] = this.processName;
        data["processReportTime"] = this.processReportTime;
        data["processSequence"] = this.processSequence;
        data["reportNum"] = this.reportNum;
        data["sort"] = this.sort;
        data["standardTime"] = this.standardTime;
        data["workTimeDiference1"] = this.workTimeDiference1;
        data["workTimeDifference2"] = this.workTimeDifference2;
        return data; 
    }
}

export interface IProductionOrderProcessScheduleVO {
    /** 采集数量 */
    collectionNum: number | undefined;
    /** 工序派工数量 */
    inputNum: number | undefined;
    /** 工单编号 */
    orderCode: string | undefined;
    /** 工序编号 */
    processCode: string | undefined;
    /** 工序采集工时 */
    processCollectionTime: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 工序报工工时 */
    processReportTime: number | undefined;
    /** 工序序号 */
    processSequence: string | undefined;
    /** 工序报工数量 */
    reportNum: number | undefined;
    /** 工序顺序 */
    sort: number | undefined;
    /** 工序额定工时 */
    standardTime: number | undefined;
    /** 工序工时差1 */
    workTimeDiference1: number | undefined;
    /** 工序工时差2 */
    workTimeDifference2: number | undefined;
}

export class ProductionOrderProcessSearchDTO implements IProductionOrderProcessSearchDTO {
    /** 生产计划ID */
    planId!: string;
    /** 工单状态查询 */
    status!: number[] | undefined;

    constructor(data?: IProductionOrderProcessSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planId = data["planId"];
            if (data["status"] && data["status"].constructor === Array) {
                this.status = [] as any;
                for (let item of data["status"])
                    this.status!.push(item);
            }
        }
    }

    static fromJS(data: any): ProductionOrderProcessSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionOrderProcessSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planId"] = this.planId;
        if (this.status && this.status.constructor === Array) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        return data; 
    }
}

export interface IProductionOrderProcessSearchDTO {
    /** 生产计划ID */
    planId: string;
    /** 工单状态查询 */
    status: number[] | undefined;
}

/** 手机端查询工序列表 */
export class ProductionOrderProcessWeiXinDTO implements IProductionOrderProcessWeiXinDTO {
    /** 计划类型id */
    planTypeId!: string | undefined;
    /** 工单编号 */
    poCode!: string | undefined;
    /** 工序id */
    processId!: string | undefined;
    /** 设备Id */
    workStationId!: string | undefined;

    constructor(data?: IProductionOrderProcessWeiXinDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planTypeId = data["planTypeId"];
            this.poCode = data["poCode"];
            this.processId = data["processId"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): ProductionOrderProcessWeiXinDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionOrderProcessWeiXinDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planTypeId"] = this.planTypeId;
        data["poCode"] = this.poCode;
        data["processId"] = this.processId;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

/** 手机端查询工序列表 */
export interface IProductionOrderProcessWeiXinDTO {
    /** 计划类型id */
    planTypeId: string | undefined;
    /** 工单编号 */
    poCode: string | undefined;
    /** 工序id */
    processId: string | undefined;
    /** 设备Id */
    workStationId: string | undefined;
}

export class ProductionOrderProcessWorkStationDTO implements IProductionOrderProcessWorkStationDTO {
    /** 派发数量 */
    assignNum!: number | undefined;
    /** 工单号 */
    code!: string | undefined;
    /** 工单Id */
    id!: string | undefined;
    /** 工单工序工位信息 */
    list!: OrderProcessWorkStationBO[] | undefined;
    /** 剩余待派发数量 */
    unassignedNum!: number | undefined;

    constructor(data?: IProductionOrderProcessWorkStationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignNum = data["assignNum"];
            this.code = data["code"];
            this.id = data["id"];
            if (data["list"] && data["list"].constructor === Array) {
                this.list = [] as any;
                for (let item of data["list"])
                    this.list!.push(OrderProcessWorkStationBO.fromJS(item));
            }
            this.unassignedNum = data["unassignedNum"];
        }
    }

    static fromJS(data: any): ProductionOrderProcessWorkStationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionOrderProcessWorkStationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignNum"] = this.assignNum;
        data["code"] = this.code;
        data["id"] = this.id;
        if (this.list && this.list.constructor === Array) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        data["unassignedNum"] = this.unassignedNum;
        return data; 
    }
}

export interface IProductionOrderProcessWorkStationDTO {
    /** 派发数量 */
    assignNum: number | undefined;
    /** 工单号 */
    code: string | undefined;
    /** 工单Id */
    id: string | undefined;
    /** 工单工序工位信息 */
    list: OrderProcessWorkStationBO[] | undefined;
    /** 剩余待派发数量 */
    unassignedNum: number | undefined;
}

export class ProductionOrderProcessWorkStationRecordVO implements IProductionOrderProcessWorkStationRecordVO {
    /** 采集数量 */
    collectionNum!: number | undefined;
    /** 报工时间 */
    endTime!: Date | undefined;
    /** 自定义字段1 */
    extend1!: string | undefined;
    /** 自定义字段2 */
    extend2!: string | undefined;
    /** 自定义字段3 */
    extend3!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 工序id */
    poProcessId!: string | undefined;
    /** 工序编号 */
    processCode!: string | undefined;
    /** 加工人员 */
    producerName!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 合格数量 */
    qualifyNum!: number | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 报工数量 */
    reportNum!: number | undefined;
    /** 报工工时 */
    reportWorkingHours!: string | undefined;
    /** 报废数量 */
    scrappedNum!: number | undefined;
    /** 工序顺序 */
    sort!: number | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 开工时间 */
    startTime!: Date | undefined;
    /** 开工状态：1-未开工，2-已开工,3-完成 */
    status!: number | undefined;
    /** 派发数量 */
    workStationAssignNum!: number | undefined;
    /** 工位id */
    workStationId!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;

    constructor(data?: IProductionOrderProcessWorkStationRecordVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.collectionNum = data["collectionNum"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.id = data["id"];
            this.poProcessId = data["poProcessId"];
            this.processCode = data["processCode"];
            this.producerName = data["producerName"];
            this.productName = data["productName"];
            this.qualifyNum = data["qualifyNum"];
            this.remark = data["remark"];
            this.reportNum = data["reportNum"];
            this.reportWorkingHours = data["reportWorkingHours"];
            this.scrappedNum = data["scrappedNum"];
            this.sort = data["sort"];
            this.standardModel = data["standardModel"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.status = data["status"];
            this.workStationAssignNum = data["workStationAssignNum"];
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): ProductionOrderProcessWorkStationRecordVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionOrderProcessWorkStationRecordVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collectionNum"] = this.collectionNum;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["id"] = this.id;
        data["poProcessId"] = this.poProcessId;
        data["processCode"] = this.processCode;
        data["producerName"] = this.producerName;
        data["productName"] = this.productName;
        data["qualifyNum"] = this.qualifyNum;
        data["remark"] = this.remark;
        data["reportNum"] = this.reportNum;
        data["reportWorkingHours"] = this.reportWorkingHours;
        data["scrappedNum"] = this.scrappedNum;
        data["sort"] = this.sort;
        data["standardModel"] = this.standardModel;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["workStationAssignNum"] = this.workStationAssignNum;
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IProductionOrderProcessWorkStationRecordVO {
    /** 采集数量 */
    collectionNum: number | undefined;
    /** 报工时间 */
    endTime: Date | undefined;
    /** 自定义字段1 */
    extend1: string | undefined;
    /** 自定义字段2 */
    extend2: string | undefined;
    /** 自定义字段3 */
    extend3: string | undefined;
    /** id */
    id: string | undefined;
    /** 工序id */
    poProcessId: string | undefined;
    /** 工序编号 */
    processCode: string | undefined;
    /** 加工人员 */
    producerName: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 合格数量 */
    qualifyNum: number | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 报工数量 */
    reportNum: number | undefined;
    /** 报工工时 */
    reportWorkingHours: string | undefined;
    /** 报废数量 */
    scrappedNum: number | undefined;
    /** 工序顺序 */
    sort: number | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 开工时间 */
    startTime: Date | undefined;
    /** 开工状态：1-未开工，2-已开工,3-完成 */
    status: number | undefined;
    /** 派发数量 */
    workStationAssignNum: number | undefined;
    /** 工位id */
    workStationId: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
}

export class ProductionOrderProcessWorkStationVO implements IProductionOrderProcessWorkStationVO {
    /** 工单编号 */
    code!: string | undefined;
    /** 超差预警 */
    overFlowWarning!: number | undefined;
    /** 所属工单工序的开工工位 */
    poProcessWorkStationId!: string | undefined;
    /** 工序编号 */
    processCode!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 工序顺序 */
    processSort!: number | undefined;
    /** 产品编号 */
    productCode!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 工位产能 */
    stationProductionCapacity!: number | undefined;
    /** 加工工位 */
    workStationId!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;

    constructor(data?: IProductionOrderProcessWorkStationVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.overFlowWarning = data["overFlowWarning"];
            this.poProcessWorkStationId = data["poProcessWorkStationId"];
            this.processCode = data["processCode"];
            this.processName = data["processName"];
            this.processSort = data["processSort"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.stationProductionCapacity = data["stationProductionCapacity"];
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): ProductionOrderProcessWorkStationVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionOrderProcessWorkStationVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["overFlowWarning"] = this.overFlowWarning;
        data["poProcessWorkStationId"] = this.poProcessWorkStationId;
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        data["processSort"] = this.processSort;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["stationProductionCapacity"] = this.stationProductionCapacity;
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IProductionOrderProcessWorkStationVO {
    /** 工单编号 */
    code: string | undefined;
    /** 超差预警 */
    overFlowWarning: number | undefined;
    /** 所属工单工序的开工工位 */
    poProcessWorkStationId: string | undefined;
    /** 工序编号 */
    processCode: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 工序顺序 */
    processSort: number | undefined;
    /** 产品编号 */
    productCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 工位产能 */
    stationProductionCapacity: number | undefined;
    /** 加工工位 */
    workStationId: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
}

export class ProductionOrderVisualVO implements IProductionOrderVisualVO {
    /** 理论结束时间 */
    actualEndTime!: Date | undefined;
    /** 派工数量 */
    assignNum!: number | undefined;
    /** 工单编号 */
    code!: string | undefined;
    /** 采集数量完成率 */
    collectNumCompleteRate!: string | undefined;
    /** 工单状态(1：待加工，2：加工中，3：暂停，4：关闭,5:完工) */
    orderStatus!: string | undefined;
    /** 工序数量 */
    processNum!: number | undefined;
    /** 工单合格数量 */
    qualifyNum!: number | undefined;
    /** 工单的报工数量 */
    reportNum!: number | undefined;
    /** 报工数量完成率 */
    reportNumCompleteRate!: string | undefined;
    /** 工单工序报工数量 */
    reportNums!: string | undefined;
    /** 报工报废数量 */
    scrappedNum!: number | undefined;
    /** 实际开始时间 */
    startTime!: Date | undefined;
    /** 工时完成率 */
    workCompleteRate!: string | undefined;

    constructor(data?: IProductionOrderVisualVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.actualEndTime = data["actualEndTime"] ? new Date(data["actualEndTime"].toString()) : <any>undefined;
            this.assignNum = data["assignNum"];
            this.code = data["code"];
            this.collectNumCompleteRate = data["collectNumCompleteRate"];
            this.orderStatus = data["orderStatus"];
            this.processNum = data["processNum"];
            this.qualifyNum = data["qualifyNum"];
            this.reportNum = data["reportNum"];
            this.reportNumCompleteRate = data["reportNumCompleteRate"];
            this.reportNums = data["reportNums"];
            this.scrappedNum = data["scrappedNum"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.workCompleteRate = data["workCompleteRate"];
        }
    }

    static fromJS(data: any): ProductionOrderVisualVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionOrderVisualVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actualEndTime"] = this.actualEndTime ? this.actualEndTime.toISOString() : <any>undefined;
        data["assignNum"] = this.assignNum;
        data["code"] = this.code;
        data["collectNumCompleteRate"] = this.collectNumCompleteRate;
        data["orderStatus"] = this.orderStatus;
        data["processNum"] = this.processNum;
        data["qualifyNum"] = this.qualifyNum;
        data["reportNum"] = this.reportNum;
        data["reportNumCompleteRate"] = this.reportNumCompleteRate;
        data["reportNums"] = this.reportNums;
        data["scrappedNum"] = this.scrappedNum;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["workCompleteRate"] = this.workCompleteRate;
        return data; 
    }
}

export interface IProductionOrderVisualVO {
    /** 理论结束时间 */
    actualEndTime: Date | undefined;
    /** 派工数量 */
    assignNum: number | undefined;
    /** 工单编号 */
    code: string | undefined;
    /** 采集数量完成率 */
    collectNumCompleteRate: string | undefined;
    /** 工单状态(1：待加工，2：加工中，3：暂停，4：关闭,5:完工) */
    orderStatus: string | undefined;
    /** 工序数量 */
    processNum: number | undefined;
    /** 工单合格数量 */
    qualifyNum: number | undefined;
    /** 工单的报工数量 */
    reportNum: number | undefined;
    /** 报工数量完成率 */
    reportNumCompleteRate: string | undefined;
    /** 工单工序报工数量 */
    reportNums: string | undefined;
    /** 报工报废数量 */
    scrappedNum: number | undefined;
    /** 实际开始时间 */
    startTime: Date | undefined;
    /** 工时完成率 */
    workCompleteRate: string | undefined;
}

export class ProductionOrderWorkStationDTO implements IProductionOrderWorkStationDTO {
    /** 工单ID */
    orderId!: string;
    /** 工序工位列表 */
    processWorkStationDTOS!: ProcessWorkStationDTO[] | undefined;

    constructor(data?: IProductionOrderWorkStationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderId = data["orderId"];
            if (data["processWorkStationDTOS"] && data["processWorkStationDTOS"].constructor === Array) {
                this.processWorkStationDTOS = [] as any;
                for (let item of data["processWorkStationDTOS"])
                    this.processWorkStationDTOS!.push(ProcessWorkStationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductionOrderWorkStationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionOrderWorkStationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        if (this.processWorkStationDTOS && this.processWorkStationDTOS.constructor === Array) {
            data["processWorkStationDTOS"] = [];
            for (let item of this.processWorkStationDTOS)
                data["processWorkStationDTOS"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProductionOrderWorkStationDTO {
    /** 工单ID */
    orderId: string;
    /** 工序工位列表 */
    processWorkStationDTOS: ProcessWorkStationDTO[] | undefined;
}

export class ProductionPlan implements IProductionPlan {
    bomId!: string | undefined;
    /** BOM版本 */
    bomVersion!: string | undefined;
    /** 计划类别 */
    category!: number | undefined;
    /** 生产计划编号 */
    code!: string | undefined;
    /** 采集数量 */
    collectionNum!: number | undefined;
    /** 所属产品工艺 */
    craftId!: string | undefined;
    /** 产品工艺版本 */
    craftVersion!: string | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    customerId!: string | undefined;
    /** 客户姓名 */
    customerName!: string | undefined;
    /** 实际结束时间 */
    endTime!: Date | undefined;
    extend1!: string | undefined;
    extend2!: string | undefined;
    extend3!: string | undefined;
    extend4!: string | undefined;
    extend5!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 物料编号 */
    materialCode!: string | undefined;
    /** 订单编码 */
    orderCode!: string | undefined;
    /** 计划结束时间 */
    planEndTime!: Date | undefined;
    /** 计划模式，1-依序进行、2-多序并行 */
    planMode!: number | undefined;
    /** 计划数量 */
    planNum!: number | undefined;
    /** 计划开始时间 */
    planStartTime!: Date | undefined;
    /** 计划状态 */
    planStatus!: number | undefined;
    /** 暂停前状态 */
    planStatusBefore!: number | undefined;
    /** 工序派工（0-未启用、1-启用） */
    processAssignMode!: number | undefined;
    /** 产品编号 */
    productCode!: string | undefined;
    /** 所属产品 */
    productId!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 产品类型Id */
    productTypeId!: string | undefined;
    /** 产品类型Name */
    productTypeName!: string | undefined;
    /** 工序合格数量 */
    qualifyNum!: number | undefined;
    /** 报工数量 */
    reportNum!: number | undefined;
    /** 资源ID */
    resourceId!: string | undefined;
    /** 工序报废数量 */
    scrappedNum!: number | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 实际开始时间 */
    startTime!: Date | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 租户ID */
    tenantId!: string | undefined;
    /** 生产计划类型 */
    typeId!: string | undefined;
    /** 待派发数量 */
    unassignedNum!: number | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;
    /** 计划报工工时 */
    workTime!: number | undefined;

    constructor(data?: IProductionPlan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bomId = data["bomId"];
            this.bomVersion = data["bomVersion"];
            this.category = data["category"];
            this.code = data["code"];
            this.collectionNum = data["collectionNum"];
            this.craftId = data["craftId"];
            this.craftVersion = data["craftVersion"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.customerId = data["customerId"];
            this.customerName = data["customerName"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.materialCode = data["materialCode"];
            this.orderCode = data["orderCode"];
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.planMode = data["planMode"];
            this.planNum = data["planNum"];
            this.planStartTime = data["planStartTime"] ? new Date(data["planStartTime"].toString()) : <any>undefined;
            this.planStatus = data["planStatus"];
            this.planStatusBefore = data["planStatusBefore"];
            this.processAssignMode = data["processAssignMode"];
            this.productCode = data["productCode"];
            this.productId = data["productId"];
            this.productName = data["productName"];
            this.productTypeId = data["productTypeId"];
            this.productTypeName = data["productTypeName"];
            this.qualifyNum = data["qualifyNum"];
            this.reportNum = data["reportNum"];
            this.resourceId = data["resourceId"];
            this.scrappedNum = data["scrappedNum"];
            this.standardModel = data["standardModel"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.status = data["status"];
            this.tenantId = data["tenantId"];
            this.typeId = data["typeId"];
            this.unassignedNum = data["unassignedNum"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
            this.workTime = data["workTime"];
        }
    }

    static fromJS(data: any): ProductionPlan {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionPlan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bomId"] = this.bomId;
        data["bomVersion"] = this.bomVersion;
        data["category"] = this.category;
        data["code"] = this.code;
        data["collectionNum"] = this.collectionNum;
        data["craftId"] = this.craftId;
        data["craftVersion"] = this.craftVersion;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["materialCode"] = this.materialCode;
        data["orderCode"] = this.orderCode;
        data["planEndTime"] = this.planEndTime ? this.planEndTime.toISOString() : <any>undefined;
        data["planMode"] = this.planMode;
        data["planNum"] = this.planNum;
        data["planStartTime"] = this.planStartTime ? this.planStartTime.toISOString() : <any>undefined;
        data["planStatus"] = this.planStatus;
        data["planStatusBefore"] = this.planStatusBefore;
        data["processAssignMode"] = this.processAssignMode;
        data["productCode"] = this.productCode;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productTypeId"] = this.productTypeId;
        data["productTypeName"] = this.productTypeName;
        data["qualifyNum"] = this.qualifyNum;
        data["reportNum"] = this.reportNum;
        data["resourceId"] = this.resourceId;
        data["scrappedNum"] = this.scrappedNum;
        data["standardModel"] = this.standardModel;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["typeId"] = this.typeId;
        data["unassignedNum"] = this.unassignedNum;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        data["workTime"] = this.workTime;
        return data; 
    }
}

export interface IProductionPlan {
    bomId: string | undefined;
    /** BOM版本 */
    bomVersion: string | undefined;
    /** 计划类别 */
    category: number | undefined;
    /** 生产计划编号 */
    code: string | undefined;
    /** 采集数量 */
    collectionNum: number | undefined;
    /** 所属产品工艺 */
    craftId: string | undefined;
    /** 产品工艺版本 */
    craftVersion: string | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    customerId: string | undefined;
    /** 客户姓名 */
    customerName: string | undefined;
    /** 实际结束时间 */
    endTime: Date | undefined;
    extend1: string | undefined;
    extend2: string | undefined;
    extend3: string | undefined;
    extend4: string | undefined;
    extend5: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 物料编号 */
    materialCode: string | undefined;
    /** 订单编码 */
    orderCode: string | undefined;
    /** 计划结束时间 */
    planEndTime: Date | undefined;
    /** 计划模式，1-依序进行、2-多序并行 */
    planMode: number | undefined;
    /** 计划数量 */
    planNum: number | undefined;
    /** 计划开始时间 */
    planStartTime: Date | undefined;
    /** 计划状态 */
    planStatus: number | undefined;
    /** 暂停前状态 */
    planStatusBefore: number | undefined;
    /** 工序派工（0-未启用、1-启用） */
    processAssignMode: number | undefined;
    /** 产品编号 */
    productCode: string | undefined;
    /** 所属产品 */
    productId: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 产品类型Id */
    productTypeId: string | undefined;
    /** 产品类型Name */
    productTypeName: string | undefined;
    /** 工序合格数量 */
    qualifyNum: number | undefined;
    /** 报工数量 */
    reportNum: number | undefined;
    /** 资源ID */
    resourceId: string | undefined;
    /** 工序报废数量 */
    scrappedNum: number | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 实际开始时间 */
    startTime: Date | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 租户ID */
    tenantId: string | undefined;
    /** 生产计划类型 */
    typeId: string | undefined;
    /** 待派发数量 */
    unassignedNum: number | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
    /** 计划报工工时 */
    workTime: number | undefined;
}

/** 生产计划 */
export class ProductionPlanBO implements IProductionPlanBO {
    /** 计划类别 */
    category!: number | undefined;
    /** 生产计划编号 */
    code!: string | undefined;
    /** 所属产品工艺 */
    craftId!: string | undefined;
    /** 产品工艺版本 */
    craftVersion!: string | undefined;
    /** 实际结束时间 */
    endTime!: Date | undefined;
    /** 扩展字段1 */
    extend1!: string | undefined;
    /** 扩展字段2 */
    extend2!: string | undefined;
    /** 扩展字段3 */
    extend3!: string | undefined;
    /** 扩展字段4 */
    extend4!: string | undefined;
    /** 扩展字段5 */
    extend5!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 物料编号 */
    materialCode!: string | undefined;
    /** 订单编码 */
    orderCode!: string | undefined;
    /** 计划结束时间 */
    planEndTime!: Date | undefined;
    /** 计划数量 */
    planNum!: number | undefined;
    /** 计划开始时间 */
    planStartTime!: Date | undefined;
    /** 计划状态 */
    planStatus!: number | undefined;
    /** 暂停前状态 */
    planStatusBefore!: number | undefined;
    /** 产品编号 */
    productCode!: string | undefined;
    /** 所属产品 */
    productId!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 产品类型Id */
    productTypeId!: string | undefined;
    /** 产品类型名称 */
    productTypeName!: string | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 实际开始时间 */
    startTime!: Date | undefined;
    /** 待派发数量 */
    unassignedNum!: number | undefined;

    constructor(data?: IProductionPlanBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"];
            this.code = data["code"];
            this.craftId = data["craftId"];
            this.craftVersion = data["craftVersion"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.id = data["id"];
            this.materialCode = data["materialCode"];
            this.orderCode = data["orderCode"];
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.planNum = data["planNum"];
            this.planStartTime = data["planStartTime"] ? new Date(data["planStartTime"].toString()) : <any>undefined;
            this.planStatus = data["planStatus"];
            this.planStatusBefore = data["planStatusBefore"];
            this.productCode = data["productCode"];
            this.productId = data["productId"];
            this.productName = data["productName"];
            this.productTypeId = data["productTypeId"];
            this.productTypeName = data["productTypeName"];
            this.standardModel = data["standardModel"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.unassignedNum = data["unassignedNum"];
        }
    }

    static fromJS(data: any): ProductionPlanBO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionPlanBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["code"] = this.code;
        data["craftId"] = this.craftId;
        data["craftVersion"] = this.craftVersion;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["id"] = this.id;
        data["materialCode"] = this.materialCode;
        data["orderCode"] = this.orderCode;
        data["planEndTime"] = this.planEndTime ? this.planEndTime.toISOString() : <any>undefined;
        data["planNum"] = this.planNum;
        data["planStartTime"] = this.planStartTime ? this.planStartTime.toISOString() : <any>undefined;
        data["planStatus"] = this.planStatus;
        data["planStatusBefore"] = this.planStatusBefore;
        data["productCode"] = this.productCode;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productTypeId"] = this.productTypeId;
        data["productTypeName"] = this.productTypeName;
        data["standardModel"] = this.standardModel;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["unassignedNum"] = this.unassignedNum;
        return data; 
    }
}

/** 生产计划 */
export interface IProductionPlanBO {
    /** 计划类别 */
    category: number | undefined;
    /** 生产计划编号 */
    code: string | undefined;
    /** 所属产品工艺 */
    craftId: string | undefined;
    /** 产品工艺版本 */
    craftVersion: string | undefined;
    /** 实际结束时间 */
    endTime: Date | undefined;
    /** 扩展字段1 */
    extend1: string | undefined;
    /** 扩展字段2 */
    extend2: string | undefined;
    /** 扩展字段3 */
    extend3: string | undefined;
    /** 扩展字段4 */
    extend4: string | undefined;
    /** 扩展字段5 */
    extend5: string | undefined;
    /** id */
    id: string | undefined;
    /** 物料编号 */
    materialCode: string | undefined;
    /** 订单编码 */
    orderCode: string | undefined;
    /** 计划结束时间 */
    planEndTime: Date | undefined;
    /** 计划数量 */
    planNum: number | undefined;
    /** 计划开始时间 */
    planStartTime: Date | undefined;
    /** 计划状态 */
    planStatus: number | undefined;
    /** 暂停前状态 */
    planStatusBefore: number | undefined;
    /** 产品编号 */
    productCode: string | undefined;
    /** 所属产品 */
    productId: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 产品类型Id */
    productTypeId: string | undefined;
    /** 产品类型名称 */
    productTypeName: string | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 实际开始时间 */
    startTime: Date | undefined;
    /** 待派发数量 */
    unassignedNum: number | undefined;
}

export class ProductionPlanCardVO implements IProductionPlanCardVO {
    /** 计划类型 */
    category!: number | undefined;
    /** 计划编号 */
    code!: string | undefined;
    /** 计划数量 */
    planNum!: number | undefined;
    /** 计划进度 */
    planSchedule!: string | undefined;
    /** 当前计划状态(1：待派发，2：待加工，3：加工中，4：暂停) */
    planStatus!: number | undefined;
    /** 产品编号 */
    productCode!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 产品单位 */
    unit!: string | undefined;

    constructor(data?: IProductionPlanCardVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"];
            this.code = data["code"];
            this.planNum = data["planNum"];
            this.planSchedule = data["planSchedule"];
            this.planStatus = data["planStatus"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.standardModel = data["standardModel"];
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): ProductionPlanCardVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionPlanCardVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["code"] = this.code;
        data["planNum"] = this.planNum;
        data["planSchedule"] = this.planSchedule;
        data["planStatus"] = this.planStatus;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["standardModel"] = this.standardModel;
        data["unit"] = this.unit;
        return data; 
    }
}

export interface IProductionPlanCardVO {
    /** 计划类型 */
    category: number | undefined;
    /** 计划编号 */
    code: string | undefined;
    /** 计划数量 */
    planNum: number | undefined;
    /** 计划进度 */
    planSchedule: string | undefined;
    /** 当前计划状态(1：待派发，2：待加工，3：加工中，4：暂停) */
    planStatus: number | undefined;
    /** 产品编号 */
    productCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 产品单位 */
    unit: string | undefined;
}

/** 生产计划 */
export class ProductionPlanDTO implements IProductionPlanDTO {
    /** 计划类别：2、来料计划 */
    category!: number;
    /** 生产计划编号 */
    code!: string | undefined;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 所属产品工艺 */
    craftId!: string | undefined;
    /** 产品工艺版本 */
    craftVersion!: string | undefined;
    customerId!: string | undefined;
    /** 客户姓名 */
    customerName!: string | undefined;
    /** 实际结束时间 */
    endTime!: Date | undefined;
    extend1!: string | undefined;
    extend2!: string | undefined;
    extend3!: string | undefined;
    extend4!: string | undefined;
    extend5!: string | undefined;
    /** 文件信息列表 */
    fileList!: FileInfoDetailDTO[] | undefined;
    /** id */
    id!: string | undefined;
    /** 自定义工序列表 */
    list!: ProductionPlanProcessDTO[] | undefined;
    /** 物料编号 */
    materialCode!: string | undefined;
    /** 订单编码 */
    orderCode!: string | undefined;
    /** 计划结束时间 */
    planEndTime!: Date;
    /** 计划数量 */
    planNum!: number;
    /** 计划开始时间 */
    planStartTime!: Date;
    /** 计划状态 */
    planStatus!: number | undefined;
    /** 暂停前状态 */
    planStatusBefore!: number | undefined;
    /** 产品编号 */
    productCode!: string | undefined;
    /** 所属产品 */
    productId!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 产品类型Id */
    productTypeId!: string | undefined;
    /** 产品类型名称 */
    productTypeName!: string | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 实际开始时间 */
    startTime!: Date | undefined;
    /** 所属计划类型 */
    typeId!: string;
    /** 类型名 */
    typeName!: string | undefined;
    /** 待派发数量 */
    unassignedNum!: number | undefined;

    constructor(data?: IProductionPlanDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"];
            this.code = data["code"];
            this.codeRuleId = data["codeRuleId"];
            this.craftId = data["craftId"];
            this.craftVersion = data["craftVersion"];
            this.customerId = data["customerId"];
            this.customerName = data["customerName"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            if (data["fileList"] && data["fileList"].constructor === Array) {
                this.fileList = [] as any;
                for (let item of data["fileList"])
                    this.fileList!.push(FileInfoDetailDTO.fromJS(item));
            }
            this.id = data["id"];
            if (data["list"] && data["list"].constructor === Array) {
                this.list = [] as any;
                for (let item of data["list"])
                    this.list!.push(ProductionPlanProcessDTO.fromJS(item));
            }
            this.materialCode = data["materialCode"];
            this.orderCode = data["orderCode"];
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.planNum = data["planNum"];
            this.planStartTime = data["planStartTime"] ? new Date(data["planStartTime"].toString()) : <any>undefined;
            this.planStatus = data["planStatus"];
            this.planStatusBefore = data["planStatusBefore"];
            this.productCode = data["productCode"];
            this.productId = data["productId"];
            this.productName = data["productName"];
            this.productTypeId = data["productTypeId"];
            this.productTypeName = data["productTypeName"];
            this.standardModel = data["standardModel"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.typeId = data["typeId"];
            this.typeName = data["typeName"];
            this.unassignedNum = data["unassignedNum"];
        }
    }

    static fromJS(data: any): ProductionPlanDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionPlanDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["code"] = this.code;
        data["codeRuleId"] = this.codeRuleId;
        data["craftId"] = this.craftId;
        data["craftVersion"] = this.craftVersion;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        if (this.fileList && this.fileList.constructor === Array) {
            data["fileList"] = [];
            for (let item of this.fileList)
                data["fileList"].push(item.toJSON());
        }
        data["id"] = this.id;
        if (this.list && this.list.constructor === Array) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        data["materialCode"] = this.materialCode;
        data["orderCode"] = this.orderCode;
        data["planEndTime"] = this.planEndTime ? this.planEndTime.toISOString() : <any>undefined;
        data["planNum"] = this.planNum;
        data["planStartTime"] = this.planStartTime ? this.planStartTime.toISOString() : <any>undefined;
        data["planStatus"] = this.planStatus;
        data["planStatusBefore"] = this.planStatusBefore;
        data["productCode"] = this.productCode;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productTypeId"] = this.productTypeId;
        data["productTypeName"] = this.productTypeName;
        data["standardModel"] = this.standardModel;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["unassignedNum"] = this.unassignedNum;
        return data; 
    }
}

/** 生产计划 */
export interface IProductionPlanDTO {
    /** 计划类别：2、来料计划 */
    category: number;
    /** 生产计划编号 */
    code: string | undefined;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 所属产品工艺 */
    craftId: string | undefined;
    /** 产品工艺版本 */
    craftVersion: string | undefined;
    customerId: string | undefined;
    /** 客户姓名 */
    customerName: string | undefined;
    /** 实际结束时间 */
    endTime: Date | undefined;
    extend1: string | undefined;
    extend2: string | undefined;
    extend3: string | undefined;
    extend4: string | undefined;
    extend5: string | undefined;
    /** 文件信息列表 */
    fileList: FileInfoDetailDTO[] | undefined;
    /** id */
    id: string | undefined;
    /** 自定义工序列表 */
    list: ProductionPlanProcessDTO[] | undefined;
    /** 物料编号 */
    materialCode: string | undefined;
    /** 订单编码 */
    orderCode: string | undefined;
    /** 计划结束时间 */
    planEndTime: Date;
    /** 计划数量 */
    planNum: number;
    /** 计划开始时间 */
    planStartTime: Date;
    /** 计划状态 */
    planStatus: number | undefined;
    /** 暂停前状态 */
    planStatusBefore: number | undefined;
    /** 产品编号 */
    productCode: string | undefined;
    /** 所属产品 */
    productId: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 产品类型Id */
    productTypeId: string | undefined;
    /** 产品类型名称 */
    productTypeName: string | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 实际开始时间 */
    startTime: Date | undefined;
    /** 所属计划类型 */
    typeId: string;
    /** 类型名 */
    typeName: string | undefined;
    /** 待派发数量 */
    unassignedNum: number | undefined;
}

export class ProductionPlanExcelExportDTO implements IProductionPlanExcelExportDTO {
    /** 是否选中导出 */
    exportSelected!: boolean | undefined;
    /** 筛选条件 */
    searchCondition!: ProductionPlanSearchDTO | undefined;
    /** 选中记录id集合 */
    selectedRecords!: string[] | undefined;
    /** bizDataId */
    typeId!: string | undefined;

    constructor(data?: IProductionPlanExcelExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.exportSelected = data["exportSelected"];
            this.searchCondition = data["searchCondition"] ? ProductionPlanSearchDTO.fromJS(data["searchCondition"]) : <any>undefined;
            if (data["selectedRecords"] && data["selectedRecords"].constructor === Array) {
                this.selectedRecords = [] as any;
                for (let item of data["selectedRecords"])
                    this.selectedRecords!.push(item);
            }
            this.typeId = data["typeId"];
        }
    }

    static fromJS(data: any): ProductionPlanExcelExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionPlanExcelExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exportSelected"] = this.exportSelected;
        data["searchCondition"] = this.searchCondition ? this.searchCondition.toJSON() : <any>undefined;
        if (this.selectedRecords && this.selectedRecords.constructor === Array) {
            data["selectedRecords"] = [];
            for (let item of this.selectedRecords)
                data["selectedRecords"].push(item);
        }
        data["typeId"] = this.typeId;
        return data; 
    }
}

export interface IProductionPlanExcelExportDTO {
    /** 是否选中导出 */
    exportSelected: boolean | undefined;
    /** 筛选条件 */
    searchCondition: ProductionPlanSearchDTO | undefined;
    /** 选中记录id集合 */
    selectedRecords: string[] | undefined;
    /** bizDataId */
    typeId: string | undefined;
}

export class ProductionPlanExportResult implements IProductionPlanExportResult {
    /** 失败记录数 */
    failUploadRecords!: number | undefined;
    /** 成功上传记录数 */
    successUploadRecords!: number | undefined;
    /** 上传记录数 */
    uploadTotal!: number | undefined;

    constructor(data?: IProductionPlanExportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.failUploadRecords = data["failUploadRecords"];
            this.successUploadRecords = data["successUploadRecords"];
            this.uploadTotal = data["uploadTotal"];
        }
    }

    static fromJS(data: any): ProductionPlanExportResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionPlanExportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["failUploadRecords"] = this.failUploadRecords;
        data["successUploadRecords"] = this.successUploadRecords;
        data["uploadTotal"] = this.uploadTotal;
        return data; 
    }
}

export interface IProductionPlanExportResult {
    /** 失败记录数 */
    failUploadRecords: number | undefined;
    /** 成功上传记录数 */
    successUploadRecords: number | undefined;
    /** 上传记录数 */
    uploadTotal: number | undefined;
}

export class ProductionPlanOrderProcessReportNumDTO implements IProductionPlanOrderProcessReportNumDTO {
    /** 工单ID */
    id!: string;
    /** 工单工序编号code */
    processCode!: string;
    /** 工单工序名称 */
    processName!: string;
    /** 工单工序报工数量 */
    reportNum!: number | undefined;
    /** 工序顺序 */
    sort!: number | undefined;
    /** 工单工序工时 */
    workTime!: number | undefined;

    constructor(data?: IProductionPlanOrderProcessReportNumDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.processCode = data["processCode"];
            this.processName = data["processName"];
            this.reportNum = data["reportNum"];
            this.sort = data["sort"];
            this.workTime = data["workTime"];
        }
    }

    static fromJS(data: any): ProductionPlanOrderProcessReportNumDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionPlanOrderProcessReportNumDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        data["reportNum"] = this.reportNum;
        data["sort"] = this.sort;
        data["workTime"] = this.workTime;
        return data; 
    }
}

export interface IProductionPlanOrderProcessReportNumDTO {
    /** 工单ID */
    id: string;
    /** 工单工序编号code */
    processCode: string;
    /** 工单工序名称 */
    processName: string;
    /** 工单工序报工数量 */
    reportNum: number | undefined;
    /** 工序顺序 */
    sort: number | undefined;
    /** 工单工序工时 */
    workTime: number | undefined;
}

export class ProductionPlanOrderScheduleVO implements IProductionPlanOrderScheduleVO {
    /** 理论结束时间 */
    actualEndTime!: Date | undefined;
    /** 派工数量 */
    assignNum!: number | undefined;
    /** 工单编号 */
    code!: string | undefined;
    /** 采集数量完成率 */
    collectNumCompleteRate!: string | undefined;
    /** 工单状态(1：待加工，2：加工中，3：暂停，4：关闭,5:完工) */
    orderStatus!: number | undefined;
    /** 工序数量 */
    processNum!: number | undefined;
    /** 工单工序报工数量进度 */
    processReportNumList!: ProductionPlanOrderProcessReportNumDTO[] | undefined;
    /** 工单合格数量 */
    qualifyNum!: number | undefined;
    /** 工单的报工数量 */
    reportNum!: number | undefined;
    /** 报工数量完成率 */
    reportNumCompleteRate!: string | undefined;
    /** 实际开始时间 */
    startTime!: Date | undefined;
    /** 工时完成率 */
    workCompleteRate!: string | undefined;

    constructor(data?: IProductionPlanOrderScheduleVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.actualEndTime = data["actualEndTime"] ? new Date(data["actualEndTime"].toString()) : <any>undefined;
            this.assignNum = data["assignNum"];
            this.code = data["code"];
            this.collectNumCompleteRate = data["collectNumCompleteRate"];
            this.orderStatus = data["orderStatus"];
            this.processNum = data["processNum"];
            if (data["processReportNumList"] && data["processReportNumList"].constructor === Array) {
                this.processReportNumList = [] as any;
                for (let item of data["processReportNumList"])
                    this.processReportNumList!.push(ProductionPlanOrderProcessReportNumDTO.fromJS(item));
            }
            this.qualifyNum = data["qualifyNum"];
            this.reportNum = data["reportNum"];
            this.reportNumCompleteRate = data["reportNumCompleteRate"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.workCompleteRate = data["workCompleteRate"];
        }
    }

    static fromJS(data: any): ProductionPlanOrderScheduleVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionPlanOrderScheduleVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actualEndTime"] = this.actualEndTime ? this.actualEndTime.toISOString() : <any>undefined;
        data["assignNum"] = this.assignNum;
        data["code"] = this.code;
        data["collectNumCompleteRate"] = this.collectNumCompleteRate;
        data["orderStatus"] = this.orderStatus;
        data["processNum"] = this.processNum;
        if (this.processReportNumList && this.processReportNumList.constructor === Array) {
            data["processReportNumList"] = [];
            for (let item of this.processReportNumList)
                data["processReportNumList"].push(item.toJSON());
        }
        data["qualifyNum"] = this.qualifyNum;
        data["reportNum"] = this.reportNum;
        data["reportNumCompleteRate"] = this.reportNumCompleteRate;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["workCompleteRate"] = this.workCompleteRate;
        return data; 
    }
}

export interface IProductionPlanOrderScheduleVO {
    /** 理论结束时间 */
    actualEndTime: Date | undefined;
    /** 派工数量 */
    assignNum: number | undefined;
    /** 工单编号 */
    code: string | undefined;
    /** 采集数量完成率 */
    collectNumCompleteRate: string | undefined;
    /** 工单状态(1：待加工，2：加工中，3：暂停，4：关闭,5:完工) */
    orderStatus: number | undefined;
    /** 工序数量 */
    processNum: number | undefined;
    /** 工单工序报工数量进度 */
    processReportNumList: ProductionPlanOrderProcessReportNumDTO[] | undefined;
    /** 工单合格数量 */
    qualifyNum: number | undefined;
    /** 工单的报工数量 */
    reportNum: number | undefined;
    /** 报工数量完成率 */
    reportNumCompleteRate: string | undefined;
    /** 实际开始时间 */
    startTime: Date | undefined;
    /** 工时完成率 */
    workCompleteRate: string | undefined;
}

export class ProductionPlanOrderSearchDTO implements IProductionPlanOrderSearchDTO {
    /** 生产计划ID */
    planId!: string;
    /** 工单状态查询 */
    status!: number[] | undefined;

    constructor(data?: IProductionPlanOrderSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planId = data["planId"];
            if (data["status"] && data["status"].constructor === Array) {
                this.status = [] as any;
                for (let item of data["status"])
                    this.status!.push(item);
            }
        }
    }

    static fromJS(data: any): ProductionPlanOrderSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionPlanOrderSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planId"] = this.planId;
        if (this.status && this.status.constructor === Array) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        return data; 
    }
}

export interface IProductionPlanOrderSearchDTO {
    /** 生产计划ID */
    planId: string;
    /** 工单状态查询 */
    status: number[] | undefined;
}

export class ProductionPlanOverAllProgress implements IProductionPlanOverAllProgress {
    /** 计划完成率 */
    completionRate!: string | undefined;
    /** 报工数量 */
    olNums!: number | undefined;
    /** 计划数量 */
    planNums!: number | undefined;
    /** 待加工数量 */
    processedNums!: number | undefined;
    /** 合格数量 */
    qualifiedNums!: number | undefined;
    /** 报废数量 */
    scrappedNums!: number | undefined;

    constructor(data?: IProductionPlanOverAllProgress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.completionRate = data["completionRate"];
            this.olNums = data["olNums"];
            this.planNums = data["planNums"];
            this.processedNums = data["processedNums"];
            this.qualifiedNums = data["qualifiedNums"];
            this.scrappedNums = data["scrappedNums"];
        }
    }

    static fromJS(data: any): ProductionPlanOverAllProgress {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionPlanOverAllProgress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completionRate"] = this.completionRate;
        data["olNums"] = this.olNums;
        data["planNums"] = this.planNums;
        data["processedNums"] = this.processedNums;
        data["qualifiedNums"] = this.qualifiedNums;
        data["scrappedNums"] = this.scrappedNums;
        return data; 
    }
}

export interface IProductionPlanOverAllProgress {
    /** 计划完成率 */
    completionRate: string | undefined;
    /** 报工数量 */
    olNums: number | undefined;
    /** 计划数量 */
    planNums: number | undefined;
    /** 待加工数量 */
    processedNums: number | undefined;
    /** 合格数量 */
    qualifiedNums: number | undefined;
    /** 报废数量 */
    scrappedNums: number | undefined;
}

export class ProductionPlanOverdueVO implements IProductionPlanOverdueVO {
    /** 生产计划编号 */
    code!: string | undefined;
    /** 实际结束时间 */
    endTime!: Date | undefined;
    /** 预测理论结束时间 */
    forecastEndTime!: Date | undefined;
    /** 预测理论超期时长 */
    forecastOverdueDuration!: string | undefined;
    /** 编号 */
    id!: string | undefined;
    /** 实际超期时长 */
    overdueDuration!: string | undefined;
    /** 计划结束时间 */
    planEndTime!: Date | undefined;
    /** 计划数量 */
    planNum!: number | undefined;
    /** 计划开始时间 */
    planStartTime!: Date | undefined;
    /** 计划状态计划状态(1：待派发，2：待加工，3：加工中，4：暂停，5：关闭,6:完工) */
    planStatus!: number | undefined;
    /** 产品编号 */
    productCode!: string | undefined;
    /** 产品类型 */
    productTypeName!: string | undefined;
    /** 实际开始时间 */
    startTime!: Date | undefined;

    constructor(data?: IProductionPlanOverdueVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.forecastEndTime = data["forecastEndTime"] ? new Date(data["forecastEndTime"].toString()) : <any>undefined;
            this.forecastOverdueDuration = data["forecastOverdueDuration"];
            this.id = data["id"];
            this.overdueDuration = data["overdueDuration"];
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.planNum = data["planNum"];
            this.planStartTime = data["planStartTime"] ? new Date(data["planStartTime"].toString()) : <any>undefined;
            this.planStatus = data["planStatus"];
            this.productCode = data["productCode"];
            this.productTypeName = data["productTypeName"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductionPlanOverdueVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionPlanOverdueVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["forecastEndTime"] = this.forecastEndTime ? this.forecastEndTime.toISOString() : <any>undefined;
        data["forecastOverdueDuration"] = this.forecastOverdueDuration;
        data["id"] = this.id;
        data["overdueDuration"] = this.overdueDuration;
        data["planEndTime"] = this.planEndTime ? this.planEndTime.toISOString() : <any>undefined;
        data["planNum"] = this.planNum;
        data["planStartTime"] = this.planStartTime ? this.planStartTime.toISOString() : <any>undefined;
        data["planStatus"] = this.planStatus;
        data["productCode"] = this.productCode;
        data["productTypeName"] = this.productTypeName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IProductionPlanOverdueVO {
    /** 生产计划编号 */
    code: string | undefined;
    /** 实际结束时间 */
    endTime: Date | undefined;
    /** 预测理论结束时间 */
    forecastEndTime: Date | undefined;
    /** 预测理论超期时长 */
    forecastOverdueDuration: string | undefined;
    /** 编号 */
    id: string | undefined;
    /** 实际超期时长 */
    overdueDuration: string | undefined;
    /** 计划结束时间 */
    planEndTime: Date | undefined;
    /** 计划数量 */
    planNum: number | undefined;
    /** 计划开始时间 */
    planStartTime: Date | undefined;
    /** 计划状态计划状态(1：待派发，2：待加工，3：加工中，4：暂停，5：关闭,6:完工) */
    planStatus: number | undefined;
    /** 产品编号 */
    productCode: string | undefined;
    /** 产品类型 */
    productTypeName: string | undefined;
    /** 实际开始时间 */
    startTime: Date | undefined;
}

/** 自定义生产工序 */
export class ProductionPlanProcessBO implements IProductionPlanProcessBO {
    /** 工序编号 */
    code!: string | undefined;
    /** 拆卸工时 */
    disassemblyTime!: number | undefined;
    /** 工艺参数1 */
    extend1!: string | undefined;
    /** 工艺参数2 */
    extend2!: string | undefined;
    /** 工艺参数3 */
    extend3!: string | undefined;
    /** 工艺参数4 */
    extend4!: string | undefined;
    /** 工艺参数5 */
    extend5!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 工序名称 */
    name!: string | undefined;
    /** 准备工时 */
    prepareTime!: number | undefined;
    /** 工序序号 */
    processSequence!: string | undefined;
    /** 工位信息 */
    processWorkStationBOList!: ProcessWorkStationBO[] | undefined;
    /** 程序名称 */
    programName!: string | undefined;
    /** 工序顺序 */
    sort!: number | undefined;
    /** 标准工时 */
    standardTime!: number | undefined;
    /** 运输工时 */
    transportTime!: number | undefined;

    constructor(data?: IProductionPlanProcessBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.disassemblyTime = data["disassemblyTime"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.id = data["id"];
            this.name = data["name"];
            this.prepareTime = data["prepareTime"];
            this.processSequence = data["processSequence"];
            if (data["processWorkStationBOList"] && data["processWorkStationBOList"].constructor === Array) {
                this.processWorkStationBOList = [] as any;
                for (let item of data["processWorkStationBOList"])
                    this.processWorkStationBOList!.push(ProcessWorkStationBO.fromJS(item));
            }
            this.programName = data["programName"];
            this.sort = data["sort"];
            this.standardTime = data["standardTime"];
            this.transportTime = data["transportTime"];
        }
    }

    static fromJS(data: any): ProductionPlanProcessBO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionPlanProcessBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["disassemblyTime"] = this.disassemblyTime;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["id"] = this.id;
        data["name"] = this.name;
        data["prepareTime"] = this.prepareTime;
        data["processSequence"] = this.processSequence;
        if (this.processWorkStationBOList && this.processWorkStationBOList.constructor === Array) {
            data["processWorkStationBOList"] = [];
            for (let item of this.processWorkStationBOList)
                data["processWorkStationBOList"].push(item.toJSON());
        }
        data["programName"] = this.programName;
        data["sort"] = this.sort;
        data["standardTime"] = this.standardTime;
        data["transportTime"] = this.transportTime;
        return data; 
    }
}

/** 自定义生产工序 */
export interface IProductionPlanProcessBO {
    /** 工序编号 */
    code: string | undefined;
    /** 拆卸工时 */
    disassemblyTime: number | undefined;
    /** 工艺参数1 */
    extend1: string | undefined;
    /** 工艺参数2 */
    extend2: string | undefined;
    /** 工艺参数3 */
    extend3: string | undefined;
    /** 工艺参数4 */
    extend4: string | undefined;
    /** 工艺参数5 */
    extend5: string | undefined;
    /** id */
    id: string | undefined;
    /** 工序名称 */
    name: string | undefined;
    /** 准备工时 */
    prepareTime: number | undefined;
    /** 工序序号 */
    processSequence: string | undefined;
    /** 工位信息 */
    processWorkStationBOList: ProcessWorkStationBO[] | undefined;
    /** 程序名称 */
    programName: string | undefined;
    /** 工序顺序 */
    sort: number | undefined;
    /** 标准工时 */
    standardTime: number | undefined;
    /** 运输工时 */
    transportTime: number | undefined;
}

/** 自定义工序 */
export class ProductionPlanProcessDTO implements IProductionPlanProcessDTO {
    /** 工序编号 */
    code!: string | undefined;
    /** 拆卸工时 */
    disassemblyTime!: number | undefined;
    /** 工艺参数1 */
    extend1!: string | undefined;
    /** 工艺参数2 */
    extend2!: string | undefined;
    /** 工艺参数3 */
    extend3!: string | undefined;
    /** 工艺参数4 */
    extend4!: string | undefined;
    /** 工艺参数5 */
    extend5!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 工序名称 */
    name!: string | undefined;
    /** 所属生产计划 */
    planId!: string | undefined;
    /** 准备工时 */
    prepareTime!: number | undefined;
    /** 工序序号 */
    processSequence!: string | undefined;
    /** 程序名称 */
    programName!: string | undefined;
    /** 工序顺序 */
    sort!: number | undefined;
    /** 标准工时 */
    standardTime!: number | undefined;
    /** 运输工时 */
    transportTime!: number | undefined;

    constructor(data?: IProductionPlanProcessDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.disassemblyTime = data["disassemblyTime"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.id = data["id"];
            this.name = data["name"];
            this.planId = data["planId"];
            this.prepareTime = data["prepareTime"];
            this.processSequence = data["processSequence"];
            this.programName = data["programName"];
            this.sort = data["sort"];
            this.standardTime = data["standardTime"];
            this.transportTime = data["transportTime"];
        }
    }

    static fromJS(data: any): ProductionPlanProcessDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionPlanProcessDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["disassemblyTime"] = this.disassemblyTime;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["id"] = this.id;
        data["name"] = this.name;
        data["planId"] = this.planId;
        data["prepareTime"] = this.prepareTime;
        data["processSequence"] = this.processSequence;
        data["programName"] = this.programName;
        data["sort"] = this.sort;
        data["standardTime"] = this.standardTime;
        data["transportTime"] = this.transportTime;
        return data; 
    }
}

/** 自定义工序 */
export interface IProductionPlanProcessDTO {
    /** 工序编号 */
    code: string | undefined;
    /** 拆卸工时 */
    disassemblyTime: number | undefined;
    /** 工艺参数1 */
    extend1: string | undefined;
    /** 工艺参数2 */
    extend2: string | undefined;
    /** 工艺参数3 */
    extend3: string | undefined;
    /** 工艺参数4 */
    extend4: string | undefined;
    /** 工艺参数5 */
    extend5: string | undefined;
    /** id */
    id: string | undefined;
    /** 工序名称 */
    name: string | undefined;
    /** 所属生产计划 */
    planId: string | undefined;
    /** 准备工时 */
    prepareTime: number | undefined;
    /** 工序序号 */
    processSequence: string | undefined;
    /** 程序名称 */
    programName: string | undefined;
    /** 工序顺序 */
    sort: number | undefined;
    /** 标准工时 */
    standardTime: number | undefined;
    /** 运输工时 */
    transportTime: number | undefined;
}

export class ProductionPlanProcessReportNumDTO implements IProductionPlanProcessReportNumDTO {
    /** 计划工序code */
    code!: string;
    /** 计划工序名称 */
    name!: string;
    /** 计划ID */
    planId!: string;
    /** 计划工序报工数量 */
    reportNum!: number | undefined;
    /** 计划工序顺序 */
    sort!: number | undefined;

    constructor(data?: IProductionPlanProcessReportNumDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.planId = data["planId"];
            this.reportNum = data["reportNum"];
            this.sort = data["sort"];
        }
    }

    static fromJS(data: any): ProductionPlanProcessReportNumDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionPlanProcessReportNumDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["planId"] = this.planId;
        data["reportNum"] = this.reportNum;
        data["sort"] = this.sort;
        return data; 
    }
}

export interface IProductionPlanProcessReportNumDTO {
    /** 计划工序code */
    code: string;
    /** 计划工序名称 */
    name: string;
    /** 计划ID */
    planId: string;
    /** 计划工序报工数量 */
    reportNum: number | undefined;
    /** 计划工序顺序 */
    sort: number | undefined;
}

export class ProductionPlanProcessScheduleVO implements IProductionPlanProcessScheduleVO {
    /** 单件工时差2 */
    acquisitionTimedifference!: number | undefined;
    /** 计划编号 */
    code!: string | undefined;
    /** 单件采集工时 */
    collectionTotalTime!: number | undefined;
    /** id */
    id!: string | undefined;
    /** 计划结束时间 */
    planEndTime!: Date | undefined;
    /** 计划数量 */
    planNum!: number | undefined;
    /** 计划开始时间 */
    planStartTime!: Date | undefined;
    /** 产品编号 */
    productCode!: string | undefined;
    /** 产品类型名称 */
    productTypeName!: string | undefined;
    /** 单件工时差1 */
    reportTimeDifference!: number | undefined;
    /** 单件报工工时 */
    reportTotalTime!: number | undefined;
    /** 单件额定工时 */
    standardTotalTime!: number | undefined;
    /** 额定总工时 */
    totleWorkHours!: number | undefined;

    constructor(data?: IProductionPlanProcessScheduleVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.acquisitionTimedifference = data["acquisitionTimedifference"];
            this.code = data["code"];
            this.collectionTotalTime = data["collectionTotalTime"];
            this.id = data["id"];
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.planNum = data["planNum"];
            this.planStartTime = data["planStartTime"] ? new Date(data["planStartTime"].toString()) : <any>undefined;
            this.productCode = data["productCode"];
            this.productTypeName = data["productTypeName"];
            this.reportTimeDifference = data["reportTimeDifference"];
            this.reportTotalTime = data["reportTotalTime"];
            this.standardTotalTime = data["standardTotalTime"];
            this.totleWorkHours = data["totleWorkHours"];
        }
    }

    static fromJS(data: any): ProductionPlanProcessScheduleVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionPlanProcessScheduleVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acquisitionTimedifference"] = this.acquisitionTimedifference;
        data["code"] = this.code;
        data["collectionTotalTime"] = this.collectionTotalTime;
        data["id"] = this.id;
        data["planEndTime"] = this.planEndTime ? this.planEndTime.toISOString() : <any>undefined;
        data["planNum"] = this.planNum;
        data["planStartTime"] = this.planStartTime ? this.planStartTime.toISOString() : <any>undefined;
        data["productCode"] = this.productCode;
        data["productTypeName"] = this.productTypeName;
        data["reportTimeDifference"] = this.reportTimeDifference;
        data["reportTotalTime"] = this.reportTotalTime;
        data["standardTotalTime"] = this.standardTotalTime;
        data["totleWorkHours"] = this.totleWorkHours;
        return data; 
    }
}

export interface IProductionPlanProcessScheduleVO {
    /** 单件工时差2 */
    acquisitionTimedifference: number | undefined;
    /** 计划编号 */
    code: string | undefined;
    /** 单件采集工时 */
    collectionTotalTime: number | undefined;
    /** id */
    id: string | undefined;
    /** 计划结束时间 */
    planEndTime: Date | undefined;
    /** 计划数量 */
    planNum: number | undefined;
    /** 计划开始时间 */
    planStartTime: Date | undefined;
    /** 产品编号 */
    productCode: string | undefined;
    /** 产品类型名称 */
    productTypeName: string | undefined;
    /** 单件工时差1 */
    reportTimeDifference: number | undefined;
    /** 单件报工工时 */
    reportTotalTime: number | undefined;
    /** 单件额定工时 */
    standardTotalTime: number | undefined;
    /** 额定总工时 */
    totleWorkHours: number | undefined;
}

export class ProductionPlanSaveDTO implements IProductionPlanSaveDTO {
    /** 所选BOM的Id */
    bomId!: string | undefined;
    /** BOM版本 */
    bomVersion!: string | undefined;
    /** 计划类别：1、生产计划，2、来料计划 */
    category!: number;
    /** 生产计划编号 */
    code!: string | undefined;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 所属产品工艺 */
    craftId!: string;
    /** 产品工艺版本 */
    craftVersion!: string;
    /** 客户id */
    customerId!: string | undefined;
    /** 客户姓名 */
    customerName!: string | undefined;
    /** 实际结束时间 */
    endTime!: Date | undefined;
    /** 扩展字段1 */
    extend1!: string | undefined;
    /** 扩展字段2 */
    extend2!: string | undefined;
    /** 扩展字段3 */
    extend3!: string | undefined;
    /** 扩展字段4 */
    extend4!: string | undefined;
    /** 扩展字段5 */
    extend5!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 物料编号 */
    materialCode!: string | undefined;
    /** 订单编码 */
    orderCode!: string | undefined;
    /** 计划结束时间 */
    planEndTime!: Date;
    /** 计划数量 */
    planNum!: number;
    /** 计划开始时间 */
    planStartTime!: Date;
    /** 计划状态 */
    planStatus!: number | undefined;
    /** 暂停前状态 */
    planStatusBefore!: number | undefined;
    /** 产品编号 */
    productCode!: string;
    /** 所属产品 */
    productId!: string;
    /** 产品名称 */
    productName!: string | undefined;
    /** 产品类型Id */
    productTypeId!: string;
    /** 产品类型名称 */
    productTypeName!: string | undefined;
    /** 计划关联的资源id */
    resourceId!: string | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 实际开始时间 */
    startTime!: Date | undefined;
    /** 所属计划类型 */
    typeId!: string;
    /** 类型名 */
    typeName!: string | undefined;
    /** 待派发数量 */
    unassignedNum!: number | undefined;

    constructor(data?: IProductionPlanSaveDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bomId = data["bomId"];
            this.bomVersion = data["bomVersion"];
            this.category = data["category"];
            this.code = data["code"];
            this.codeRuleId = data["codeRuleId"];
            this.craftId = data["craftId"];
            this.craftVersion = data["craftVersion"];
            this.customerId = data["customerId"];
            this.customerName = data["customerName"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.id = data["id"];
            this.materialCode = data["materialCode"];
            this.orderCode = data["orderCode"];
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.planNum = data["planNum"];
            this.planStartTime = data["planStartTime"] ? new Date(data["planStartTime"].toString()) : <any>undefined;
            this.planStatus = data["planStatus"];
            this.planStatusBefore = data["planStatusBefore"];
            this.productCode = data["productCode"];
            this.productId = data["productId"];
            this.productName = data["productName"];
            this.productTypeId = data["productTypeId"];
            this.productTypeName = data["productTypeName"];
            this.resourceId = data["resourceId"];
            this.standardModel = data["standardModel"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.typeId = data["typeId"];
            this.typeName = data["typeName"];
            this.unassignedNum = data["unassignedNum"];
        }
    }

    static fromJS(data: any): ProductionPlanSaveDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionPlanSaveDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bomId"] = this.bomId;
        data["bomVersion"] = this.bomVersion;
        data["category"] = this.category;
        data["code"] = this.code;
        data["codeRuleId"] = this.codeRuleId;
        data["craftId"] = this.craftId;
        data["craftVersion"] = this.craftVersion;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["id"] = this.id;
        data["materialCode"] = this.materialCode;
        data["orderCode"] = this.orderCode;
        data["planEndTime"] = this.planEndTime ? this.planEndTime.toISOString() : <any>undefined;
        data["planNum"] = this.planNum;
        data["planStartTime"] = this.planStartTime ? this.planStartTime.toISOString() : <any>undefined;
        data["planStatus"] = this.planStatus;
        data["planStatusBefore"] = this.planStatusBefore;
        data["productCode"] = this.productCode;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productTypeId"] = this.productTypeId;
        data["productTypeName"] = this.productTypeName;
        data["resourceId"] = this.resourceId;
        data["standardModel"] = this.standardModel;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["unassignedNum"] = this.unassignedNum;
        return data; 
    }
}

export interface IProductionPlanSaveDTO {
    /** 所选BOM的Id */
    bomId: string | undefined;
    /** BOM版本 */
    bomVersion: string | undefined;
    /** 计划类别：1、生产计划，2、来料计划 */
    category: number;
    /** 生产计划编号 */
    code: string | undefined;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 所属产品工艺 */
    craftId: string;
    /** 产品工艺版本 */
    craftVersion: string;
    /** 客户id */
    customerId: string | undefined;
    /** 客户姓名 */
    customerName: string | undefined;
    /** 实际结束时间 */
    endTime: Date | undefined;
    /** 扩展字段1 */
    extend1: string | undefined;
    /** 扩展字段2 */
    extend2: string | undefined;
    /** 扩展字段3 */
    extend3: string | undefined;
    /** 扩展字段4 */
    extend4: string | undefined;
    /** 扩展字段5 */
    extend5: string | undefined;
    /** id */
    id: string | undefined;
    /** 物料编号 */
    materialCode: string | undefined;
    /** 订单编码 */
    orderCode: string | undefined;
    /** 计划结束时间 */
    planEndTime: Date;
    /** 计划数量 */
    planNum: number;
    /** 计划开始时间 */
    planStartTime: Date;
    /** 计划状态 */
    planStatus: number | undefined;
    /** 暂停前状态 */
    planStatusBefore: number | undefined;
    /** 产品编号 */
    productCode: string;
    /** 所属产品 */
    productId: string;
    /** 产品名称 */
    productName: string | undefined;
    /** 产品类型Id */
    productTypeId: string;
    /** 产品类型名称 */
    productTypeName: string | undefined;
    /** 计划关联的资源id */
    resourceId: string | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 实际开始时间 */
    startTime: Date | undefined;
    /** 所属计划类型 */
    typeId: string;
    /** 类型名 */
    typeName: string | undefined;
    /** 待派发数量 */
    unassignedNum: number | undefined;
}

export class ProductionPlanScheduleVO implements IProductionPlanScheduleVO {
    /** 生产计划编号 */
    code!: string | undefined;
    /** 采集数量完成率:VO */
    collectCompleteRate!: string | undefined;
    /** 理论结束时间 */
    forecastEndTime!: Date | undefined;
    /** 编号 */
    id!: string | undefined;
    /** 计划结束时间 */
    planEndTime!: Date | undefined;
    /** 计划数量 */
    planNum!: number | undefined;
    /** 计划开始时间 */
    planStartTime!: Date | undefined;
    /** 计划工序报工数量进度 */
    processReportNumList!: ProductionPlanProcessReportNumDTO[] | undefined;
    /** 产品编号 */
    productCode!: string | undefined;
    /** 产品类型名称 */
    productTypeName!: string | undefined;
    /** 计划合格数量 */
    qualifyNum!: number | undefined;
    /** 报工数量完成率:VO */
    reportCompleteRate!: string | undefined;
    /** 计划报工数量 */
    reportNum!: number | undefined;
    /** 实际开始时间 */
    startTime!: Date | undefined;
    /** 工时完成率 */
    workCompleteRate!: string | undefined;

    constructor(data?: IProductionPlanScheduleVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.collectCompleteRate = data["collectCompleteRate"];
            this.forecastEndTime = data["forecastEndTime"] ? new Date(data["forecastEndTime"].toString()) : <any>undefined;
            this.id = data["id"];
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.planNum = data["planNum"];
            this.planStartTime = data["planStartTime"] ? new Date(data["planStartTime"].toString()) : <any>undefined;
            if (data["processReportNumList"] && data["processReportNumList"].constructor === Array) {
                this.processReportNumList = [] as any;
                for (let item of data["processReportNumList"])
                    this.processReportNumList!.push(ProductionPlanProcessReportNumDTO.fromJS(item));
            }
            this.productCode = data["productCode"];
            this.productTypeName = data["productTypeName"];
            this.qualifyNum = data["qualifyNum"];
            this.reportCompleteRate = data["reportCompleteRate"];
            this.reportNum = data["reportNum"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.workCompleteRate = data["workCompleteRate"];
        }
    }

    static fromJS(data: any): ProductionPlanScheduleVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionPlanScheduleVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["collectCompleteRate"] = this.collectCompleteRate;
        data["forecastEndTime"] = this.forecastEndTime ? this.forecastEndTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["planEndTime"] = this.planEndTime ? this.planEndTime.toISOString() : <any>undefined;
        data["planNum"] = this.planNum;
        data["planStartTime"] = this.planStartTime ? this.planStartTime.toISOString() : <any>undefined;
        if (this.processReportNumList && this.processReportNumList.constructor === Array) {
            data["processReportNumList"] = [];
            for (let item of this.processReportNumList)
                data["processReportNumList"].push(item.toJSON());
        }
        data["productCode"] = this.productCode;
        data["productTypeName"] = this.productTypeName;
        data["qualifyNum"] = this.qualifyNum;
        data["reportCompleteRate"] = this.reportCompleteRate;
        data["reportNum"] = this.reportNum;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["workCompleteRate"] = this.workCompleteRate;
        return data; 
    }
}

export interface IProductionPlanScheduleVO {
    /** 生产计划编号 */
    code: string | undefined;
    /** 采集数量完成率:VO */
    collectCompleteRate: string | undefined;
    /** 理论结束时间 */
    forecastEndTime: Date | undefined;
    /** 编号 */
    id: string | undefined;
    /** 计划结束时间 */
    planEndTime: Date | undefined;
    /** 计划数量 */
    planNum: number | undefined;
    /** 计划开始时间 */
    planStartTime: Date | undefined;
    /** 计划工序报工数量进度 */
    processReportNumList: ProductionPlanProcessReportNumDTO[] | undefined;
    /** 产品编号 */
    productCode: string | undefined;
    /** 产品类型名称 */
    productTypeName: string | undefined;
    /** 计划合格数量 */
    qualifyNum: number | undefined;
    /** 报工数量完成率:VO */
    reportCompleteRate: string | undefined;
    /** 计划报工数量 */
    reportNum: number | undefined;
    /** 实际开始时间 */
    startTime: Date | undefined;
    /** 工时完成率 */
    workCompleteRate: string | undefined;
}

export class ProductionPlanSearchDTO implements IProductionPlanSearchDTO {
    /** 生产计划编号查询 */
    code!: string | undefined;
    /** 是否高级筛选 */
    filterPlus!: boolean;
    /** 查询条件字典 */
    param!: any | undefined;
    /** 生产计划状态查询 */
    planStatus!: number[] | undefined;
    /** 产品信息查询 */
    productInfo!: string | undefined;
    /** 生产计划类型ID */
    typeId!: string;

    constructor(data?: IProductionPlanSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.filterPlus = data["filterPlus"];
            this.param = data["param"];
            if (data["planStatus"] && data["planStatus"].constructor === Array) {
                this.planStatus = [] as any;
                for (let item of data["planStatus"])
                    this.planStatus!.push(item);
            }
            this.productInfo = data["productInfo"];
            this.typeId = data["typeId"];
        }
    }

    static fromJS(data: any): ProductionPlanSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionPlanSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["filterPlus"] = this.filterPlus;
        data["param"] = this.param;
        if (this.planStatus && this.planStatus.constructor === Array) {
            data["planStatus"] = [];
            for (let item of this.planStatus)
                data["planStatus"].push(item);
        }
        data["productInfo"] = this.productInfo;
        data["typeId"] = this.typeId;
        return data; 
    }
}

export interface IProductionPlanSearchDTO {
    /** 生产计划编号查询 */
    code: string | undefined;
    /** 是否高级筛选 */
    filterPlus: boolean;
    /** 查询条件字典 */
    param: any | undefined;
    /** 生产计划状态查询 */
    planStatus: number[] | undefined;
    /** 产品信息查询 */
    productInfo: string | undefined;
    /** 生产计划类型ID */
    typeId: string;
}

export class ProductionPlanSettingDTO implements IProductionPlanSettingDTO {
    /** 多语言名称 */
    languageList!: LanguageDTO[] | undefined;
    /** 计划类型id */
    planTypeId!: string | undefined;
    /** 工序派工（0-未启用、1-启用） */
    processAssignMode!: number | undefined;
    /** 产品类型ID列表 */
    productTypeIds!: string[] | undefined;
    /** 模块名 */
    source!: string | undefined;
    /** 开工模式1-依序进行、2-多序进行,无数量限制 3-多序进行,数量限制 */
    startWorkModel!: number | undefined;

    constructor(data?: IProductionPlanSettingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["languageList"] && data["languageList"].constructor === Array) {
                this.languageList = [] as any;
                for (let item of data["languageList"])
                    this.languageList!.push(LanguageDTO.fromJS(item));
            }
            this.planTypeId = data["planTypeId"];
            this.processAssignMode = data["processAssignMode"];
            if (data["productTypeIds"] && data["productTypeIds"].constructor === Array) {
                this.productTypeIds = [] as any;
                for (let item of data["productTypeIds"])
                    this.productTypeIds!.push(item);
            }
            this.source = data["source"];
            this.startWorkModel = data["startWorkModel"];
        }
    }

    static fromJS(data: any): ProductionPlanSettingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionPlanSettingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.languageList && this.languageList.constructor === Array) {
            data["languageList"] = [];
            for (let item of this.languageList)
                data["languageList"].push(item.toJSON());
        }
        data["planTypeId"] = this.planTypeId;
        data["processAssignMode"] = this.processAssignMode;
        if (this.productTypeIds && this.productTypeIds.constructor === Array) {
            data["productTypeIds"] = [];
            for (let item of this.productTypeIds)
                data["productTypeIds"].push(item);
        }
        data["source"] = this.source;
        data["startWorkModel"] = this.startWorkModel;
        return data; 
    }
}

export interface IProductionPlanSettingDTO {
    /** 多语言名称 */
    languageList: LanguageDTO[] | undefined;
    /** 计划类型id */
    planTypeId: string | undefined;
    /** 工序派工（0-未启用、1-启用） */
    processAssignMode: number | undefined;
    /** 产品类型ID列表 */
    productTypeIds: string[] | undefined;
    /** 模块名 */
    source: string | undefined;
    /** 开工模式1-依序进行、2-多序进行,无数量限制 3-多序进行,数量限制 */
    startWorkModel: number | undefined;
}

export class ProductionPlanTypeInfoVO implements IProductionPlanTypeInfoVO {
    /** 计划id */
    id!: string | undefined;
    /** 计划名称 */
    name!: string | undefined;
    /** 工序派工（0-未启用、1-启用） */
    processAssignMode!: number | undefined;
    /** 计划关联的产品类型id */
    productTypes!: string[] | undefined;
    /** 开工模式，1-依序进行、2-多序进行 */
    startWorkModel!: number | undefined;

    constructor(data?: IProductionPlanTypeInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.processAssignMode = data["processAssignMode"];
            if (data["productTypes"] && data["productTypes"].constructor === Array) {
                this.productTypes = [] as any;
                for (let item of data["productTypes"])
                    this.productTypes!.push(item);
            }
            this.startWorkModel = data["startWorkModel"];
        }
    }

    static fromJS(data: any): ProductionPlanTypeInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionPlanTypeInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["processAssignMode"] = this.processAssignMode;
        if (this.productTypes && this.productTypes.constructor === Array) {
            data["productTypes"] = [];
            for (let item of this.productTypes)
                data["productTypes"].push(item);
        }
        data["startWorkModel"] = this.startWorkModel;
        return data; 
    }
}

export interface IProductionPlanTypeInfoVO {
    /** 计划id */
    id: string | undefined;
    /** 计划名称 */
    name: string | undefined;
    /** 工序派工（0-未启用、1-启用） */
    processAssignMode: number | undefined;
    /** 计划关联的产品类型id */
    productTypes: string[] | undefined;
    /** 开工模式，1-依序进行、2-多序进行 */
    startWorkModel: number | undefined;
}

export class ProductionPlanTypeProductTypeDTO implements IProductionPlanTypeProductTypeDTO {
    /** 计划类型ID */
    planTypeId!: string | undefined;
    /** 产品类型ID列表 */
    productTypeIds!: string[] | undefined;

    constructor(data?: IProductionPlanTypeProductTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planTypeId = data["planTypeId"];
            if (data["productTypeIds"] && data["productTypeIds"].constructor === Array) {
                this.productTypeIds = [] as any;
                for (let item of data["productTypeIds"])
                    this.productTypeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ProductionPlanTypeProductTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionPlanTypeProductTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planTypeId"] = this.planTypeId;
        if (this.productTypeIds && this.productTypeIds.constructor === Array) {
            data["productTypeIds"] = [];
            for (let item of this.productTypeIds)
                data["productTypeIds"].push(item);
        }
        return data; 
    }
}

export interface IProductionPlanTypeProductTypeDTO {
    /** 计划类型ID */
    planTypeId: string | undefined;
    /** 产品类型ID列表 */
    productTypeIds: string[] | undefined;
}

export class ProductionStatisticsByWorkStationReportExcelDTO implements IProductionStatisticsByWorkStationReportExcelDTO {
    /** 业务type */
    bizType!: string | undefined;
    /** 日 */
    date!: string[] | undefined;
    /** 结束时间 */
    endTime!: Date | undefined;
    /** 月 */
    month!: number[] | undefined;
    /** 计划编号 */
    planCode!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 产品类型ID */
    productTypeId!: string;
    /** 选中的班次信息 */
    shiftList!: KeyNameDTO[] | undefined;
    /** 开始时间 */
    startTime!: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod!: ProductionStatisticsByWorkStationReportExcelDTOStatisticalMethod | undefined;
    /** 周 */
    week!: number[] | undefined;
    /** 选中的工位 */
    workStationBOList!: WorkStationBO[] | undefined;
    /** 年 */
    year!: number | undefined;

    constructor(data?: IProductionStatisticsByWorkStationReportExcelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bizType = data["bizType"];
            if (data["date"] && data["date"].constructor === Array) {
                this.date = [] as any;
                for (let item of data["date"])
                    this.date!.push(item);
            }
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            if (data["month"] && data["month"].constructor === Array) {
                this.month = [] as any;
                for (let item of data["month"])
                    this.month!.push(item);
            }
            this.planCode = data["planCode"];
            this.productName = data["productName"];
            this.productTypeId = data["productTypeId"];
            if (data["shiftList"] && data["shiftList"].constructor === Array) {
                this.shiftList = [] as any;
                for (let item of data["shiftList"])
                    this.shiftList!.push(KeyNameDTO.fromJS(item));
            }
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.statisticalMethod = data["statisticalMethod"];
            if (data["week"] && data["week"].constructor === Array) {
                this.week = [] as any;
                for (let item of data["week"])
                    this.week!.push(item);
            }
            if (data["workStationBOList"] && data["workStationBOList"].constructor === Array) {
                this.workStationBOList = [] as any;
                for (let item of data["workStationBOList"])
                    this.workStationBOList!.push(WorkStationBO.fromJS(item));
            }
            this.year = data["year"];
        }
    }

    static fromJS(data: any): ProductionStatisticsByWorkStationReportExcelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionStatisticsByWorkStationReportExcelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bizType"] = this.bizType;
        if (this.date && this.date.constructor === Array) {
            data["date"] = [];
            for (let item of this.date)
                data["date"].push(item);
        }
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        if (this.month && this.month.constructor === Array) {
            data["month"] = [];
            for (let item of this.month)
                data["month"].push(item);
        }
        data["planCode"] = this.planCode;
        data["productName"] = this.productName;
        data["productTypeId"] = this.productTypeId;
        if (this.shiftList && this.shiftList.constructor === Array) {
            data["shiftList"] = [];
            for (let item of this.shiftList)
                data["shiftList"].push(item.toJSON());
        }
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["statisticalMethod"] = this.statisticalMethod;
        if (this.week && this.week.constructor === Array) {
            data["week"] = [];
            for (let item of this.week)
                data["week"].push(item);
        }
        if (this.workStationBOList && this.workStationBOList.constructor === Array) {
            data["workStationBOList"] = [];
            for (let item of this.workStationBOList)
                data["workStationBOList"].push(item.toJSON());
        }
        data["year"] = this.year;
        return data; 
    }
}

export interface IProductionStatisticsByWorkStationReportExcelDTO {
    /** 业务type */
    bizType: string | undefined;
    /** 日 */
    date: string[] | undefined;
    /** 结束时间 */
    endTime: Date | undefined;
    /** 月 */
    month: number[] | undefined;
    /** 计划编号 */
    planCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 产品类型ID */
    productTypeId: string;
    /** 选中的班次信息 */
    shiftList: KeyNameDTO[] | undefined;
    /** 开始时间 */
    startTime: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod: ProductionStatisticsByWorkStationReportExcelDTOStatisticalMethod | undefined;
    /** 周 */
    week: number[] | undefined;
    /** 选中的工位 */
    workStationBOList: WorkStationBO[] | undefined;
    /** 年 */
    year: number | undefined;
}

export class ProductionStatisticsByWorkStationVO implements IProductionStatisticsByWorkStationVO {
    /** 采集数量 */
    collectionNum!: number | undefined;
    /** 报工时间 */
    endTime!: Date | undefined;
    /** 自定义字段1 */
    extend1!: string | undefined;
    /** 自定义字段2 */
    extend2!: string | undefined;
    /** 自定义字段3 */
    extend3!: string | undefined;
    /** 完工数量 */
    finishNum!: number | undefined;
    /** 完工差异 */
    finishedDifference!: number | undefined;
    /** 计划单号 */
    planCode!: string | undefined;
    /** 工序编码 */
    processCode!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 工序顺序 */
    processSort!: number | undefined;
    /** 产品编码 */
    productCode!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 合格数量 */
    qualifyNum!: number | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 报工数量 */
    reportNum!: number | undefined;
    /** 报废数量 */
    scrappedNum!: number | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 日期 */
    startDate!: string | undefined;
    /** 加工人员 */
    startPerson!: string | undefined;
    /** 开工时间 */
    startTime!: Date | undefined;
    /** 工位产能 */
    stationProductionCapacity!: number | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;
    /** 加工时间 单位：秒 */
    workTime!: string | undefined;

    constructor(data?: IProductionStatisticsByWorkStationVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.collectionNum = data["collectionNum"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.finishNum = data["finishNum"];
            this.finishedDifference = data["finishedDifference"];
            this.planCode = data["planCode"];
            this.processCode = data["processCode"];
            this.processName = data["processName"];
            this.processSort = data["processSort"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.qualifyNum = data["qualifyNum"];
            this.remark = data["remark"];
            this.reportNum = data["reportNum"];
            this.scrappedNum = data["scrappedNum"];
            this.standardModel = data["standardModel"];
            this.startDate = data["startDate"];
            this.startPerson = data["startPerson"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.stationProductionCapacity = data["stationProductionCapacity"];
            this.workStationName = data["workStationName"];
            this.workTime = data["workTime"];
        }
    }

    static fromJS(data: any): ProductionStatisticsByWorkStationVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionStatisticsByWorkStationVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collectionNum"] = this.collectionNum;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["finishNum"] = this.finishNum;
        data["finishedDifference"] = this.finishedDifference;
        data["planCode"] = this.planCode;
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        data["processSort"] = this.processSort;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["qualifyNum"] = this.qualifyNum;
        data["remark"] = this.remark;
        data["reportNum"] = this.reportNum;
        data["scrappedNum"] = this.scrappedNum;
        data["standardModel"] = this.standardModel;
        data["startDate"] = this.startDate;
        data["startPerson"] = this.startPerson;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["stationProductionCapacity"] = this.stationProductionCapacity;
        data["workStationName"] = this.workStationName;
        data["workTime"] = this.workTime;
        return data; 
    }
}

export interface IProductionStatisticsByWorkStationVO {
    /** 采集数量 */
    collectionNum: number | undefined;
    /** 报工时间 */
    endTime: Date | undefined;
    /** 自定义字段1 */
    extend1: string | undefined;
    /** 自定义字段2 */
    extend2: string | undefined;
    /** 自定义字段3 */
    extend3: string | undefined;
    /** 完工数量 */
    finishNum: number | undefined;
    /** 完工差异 */
    finishedDifference: number | undefined;
    /** 计划单号 */
    planCode: string | undefined;
    /** 工序编码 */
    processCode: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 工序顺序 */
    processSort: number | undefined;
    /** 产品编码 */
    productCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 合格数量 */
    qualifyNum: number | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 报工数量 */
    reportNum: number | undefined;
    /** 报废数量 */
    scrappedNum: number | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 日期 */
    startDate: string | undefined;
    /** 加工人员 */
    startPerson: string | undefined;
    /** 开工时间 */
    startTime: Date | undefined;
    /** 工位产能 */
    stationProductionCapacity: number | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
    /** 加工时间 单位：秒 */
    workTime: string | undefined;
}

export class ProductionStatisticsReportDTO implements IProductionStatisticsReportDTO {
    /** 日 */
    date!: Date | undefined;
    /** 结束时间 */
    endDate!: Date | undefined;
    /** 月 */
    month!: number | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 产品类型ID */
    productTypeId!: string;
    /** 班次index */
    shiftIndex!: number | undefined;
    /** 开始时间 */
    startDate!: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod!: ProductionStatisticsReportDTOStatisticalMethod | undefined;
    /** 周 */
    week!: number | undefined;
    /** 选中的工位id-工单工序id */
    workStationAndPoProcessList!: WorkStationAndPoProcessDTO[] | undefined;
    workStationBOList!: WorkStationBO[] | undefined;
    /** 年 */
    year!: number | undefined;

    constructor(data?: IProductionStatisticsReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? new Date(data["date"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            this.month = data["month"];
            this.productName = data["productName"];
            this.productTypeId = data["productTypeId"];
            this.shiftIndex = data["shiftIndex"];
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            this.statisticalMethod = data["statisticalMethod"];
            this.week = data["week"];
            if (data["workStationAndPoProcessList"] && data["workStationAndPoProcessList"].constructor === Array) {
                this.workStationAndPoProcessList = [] as any;
                for (let item of data["workStationAndPoProcessList"])
                    this.workStationAndPoProcessList!.push(WorkStationAndPoProcessDTO.fromJS(item));
            }
            if (data["workStationBOList"] && data["workStationBOList"].constructor === Array) {
                this.workStationBOList = [] as any;
                for (let item of data["workStationBOList"])
                    this.workStationBOList!.push(WorkStationBO.fromJS(item));
            }
            this.year = data["year"];
        }
    }

    static fromJS(data: any): ProductionStatisticsReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionStatisticsReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["month"] = this.month;
        data["productName"] = this.productName;
        data["productTypeId"] = this.productTypeId;
        data["shiftIndex"] = this.shiftIndex;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["statisticalMethod"] = this.statisticalMethod;
        data["week"] = this.week;
        if (this.workStationAndPoProcessList && this.workStationAndPoProcessList.constructor === Array) {
            data["workStationAndPoProcessList"] = [];
            for (let item of this.workStationAndPoProcessList)
                data["workStationAndPoProcessList"].push(item.toJSON());
        }
        if (this.workStationBOList && this.workStationBOList.constructor === Array) {
            data["workStationBOList"] = [];
            for (let item of this.workStationBOList)
                data["workStationBOList"].push(item.toJSON());
        }
        data["year"] = this.year;
        return data; 
    }
}

export interface IProductionStatisticsReportDTO {
    /** 日 */
    date: Date | undefined;
    /** 结束时间 */
    endDate: Date | undefined;
    /** 月 */
    month: number | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 产品类型ID */
    productTypeId: string;
    /** 班次index */
    shiftIndex: number | undefined;
    /** 开始时间 */
    startDate: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod: ProductionStatisticsReportDTOStatisticalMethod | undefined;
    /** 周 */
    week: number | undefined;
    /** 选中的工位id-工单工序id */
    workStationAndPoProcessList: WorkStationAndPoProcessDTO[] | undefined;
    workStationBOList: WorkStationBO[] | undefined;
    /** 年 */
    year: number | undefined;
}

export class ProductionStatisticsReportExcelDTO implements IProductionStatisticsReportExcelDTO {
    /** 日 */
    date!: string[] | undefined;
    /** 结束时间 */
    endTime!: Date | undefined;
    /** 月 */
    month!: number[] | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 产品类型ID */
    productTypeId!: string;
    /** 选中的班次信息 */
    shiftList!: KeyNameDTO[] | undefined;
    /** 开始时间 */
    startTime!: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod!: ProductionStatisticsReportExcelDTOStatisticalMethod | undefined;
    /** 周 */
    week!: number[] | undefined;
    /** 选中的工位id-工单工序id */
    workStationAndPoProcessList!: WorkStationAndPoProcessDTO[] | undefined;
    /** 年 */
    year!: number | undefined;

    constructor(data?: IProductionStatisticsReportExcelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["date"] && data["date"].constructor === Array) {
                this.date = [] as any;
                for (let item of data["date"])
                    this.date!.push(item);
            }
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            if (data["month"] && data["month"].constructor === Array) {
                this.month = [] as any;
                for (let item of data["month"])
                    this.month!.push(item);
            }
            this.productName = data["productName"];
            this.productTypeId = data["productTypeId"];
            if (data["shiftList"] && data["shiftList"].constructor === Array) {
                this.shiftList = [] as any;
                for (let item of data["shiftList"])
                    this.shiftList!.push(KeyNameDTO.fromJS(item));
            }
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.statisticalMethod = data["statisticalMethod"];
            if (data["week"] && data["week"].constructor === Array) {
                this.week = [] as any;
                for (let item of data["week"])
                    this.week!.push(item);
            }
            if (data["workStationAndPoProcessList"] && data["workStationAndPoProcessList"].constructor === Array) {
                this.workStationAndPoProcessList = [] as any;
                for (let item of data["workStationAndPoProcessList"])
                    this.workStationAndPoProcessList!.push(WorkStationAndPoProcessDTO.fromJS(item));
            }
            this.year = data["year"];
        }
    }

    static fromJS(data: any): ProductionStatisticsReportExcelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionStatisticsReportExcelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.date && this.date.constructor === Array) {
            data["date"] = [];
            for (let item of this.date)
                data["date"].push(item);
        }
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        if (this.month && this.month.constructor === Array) {
            data["month"] = [];
            for (let item of this.month)
                data["month"].push(item);
        }
        data["productName"] = this.productName;
        data["productTypeId"] = this.productTypeId;
        if (this.shiftList && this.shiftList.constructor === Array) {
            data["shiftList"] = [];
            for (let item of this.shiftList)
                data["shiftList"].push(item.toJSON());
        }
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["statisticalMethod"] = this.statisticalMethod;
        if (this.week && this.week.constructor === Array) {
            data["week"] = [];
            for (let item of this.week)
                data["week"].push(item);
        }
        if (this.workStationAndPoProcessList && this.workStationAndPoProcessList.constructor === Array) {
            data["workStationAndPoProcessList"] = [];
            for (let item of this.workStationAndPoProcessList)
                data["workStationAndPoProcessList"].push(item.toJSON());
        }
        data["year"] = this.year;
        return data; 
    }
}

export interface IProductionStatisticsReportExcelDTO {
    /** 日 */
    date: string[] | undefined;
    /** 结束时间 */
    endTime: Date | undefined;
    /** 月 */
    month: number[] | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 产品类型ID */
    productTypeId: string;
    /** 选中的班次信息 */
    shiftList: KeyNameDTO[] | undefined;
    /** 开始时间 */
    startTime: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod: ProductionStatisticsReportExcelDTOStatisticalMethod | undefined;
    /** 周 */
    week: number[] | undefined;
    /** 选中的工位id-工单工序id */
    workStationAndPoProcessList: WorkStationAndPoProcessDTO[] | undefined;
    /** 年 */
    year: number | undefined;
}

export class ProductionStatisticsVO implements IProductionStatisticsVO {
    /** 指派数量 */
    assignNum!: number | undefined;
    /** 采集数量 */
    collectionNum!: number | undefined;
    /** 完工比 */
    completeCompare!: string | undefined;
    /** 完工差异 */
    completeDifference!: number | undefined;
    /** 日期 */
    date!: string | undefined;
    /** 自定义字段1 */
    extend1!: string | undefined;
    /** 自定义字段2 */
    extend2!: string | undefined;
    /** 自定义字段3 */
    extend3!: string | undefined;
    /** 投产数量 */
    inputNum!: number | undefined;
    /** 计划id */
    planId!: string | undefined;
    /** 工单工序id */
    poProcessId!: string | undefined;
    /** 工序编码 */
    processCode!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 工序顺序 */
    processSort!: number | undefined;
    /** 加工工时 */
    processTime!: number | undefined;
    /** 产品编码 */
    productCode!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 产品类型 */
    productTypeId!: string | undefined;
    /** 报工数量 */
    reportNum!: number | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 标准工时 */
    standardTime!: number | undefined;
    /** 工位code */
    workStationCode!: string | undefined;
    /** 工位id */
    workStationId!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;
    /** 加工时间 单位：分钟 */
    workTime!: string | undefined;

    constructor(data?: IProductionStatisticsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignNum = data["assignNum"];
            this.collectionNum = data["collectionNum"];
            this.completeCompare = data["completeCompare"];
            this.completeDifference = data["completeDifference"];
            this.date = data["date"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.inputNum = data["inputNum"];
            this.planId = data["planId"];
            this.poProcessId = data["poProcessId"];
            this.processCode = data["processCode"];
            this.processName = data["processName"];
            this.processSort = data["processSort"];
            this.processTime = data["processTime"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.productTypeId = data["productTypeId"];
            this.reportNum = data["reportNum"];
            this.standardModel = data["standardModel"];
            this.standardTime = data["standardTime"];
            this.workStationCode = data["workStationCode"];
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
            this.workTime = data["workTime"];
        }
    }

    static fromJS(data: any): ProductionStatisticsVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionStatisticsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignNum"] = this.assignNum;
        data["collectionNum"] = this.collectionNum;
        data["completeCompare"] = this.completeCompare;
        data["completeDifference"] = this.completeDifference;
        data["date"] = this.date;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["inputNum"] = this.inputNum;
        data["planId"] = this.planId;
        data["poProcessId"] = this.poProcessId;
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        data["processSort"] = this.processSort;
        data["processTime"] = this.processTime;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productTypeId"] = this.productTypeId;
        data["reportNum"] = this.reportNum;
        data["standardModel"] = this.standardModel;
        data["standardTime"] = this.standardTime;
        data["workStationCode"] = this.workStationCode;
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        data["workTime"] = this.workTime;
        return data; 
    }
}

export interface IProductionStatisticsVO {
    /** 指派数量 */
    assignNum: number | undefined;
    /** 采集数量 */
    collectionNum: number | undefined;
    /** 完工比 */
    completeCompare: string | undefined;
    /** 完工差异 */
    completeDifference: number | undefined;
    /** 日期 */
    date: string | undefined;
    /** 自定义字段1 */
    extend1: string | undefined;
    /** 自定义字段2 */
    extend2: string | undefined;
    /** 自定义字段3 */
    extend3: string | undefined;
    /** 投产数量 */
    inputNum: number | undefined;
    /** 计划id */
    planId: string | undefined;
    /** 工单工序id */
    poProcessId: string | undefined;
    /** 工序编码 */
    processCode: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 工序顺序 */
    processSort: number | undefined;
    /** 加工工时 */
    processTime: number | undefined;
    /** 产品编码 */
    productCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 产品类型 */
    productTypeId: string | undefined;
    /** 报工数量 */
    reportNum: number | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 标准工时 */
    standardTime: number | undefined;
    /** 工位code */
    workStationCode: string | undefined;
    /** 工位id */
    workStationId: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
    /** 加工时间 单位：分钟 */
    workTime: string | undefined;
}

export class ProductionStatisticsWorkStationReportDTO implements IProductionStatisticsWorkStationReportDTO {
    /** 日 */
    date!: Date | undefined;
    /** 结束时间 */
    endDate!: Date | undefined;
    /** 月 */
    month!: number | undefined;
    /** 计划编号 */
    planCode!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 产品类型ID */
    productTypeId!: string;
    /** 班次index */
    shiftIndex!: number | undefined;
    /** 开始时间 */
    startDate!: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod!: ProductionStatisticsWorkStationReportDTOStatisticalMethod | undefined;
    /** 周 */
    week!: number | undefined;
    /** 选中的工位 */
    workStationBOList!: WorkStationBO[];
    /** 年 */
    year!: number | undefined;

    constructor(data?: IProductionStatisticsWorkStationReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.workStationBOList = [];
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? new Date(data["date"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            this.month = data["month"];
            this.planCode = data["planCode"];
            this.productName = data["productName"];
            this.productTypeId = data["productTypeId"];
            this.shiftIndex = data["shiftIndex"];
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            this.statisticalMethod = data["statisticalMethod"];
            this.week = data["week"];
            if (data["workStationBOList"] && data["workStationBOList"].constructor === Array) {
                this.workStationBOList = [] as any;
                for (let item of data["workStationBOList"])
                    this.workStationBOList!.push(WorkStationBO.fromJS(item));
            }
            this.year = data["year"];
        }
    }

    static fromJS(data: any): ProductionStatisticsWorkStationReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionStatisticsWorkStationReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["month"] = this.month;
        data["planCode"] = this.planCode;
        data["productName"] = this.productName;
        data["productTypeId"] = this.productTypeId;
        data["shiftIndex"] = this.shiftIndex;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["statisticalMethod"] = this.statisticalMethod;
        data["week"] = this.week;
        if (this.workStationBOList && this.workStationBOList.constructor === Array) {
            data["workStationBOList"] = [];
            for (let item of this.workStationBOList)
                data["workStationBOList"].push(item.toJSON());
        }
        data["year"] = this.year;
        return data; 
    }
}

export interface IProductionStatisticsWorkStationReportDTO {
    /** 日 */
    date: Date | undefined;
    /** 结束时间 */
    endDate: Date | undefined;
    /** 月 */
    month: number | undefined;
    /** 计划编号 */
    planCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 产品类型ID */
    productTypeId: string;
    /** 班次index */
    shiftIndex: number | undefined;
    /** 开始时间 */
    startDate: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod: ProductionStatisticsWorkStationReportDTOStatisticalMethod | undefined;
    /** 周 */
    week: number | undefined;
    /** 选中的工位 */
    workStationBOList: WorkStationBO[];
    /** 年 */
    year: number | undefined;
}

export class QcItemDTO implements IQcItemDTO {
    /** 质检项名称 */
    itemName!: string | undefined;
    /** 测量值 */
    measuredValue!: number | undefined;
    /** 标准值 */
    standardValue!: number | undefined;

    constructor(data?: IQcItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemName = data["itemName"];
            this.measuredValue = data["measuredValue"];
            this.standardValue = data["standardValue"];
        }
    }

    static fromJS(data: any): QcItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QcItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemName"] = this.itemName;
        data["measuredValue"] = this.measuredValue;
        data["standardValue"] = this.standardValue;
        return data; 
    }
}

export interface IQcItemDTO {
    /** 质检项名称 */
    itemName: string | undefined;
    /** 测量值 */
    measuredValue: number | undefined;
    /** 标准值 */
    standardValue: number | undefined;
}

export class QcItemReportVO implements IQcItemReportVO {
    /** 质检项 */
    itemName!: string | undefined;
    /** 测量值 */
    measuredValue!: number | undefined;
    /** 标准值 */
    standardValue!: number | undefined;

    constructor(data?: IQcItemReportVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemName = data["itemName"];
            this.measuredValue = data["measuredValue"];
            this.standardValue = data["standardValue"];
        }
    }

    static fromJS(data: any): QcItemReportVO {
        data = typeof data === 'object' ? data : {};
        let result = new QcItemReportVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemName"] = this.itemName;
        data["measuredValue"] = this.measuredValue;
        data["standardValue"] = this.standardValue;
        return data; 
    }
}

export interface IQcItemReportVO {
    /** 质检项 */
    itemName: string | undefined;
    /** 测量值 */
    measuredValue: number | undefined;
    /** 标准值 */
    standardValue: number | undefined;
}

export class QcItemUpdateDTO implements IQcItemUpdateDTO {
    /** 主键Id */
    id!: string | undefined;
    /** 测量值 */
    measuredValue!: number | undefined;

    constructor(data?: IQcItemUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.measuredValue = data["measuredValue"];
        }
    }

    static fromJS(data: any): QcItemUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QcItemUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["measuredValue"] = this.measuredValue;
        return data; 
    }
}

export interface IQcItemUpdateDTO {
    /** 主键Id */
    id: string | undefined;
    /** 测量值 */
    measuredValue: number | undefined;
}

export class QcPlanReportVO implements IQcPlanReportVO {
    /** 主键Id */
    id!: string | undefined;
    /** 计划编码 */
    planCode!: string | undefined;
    /** 产品编码 */
    productCode!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 合格数量 */
    qualifyNum!: number | undefined;
    /** 报工数量 */
    reportNum!: number | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;

    constructor(data?: IQcPlanReportVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.planCode = data["planCode"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.qualifyNum = data["qualifyNum"];
            this.reportNum = data["reportNum"];
            this.standardModel = data["standardModel"];
        }
    }

    static fromJS(data: any): QcPlanReportVO {
        data = typeof data === 'object' ? data : {};
        let result = new QcPlanReportVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["planCode"] = this.planCode;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["qualifyNum"] = this.qualifyNum;
        data["reportNum"] = this.reportNum;
        data["standardModel"] = this.standardModel;
        return data; 
    }
}

export interface IQcPlanReportVO {
    /** 主键Id */
    id: string | undefined;
    /** 计划编码 */
    planCode: string | undefined;
    /** 产品编码 */
    productCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 合格数量 */
    qualifyNum: number | undefined;
    /** 报工数量 */
    reportNum: number | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
}

export class QcPlanSearchDTO implements IQcPlanSearchDTO {
    /** 计划编码 */
    planCode!: string | undefined;
    /** 产品编码 */
    productCode!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 生产计划类型ID */
    typeId!: string | undefined;

    constructor(data?: IQcPlanSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planCode = data["planCode"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.standardModel = data["standardModel"];
            this.typeId = data["typeId"];
        }
    }

    static fromJS(data: any): QcPlanSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QcPlanSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planCode"] = this.planCode;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["standardModel"] = this.standardModel;
        data["typeId"] = this.typeId;
        return data; 
    }
}

export interface IQcPlanSearchDTO {
    /** 计划编码 */
    planCode: string | undefined;
    /** 产品编码 */
    productCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 生产计划类型ID */
    typeId: string | undefined;
}

/** 查询条件 */
export class Query implements IQuery {
    /** 当前页 */
    current!: number | undefined;
    /** 每页的数量 */
    size!: number | undefined;

    constructor(data?: IQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.size = data["size"];
        }
    }

    static fromJS(data: any): Query {
        data = typeof data === 'object' ? data : {};
        let result = new Query();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["size"] = this.size;
        return data; 
    }
}

/** 查询条件 */
export interface IQuery {
    /** 当前页 */
    current: number | undefined;
    /** 每页的数量 */
    size: number | undefined;
}

/** 返回信息 */
export class R implements IR {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: any | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IR) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"];
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): R {
        data = typeof data === 'object' ? data : {};
        let result = new R();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IR {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: any | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfEmployeeDetails implements IROfListOfEmployeeDetails {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: EmployeeDetails[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfEmployeeDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(EmployeeDetails.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfEmployeeDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfEmployeeDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfEmployeeDetails {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: EmployeeDetails[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfEmployeePerformanceDTO implements IROfListOfEmployeePerformanceDTO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: EmployeePerformanceDTO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfEmployeePerformanceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(EmployeePerformanceDTO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfEmployeePerformanceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfEmployeePerformanceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfEmployeePerformanceDTO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: EmployeePerformanceDTO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfProductionOrderDetailsVO implements IROfListOfProductionOrderDetailsVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: ProductionOrderDetailsVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfProductionOrderDetailsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(ProductionOrderDetailsVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfProductionOrderDetailsVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfProductionOrderDetailsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfProductionOrderDetailsVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: ProductionOrderDetailsVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfProductionOrderVisualVO implements IROfListOfProductionOrderVisualVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: ProductionOrderVisualVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfProductionOrderVisualVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(ProductionOrderVisualVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfProductionOrderVisualVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfProductionOrderVisualVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfProductionOrderVisualVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: ProductionOrderVisualVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfVisualPlanWipVO implements IROfListOfVisualPlanWipVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: VisualPlanWipVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfVisualPlanWipVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(VisualPlanWipVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfVisualPlanWipVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfVisualPlanWipVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfVisualPlanWipVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: VisualPlanWipVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfVisualProductionPlanScheduleVO implements IROfListOfVisualProductionPlanScheduleVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: VisualProductionPlanScheduleVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfVisualProductionPlanScheduleVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(VisualProductionPlanScheduleVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfVisualProductionPlanScheduleVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfVisualProductionPlanScheduleVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfVisualProductionPlanScheduleVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: VisualProductionPlanScheduleVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfVisualTransferLog implements IROfListOfVisualTransferLog {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: VisualTransferLog[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfVisualTransferLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(VisualTransferLog.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfVisualTransferLog {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfVisualTransferLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfVisualTransferLog {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: VisualTransferLog[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfVisualWorkStationStatusVO implements IROfListOfVisualWorkStationStatusVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: VisualWorkStationStatusVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfVisualWorkStationStatusVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(VisualWorkStationStatusVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfVisualWorkStationStatusVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfVisualWorkStationStatusVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfVisualWorkStationStatusVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: VisualWorkStationStatusVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfWorkStationCalendarReportVO implements IROfListOfWorkStationCalendarReportVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: WorkStationCalendarReportVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfWorkStationCalendarReportVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(WorkStationCalendarReportVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfWorkStationCalendarReportVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfWorkStationCalendarReportVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfWorkStationCalendarReportVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: WorkStationCalendarReportVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfWorkStationOrderCraftVO implements IROfListOfWorkStationOrderCraftVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: WorkStationOrderCraftVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfWorkStationOrderCraftVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(WorkStationOrderCraftVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfWorkStationOrderCraftVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfWorkStationOrderCraftVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfWorkStationOrderCraftVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: WorkStationOrderCraftVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfMdcVisualVO implements IROfMdcVisualVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: MdcVisualVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfMdcVisualVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? MdcVisualVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfMdcVisualVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfMdcVisualVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfMdcVisualVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: MdcVisualVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfProductionPlanOverAllProgress implements IROfProductionPlanOverAllProgress {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: ProductionPlanOverAllProgress | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfProductionPlanOverAllProgress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? ProductionPlanOverAllProgress.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfProductionPlanOverAllProgress {
        data = typeof data === 'object' ? data : {};
        let result = new ROfProductionPlanOverAllProgress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfProductionPlanOverAllProgress {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: ProductionPlanOverAllProgress | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfVisualOrderProcess implements IROfVisualOrderProcess {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: VisualOrderProcess | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfVisualOrderProcess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? VisualOrderProcess.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfVisualOrderProcess {
        data = typeof data === 'object' ? data : {};
        let result = new ROfVisualOrderProcess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfVisualOrderProcess {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: VisualOrderProcess | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

export class RecordRemarkDTO implements IRecordRemarkDTO {
    /** id */
    id!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IRecordRemarkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): RecordRemarkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RecordRemarkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IRecordRemarkDTO {
    /** id */
    id: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

/** 开/报工详情中的工序工位详情 */
export class ReportDetailVO implements IReportDetailVO {
    /** 设备产量(暂无) */
    collectionNum!: number | undefined;
    /** 生产人员 */
    producerName!: string | undefined;
    /** 本次合格 */
    qualifyNum!: number | undefined;
    /** 本次报废 */
    scrappedNum!: number | undefined;
    /** 生产设备 */
    workStationName!: string | undefined;

    constructor(data?: IReportDetailVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.collectionNum = data["collectionNum"];
            this.producerName = data["producerName"];
            this.qualifyNum = data["qualifyNum"];
            this.scrappedNum = data["scrappedNum"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): ReportDetailVO {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDetailVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collectionNum"] = this.collectionNum;
        data["producerName"] = this.producerName;
        data["qualifyNum"] = this.qualifyNum;
        data["scrappedNum"] = this.scrappedNum;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

/** 开/报工详情中的工序工位详情 */
export interface IReportDetailVO {
    /** 设备产量(暂无) */
    collectionNum: number | undefined;
    /** 生产人员 */
    producerName: string | undefined;
    /** 本次合格 */
    qualifyNum: number | undefined;
    /** 本次报废 */
    scrappedNum: number | undefined;
    /** 生产设备 */
    workStationName: string | undefined;
}

/** 报工记录DTO */
export class ReportWorkHistoryDTO implements IReportWorkHistoryDTO {
    /** 报工结束时间 */
    endTime!: string | undefined;
    /** 计划类型 */
    planTypeId!: number | undefined;
    /** 工单编号 */
    poCode!: string | undefined;
    /** 报工开始时间 */
    startTime!: string | undefined;
    /** 设备id */
    workStationId!: string | undefined;

    constructor(data?: IReportWorkHistoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.endTime = data["endTime"];
            this.planTypeId = data["planTypeId"];
            this.poCode = data["poCode"];
            this.startTime = data["startTime"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): ReportWorkHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ReportWorkHistoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endTime"] = this.endTime;
        data["planTypeId"] = this.planTypeId;
        data["poCode"] = this.poCode;
        data["startTime"] = this.startTime;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

/** 报工记录DTO */
export interface IReportWorkHistoryDTO {
    /** 报工结束时间 */
    endTime: string | undefined;
    /** 计划类型 */
    planTypeId: number | undefined;
    /** 工单编号 */
    poCode: string | undefined;
    /** 报工开始时间 */
    startTime: string | undefined;
    /** 设备id */
    workStationId: string | undefined;
}

/** 查询开/报工历史记录DTO */
export class ReportWorkHistoryDetailDTO implements IReportWorkHistoryDetailDTO {
    /** 报工时间 */
    endTime!: Date | undefined;
    /** 工序id */
    processId!: string | undefined;

    constructor(data?: IReportWorkHistoryDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.processId = data["processId"];
        }
    }

    static fromJS(data: any): ReportWorkHistoryDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ReportWorkHistoryDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["processId"] = this.processId;
        return data; 
    }
}

/** 查询开/报工历史记录DTO */
export interface IReportWorkHistoryDetailDTO {
    /** 报工时间 */
    endTime: Date | undefined;
    /** 工序id */
    processId: string | undefined;
}

/** 开报工历史详情 */
export class ReportWorkHistoryDetailVO implements IReportWorkHistoryDetailVO {
    /** 派发数量 */
    assignNum!: number | undefined;
    /** 采集数量 */
    collectionNum!: number | undefined;
    /** 设备采集数量 */
    deviceCollectionNum!: number | undefined;
    /** 报工时间 */
    endTime!: Date | undefined;
    /** 工位开/报工集合 */
    list!: ReportDetailVO[] | undefined;
    /** 物料编号 */
    materialCode!: string | undefined;
    /** 工单编号 */
    orderCode!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 提交工时（暂无） */
    submitWorkHour!: string | undefined;

    constructor(data?: IReportWorkHistoryDetailVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignNum = data["assignNum"];
            this.collectionNum = data["collectionNum"];
            this.deviceCollectionNum = data["deviceCollectionNum"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            if (data["list"] && data["list"].constructor === Array) {
                this.list = [] as any;
                for (let item of data["list"])
                    this.list!.push(ReportDetailVO.fromJS(item));
            }
            this.materialCode = data["materialCode"];
            this.orderCode = data["orderCode"];
            this.processName = data["processName"];
            this.productName = data["productName"];
            this.standardModel = data["standardModel"];
            this.submitWorkHour = data["submitWorkHour"];
        }
    }

    static fromJS(data: any): ReportWorkHistoryDetailVO {
        data = typeof data === 'object' ? data : {};
        let result = new ReportWorkHistoryDetailVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignNum"] = this.assignNum;
        data["collectionNum"] = this.collectionNum;
        data["deviceCollectionNum"] = this.deviceCollectionNum;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        if (this.list && this.list.constructor === Array) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        data["materialCode"] = this.materialCode;
        data["orderCode"] = this.orderCode;
        data["processName"] = this.processName;
        data["productName"] = this.productName;
        data["standardModel"] = this.standardModel;
        data["submitWorkHour"] = this.submitWorkHour;
        return data; 
    }
}

/** 开报工历史详情 */
export interface IReportWorkHistoryDetailVO {
    /** 派发数量 */
    assignNum: number | undefined;
    /** 采集数量 */
    collectionNum: number | undefined;
    /** 设备采集数量 */
    deviceCollectionNum: number | undefined;
    /** 报工时间 */
    endTime: Date | undefined;
    /** 工位开/报工集合 */
    list: ReportDetailVO[] | undefined;
    /** 物料编号 */
    materialCode: string | undefined;
    /** 工单编号 */
    orderCode: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 提交工时（暂无） */
    submitWorkHour: string | undefined;
}

/** 个人记录 */
export class ReportWorkHistoryVO implements IReportWorkHistoryVO {
    /** 报工时间 */
    endTime!: Date | undefined;
    /** 计划id */
    planId!: string | undefined;
    /** 计划类型 */
    planType!: string | undefined;
    /** 计划类型id */
    planTypeId!: string | undefined;
    /** 工单编号 */
    poCode!: string | undefined;
    /** 工单id */
    poId!: string | undefined;
    /** 工序编码 */
    processCode!: string | undefined;
    /** 工序id */
    processId!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 合格数量 */
    qualifiedNum!: number | undefined;
    /** 报废数量 */
    scrappedNum!: number | undefined;

    constructor(data?: IReportWorkHistoryVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.planId = data["planId"];
            this.planType = data["planType"];
            this.planTypeId = data["planTypeId"];
            this.poCode = data["poCode"];
            this.poId = data["poId"];
            this.processCode = data["processCode"];
            this.processId = data["processId"];
            this.processName = data["processName"];
            this.productName = data["productName"];
            this.qualifiedNum = data["qualifiedNum"];
            this.scrappedNum = data["scrappedNum"];
        }
    }

    static fromJS(data: any): ReportWorkHistoryVO {
        data = typeof data === 'object' ? data : {};
        let result = new ReportWorkHistoryVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["planId"] = this.planId;
        data["planType"] = this.planType;
        data["planTypeId"] = this.planTypeId;
        data["poCode"] = this.poCode;
        data["poId"] = this.poId;
        data["processCode"] = this.processCode;
        data["processId"] = this.processId;
        data["processName"] = this.processName;
        data["productName"] = this.productName;
        data["qualifiedNum"] = this.qualifiedNum;
        data["scrappedNum"] = this.scrappedNum;
        return data; 
    }
}

/** 个人记录 */
export interface IReportWorkHistoryVO {
    /** 报工时间 */
    endTime: Date | undefined;
    /** 计划id */
    planId: string | undefined;
    /** 计划类型 */
    planType: string | undefined;
    /** 计划类型id */
    planTypeId: string | undefined;
    /** 工单编号 */
    poCode: string | undefined;
    /** 工单id */
    poId: string | undefined;
    /** 工序编码 */
    processCode: string | undefined;
    /** 工序id */
    processId: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 合格数量 */
    qualifiedNum: number | undefined;
    /** 报废数量 */
    scrappedNum: number | undefined;
}

export class ResourceFileVO implements IResourceFileVO {
    /** 文件大小,必须大于等于0 */
    contentLength!: string | undefined;
    /** 文件H5 */
    contentMd5!: string | undefined;
    /** 内容类型，文件夹为null */
    contentType!: string | undefined;
    /** 名称 */
    displayName!: string | undefined;
    /** 文件名 */
    fileName!: string | undefined;
    /** 文件大小 */
    fileSize!: string | undefined;
    /** 文件类别：1、加工文件，2、工艺文件 */
    fileType!: number | undefined;
    id!: string | undefined;
    /** 文件唯一标识 */
    objectKey!: string | undefined;
    /** 后缀名，文件夹为null */
    suffix!: string | undefined;
    /** 上传时间 */
    updateTime!: Date | undefined;
    /** 上传人员 */
    uploadName!: string | undefined;

    constructor(data?: IResourceFileVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentLength = data["contentLength"];
            this.contentMd5 = data["contentMd5"];
            this.contentType = data["contentType"];
            this.displayName = data["displayName"];
            this.fileName = data["fileName"];
            this.fileSize = data["fileSize"];
            this.fileType = data["fileType"];
            this.id = data["id"];
            this.objectKey = data["objectKey"];
            this.suffix = data["suffix"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.uploadName = data["uploadName"];
        }
    }

    static fromJS(data: any): ResourceFileVO {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceFileVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentLength"] = this.contentLength;
        data["contentMd5"] = this.contentMd5;
        data["contentType"] = this.contentType;
        data["displayName"] = this.displayName;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["fileType"] = this.fileType;
        data["id"] = this.id;
        data["objectKey"] = this.objectKey;
        data["suffix"] = this.suffix;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["uploadName"] = this.uploadName;
        return data; 
    }
}

export interface IResourceFileVO {
    /** 文件大小,必须大于等于0 */
    contentLength: string | undefined;
    /** 文件H5 */
    contentMd5: string | undefined;
    /** 内容类型，文件夹为null */
    contentType: string | undefined;
    /** 名称 */
    displayName: string | undefined;
    /** 文件名 */
    fileName: string | undefined;
    /** 文件大小 */
    fileSize: string | undefined;
    /** 文件类别：1、加工文件，2、工艺文件 */
    fileType: number | undefined;
    id: string | undefined;
    /** 文件唯一标识 */
    objectKey: string | undefined;
    /** 后缀名，文件夹为null */
    suffix: string | undefined;
    /** 上传时间 */
    updateTime: Date | undefined;
    /** 上传人员 */
    uploadName: string | undefined;
}

export class RouteDefinition implements IRouteDefinition {
    compatibleMode!: number | undefined;
    filters!: GatewayFilterDefinition[] | undefined;
    id!: string | undefined;
    ignoreValidate!: number | undefined;
    mergeResult!: number | undefined;
    name!: string | undefined;
    needToken!: number | undefined;
    order!: number | undefined;
    path!: string | undefined;
    permission!: number | undefined;
    predicates!: GatewayPredicateDefinition[] | undefined;
    status!: number | undefined;
    uri!: string | undefined;
    version!: string | undefined;

    constructor(data?: IRouteDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.compatibleMode = data["compatibleMode"];
            if (data["filters"] && data["filters"].constructor === Array) {
                this.filters = [] as any;
                for (let item of data["filters"])
                    this.filters!.push(GatewayFilterDefinition.fromJS(item));
            }
            this.id = data["id"];
            this.ignoreValidate = data["ignoreValidate"];
            this.mergeResult = data["mergeResult"];
            this.name = data["name"];
            this.needToken = data["needToken"];
            this.order = data["order"];
            this.path = data["path"];
            this.permission = data["permission"];
            if (data["predicates"] && data["predicates"].constructor === Array) {
                this.predicates = [] as any;
                for (let item of data["predicates"])
                    this.predicates!.push(GatewayPredicateDefinition.fromJS(item));
            }
            this.status = data["status"];
            this.uri = data["uri"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): RouteDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new RouteDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compatibleMode"] = this.compatibleMode;
        if (this.filters && this.filters.constructor === Array) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["ignoreValidate"] = this.ignoreValidate;
        data["mergeResult"] = this.mergeResult;
        data["name"] = this.name;
        data["needToken"] = this.needToken;
        data["order"] = this.order;
        data["path"] = this.path;
        data["permission"] = this.permission;
        if (this.predicates && this.predicates.constructor === Array) {
            data["predicates"] = [];
            for (let item of this.predicates)
                data["predicates"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["uri"] = this.uri;
        data["version"] = this.version;
        return data; 
    }
}

export interface IRouteDefinition {
    compatibleMode: number | undefined;
    filters: GatewayFilterDefinition[] | undefined;
    id: string | undefined;
    ignoreValidate: number | undefined;
    mergeResult: number | undefined;
    name: string | undefined;
    needToken: number | undefined;
    order: number | undefined;
    path: string | undefined;
    permission: number | undefined;
    predicates: GatewayPredicateDefinition[] | undefined;
    status: number | undefined;
    uri: string | undefined;
    version: string | undefined;
}

export class ScrappedReasonReportVO implements IScrappedReasonReportVO {
    /** 自定义字段1 */
    extend1!: string | undefined;
    /** 自定义字段2 */
    extend2!: string | undefined;
    /** 自定义字段3 */
    extend3!: string | undefined;
    /** 工单编号 */
    orderCode!: string | undefined;
    /** 计划编码 */
    planCode!: string | undefined;
    /** 工序编码 */
    processCode!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 产品编码 */
    productCode!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 报工人员 */
    reportName!: string | undefined;
    /** 报废数量 */
    scrappedNumber!: number | undefined;
    /** 报废原因 */
    scrappedReason!: string | undefined;
    /** 报废时间 */
    scrappedTime!: Date | undefined;
    /** 报废类型 */
    scrappedType!: string | undefined;
    /** 报废类型编码 */
    scrappedTypeCode!: string | undefined;
    /** 生产工位 */
    workStationName!: string | undefined;

    constructor(data?: IScrappedReasonReportVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.orderCode = data["orderCode"];
            this.planCode = data["planCode"];
            this.processCode = data["processCode"];
            this.processName = data["processName"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.reportName = data["reportName"];
            this.scrappedNumber = data["scrappedNumber"];
            this.scrappedReason = data["scrappedReason"];
            this.scrappedTime = data["scrappedTime"] ? new Date(data["scrappedTime"].toString()) : <any>undefined;
            this.scrappedType = data["scrappedType"];
            this.scrappedTypeCode = data["scrappedTypeCode"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): ScrappedReasonReportVO {
        data = typeof data === 'object' ? data : {};
        let result = new ScrappedReasonReportVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["orderCode"] = this.orderCode;
        data["planCode"] = this.planCode;
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["reportName"] = this.reportName;
        data["scrappedNumber"] = this.scrappedNumber;
        data["scrappedReason"] = this.scrappedReason;
        data["scrappedTime"] = this.scrappedTime ? this.scrappedTime.toISOString() : <any>undefined;
        data["scrappedType"] = this.scrappedType;
        data["scrappedTypeCode"] = this.scrappedTypeCode;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IScrappedReasonReportVO {
    /** 自定义字段1 */
    extend1: string | undefined;
    /** 自定义字段2 */
    extend2: string | undefined;
    /** 自定义字段3 */
    extend3: string | undefined;
    /** 工单编号 */
    orderCode: string | undefined;
    /** 计划编码 */
    planCode: string | undefined;
    /** 工序编码 */
    processCode: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 产品编码 */
    productCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 报工人员 */
    reportName: string | undefined;
    /** 报废数量 */
    scrappedNumber: number | undefined;
    /** 报废原因 */
    scrappedReason: string | undefined;
    /** 报废时间 */
    scrappedTime: Date | undefined;
    /** 报废类型 */
    scrappedType: string | undefined;
    /** 报废类型编码 */
    scrappedTypeCode: string | undefined;
    /** 生产工位 */
    workStationName: string | undefined;
}

export class ServiceRouteInfo implements IServiceRouteInfo {
    createTime!: Date | undefined;
    description!: string | undefined;
    routeDefinitionList!: RouteDefinition[] | undefined;
    serviceId!: string | undefined;
    updateTime!: Date | undefined;

    constructor(data?: IServiceRouteInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.description = data["description"];
            if (data["routeDefinitionList"] && data["routeDefinitionList"].constructor === Array) {
                this.routeDefinitionList = [] as any;
                for (let item of data["routeDefinitionList"])
                    this.routeDefinitionList!.push(RouteDefinition.fromJS(item));
            }
            this.serviceId = data["serviceId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceRouteInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRouteInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        if (this.routeDefinitionList && this.routeDefinitionList.constructor === Array) {
            data["routeDefinitionList"] = [];
            for (let item of this.routeDefinitionList)
                data["routeDefinitionList"].push(item.toJSON());
        }
        data["serviceId"] = this.serviceId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IServiceRouteInfo {
    createTime: Date | undefined;
    description: string | undefined;
    routeDefinitionList: RouteDefinition[] | undefined;
    serviceId: string | undefined;
    updateTime: Date | undefined;
}

export class SimpleWorkstationDTO implements ISimpleWorkstationDTO {
    /** 工位code */
    workStationCode!: string | undefined;
    /** 工位Id */
    workStationId!: string;
    /** 工位名称 */
    workStationName!: string;

    constructor(data?: ISimpleWorkstationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.workStationCode = data["workStationCode"];
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): SimpleWorkstationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleWorkstationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workStationCode"] = this.workStationCode;
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface ISimpleWorkstationDTO {
    /** 工位code */
    workStationCode: string | undefined;
    /** 工位Id */
    workStationId: string;
    /** 工位名称 */
    workStationName: string;
}

export class SrappedReasonSearchDTO implements ISrappedReasonSearchDTO {
    /** 业务类别 */
    bizType!: string | undefined;
    /** 结束时间 */
    endTime!: Date | undefined;
    /** 计划编码 */
    planCode!: string | undefined;
    /** 报工人员 */
    reportName!: string | undefined;
    /** 报废原因 */
    scrappedReason!: string | undefined;
    /** 报废类型 */
    scrappedType!: string | undefined;
    /** 开始时间 */
    startTime!: Date | undefined;
    /** 生产计划类型ID */
    typeId!: string;
    /** 生产工位 */
    workStationName!: string | undefined;

    constructor(data?: ISrappedReasonSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bizType = data["bizType"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.planCode = data["planCode"];
            this.reportName = data["reportName"];
            this.scrappedReason = data["scrappedReason"];
            this.scrappedType = data["scrappedType"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.typeId = data["typeId"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): SrappedReasonSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SrappedReasonSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bizType"] = this.bizType;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["planCode"] = this.planCode;
        data["reportName"] = this.reportName;
        data["scrappedReason"] = this.scrappedReason;
        data["scrappedType"] = this.scrappedType;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["typeId"] = this.typeId;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface ISrappedReasonSearchDTO {
    /** 业务类别 */
    bizType: string | undefined;
    /** 结束时间 */
    endTime: Date | undefined;
    /** 计划编码 */
    planCode: string | undefined;
    /** 报工人员 */
    reportName: string | undefined;
    /** 报废原因 */
    scrappedReason: string | undefined;
    /** 报废类型 */
    scrappedType: string | undefined;
    /** 开始时间 */
    startTime: Date | undefined;
    /** 生产计划类型ID */
    typeId: string;
    /** 生产工位 */
    workStationName: string | undefined;
}

export class StationCalendarDTO implements IStationCalendarDTO {
    /** 生产计划类型ID */
    typeId!: string;
    /** 工位id */
    workStationId!: string | undefined;

    constructor(data?: IStationCalendarDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.typeId = data["typeId"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): StationCalendarDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StationCalendarDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IStationCalendarDTO {
    /** 生产计划类型ID */
    typeId: string;
    /** 工位id */
    workStationId: string | undefined;
}

export class StationProductionCalendarVO implements IStationProductionCalendarVO {
    /** 工单号 */
    orderCode!: string | undefined;
    /** 生产计划编号 */
    planCode!: string | undefined;
    /** 预计结束时间 */
    planEndTime!: Date | undefined;
    /** 工序id */
    processId!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 生产人员名称 */
    producerName!: string | undefined;
    /** 成品名称 */
    productName!: string | undefined;
    /** 指派总数 */
    totalNum!: number | undefined;
    /** 待报工数量 */
    unReportNum!: number | undefined;

    constructor(data?: IStationProductionCalendarVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderCode = data["orderCode"];
            this.planCode = data["planCode"];
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.processId = data["processId"];
            this.processName = data["processName"];
            this.producerName = data["producerName"];
            this.productName = data["productName"];
            this.totalNum = data["totalNum"];
            this.unReportNum = data["unReportNum"];
        }
    }

    static fromJS(data: any): StationProductionCalendarVO {
        data = typeof data === 'object' ? data : {};
        let result = new StationProductionCalendarVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderCode"] = this.orderCode;
        data["planCode"] = this.planCode;
        data["planEndTime"] = this.planEndTime ? this.planEndTime.toISOString() : <any>undefined;
        data["processId"] = this.processId;
        data["processName"] = this.processName;
        data["producerName"] = this.producerName;
        data["productName"] = this.productName;
        data["totalNum"] = this.totalNum;
        data["unReportNum"] = this.unReportNum;
        return data; 
    }
}

export interface IStationProductionCalendarVO {
    /** 工单号 */
    orderCode: string | undefined;
    /** 生产计划编号 */
    planCode: string | undefined;
    /** 预计结束时间 */
    planEndTime: Date | undefined;
    /** 工序id */
    processId: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 生产人员名称 */
    producerName: string | undefined;
    /** 成品名称 */
    productName: string | undefined;
    /** 指派总数 */
    totalNum: number | undefined;
    /** 待报工数量 */
    unReportNum: number | undefined;
}

export class UpdateWorkStationProductionCapacityDTO implements IUpdateWorkStationProductionCapacityDTO {
    /** 超差预警 默认50 */
    overFlowWarning!: number | undefined;
    /** 所属工单工序的开工工位 */
    poProcessWorkStationId!: string | undefined;
    /** 工位产能 */
    stationProductionCapacity!: number | undefined;

    constructor(data?: IUpdateWorkStationProductionCapacityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.overFlowWarning = data["overFlowWarning"];
            this.poProcessWorkStationId = data["poProcessWorkStationId"];
            this.stationProductionCapacity = data["stationProductionCapacity"];
        }
    }

    static fromJS(data: any): UpdateWorkStationProductionCapacityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkStationProductionCapacityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["overFlowWarning"] = this.overFlowWarning;
        data["poProcessWorkStationId"] = this.poProcessWorkStationId;
        data["stationProductionCapacity"] = this.stationProductionCapacity;
        return data; 
    }
}

export interface IUpdateWorkStationProductionCapacityDTO {
    /** 超差预警 默认50 */
    overFlowWarning: number | undefined;
    /** 所属工单工序的开工工位 */
    poProcessWorkStationId: string | undefined;
    /** 工位产能 */
    stationProductionCapacity: number | undefined;
}

export class VisualOrderProcess implements IVisualOrderProcess {
    /** y轴列表 */
    categories!: string[] | undefined;
    /** 图表信息 */
    series!: ColumnInfo[] | undefined;

    constructor(data?: IVisualOrderProcess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["categories"] && data["categories"].constructor === Array) {
                this.categories = [] as any;
                for (let item of data["categories"])
                    this.categories!.push(item);
            }
            if (data["series"] && data["series"].constructor === Array) {
                this.series = [] as any;
                for (let item of data["series"])
                    this.series!.push(ColumnInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VisualOrderProcess {
        data = typeof data === 'object' ? data : {};
        let result = new VisualOrderProcess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.categories && this.categories.constructor === Array) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        if (this.series && this.series.constructor === Array) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IVisualOrderProcess {
    /** y轴列表 */
    categories: string[] | undefined;
    /** 图表信息 */
    series: ColumnInfo[] | undefined;
}

export class VisualPlanWipVO implements IVisualPlanWipVO {
    /** 计划编号 */
    code!: string | undefined;
    /** 扩展字段1 */
    extend1!: string | undefined;
    /** 扩展字段2 */
    extend2!: string | undefined;
    /** 扩展字段3 */
    extend3!: string | undefined;
    /** 扩展字段4 */
    extend4!: string | undefined;
    /** 扩展字段5 */
    extend5!: string | undefined;
    /** 主键Id */
    id!: string | undefined;
    /** 计划结束时间 */
    planEndTime!: Date | undefined;
    /** 计划数量 */
    planNum!: number | undefined;
    /** 计划开始时间 */
    planStartTime!: Date | undefined;
    /** 产品编号 */
    productCode!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 计划合格数量 */
    qualifyNum!: number | undefined;
    /** 计划报工数量 */
    reportNum!: number | undefined;
    /** 工序在制品汇总 */
    summary!: string | undefined;

    constructor(data?: IVisualPlanWipVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.id = data["id"];
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.planNum = data["planNum"];
            this.planStartTime = data["planStartTime"] ? new Date(data["planStartTime"].toString()) : <any>undefined;
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.qualifyNum = data["qualifyNum"];
            this.reportNum = data["reportNum"];
            this.summary = data["summary"];
        }
    }

    static fromJS(data: any): VisualPlanWipVO {
        data = typeof data === 'object' ? data : {};
        let result = new VisualPlanWipVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["id"] = this.id;
        data["planEndTime"] = this.planEndTime ? this.planEndTime.toISOString() : <any>undefined;
        data["planNum"] = this.planNum;
        data["planStartTime"] = this.planStartTime ? this.planStartTime.toISOString() : <any>undefined;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["qualifyNum"] = this.qualifyNum;
        data["reportNum"] = this.reportNum;
        data["summary"] = this.summary;
        return data; 
    }
}

export interface IVisualPlanWipVO {
    /** 计划编号 */
    code: string | undefined;
    /** 扩展字段1 */
    extend1: string | undefined;
    /** 扩展字段2 */
    extend2: string | undefined;
    /** 扩展字段3 */
    extend3: string | undefined;
    /** 扩展字段4 */
    extend4: string | undefined;
    /** 扩展字段5 */
    extend5: string | undefined;
    /** 主键Id */
    id: string | undefined;
    /** 计划结束时间 */
    planEndTime: Date | undefined;
    /** 计划数量 */
    planNum: number | undefined;
    /** 计划开始时间 */
    planStartTime: Date | undefined;
    /** 产品编号 */
    productCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 计划合格数量 */
    qualifyNum: number | undefined;
    /** 计划报工数量 */
    reportNum: number | undefined;
    /** 工序在制品汇总 */
    summary: string | undefined;
}

export class VisualProductionPlanScheduleVO implements IVisualProductionPlanScheduleVO {
    /** 生产计划编号 */
    code!: string | undefined;
    /** 采集数量完成率:VO */
    collectCompleteRate!: string | undefined;
    /** 扩展字段1 */
    extend1!: string | undefined;
    /** 扩展字段2 */
    extend2!: string | undefined;
    /** 扩展字段3 */
    extend3!: string | undefined;
    /** 扩展字段4 */
    extend4!: string | undefined;
    /** 扩展字段5 */
    extend5!: string | undefined;
    /** 理论结束时间 */
    forecastEndTime!: Date | undefined;
    /** 编号 */
    id!: string | undefined;
    /** 计划结束时间 */
    planEndTime!: Date | undefined;
    /** 计划数量 */
    planNum!: number | undefined;
    /** 计划开始时间 */
    planStartTime!: Date | undefined;
    /** 产品编号 */
    productCode!: string | undefined;
    /** 计划合格数量 */
    qualifyNum!: number | undefined;
    /** 报工数量完成率:VO */
    reportCompleteRate!: string | undefined;
    /** 计划报工数量 */
    reportNum!: number | undefined;
    /** 计划工序报工数量进度 */
    reportNums!: string | undefined;
    /** 实际开始时间 */
    startTime!: Date | undefined;
    /** 工时完成率 */
    workCompleteRate!: string | undefined;

    constructor(data?: IVisualProductionPlanScheduleVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.collectCompleteRate = data["collectCompleteRate"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.forecastEndTime = data["forecastEndTime"] ? new Date(data["forecastEndTime"].toString()) : <any>undefined;
            this.id = data["id"];
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.planNum = data["planNum"];
            this.planStartTime = data["planStartTime"] ? new Date(data["planStartTime"].toString()) : <any>undefined;
            this.productCode = data["productCode"];
            this.qualifyNum = data["qualifyNum"];
            this.reportCompleteRate = data["reportCompleteRate"];
            this.reportNum = data["reportNum"];
            this.reportNums = data["reportNums"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.workCompleteRate = data["workCompleteRate"];
        }
    }

    static fromJS(data: any): VisualProductionPlanScheduleVO {
        data = typeof data === 'object' ? data : {};
        let result = new VisualProductionPlanScheduleVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["collectCompleteRate"] = this.collectCompleteRate;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["forecastEndTime"] = this.forecastEndTime ? this.forecastEndTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["planEndTime"] = this.planEndTime ? this.planEndTime.toISOString() : <any>undefined;
        data["planNum"] = this.planNum;
        data["planStartTime"] = this.planStartTime ? this.planStartTime.toISOString() : <any>undefined;
        data["productCode"] = this.productCode;
        data["qualifyNum"] = this.qualifyNum;
        data["reportCompleteRate"] = this.reportCompleteRate;
        data["reportNum"] = this.reportNum;
        data["reportNums"] = this.reportNums;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["workCompleteRate"] = this.workCompleteRate;
        return data; 
    }
}

export interface IVisualProductionPlanScheduleVO {
    /** 生产计划编号 */
    code: string | undefined;
    /** 采集数量完成率:VO */
    collectCompleteRate: string | undefined;
    /** 扩展字段1 */
    extend1: string | undefined;
    /** 扩展字段2 */
    extend2: string | undefined;
    /** 扩展字段3 */
    extend3: string | undefined;
    /** 扩展字段4 */
    extend4: string | undefined;
    /** 扩展字段5 */
    extend5: string | undefined;
    /** 理论结束时间 */
    forecastEndTime: Date | undefined;
    /** 编号 */
    id: string | undefined;
    /** 计划结束时间 */
    planEndTime: Date | undefined;
    /** 计划数量 */
    planNum: number | undefined;
    /** 计划开始时间 */
    planStartTime: Date | undefined;
    /** 产品编号 */
    productCode: string | undefined;
    /** 计划合格数量 */
    qualifyNum: number | undefined;
    /** 报工数量完成率:VO */
    reportCompleteRate: string | undefined;
    /** 计划报工数量 */
    reportNum: number | undefined;
    /** 计划工序报工数量进度 */
    reportNums: string | undefined;
    /** 实际开始时间 */
    startTime: Date | undefined;
    /** 工时完成率 */
    workCompleteRate: string | undefined;
}

export class VisualTransferLog implements IVisualTransferLog {
    /** 信息类型 */
    messageType!: string | undefined;
    /** 操作人姓名 */
    operateName!: string | undefined;
    /** 操作时间 */
    operateTime!: Date | undefined;
    /** 操作类型 */
    operation!: string | undefined;
    /** 资源名称 */
    resourceName!: string | undefined;
    /** 资源版本名称 */
    versionName!: string | undefined;

    constructor(data?: IVisualTransferLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.messageType = data["messageType"];
            this.operateName = data["operateName"];
            this.operateTime = data["operateTime"] ? new Date(data["operateTime"].toString()) : <any>undefined;
            this.operation = data["operation"];
            this.resourceName = data["resourceName"];
            this.versionName = data["versionName"];
        }
    }

    static fromJS(data: any): VisualTransferLog {
        data = typeof data === 'object' ? data : {};
        let result = new VisualTransferLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageType"] = this.messageType;
        data["operateName"] = this.operateName;
        data["operateTime"] = this.operateTime ? this.operateTime.toISOString() : <any>undefined;
        data["operation"] = this.operation;
        data["resourceName"] = this.resourceName;
        data["versionName"] = this.versionName;
        return data; 
    }
}

export interface IVisualTransferLog {
    /** 信息类型 */
    messageType: string | undefined;
    /** 操作人姓名 */
    operateName: string | undefined;
    /** 操作时间 */
    operateTime: Date | undefined;
    /** 操作类型 */
    operation: string | undefined;
    /** 资源名称 */
    resourceName: string | undefined;
    /** 资源版本名称 */
    versionName: string | undefined;
}

export class VisualWorkStationStatusVO implements IVisualWorkStationStatusVO {
    /** 工位code */
    code!: string | undefined;
    /** 工位id */
    id!: string | undefined;
    /** 工位名称 */
    name!: string | undefined;
    /** 工单code */
    orderCode!: string | undefined;
    /** 加工人员 */
    producerName!: string | undefined;

    constructor(data?: IVisualWorkStationStatusVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.name = data["name"];
            this.orderCode = data["orderCode"];
            this.producerName = data["producerName"];
        }
    }

    static fromJS(data: any): VisualWorkStationStatusVO {
        data = typeof data === 'object' ? data : {};
        let result = new VisualWorkStationStatusVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["name"] = this.name;
        data["orderCode"] = this.orderCode;
        data["producerName"] = this.producerName;
        return data; 
    }
}

export interface IVisualWorkStationStatusVO {
    /** 工位code */
    code: string | undefined;
    /** 工位id */
    id: string | undefined;
    /** 工位名称 */
    name: string | undefined;
    /** 工单code */
    orderCode: string | undefined;
    /** 加工人员 */
    producerName: string | undefined;
}

export class WipStockInRecordVO implements IWipStockInRecordVO {
    area!: string | undefined;
    location!: string | undefined;
    materialCode!: string | undefined;
    materialName!: string | undefined;
    nextProcessCode!: string | undefined;
    nextProcessId!: string | undefined;
    nextProcessName!: string | undefined;
    number!: number | undefined;
    orderCode!: string | undefined;
    orderId!: string | undefined;
    planCode!: string | undefined;
    planId!: string | undefined;
    processCode!: string | undefined;
    processId!: string | undefined;
    processName!: string | undefined;

    constructor(data?: IWipStockInRecordVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.area = data["area"];
            this.location = data["location"];
            this.materialCode = data["materialCode"];
            this.materialName = data["materialName"];
            this.nextProcessCode = data["nextProcessCode"];
            this.nextProcessId = data["nextProcessId"];
            this.nextProcessName = data["nextProcessName"];
            this.number = data["number"];
            this.orderCode = data["orderCode"];
            this.orderId = data["orderId"];
            this.planCode = data["planCode"];
            this.planId = data["planId"];
            this.processCode = data["processCode"];
            this.processId = data["processId"];
            this.processName = data["processName"];
        }
    }

    static fromJS(data: any): WipStockInRecordVO {
        data = typeof data === 'object' ? data : {};
        let result = new WipStockInRecordVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["area"] = this.area;
        data["location"] = this.location;
        data["materialCode"] = this.materialCode;
        data["materialName"] = this.materialName;
        data["nextProcessCode"] = this.nextProcessCode;
        data["nextProcessId"] = this.nextProcessId;
        data["nextProcessName"] = this.nextProcessName;
        data["number"] = this.number;
        data["orderCode"] = this.orderCode;
        data["orderId"] = this.orderId;
        data["planCode"] = this.planCode;
        data["planId"] = this.planId;
        data["processCode"] = this.processCode;
        data["processId"] = this.processId;
        data["processName"] = this.processName;
        return data; 
    }
}

export interface IWipStockInRecordVO {
    area: string | undefined;
    location: string | undefined;
    materialCode: string | undefined;
    materialName: string | undefined;
    nextProcessCode: string | undefined;
    nextProcessId: string | undefined;
    nextProcessName: string | undefined;
    number: number | undefined;
    orderCode: string | undefined;
    orderId: string | undefined;
    planCode: string | undefined;
    planId: string | undefined;
    processCode: string | undefined;
    processId: string | undefined;
    processName: string | undefined;
}

export class WipStockOutRecordVO implements IWipStockOutRecordVO {
    area!: string | undefined;
    id!: string | undefined;
    location!: string | undefined;
    materialCode!: string | undefined;
    materialName!: string | undefined;
    number!: number | undefined;
    orderCode!: string | undefined;
    orderId!: string | undefined;
    planCode!: string | undefined;
    planId!: string | undefined;
    processCode!: string | undefined;
    processId!: string | undefined;
    processName!: string | undefined;

    constructor(data?: IWipStockOutRecordVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.area = data["area"];
            this.id = data["id"];
            this.location = data["location"];
            this.materialCode = data["materialCode"];
            this.materialName = data["materialName"];
            this.number = data["number"];
            this.orderCode = data["orderCode"];
            this.orderId = data["orderId"];
            this.planCode = data["planCode"];
            this.planId = data["planId"];
            this.processCode = data["processCode"];
            this.processId = data["processId"];
            this.processName = data["processName"];
        }
    }

    static fromJS(data: any): WipStockOutRecordVO {
        data = typeof data === 'object' ? data : {};
        let result = new WipStockOutRecordVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["area"] = this.area;
        data["id"] = this.id;
        data["location"] = this.location;
        data["materialCode"] = this.materialCode;
        data["materialName"] = this.materialName;
        data["number"] = this.number;
        data["orderCode"] = this.orderCode;
        data["orderId"] = this.orderId;
        data["planCode"] = this.planCode;
        data["planId"] = this.planId;
        data["processCode"] = this.processCode;
        data["processId"] = this.processId;
        data["processName"] = this.processName;
        return data; 
    }
}

export interface IWipStockOutRecordVO {
    area: string | undefined;
    id: string | undefined;
    location: string | undefined;
    materialCode: string | undefined;
    materialName: string | undefined;
    number: number | undefined;
    orderCode: string | undefined;
    orderId: string | undefined;
    planCode: string | undefined;
    planId: string | undefined;
    processCode: string | undefined;
    processId: string | undefined;
    processName: string | undefined;
}

export class WorkInProcessInStockDTO implements IWorkInProcessInStockDTO {
    /** 收料人员 */
    customerId!: string | undefined;
    /** 收料部门 */
    deptId!: string | undefined;
    /** 下表数据 */
    inStockDTO!: InStockDTO | undefined;
    /** 工单编号 */
    orderCode!: string | undefined;
    /** 工单id */
    orderId!: string | undefined;
    /** 计划编号 */
    planCode!: string | undefined;
    /** 计划Id */
    planId!: string | undefined;
    /** 收料时间 */
    receivingTime!: Date | undefined;

    constructor(data?: IWorkInProcessInStockDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerId = data["customerId"];
            this.deptId = data["deptId"];
            this.inStockDTO = data["inStockDTO"] ? InStockDTO.fromJS(data["inStockDTO"]) : <any>undefined;
            this.orderCode = data["orderCode"];
            this.orderId = data["orderId"];
            this.planCode = data["planCode"];
            this.planId = data["planId"];
            this.receivingTime = data["receivingTime"] ? new Date(data["receivingTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkInProcessInStockDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkInProcessInStockDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["deptId"] = this.deptId;
        data["inStockDTO"] = this.inStockDTO ? this.inStockDTO.toJSON() : <any>undefined;
        data["orderCode"] = this.orderCode;
        data["orderId"] = this.orderId;
        data["planCode"] = this.planCode;
        data["planId"] = this.planId;
        data["receivingTime"] = this.receivingTime ? this.receivingTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IWorkInProcessInStockDTO {
    /** 收料人员 */
    customerId: string | undefined;
    /** 收料部门 */
    deptId: string | undefined;
    /** 下表数据 */
    inStockDTO: InStockDTO | undefined;
    /** 工单编号 */
    orderCode: string | undefined;
    /** 工单id */
    orderId: string | undefined;
    /** 计划编号 */
    planCode: string | undefined;
    /** 计划Id */
    planId: string | undefined;
    /** 收料时间 */
    receivingTime: Date | undefined;
}

export class WorkInProcessOutStockDTO implements IWorkInProcessOutStockDTO {
    /** 收料人员Id */
    customerId!: string | undefined;
    /** 收料部门Id */
    deptId!: string | undefined;
    /** 工单编号 */
    orderCode!: string | undefined;
    /** 工单id */
    orderId!: string | undefined;
    /** 下表数据 */
    outStockDTO!: OutStockDTO | undefined;
    /** 计划编号 */
    planCode!: string | undefined;
    /** 计划Id */
    planId!: string | undefined;
    /** 收料时间 */
    receivingTime!: Date | undefined;

    constructor(data?: IWorkInProcessOutStockDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerId = data["customerId"];
            this.deptId = data["deptId"];
            this.orderCode = data["orderCode"];
            this.orderId = data["orderId"];
            this.outStockDTO = data["outStockDTO"] ? OutStockDTO.fromJS(data["outStockDTO"]) : <any>undefined;
            this.planCode = data["planCode"];
            this.planId = data["planId"];
            this.receivingTime = data["receivingTime"] ? new Date(data["receivingTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkInProcessOutStockDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkInProcessOutStockDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["deptId"] = this.deptId;
        data["orderCode"] = this.orderCode;
        data["orderId"] = this.orderId;
        data["outStockDTO"] = this.outStockDTO ? this.outStockDTO.toJSON() : <any>undefined;
        data["planCode"] = this.planCode;
        data["planId"] = this.planId;
        data["receivingTime"] = this.receivingTime ? this.receivingTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IWorkInProcessOutStockDTO {
    /** 收料人员Id */
    customerId: string | undefined;
    /** 收料部门Id */
    deptId: string | undefined;
    /** 工单编号 */
    orderCode: string | undefined;
    /** 工单id */
    orderId: string | undefined;
    /** 下表数据 */
    outStockDTO: OutStockDTO | undefined;
    /** 计划编号 */
    planCode: string | undefined;
    /** 计划Id */
    planId: string | undefined;
    /** 收料时间 */
    receivingTime: Date | undefined;
}

export class WorkStationAssignDTO implements IWorkStationAssignDTO {
    /** 生产班组id */
    assignDeptId!: string | undefined;
    /** 生产班组名称 */
    assignDeptName!: string | undefined;
    /** 指派数量 */
    assignNum!: number | undefined;
    /** 采集数量 */
    collectionNum!: number | undefined;
    /** 已派数量 */
    hasAssignNum!: number | undefined;
    /** 预计结束时间 */
    planEndTime!: Date | undefined;
    /** 预计开始时间 */
    planStartTime!: Date | undefined;
    /** 生产人员编码 */
    producerCode!: string | undefined;
    /** 生产人员id */
    producerId!: string | undefined;
    /** 生产人员名称 */
    producerName!: string | undefined;
    /** 报工数量 */
    reportNum!: number | undefined;
    /** 工单工序的开工工位id */
    workStationAssignId!: string | undefined;
    /** 工位id */
    workStationId!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;

    constructor(data?: IWorkStationAssignDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignDeptId = data["assignDeptId"];
            this.assignDeptName = data["assignDeptName"];
            this.assignNum = data["assignNum"];
            this.collectionNum = data["collectionNum"];
            this.hasAssignNum = data["hasAssignNum"];
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.planStartTime = data["planStartTime"] ? new Date(data["planStartTime"].toString()) : <any>undefined;
            this.producerCode = data["producerCode"];
            this.producerId = data["producerId"];
            this.producerName = data["producerName"];
            this.reportNum = data["reportNum"];
            this.workStationAssignId = data["workStationAssignId"];
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): WorkStationAssignDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationAssignDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignDeptId"] = this.assignDeptId;
        data["assignDeptName"] = this.assignDeptName;
        data["assignNum"] = this.assignNum;
        data["collectionNum"] = this.collectionNum;
        data["hasAssignNum"] = this.hasAssignNum;
        data["planEndTime"] = this.planEndTime ? formatDate(this.planEndTime) : <any>undefined;
        data["planStartTime"] = this.planStartTime ? formatDate(this.planStartTime) : <any>undefined;
        data["producerCode"] = this.producerCode;
        data["producerId"] = this.producerId;
        data["producerName"] = this.producerName;
        data["reportNum"] = this.reportNum;
        data["workStationAssignId"] = this.workStationAssignId;
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IWorkStationAssignDTO {
    /** 生产班组id */
    assignDeptId: string | undefined;
    /** 生产班组名称 */
    assignDeptName: string | undefined;
    /** 指派数量 */
    assignNum: number | undefined;
    /** 采集数量 */
    collectionNum: number | undefined;
    /** 已派数量 */
    hasAssignNum: number | undefined;
    /** 预计结束时间 */
    planEndTime: Date | undefined;
    /** 预计开始时间 */
    planStartTime: Date | undefined;
    /** 生产人员编码 */
    producerCode: string | undefined;
    /** 生产人员id */
    producerId: string | undefined;
    /** 生产人员名称 */
    producerName: string | undefined;
    /** 报工数量 */
    reportNum: number | undefined;
    /** 工单工序的开工工位id */
    workStationAssignId: string | undefined;
    /** 工位id */
    workStationId: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
}

export class WorkStationAssignOutDTO implements IWorkStationAssignOutDTO {
    /** 生产班组名称 */
    assignDeptName!: string | undefined;
    /** 采集数量 */
    collectionNum!: number | undefined;
    /** 工单号 */
    orderCode!: string | undefined;
    /** 工单工序ID */
    orderProcessId!: string | undefined;
    /** 生产计划编号 */
    planCode!: string | undefined;
    /** 预计结束时间 */
    planEndTime!: Date | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 生产人员名称 */
    producerName!: string | undefined;
    /** 产品编码 */
    productCode!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 指派总数 */
    totalNum!: number | undefined;
    /** 待报工数量 */
    unreportNum!: number | undefined;

    constructor(data?: IWorkStationAssignOutDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignDeptName = data["assignDeptName"];
            this.collectionNum = data["collectionNum"];
            this.orderCode = data["orderCode"];
            this.orderProcessId = data["orderProcessId"];
            this.planCode = data["planCode"];
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.processName = data["processName"];
            this.producerName = data["producerName"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.totalNum = data["totalNum"];
            this.unreportNum = data["unreportNum"];
        }
    }

    static fromJS(data: any): WorkStationAssignOutDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationAssignOutDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignDeptName"] = this.assignDeptName;
        data["collectionNum"] = this.collectionNum;
        data["orderCode"] = this.orderCode;
        data["orderProcessId"] = this.orderProcessId;
        data["planCode"] = this.planCode;
        data["planEndTime"] = this.planEndTime ? this.planEndTime.toISOString() : <any>undefined;
        data["processName"] = this.processName;
        data["producerName"] = this.producerName;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["totalNum"] = this.totalNum;
        data["unreportNum"] = this.unreportNum;
        return data; 
    }
}

export interface IWorkStationAssignOutDTO {
    /** 生产班组名称 */
    assignDeptName: string | undefined;
    /** 采集数量 */
    collectionNum: number | undefined;
    /** 工单号 */
    orderCode: string | undefined;
    /** 工单工序ID */
    orderProcessId: string | undefined;
    /** 生产计划编号 */
    planCode: string | undefined;
    /** 预计结束时间 */
    planEndTime: Date | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 生产人员名称 */
    producerName: string | undefined;
    /** 产品编码 */
    productCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 指派总数 */
    totalNum: number | undefined;
    /** 待报工数量 */
    unreportNum: number | undefined;
}

export class WorkStationBO implements IWorkStationBO {
    calendarCode!: string | undefined;
    /** 工位编码 */
    code!: string | undefined;
    /** 联系方式 */
    contact!: string | undefined;
    /** 客户id */
    customerId!: string | undefined;
    /** 客户名称 */
    customerName!: string | undefined;
    id!: string | undefined;
    /** 工位名字 */
    name!: string | undefined;
    standardEfficiency!: number | undefined;
    /** 联系方式 */
    tel!: string | undefined;
    /** 产量倍率 */
    yieldRatio!: number | undefined;

    constructor(data?: IWorkStationBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.calendarCode = data["calendarCode"];
            this.code = data["code"];
            this.contact = data["contact"];
            this.customerId = data["customerId"];
            this.customerName = data["customerName"];
            this.id = data["id"];
            this.name = data["name"];
            this.standardEfficiency = data["standardEfficiency"];
            this.tel = data["tel"];
            this.yieldRatio = data["yieldRatio"];
        }
    }

    static fromJS(data: any): WorkStationBO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendarCode"] = this.calendarCode;
        data["code"] = this.code;
        data["contact"] = this.contact;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["id"] = this.id;
        data["name"] = this.name;
        data["standardEfficiency"] = this.standardEfficiency;
        data["tel"] = this.tel;
        data["yieldRatio"] = this.yieldRatio;
        return data; 
    }
}

export interface IWorkStationBO {
    calendarCode: string | undefined;
    /** 工位编码 */
    code: string | undefined;
    /** 联系方式 */
    contact: string | undefined;
    /** 客户id */
    customerId: string | undefined;
    /** 客户名称 */
    customerName: string | undefined;
    id: string | undefined;
    /** 工位名字 */
    name: string | undefined;
    standardEfficiency: number | undefined;
    /** 联系方式 */
    tel: string | undefined;
    /** 产量倍率 */
    yieldRatio: number | undefined;
}

export class WorkStationCalendarReportDTO implements IWorkStationCalendarReportDTO {
    /** 是否高级筛选 */
    filterPlus!: boolean;
    /** 查询条件字典 */
    param!: any | undefined;
    /** 计划编号 */
    planCodeLike!: string | undefined;
    /** 计划id集合 */
    planIdList!: string[] | undefined;
    /** 工序状态 */
    processStatusList!: number[] | undefined;
    /** 生产计划类型ID */
    typeId!: string;
    /** 查看方式 1、工位  2、计划 */
    way!: number | undefined;
    /** 工位id */
    workStationIdList!: string[] | undefined;

    constructor(data?: IWorkStationCalendarReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filterPlus = data["filterPlus"];
            this.param = data["param"];
            this.planCodeLike = data["planCodeLike"];
            if (data["planIdList"] && data["planIdList"].constructor === Array) {
                this.planIdList = [] as any;
                for (let item of data["planIdList"])
                    this.planIdList!.push(item);
            }
            if (data["processStatusList"] && data["processStatusList"].constructor === Array) {
                this.processStatusList = [] as any;
                for (let item of data["processStatusList"])
                    this.processStatusList!.push(item);
            }
            this.typeId = data["typeId"];
            this.way = data["way"];
            if (data["workStationIdList"] && data["workStationIdList"].constructor === Array) {
                this.workStationIdList = [] as any;
                for (let item of data["workStationIdList"])
                    this.workStationIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): WorkStationCalendarReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationCalendarReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterPlus"] = this.filterPlus;
        data["param"] = this.param;
        data["planCodeLike"] = this.planCodeLike;
        if (this.planIdList && this.planIdList.constructor === Array) {
            data["planIdList"] = [];
            for (let item of this.planIdList)
                data["planIdList"].push(item);
        }
        if (this.processStatusList && this.processStatusList.constructor === Array) {
            data["processStatusList"] = [];
            for (let item of this.processStatusList)
                data["processStatusList"].push(item);
        }
        data["typeId"] = this.typeId;
        data["way"] = this.way;
        if (this.workStationIdList && this.workStationIdList.constructor === Array) {
            data["workStationIdList"] = [];
            for (let item of this.workStationIdList)
                data["workStationIdList"].push(item);
        }
        return data; 
    }
}

export interface IWorkStationCalendarReportDTO {
    /** 是否高级筛选 */
    filterPlus: boolean;
    /** 查询条件字典 */
    param: any | undefined;
    /** 计划编号 */
    planCodeLike: string | undefined;
    /** 计划id集合 */
    planIdList: string[] | undefined;
    /** 工序状态 */
    processStatusList: number[] | undefined;
    /** 生产计划类型ID */
    typeId: string;
    /** 查看方式 1、工位  2、计划 */
    way: number | undefined;
    /** 工位id */
    workStationIdList: string[] | undefined;
}

export class WorkStationCalendarReportVO implements IWorkStationCalendarReportVO {
    /** 采集数量 */
    collectionNum!: number | undefined;
    /** 当前进度 */
    currentProgress!: string | undefined;
    /** 待派发数量 */
    distributedNum!: number | undefined;
    /** 加工人员 */
    employeeName!: string | undefined;
    /** 班次 */
    indexName!: string | undefined;
    /** 投产数量 */
    inputNum!: number | undefined;
    /** 订单编号 */
    orderCode!: string | undefined;
    /** 工单工序id */
    orderProcessId!: string | undefined;
    /** 生产计划编号 */
    planCode!: string | undefined;
    /** 计划预计结束时间 */
    planEndTime!: Date | undefined;
    /** 生产计划id */
    planId!: string | undefined;
    /** 工序编码 */
    processCode!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 目标进度 */
    processProgress!: string | undefined;
    /** 工序状态 */
    processStatus!: number | undefined;
    /** 产品编码 */
    productCode!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 工单编号 */
    productionOrderCode!: string | undefined;
    /** 程序号 */
    programName!: string | undefined;
    /** 实时产量 */
    realTimeOutput!: string | undefined;
    /** 报工数量 */
    reportNum!: number | undefined;
    /** 工位code */
    workStationCode!: string | undefined;
    /** 工位id */
    workStationId!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;
    /** 工位状态(1：工序在工位上待加工，2：工序在工位上加工，3：工位处于空闲，4：维修中或保养中，5：工序在工位上完成) */
    workStatus!: number | undefined;
    /** 工位状态名称 */
    workStatusName!: string | undefined;
    /** 工位产能 */
    workstationCapacity!: number | undefined;

    constructor(data?: IWorkStationCalendarReportVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.collectionNum = data["collectionNum"];
            this.currentProgress = data["currentProgress"];
            this.distributedNum = data["distributedNum"];
            this.employeeName = data["employeeName"];
            this.indexName = data["indexName"];
            this.inputNum = data["inputNum"];
            this.orderCode = data["orderCode"];
            this.orderProcessId = data["orderProcessId"];
            this.planCode = data["planCode"];
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.planId = data["planId"];
            this.processCode = data["processCode"];
            this.processName = data["processName"];
            this.processProgress = data["processProgress"];
            this.processStatus = data["processStatus"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.productionOrderCode = data["productionOrderCode"];
            this.programName = data["programName"];
            this.realTimeOutput = data["realTimeOutput"];
            this.reportNum = data["reportNum"];
            this.workStationCode = data["workStationCode"];
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
            this.workStatus = data["workStatus"];
            this.workStatusName = data["workStatusName"];
            this.workstationCapacity = data["workstationCapacity"];
        }
    }

    static fromJS(data: any): WorkStationCalendarReportVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationCalendarReportVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collectionNum"] = this.collectionNum;
        data["currentProgress"] = this.currentProgress;
        data["distributedNum"] = this.distributedNum;
        data["employeeName"] = this.employeeName;
        data["indexName"] = this.indexName;
        data["inputNum"] = this.inputNum;
        data["orderCode"] = this.orderCode;
        data["orderProcessId"] = this.orderProcessId;
        data["planCode"] = this.planCode;
        data["planEndTime"] = this.planEndTime ? this.planEndTime.toISOString() : <any>undefined;
        data["planId"] = this.planId;
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        data["processProgress"] = this.processProgress;
        data["processStatus"] = this.processStatus;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productionOrderCode"] = this.productionOrderCode;
        data["programName"] = this.programName;
        data["realTimeOutput"] = this.realTimeOutput;
        data["reportNum"] = this.reportNum;
        data["workStationCode"] = this.workStationCode;
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        data["workStatus"] = this.workStatus;
        data["workStatusName"] = this.workStatusName;
        data["workstationCapacity"] = this.workstationCapacity;
        return data; 
    }
}

export interface IWorkStationCalendarReportVO {
    /** 采集数量 */
    collectionNum: number | undefined;
    /** 当前进度 */
    currentProgress: string | undefined;
    /** 待派发数量 */
    distributedNum: number | undefined;
    /** 加工人员 */
    employeeName: string | undefined;
    /** 班次 */
    indexName: string | undefined;
    /** 投产数量 */
    inputNum: number | undefined;
    /** 订单编号 */
    orderCode: string | undefined;
    /** 工单工序id */
    orderProcessId: string | undefined;
    /** 生产计划编号 */
    planCode: string | undefined;
    /** 计划预计结束时间 */
    planEndTime: Date | undefined;
    /** 生产计划id */
    planId: string | undefined;
    /** 工序编码 */
    processCode: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 目标进度 */
    processProgress: string | undefined;
    /** 工序状态 */
    processStatus: number | undefined;
    /** 产品编码 */
    productCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 工单编号 */
    productionOrderCode: string | undefined;
    /** 程序号 */
    programName: string | undefined;
    /** 实时产量 */
    realTimeOutput: string | undefined;
    /** 报工数量 */
    reportNum: number | undefined;
    /** 工位code */
    workStationCode: string | undefined;
    /** 工位id */
    workStationId: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
    /** 工位状态(1：工序在工位上待加工，2：工序在工位上加工，3：工位处于空闲，4：维修中或保养中，5：工序在工位上完成) */
    workStatus: number | undefined;
    /** 工位状态名称 */
    workStatusName: string | undefined;
    /** 工位产能 */
    workstationCapacity: number | undefined;
}

export class WorkStationInfoDTO implements IWorkStationInfoDTO {
    /** 工位ID */
    workStationId!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;

    constructor(data?: IWorkStationInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): WorkStationInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IWorkStationInfoDTO {
    /** 工位ID */
    workStationId: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
}

export class WorkStationOrderCraftVO implements IWorkStationOrderCraftVO {
    /** 工单变编号 */
    orderCode!: string | undefined;
    /** 工单状态(1：待加工，2：加工中，3：暂停，4：关闭,5:完工) */
    orderStatus!: string | undefined;
    /** 计划结束时间 */
    planEndTime!: Date | undefined;
    /** 计划ID */
    planId!: string | undefined;
    /** 计划开始时间 */
    planStartTime!: Date | undefined;
    /** 工艺版本 */
    version!: string | undefined;
    /** 工位编号 */
    workStationCode!: string | undefined;
    /** 工位ID */
    workStationId!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;

    constructor(data?: IWorkStationOrderCraftVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderCode = data["orderCode"];
            this.orderStatus = data["orderStatus"];
            this.planEndTime = data["planEndTime"] ? new Date(data["planEndTime"].toString()) : <any>undefined;
            this.planId = data["planId"];
            this.planStartTime = data["planStartTime"] ? new Date(data["planStartTime"].toString()) : <any>undefined;
            this.version = data["version"];
            this.workStationCode = data["workStationCode"];
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): WorkStationOrderCraftVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationOrderCraftVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderCode"] = this.orderCode;
        data["orderStatus"] = this.orderStatus;
        data["planEndTime"] = this.planEndTime ? this.planEndTime.toISOString() : <any>undefined;
        data["planId"] = this.planId;
        data["planStartTime"] = this.planStartTime ? this.planStartTime.toISOString() : <any>undefined;
        data["version"] = this.version;
        data["workStationCode"] = this.workStationCode;
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IWorkStationOrderCraftVO {
    /** 工单变编号 */
    orderCode: string | undefined;
    /** 工单状态(1：待加工，2：加工中，3：暂停，4：关闭,5:完工) */
    orderStatus: string | undefined;
    /** 计划结束时间 */
    planEndTime: Date | undefined;
    /** 计划ID */
    planId: string | undefined;
    /** 计划开始时间 */
    planStartTime: Date | undefined;
    /** 工艺版本 */
    version: string | undefined;
    /** 工位编号 */
    workStationCode: string | undefined;
    /** 工位ID */
    workStationId: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
}

/** 工位工单信息 */
export class WorkStationOrderProcessInfo implements IWorkStationOrderProcessInfo {
    /** 工单编号 */
    code!: string | undefined;
    id!: string | undefined;
    /** 投产数量 */
    inputNum!: string | undefined;
    /** 订单编号 */
    orderCode!: string | undefined;
    /** 计划编号 */
    planCode!: string | undefined;
    /** 计划id */
    planId!: string | undefined;
    /** 工单工序Id */
    poProcessId!: string | undefined;
    /** 工序code */
    processCode!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 工序序号 */
    processSequence!: string | undefined;
    /** 工位工序状态:1.待加工、2.加工中 */
    processWorkStationStatus!: number | undefined;
    /** 产品编号 */
    productCode!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 加工文件 */
    programName!: string | undefined;
    /** 报工数量 */
    reportNumber!: string | undefined;
    /** 资源ID */
    resourceId!: string | undefined;
    /** 工序顺序 */
    sort!: number | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;

    constructor(data?: IWorkStationOrderProcessInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.inputNum = data["inputNum"];
            this.orderCode = data["orderCode"];
            this.planCode = data["planCode"];
            this.planId = data["planId"];
            this.poProcessId = data["poProcessId"];
            this.processCode = data["processCode"];
            this.processName = data["processName"];
            this.processSequence = data["processSequence"];
            this.processWorkStationStatus = data["processWorkStationStatus"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.programName = data["programName"];
            this.reportNumber = data["reportNumber"];
            this.resourceId = data["resourceId"];
            this.sort = data["sort"];
            this.standardModel = data["standardModel"];
        }
    }

    static fromJS(data: any): WorkStationOrderProcessInfo {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationOrderProcessInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["inputNum"] = this.inputNum;
        data["orderCode"] = this.orderCode;
        data["planCode"] = this.planCode;
        data["planId"] = this.planId;
        data["poProcessId"] = this.poProcessId;
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        data["processSequence"] = this.processSequence;
        data["processWorkStationStatus"] = this.processWorkStationStatus;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["programName"] = this.programName;
        data["reportNumber"] = this.reportNumber;
        data["resourceId"] = this.resourceId;
        data["sort"] = this.sort;
        data["standardModel"] = this.standardModel;
        return data; 
    }
}

/** 工位工单信息 */
export interface IWorkStationOrderProcessInfo {
    /** 工单编号 */
    code: string | undefined;
    id: string | undefined;
    /** 投产数量 */
    inputNum: string | undefined;
    /** 订单编号 */
    orderCode: string | undefined;
    /** 计划编号 */
    planCode: string | undefined;
    /** 计划id */
    planId: string | undefined;
    /** 工单工序Id */
    poProcessId: string | undefined;
    /** 工序code */
    processCode: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 工序序号 */
    processSequence: string | undefined;
    /** 工位工序状态:1.待加工、2.加工中 */
    processWorkStationStatus: number | undefined;
    /** 产品编号 */
    productCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 加工文件 */
    programName: string | undefined;
    /** 报工数量 */
    reportNumber: string | undefined;
    /** 资源ID */
    resourceId: string | undefined;
    /** 工序顺序 */
    sort: number | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
}

/** 工位工单工序信息 */
export class WorkStationOrderProcessInfoBO implements IWorkStationOrderProcessInfoBO {
    /** 派工数量 */
    assignNum!: number | undefined;
    /** 工单编号 */
    code!: string | undefined;
    /** 生产设备 */
    devices!: string | undefined;
    /** 工单结束时间 */
    endTime!: Date | undefined;
    /** id */
    id!: string | undefined;
    /** 上序合格数 */
    lastQualifyNum!: string | undefined;
    /** 物料编号 */
    materialCode!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 工序序号 */
    processSequence!: string | undefined;
    /** 生产人员 */
    producerName!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 工序顺序 */
    sort!: number | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 当前状态 */
    status!: number | undefined;

    constructor(data?: IWorkStationOrderProcessInfoBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignNum = data["assignNum"];
            this.code = data["code"];
            this.devices = data["devices"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.id = data["id"];
            this.lastQualifyNum = data["lastQualifyNum"];
            this.materialCode = data["materialCode"];
            this.processName = data["processName"];
            this.processSequence = data["processSequence"];
            this.producerName = data["producerName"];
            this.productName = data["productName"];
            this.sort = data["sort"];
            this.standardModel = data["standardModel"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): WorkStationOrderProcessInfoBO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationOrderProcessInfoBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignNum"] = this.assignNum;
        data["code"] = this.code;
        data["devices"] = this.devices;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["lastQualifyNum"] = this.lastQualifyNum;
        data["materialCode"] = this.materialCode;
        data["processName"] = this.processName;
        data["processSequence"] = this.processSequence;
        data["producerName"] = this.producerName;
        data["productName"] = this.productName;
        data["sort"] = this.sort;
        data["standardModel"] = this.standardModel;
        data["status"] = this.status;
        return data; 
    }
}

/** 工位工单工序信息 */
export interface IWorkStationOrderProcessInfoBO {
    /** 派工数量 */
    assignNum: number | undefined;
    /** 工单编号 */
    code: string | undefined;
    /** 生产设备 */
    devices: string | undefined;
    /** 工单结束时间 */
    endTime: Date | undefined;
    /** id */
    id: string | undefined;
    /** 上序合格数 */
    lastQualifyNum: string | undefined;
    /** 物料编号 */
    materialCode: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 工序序号 */
    processSequence: string | undefined;
    /** 生产人员 */
    producerName: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 工序顺序 */
    sort: number | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 当前状态 */
    status: number | undefined;
}

export class WorkStationProducerDTO implements IWorkStationProducerDTO {
    /** 工单采集数量 */
    collectionNum!: number | undefined;
    /** 订单编码 */
    orderCode!: string | undefined;
    /** 生产计划编号 */
    planCode!: string | undefined;
    /** 生产人员编号 */
    producerCode!: string | undefined;
    /** 生产人员id */
    producerId!: string | undefined;
    /** 生产人员姓名 */
    producerName!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 工位id */
    workStationId!: string | undefined;

    constructor(data?: IWorkStationProducerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.collectionNum = data["collectionNum"];
            this.orderCode = data["orderCode"];
            this.planCode = data["planCode"];
            this.producerCode = data["producerCode"];
            this.producerId = data["producerId"];
            this.producerName = data["producerName"];
            this.productName = data["productName"];
            this.standardModel = data["standardModel"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): WorkStationProducerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationProducerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collectionNum"] = this.collectionNum;
        data["orderCode"] = this.orderCode;
        data["planCode"] = this.planCode;
        data["producerCode"] = this.producerCode;
        data["producerId"] = this.producerId;
        data["producerName"] = this.producerName;
        data["productName"] = this.productName;
        data["standardModel"] = this.standardModel;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IWorkStationProducerDTO {
    /** 工单采集数量 */
    collectionNum: number | undefined;
    /** 订单编码 */
    orderCode: string | undefined;
    /** 生产计划编号 */
    planCode: string | undefined;
    /** 生产人员编号 */
    producerCode: string | undefined;
    /** 生产人员id */
    producerId: string | undefined;
    /** 生产人员姓名 */
    producerName: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 工位id */
    workStationId: string | undefined;
}

export class WorkStationQueryDataSourceDTO implements IWorkStationQueryDataSourceDTO {
    /** 工位id */
    workStationIdList!: string[] | undefined;

    constructor(data?: IWorkStationQueryDataSourceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["workStationIdList"] && data["workStationIdList"].constructor === Array) {
                this.workStationIdList = [] as any;
                for (let item of data["workStationIdList"])
                    this.workStationIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): WorkStationQueryDataSourceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationQueryDataSourceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.workStationIdList && this.workStationIdList.constructor === Array) {
            data["workStationIdList"] = [];
            for (let item of this.workStationIdList)
                data["workStationIdList"].push(item);
        }
        return data; 
    }
}

export interface IWorkStationQueryDataSourceDTO {
    /** 工位id */
    workStationIdList: string[] | undefined;
}

export class WorkStationScrappedRecordDTO implements IWorkStationScrappedRecordDTO {
    /** 报废编码以及原因 */
    scrappedCodeAndReason!: string | undefined;
    /** 报废数量 */
    scrappedNum!: number | undefined;
    /** 报废原因 */
    scrappedReason!: string | undefined;
    /** 报废原因编码 */
    scrappedReasonCode!: string | undefined;
    /** 报废类型 */
    scrappedType!: string | undefined;
    /** 报废类型编码 */
    scrappedTypeCode!: string | undefined;

    constructor(data?: IWorkStationScrappedRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.scrappedCodeAndReason = data["scrappedCodeAndReason"];
            this.scrappedNum = data["scrappedNum"];
            this.scrappedReason = data["scrappedReason"];
            this.scrappedReasonCode = data["scrappedReasonCode"];
            this.scrappedType = data["scrappedType"];
            this.scrappedTypeCode = data["scrappedTypeCode"];
        }
    }

    static fromJS(data: any): WorkStationScrappedRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationScrappedRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scrappedCodeAndReason"] = this.scrappedCodeAndReason;
        data["scrappedNum"] = this.scrappedNum;
        data["scrappedReason"] = this.scrappedReason;
        data["scrappedReasonCode"] = this.scrappedReasonCode;
        data["scrappedType"] = this.scrappedType;
        data["scrappedTypeCode"] = this.scrappedTypeCode;
        return data; 
    }
}

export interface IWorkStationScrappedRecordDTO {
    /** 报废编码以及原因 */
    scrappedCodeAndReason: string | undefined;
    /** 报废数量 */
    scrappedNum: number | undefined;
    /** 报废原因 */
    scrappedReason: string | undefined;
    /** 报废原因编码 */
    scrappedReasonCode: string | undefined;
    /** 报废类型 */
    scrappedType: string | undefined;
    /** 报废类型编码 */
    scrappedTypeCode: string | undefined;
}

export class WorkingBO implements IWorkingBO {
    /** 参数名：加工中 */
    name!: string | undefined;
    /** 参数值：加工中数量 */
    value!: number | undefined;

    constructor(data?: IWorkingBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): WorkingBO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkingBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface IWorkingBO {
    /** 参数名：加工中 */
    name: string | undefined;
    /** 参数值：加工中数量 */
    value: number | undefined;
}

export class WorkStationAndPoProcessDTO implements IWorkStationAndPoProcessDTO {
    /** 工单工序id */
    poProcessId!: string | undefined;
    /** 工位id */
    workStationId!: string | undefined;

    constructor(data?: IWorkStationAndPoProcessDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.poProcessId = data["poProcessId"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): WorkStationAndPoProcessDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationAndPoProcessDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poProcessId"] = this.poProcessId;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IWorkStationAndPoProcessDTO {
    /** 工单工序id */
    poProcessId: string | undefined;
    /** 工位id */
    workStationId: string | undefined;
}

export enum PlanMaterialStatusDTOPlanMaterialEnums {
    OUT_OF = "OUT_OF", 
    INGREDIENTS = "INGREDIENTS", 
    COMPLETE = "COMPLETE", 
    SHUTDOWN = "SHUTDOWN", 
    RESTART = "RESTART", 
}

export enum ProductionStatisticsByWorkStationReportExcelDTOStatisticalMethod {
    SHIFT = "SHIFT", 
    DAY = "DAY", 
    WEEK = "WEEK", 
    MONTH = "MONTH", 
    DATE = "DATE", 
    LAST_TWELVE_MONTHS = "LAST_TWELVE_MONTHS", 
    LAST_THIRTY_DAYS = "LAST_THIRTY_DAYS", 
}

export enum ProductionStatisticsReportDTOStatisticalMethod {
    SHIFT = "SHIFT", 
    DAY = "DAY", 
    WEEK = "WEEK", 
    MONTH = "MONTH", 
    DATE = "DATE", 
    LAST_TWELVE_MONTHS = "LAST_TWELVE_MONTHS", 
    LAST_THIRTY_DAYS = "LAST_THIRTY_DAYS", 
}

export enum ProductionStatisticsReportExcelDTOStatisticalMethod {
    SHIFT = "SHIFT", 
    DAY = "DAY", 
    WEEK = "WEEK", 
    MONTH = "MONTH", 
    DATE = "DATE", 
    LAST_TWELVE_MONTHS = "LAST_TWELVE_MONTHS", 
    LAST_THIRTY_DAYS = "LAST_THIRTY_DAYS", 
}

export enum ProductionStatisticsWorkStationReportDTOStatisticalMethod {
    SHIFT = "SHIFT", 
    DAY = "DAY", 
    WEEK = "WEEK", 
    MONTH = "MONTH", 
    DATE = "DATE", 
    LAST_TWELVE_MONTHS = "LAST_TWELVE_MONTHS", 
    LAST_THIRTY_DAYS = "LAST_THIRTY_DAYS", 
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}